import React from "react";
import moment from "moment";
import { DataSubtypes, validateDate } from "./schema";

const sexOptions = [
	{ value: "M", label: "Masculino" },
	{ value: "F", label: "Feminino" },
	{ value: "", label: "Indefinido" },
];

const natOptions = [
	{ value: "BRASILEIRO", label: "Brasileiro" },
	{ value: "BRASILEIRO_NATURALIZADO", label: "Brasileiro Naturalizado" },
	{
		value: "BRASILEIRO_NASCIDO_EXTERIOR",
		label: "Brasileiro nascido no exterior",
	},
	{ value: "ESTRANGEIRO", label: "Estrangeiro" },
];

export const stateOptions = [
	{ value: "12", label: "AC" },
	{ value: "27", label: "AL" },
	{ value: "13", label: "AM" },
	{ value: "16", label: "AP" },
	{ value: "29", label: "BA" },
	{ value: "23", label: "CE" },
	{ value: "53", label: "DF" },
	{ value: "32", label: "ES" },
	{ value: "52", label: "GO" },
	{ value: "21", label: "MA" },
	{ value: "31", label: "MG" },
	{ value: "50", label: "MS" },
	{ value: "51", label: "MT" },
	{ value: "15", label: "PA" },
	{ value: "25", label: "PB" },
	{ value: "26", label: "PE" },
	{ value: "22", label: "PI" },
	{ value: "41", label: "PR" },
	{ value: "33", label: "RJ" },
	{ value: "24", label: "RN" },
	{ value: "11", label: "RO" },
	{ value: "14", label: "RR" },
	{ value: "43", label: "RS" },
	{ value: "42", label: "SC" },
	{ value: "28", label: "SE" },
	{ value: "35", label: "SP" },
	{ value: "17", label: "TO" },
];

export const ufOptions = [
	{ value: "AC", label: "AC" },
	{ value: "AL", label: "AL" },
	{ value: "AM", label: "AM" },
	{ value: "AP", label: "AP" },
	{ value: "BA", label: "BA" },
	{ value: "CE", label: "CE" },
	{ value: "DF", label: "DF" },
	{ value: "ES", label: "ES" },
	{ value: "GO", label: "GO" },
	{ value: "MA", label: "MA" },
	{ value: "MG", label: "MG" },
	{ value: "MS", label: "MS" },
	{ value: "MT", label: "MT" },
	{ value: "PA", label: "PA" },
	{ value: "PB", label: "PB" },
	{ value: "PE", label: "PE" },
	{ value: "PI", label: "PI" },
	{ value: "PR", label: "PR" },
	{ value: "RJ", label: "RJ" },
	{ value: "RN", label: "RN" },
	{ value: "RO", label: "RO" },
	{ value: "RR", label: "RR" },
	{ value: "RS", label: "RS" },
	{ value: "SC", label: "SC" },
	{ value: "SE", label: "SE" },
	{ value: "SP", label: "SP" },
	{ value: "TO", label: "TO" },
];

interface ICityOption {
	[key: string]: Array<{ value: string; label: string }>;
}

export const citiesOptions: ICityOption = {
	RO: [
		{ value: "0001", label: "ALTA FLORESTA D'OESTE" },
		{ value: "0037", label: "ALTO ALEGRE DOS PARECIS" },
		{ value: "0040", label: "ALTO PARAISO" },
		{ value: "0034", label: "ALVORADA D'OESTE" },
		{ value: "0002", label: "ARIQUEMES" },
		{ value: "0045", label: "BURITIS" },
		{ value: "0003", label: "CABIXI" },
		{ value: "0060", label: "CACAULANDIA" },
		{ value: "0004", label: "CACOAL" },
		{ value: "0070", label: "CAMPO NOVO DE RONDONIA" },
		{ value: "0080", label: "CANDEIAS DO JAMARI" },
		{ value: "0090", label: "CASTANHEIRAS" },
		{ value: "0005", label: "CEREJEIRAS" },
		{ value: "0092", label: "CHUPINGUAIA" },
		{ value: "0006", label: "COLORADO DO OESTE" },
		{ value: "0007", label: "CORUMBIARA" },
		{ value: "0008", label: "COSTA MARQUES" },
		{ value: "0094", label: "CUJUBIM" },
		{ value: "0009", label: "ESPIGAO D'OESTE" },
		{ value: "0000", label: "ESPIGAO DO OESTE" },
		{ value: "0100", label: "GOVERNADOR JORGE TEIXEIRA" },
		{ value: "0010", label: "GUAJARA-MIRIM" },
		{ value: "0110", label: "ITAPUA DO OESTE" },
		{ value: "0011", label: "JARU" },
		{ value: "0012", label: "JI-PARANA" },
		{ value: "0013", label: "MACHADINHO D'OESTE" },
		{ value: "0120", label: "MINISTRO ANDREAZZA" },
		{ value: "0130", label: "MIRANTE DA SERRA" },
		{ value: "0140", label: "MONTE NEGRO" },
		{ value: "0014", label: "NOVA BRASILANDIA D'OESTE" },
		{ value: "0033", label: "NOVA MAMORE" },
		{ value: "0143", label: "NOVA UNIAO" },
		{ value: "0050", label: "NOVO HORIZONTE DO OESTE" },
		{ value: "0015", label: "OURO PRETO DO OESTE" },
		{ value: "0145", label: "PARECIS" },
		{ value: "0018", label: "PIMENTA BUENO" },
		{ value: "0146", label: "PIMENTEIRAS DO OESTE" },
		{ value: "0020", label: "PORTO VELHO" },
		{ value: "0025", label: "PRESIDENTE MEDICI" },
		{ value: "0147", label: "PRIMAVERA DE RONDONIA" },
		{ value: "0026", label: "RIO CRESPO" },
		{ value: "0028", label: "ROLIM DE MOURA" },
		{ value: "0029", label: "SANTA LUZIA D'OESTE" },
		{ value: "0148", label: "SAO FELIPE D'OESTE" },
		{ value: "0149", label: "SAO FRANCISCO DO GUAPORE" },
		{ value: "0032", label: "SAO MIGUEL DO GUAPORE" },
		{ value: "0150", label: "SERINGUEIRAS" },
		{ value: "0155", label: "TEIXEIROPOLIS" },
		{ value: "0160", label: "THEOBROMA" },
		{ value: "0170", label: "URUPA" },
		{ value: "0175", label: "VALE DO ANARI" },
		{ value: "0180", label: "VALE DO PARAISO" },
		{ value: "0030", label: "VILHENA" },
	],
	AC: [
		{ value: "0001", label: "ACRELANDIA" },
		{ value: "0005", label: "ASSIS BRASIL" },
		{ value: "0010", label: "BRASILEIA" },
		{ value: "0013", label: "BUJARI" },
		{ value: "0017", label: "CAPIXABA" },
		{ value: "0020", label: "CRUZEIRO DO SUL" },
		{ value: "0025", label: "EPITACIOLANDIA" },
		{ value: "0030", label: "FEIJO" },
		{ value: "0032", label: "JORDAO" },
		{ value: "0033", label: "MANCIO LIMA" },
		{ value: "0034", label: "MANOEL URBANO" },
		{ value: "0035", label: "MARECHAL THAUMATURGO" },
		{ value: "0038", label: "PLACIDO DE CASTRO" },
		{ value: "0080", label: "PORTO ACRE" },
		{ value: "0039", label: "PORTO WALTER" },
		{ value: "0040", label: "RIO BRANCO" },
		{ value: "0042", label: "RODRIGUES ALVES" },
		{ value: "0043", label: "SANTA ROSA DO PURUS" },
		{ value: "0050", label: "SENA MADUREIRA" },
		{ value: "0045", label: "SENADOR GUIOMARD" },
		{ value: "0060", label: "TARAUACA" },
		{ value: "0070", label: "XAPURI" },
	],
	AM: [
		{ value: "0002", label: "ALVARAES" },
		{ value: "0006", label: "AMATURA" },
		{ value: "0008", label: "ANAMA" },
		{ value: "0010", label: "ANORI" },
		{ value: "0014", label: "APUI" },
		{ value: "0020", label: "ATALAIA DO NORTE" },
		{ value: "0030", label: "AUTAZES" },
		{ value: "0040", label: "BARCELOS" },
		{ value: "0050", label: "BARREIRINHA" },
		{ value: "0060", label: "BENJAMIN CONSTANT" },
		{ value: "0063", label: "BERURI" },
		{ value: "0068", label: "BOA VISTA DO RAMOS" },
		{ value: "0070", label: "BOCA DO ACRE" },
		{ value: "0080", label: "BORBA" },
		{ value: "0083", label: "CAAPIRANGA" },
		{ value: "0090", label: "CANUTAMA" },
		{ value: "0100", label: "CARAUARI" },
		{ value: "0110", label: "CAREIRO" },
		{ value: "0115", label: "CAREIRO DA VARZEA" },
		{ value: "0120", label: "COARI" },
		{ value: "0130", label: "CODAJAS" },
		{ value: "0140", label: "EIRUNEPE" },
		{ value: "0150", label: "ENVIRA" },
		{ value: "0160", label: "FONTE BOA" },
		{ value: "0165", label: "GUAJARA" },
		{ value: "0170", label: "HUMAITA" },
		{ value: "0180", label: "IPIXUNA" },
		{ value: "0185", label: "IRANDUBA" },
		{ value: "0190", label: "ITACOATIARA" },
		{ value: "0195", label: "ITAMARATI" },
		{ value: "0200", label: "ITAPIRANGA" },
		{ value: "0210", label: "JAPURA" },
		{ value: "0220", label: "JURUA" },
		{ value: "0230", label: "JUTAI" },
		{ value: "0240", label: "LABREA" },
		{ value: "0250", label: "MANACAPURU" },
		{ value: "0255", label: "MANAQUIRI" },
		{ value: "0260", label: "MANAUS" },
		{ value: "0270", label: "MANICORE" },
		{ value: "0280", label: "MARAA" },
		{ value: "0290", label: "MAUES" },
		{ value: "0300", label: "NHAMUNDA" },
		{ value: "0310", label: "NOVA OLINDA DO NORTE" },
		{ value: "0320", label: "NOVO AIRAO" },
		{ value: "0330", label: "NOVO ARIPUANA" },
		{ value: "0340", label: "PARINTINS" },
		{ value: "0350", label: "PAUINI" },
		{ value: "0353", label: "PRESIDENTE FIGUEIREDO" },
		{ value: "0356", label: "RIO PRETO DA EVA" },
		{ value: "0360", label: "SANTA ISABEL DO RIO NEGRO" },
		{ value: "0370", label: "SANTO ANTONIO DO ICA" },
		{ value: "0380", label: "SAO GABRIEL DA CACHOEIRA" },
		{ value: "0390", label: "SAO PAULO DE OLIVENCA" },
		{ value: "0395", label: "SAO SEBASTIAO DO UATUMA" },
		{ value: "0400", label: "SILVES" },
		{ value: "0406", label: "TABATINGA" },
		{ value: "0410", label: "TAPAUA" },
		{ value: "0420", label: "TEFE" },
		{ value: "0423", label: "TONANTINS" },
		{ value: "0426", label: "UARINI" },
		{ value: "0430", label: "URUCARA" },
		{ value: "0440", label: "URUCURITUBA" },
	],
	RR: [
		{ value: "0005", label: "ALTO ALEGRE" },
		{ value: "0002", label: "AMAJARI" },
		{ value: "0010", label: "BOA VISTA" },
		{ value: "0015", label: "BONFIM" },
		{ value: "0017", label: "CANTA" },
		{ value: "0020", label: "CARACARAI" },
		{ value: "0023", label: "CAROEBE" },
		{ value: "0028", label: "IRACEMA" },
		{ value: "0030", label: "MUCAJAI" },
		{ value: "0040", label: "NORMANDIA" },
		{ value: "0045", label: "PACARAIMA" },
		{ value: "0047", label: "RORAINOPOLIS" },
		{ value: "0050", label: "SAO JOAO DA BALIZA" },
		{ value: "0060", label: "SAO LUIZ" },
		{ value: "0070", label: "UIRAMUTA" },
	],
	PA: [
		{ value: "0010", label: "ABAETETUBA" },
		{ value: "0013", label: "ABEL FIGUEIREDO" },
		{ value: "0020", label: "ACARA" },
		{ value: "0030", label: "AFUA" },
		{ value: "0034", label: "AGUA AZUL DO NORTE" },
		{ value: "0040", label: "ALENQUER" },
		{ value: "0050", label: "ALMEIRIM" },
		{ value: "0060", label: "ALTAMIRA" },
		{ value: "0070", label: "ANAJAS" },
		{ value: "0080", label: "ANANINDEUA" },
		{ value: "0085", label: "ANAPU" },
		{ value: "0090", label: "AUGUSTO CORREA" },
		{ value: "0095", label: "AURORA DO PARA" },
		{ value: "0100", label: "AVEIRO" },
		{ value: "0110", label: "BAGRE" },
		{ value: "0120", label: "BAIAO" },
		{ value: "0125", label: "BANNACH" },
		{ value: "0130", label: "BARCARENA" },
		{ value: "0140", label: "BELEM" },
		{ value: "0145", label: "BELTERRA" },
		{ value: "0150", label: "BENEVIDES" },
		{ value: "0157", label: "BOM JESUS DO TOCANTINS" },
		{ value: "0160", label: "BONITO" },
		{ value: "0170", label: "BRAGANCA" },
		{ value: "0172", label: "BRASIL NOVO" },
		{ value: "0175", label: "BREJO GRANDE DO ARAGUAIA" },
		{ value: "0178", label: "BREU BRANCO" },
		{ value: "0180", label: "BREVES" },
		{ value: "0190", label: "BUJARU" },
		{ value: "0200", label: "CACHOEIRA DO ARARI" },
		{ value: "0195", label: "CACHOEIRA DO PIRIA" },
		{ value: "0210", label: "CAMETA" },
		{ value: "0215", label: "CANAA DOS CARAJAS" },
		{ value: "0220", label: "CAPANEMA" },
		{ value: "0230", label: "CAPITAO POCO" },
		{ value: "0240", label: "CASTANHAL" },
		{ value: "0250", label: "CHAVES" },
		{ value: "0260", label: "COLARES" },
		{ value: "0270", label: "CONCEICAO DO ARAGUAIA" },
		{ value: "0275", label: "CONCORDIA DO PARA" },
		{ value: "0276", label: "CUMARU DO NORTE" },
		{ value: "0277", label: "CURIONOPOLIS" },
		{ value: "0280", label: "CURRALINHO" },
		{ value: "0285", label: "CURUA" },
		{ value: "0290", label: "CURUCA" },
		{ value: "0293", label: "DOM ELISEU" },
		{ value: "0295", label: "ELDORADO DOS CARAJAS" },
		{ value: "0300", label: "FARO" },
		{ value: "0304", label: "FLORESTA DO ARAGUAIA" },
		{ value: "0307", label: "GARRAFAO DO NORTE" },
		{ value: "0309", label: "GOIANESIA DO PARA" },
		{ value: "0310", label: "GURUPA" },
		{ value: "0320", label: "IGARAPE-ACU" },
		{ value: "0330", label: "IGARAPE-MIRI" },
		{ value: "0340", label: "INHANGAPI" },
		{ value: "0345", label: "IPIXUNA DO PARA" },
		{ value: "0350", label: "IRITUIA" },
		{ value: "0360", label: "ITAITUBA" },
		{ value: "0370", label: "ITUPIRANGA" },
		{ value: "0375", label: "JACAREACANGA" },
		{ value: "0380", label: "JACUNDA" },
		{ value: "0390", label: "JURUTI" },
		{ value: "0400", label: "LIMOEIRO DO AJURU" },
		{ value: "0405", label: "MAE DO RIO" },
		{ value: "0410", label: "MAGALHAES BARATA" },
		{ value: "0420", label: "MARABA" },
		{ value: "0430", label: "MARACANA" },
		{ value: "0440", label: "MARAPANIM" },
		{ value: "0442", label: "MARITUBA" },
		{ value: "0445", label: "MEDICILANDIA" },
		{ value: "0450", label: "MELGACO" },
		{ value: "0460", label: "MOCAJUBA" },
		{ value: "0470", label: "MOJU" },
		{ value: "0475", label: "MOJUI DOS CAMPOS" },
		{ value: "0475", label: "MOJUI DOS CAMPOS" },
		{ value: "0480", label: "MONTE ALEGRE" },
		{ value: "0490", label: "MUANA" },
		{ value: "0495", label: "NOVA ESPERANCA DO PIRIA" },
		{ value: "0497", label: "NOVA IPIXUNA" },
		{ value: "0500", label: "NOVA TIMBOTEUA" },
		{ value: "0503", label: "NOVO PROGRESSO" },
		{ value: "0506", label: "NOVO REPARTIMENTO" },
		{ value: "0510", label: "OBIDOS" },
		{ value: "0520", label: "OEIRAS DO PARA" },
		{ value: "0530", label: "ORIXIMINA" },
		{ value: "0540", label: "OUREM" },
		{ value: "0543", label: "OURILANDIA DO NORTE" },
		{ value: "0548", label: "PACAJA" },
		{ value: "0549", label: "PALESTINA DO PARA" },
		{ value: "0550", label: "PARAGOMINAS" },
		{ value: "0553", label: "PARAUAPEBAS" },
		{ value: "0555", label: "PAU D'ARCO" },
		{ value: "0560", label: "PEIXE-BOI" },
		{ value: "0563", label: "PICARRA" },
		{ value: "0565", label: "PLACAS" },
		{ value: "0570", label: "PONTA DE PEDRAS" },
		{ value: "0580", label: "PORTEL" },
		{ value: "0590", label: "PORTO DE MOZ" },
		{ value: "0600", label: "PRAINHA" },
		{ value: "0610", label: "PRIMAVERA" },
		{ value: "0611", label: "QUATIPURU" },
		{ value: "0613", label: "REDENCAO" },
		{ value: "0616", label: "RIO MARIA" },
		{ value: "0618", label: "RONDON DO PARA" },
		{ value: "0619", label: "RUROPOLIS" },
		{ value: "0620", label: "SALINOPOLIS" },
		{ value: "0630", label: "SALVATERRA" },
		{ value: "0635", label: "SANTA BARBARA DO PARA" },
		{ value: "0640", label: "SANTA CRUZ DO ARARI" },
		{ value: "0650", label: "SANTA ISABEL DO PARA" },
		{ value: "0655", label: "SANTA LUZIA DO PARA" },
		{ value: "0658", label: "SANTA MARIA DAS BARREIRAS" },
		{ value: "0660", label: "SANTA MARIA DO PARA" },
		{ value: "0670", label: "SANTANA DO ARAGUAIA" },
		{ value: "0680", label: "SANTAREM" },
		{ value: "0690", label: "SANTAREM NOVO" },
		{ value: "0700", label: "SANTO ANTONIO DO TAUA" },
		{ value: "0710", label: "SAO CAETANO DE ODIVELAS" },
		{ value: "0715", label: "SAO DOMINGOS DO ARAGUAIA" },
		{ value: "0720", label: "SAO DOMINGOS DO CAPIM" },
		{ value: "0730", label: "SAO FELIX DO XINGU" },
		{ value: "0740", label: "SAO FRANCISCO DO PARA" },
		{ value: "0745", label: "SAO GERALDO DO ARAGUAIA" },
		{ value: "0746", label: "SAO JOAO DA PONTA" },
		{ value: "0747", label: "SAO JOAO DE PIRABAS" },
		{ value: "0750", label: "SAO JOAO DO ARAGUAIA" },
		{ value: "0760", label: "SAO MIGUEL DO GUAMA" },
		{ value: "0770", label: "SAO SEBASTIAO DA BOA VISTA" },
		{ value: "0775", label: "SAPUCAIA" },
		{ value: "0780", label: "SENADOR JOSE PORFIRIO" },
		{ value: "0790", label: "SOURE" },
		{ value: "0795", label: "TAILANDIA" },
		{ value: "0796", label: "TERRA ALTA" },
		{ value: "0797", label: "TERRA SANTA" },
		{ value: "0800", label: "TOME-ACU" },
		{ value: "0803", label: "TRACUATEUA" },
		{ value: "0805", label: "TRAIRAO" },
		{ value: "0808", label: "TUCUMA" },
		{ value: "0810", label: "TUCURUI" },
		{ value: "0812", label: "ULIANOPOLIS" },
		{ value: "0815", label: "URUARA" },
		{ value: "0820", label: "VIGIA" },
		{ value: "0830", label: "VISEU" },
		{ value: "0835", label: "VITORIA DO XINGU" },
		{ value: "0840", label: "XINGUARA" },
	],
	AP: [
		{ value: "0010", label: "AMAPA" },
		{ value: "0020", label: "CALCOENE" },
		{ value: "0021", label: "CUTIAS" },
		{ value: "0023", label: "FERREIRA GOMES" },
		{ value: "0025", label: "ITAUBAL" },
		{ value: "0027", label: "LARANJAL DO JARI" },
		{ value: "0030", label: "MACAPA" },
		{ value: "0040", label: "MAZAGAO" },
		{ value: "0050", label: "OIAPOQUE" },
		{ value: "0015", label: "PEDRA BRANCA DO AMAPARI" },
		{ value: "0053", label: "PORTO GRANDE" },
		{ value: "0055", label: "PRACUUBA" },
		{ value: "0060", label: "SANTANA" },
		{ value: "0005", label: "SERRA DO NAVIO" },
		{ value: "0070", label: "TARTARUGALZINHO" },
		{ value: "0080", label: "VITORIA DO JARI" },
	],
	TO: [
		{ value: "0025", label: "ABREULANDIA" },
		{ value: "0030", label: "AGUIARNOPOLIS" },
		{ value: "0035", label: "ALIANCA DO TOCANTINS" },
		{ value: "0040", label: "ALMAS" },
		{ value: "0070", label: "ALVORADA" },
		{ value: "0100", label: "ANANAS" },
		{ value: "0105", label: "ANGICO" },
		{ value: "0110", label: "APARECIDA DO RIO NEGRO" },
		{ value: "0130", label: "ARAGOMINAS" },
		{ value: "0190", label: "ARAGUACEMA" },
		{ value: "0200", label: "ARAGUACU" },
		{ value: "0210", label: "ARAGUAINA" },
		{ value: "0215", label: "ARAGUANA" },
		{ value: "0220", label: "ARAGUATINS" },
		{ value: "0230", label: "ARAPOEMA" },
		{ value: "0240", label: "ARRAIAS" },
		{ value: "0255", label: "AUGUSTINOPOLIS" },
		{ value: "0270", label: "AURORA DO TOCANTINS" },
		{ value: "0290", label: "AXIXA DO TOCANTINS" },
		{ value: "0300", label: "BABACULANDIA" },
		{ value: "0305", label: "BANDEIRANTES DO TOCANTINS" },
		{ value: "0307", label: "BARRA DO OURO" },
		{ value: "0310", label: "BARROLANDIA" },
		{ value: "0320", label: "BERNARDO SAYAO" },
		{ value: "0330", label: "BOM JESUS DO TOCANTINS" },
		{ value: "0360", label: "BRASILANDIA DO TOCANTINS" },
		{ value: "0370", label: "BREJINHO DE NAZARE" },
		{ value: "0380", label: "BURITI DO TOCANTINS" },
		{ value: "0382", label: "CACHOEIRINHA" },
		{ value: "0384", label: "CAMPOS LINDOS" },
		{ value: "0386", label: "CARIRI DO TOCANTINS" },
		{ value: "0388", label: "CARMOLANDIA" },
		{ value: "0389", label: "CARRASCO BONITO" },
		{ value: "0390", label: "CASEARA" },
		{ value: "0410", label: "CENTENARIO" },
		{ value: "0510", label: "CHAPADA DA NATIVIDADE" },
		{ value: "0460", label: "CHAPADA DE AREIA" },
		{ value: "0550", label: "COLINAS DO TOCANTINS" },
		{ value: "1670", label: "COLMEIA" },
		{ value: "0555", label: "COMBINADO" },
		{ value: "0560", label: "CONCEICAO DO TOCANTINS" },
		{ value: "0000", label: "COUTO DE MAGALHAES" },
		{ value: "0600", label: "COUTO MAGALHAES" },
		{ value: "0610", label: "CRISTALANDIA" },
		{ value: "0625", label: "CRIXAS DO TOCANTINS" },
		{ value: "0650", label: "DARCINOPOLIS" },
		{ value: "0700", label: "DIANOPOLIS" },
		{ value: "0710", label: "DIVINOPOLIS DO TOCANTINS" },
		{ value: "0720", label: "DOIS IRMAOS DO TOCANTINS" },
		{ value: "0730", label: "DUERE" },
		{ value: "0740", label: "ESPERANTINA" },
		{ value: "0755", label: "FATIMA" },
		{ value: "0765", label: "FIGUEIROPOLIS" },
		{ value: "0770", label: "FILADELFIA" },
		{ value: "0820", label: "FORMOSO DO ARAGUAIA" },
		{ value: "0825", label: "FORTALEZA DO TABOCAO" },
		{ value: "0830", label: "GOIANORTE" },
		{ value: "0900", label: "GOIATINS" },
		{ value: "0930", label: "GUARAI" },
		{ value: "0950", label: "GURUPI" },
		{ value: "0980", label: "IPUEIRAS" },
		{ value: "1050", label: "ITACAJA" },
		{ value: "1070", label: "ITAGUATINS" },
		{ value: "1090", label: "ITAPIRATINS" },
		{ value: "1110", label: "ITAPORA DO TOCANTINS" },
		{ value: "1150", label: "JAU DO TOCANTINS" },
		{ value: "1180", label: "JUARINA" },
		{ value: "1190", label: "LAGOA DA CONFUSAO" },
		{ value: "1195", label: "LAGOA DO TOCANTINS" },
		{ value: "1200", label: "LAJEADO" },
		{ value: "1215", label: "LAVANDEIRA" },
		{ value: "1240", label: "LIZARDA" },
		{ value: "1245", label: "LUZINOPOLIS" },
		{ value: "1250", label: "MARIANOPOLIS DO TOCANTINS" },
		{ value: "1270", label: "MATEIROS" },
		{ value: "1280", label: "MAURILANDIA DO TOCANTINS" },
		{ value: "1320", label: "MIRACEMA DO TOCANTINS" },
		{ value: "1330", label: "MIRANORTE" },
		{ value: "1360", label: "MONTE DO CARMO" },
		{ value: "1370", label: "MONTE SANTO DO TOCANTINS" },
		{ value: "1395", label: "MURICILANDIA" },
		{ value: "1420", label: "NATIVIDADE" },
		{ value: "1430", label: "NAZARE" },
		{ value: "1488", label: "NOVA OLINDA" },
		{ value: "1500", label: "NOVA ROSALANDIA" },
		{ value: "1510", label: "NOVO ACORDO" },
		{ value: "1515", label: "NOVO ALEGRE" },
		{ value: "1525", label: "NOVO JARDIM" },
		{ value: "1550", label: "OLIVEIRA DE FATIMA" },
		{ value: "2100", label: "PALMAS" },
		{ value: "1570", label: "PALMEIRANTE" },
		{ value: "1380", label: "PALMEIRAS DO TOCANTINS" },
		{ value: "1575", label: "PALMEIROPOLIS" },
		{ value: "1610", label: "PARAISO DO TOCANTINS" },
		{ value: "1620", label: "PARANA" },
		{ value: "1630", label: "PAU D'ARCO" },
		{ value: "1650", label: "PEDRO AFONSO" },
		{ value: "1660", label: "PEIXE" },
		{ value: "1665", label: "PEQUIZEIRO" },
		{ value: "1700", label: "PINDORAMA DO TOCANTINS" },
		{ value: "1720", label: "PIRAQUE" },
		{ value: "1750", label: "PIUM" },
		{ value: "1780", label: "PONTE ALTA DO BOM JESUS" },
		{ value: "1790", label: "PONTE ALTA DO TOCANTINS" },
		{ value: "1800", label: "PORTO ALEGRE DO TOCANTINS" },
		{ value: "1820", label: "PORTO NACIONAL" },
		{ value: "1830", label: "PRAIA NORTE" },
		{ value: "1840", label: "PRESIDENTE KENNEDY" },
		{ value: "1845", label: "PUGMIL" },
		{ value: "1850", label: "RECURSOLANDIA" },
		{ value: "1855", label: "RIACHINHO" },
		{ value: "1865", label: "RIO DA CONCEICAO" },
		{ value: "1870", label: "RIO DOS BOIS" },
		{ value: "1875", label: "RIO SONO" },
		{ value: "1880", label: "SAMPAIO" },
		{ value: "1884", label: "SANDOLANDIA" },
		{ value: "1886", label: "SANTA FE DO ARAGUAIA" },
		{ value: "1888", label: "SANTA MARIA DO TOCANTINS" },
		{ value: "1889", label: "SANTA RITA DO TOCANTINS" },
		{ value: "1890", label: "SANTA ROSA DO TOCANTINS" },
		{ value: "1900", label: "SANTA TEREZA DO TOCANTINS" },
		{ value: "2000", label: "SANTA TEREZINHA DO TOCANTINS" },
		{ value: "2010", label: "SAO BENTO DO TOCANTINS" },
		{ value: "2015", label: "SAO FELIX DO TOCANTINS" },
		{ value: "2020", label: "SAO MIGUEL DO TOCANTINS" },
		{ value: "2025", label: "SAO SALVADOR DO TOCANTINS" },
		{ value: "2030", label: "SAO SEBASTIAO DO TOCANTINS" },
		{ value: "2049", label: "SAO VALERIO DA NATIVIDADE" },
		{ value: "2065", label: "SILVANOPOLIS" },
		{ value: "2080", label: "SITIO NOVO DO TOCANTINS" },
		{ value: "2085", label: "SUCUPIRA" },
		{ value: "2090", label: "TAGUATINGA" },
		{ value: "2093", label: "TAIPAS DO TOCANTINS" },
		{ value: "2097", label: "TALISMA" },
		{ value: "2110", label: "TOCANTINIA" },
		{ value: "2120", label: "TOCANTINOPOLIS" },
		{ value: "2125", label: "TUPIRAMA" },
		{ value: "2130", label: "TUPIRATINS" },
		{ value: "2208", label: "WANDERLANDIA" },
		{ value: "2210", label: "XAMBIOA" },
	],
	MA: [
		{ value: "0005", label: "ACAILANDIA" },
		{ value: "0010", label: "AFONSO CUNHA" },
		{ value: "0015", label: "AGUA DOCE DO MARANHAO" },
		{ value: "0020", label: "ALCANTARA" },
		{ value: "0030", label: "ALDEIAS ALTAS" },
		{ value: "0040", label: "ALTAMIRA DO MARANHAO" },
		{ value: "0043", label: "ALTO ALEGRE DO MARANHAO" },
		{ value: "0047", label: "ALTO ALEGRE DO PINDARE" },
		{ value: "0050", label: "ALTO PARNAIBA" },
		{ value: "0055", label: "AMAPA DO MARANHAO" },
		{ value: "0060", label: "AMARANTE DO MARANHAO" },
		{ value: "0070", label: "ANAJATUBA" },
		{ value: "0080", label: "ANAPURUS" },
		{ value: "0083", label: "APICUM-ACU" },
		{ value: "0087", label: "ARAGUANA" },
		{ value: "0090", label: "ARAIOSES" },
		{ value: "0095", label: "ARAME" },
		{ value: "0100", label: "ARARI" },
		{ value: "0110", label: "AXIXA" },
		{ value: "0120", label: "BACABAL" },
		{ value: "0125", label: "BACABEIRA" },
		{ value: "0130", label: "BACURI" },
		{ value: "0135", label: "BACURITUBA" },
		{ value: "0140", label: "BALSAS" },
		{ value: "0150", label: "BARAO DE GRAJAU" },
		{ value: "0160", label: "BARRA DO CORDA" },
		{ value: "0170", label: "BARREIRINHAS" },
		{ value: "0177", label: "BELA VISTA DO MARANHAO" },
		{ value: "0173", label: "BELAGUA" },
		{ value: "0180", label: "BENEDITO LEITE" },
		{ value: "0190", label: "BEQUIMAO" },
		{ value: "0193", label: "BERNARDO DO MEARIM" },
		{ value: "0197", label: "BOA VISTA DO GURUPI" },
		{ value: "0200", label: "BOM JARDIM" },
		{ value: "0203", label: "BOM JESUS DAS SELVAS" },
		{ value: "0207", label: "BOM LUGAR" },
		{ value: "0210", label: "BREJO" },
		{ value: "0215", label: "BREJO DE AREIA" },
		{ value: "0220", label: "BURITI" },
		{ value: "0230", label: "BURITI BRAVO" },
		{ value: "0232", label: "BURITICUPU" },
		{ value: "0235", label: "BURITIRANA" },
		{ value: "0237", label: "CACHOEIRA GRANDE" },
		{ value: "0240", label: "CAJAPIO" },
		{ value: "0250", label: "CAJARI" },
		{ value: "0255", label: "CAMPESTRE DO MARANHAO" },
		{ value: "0260", label: "CANDIDO MENDES" },
		{ value: "0270", label: "CANTANHEDE" },
		{ value: "0275", label: "CAPINZAL DO NORTE" },
		{ value: "0280", label: "CAROLINA" },
		{ value: "0290", label: "CARUTAPERA" },
		{ value: "0300", label: "CAXIAS" },
		{ value: "0310", label: "CEDRAL" },
		{ value: "0312", label: "CENTRAL DO MARANHAO" },
		{ value: "0315", label: "CENTRO DO GUILHERME" },
		{ value: "0317", label: "CENTRO NOVO DO MARANHAO" },
		{ value: "0320", label: "CHAPADINHA" },
		{ value: "0325", label: "CIDELANDIA" },
		{ value: "0330", label: "CODO" },
		{ value: "0340", label: "COELHO NETO" },
		{ value: "0350", label: "COLINAS" },
		{ value: "0355", label: "CONCEICAO DO LAGO-ACU" },
		{ value: "0360", label: "COROATA" },
		{ value: "0370", label: "CURURUPU" },
		{ value: "0375", label: "DAVINOPOLIS" },
		{ value: "0380", label: "DOM PEDRO" },
		{ value: "0390", label: "DUQUE BACELAR" },
		{ value: "0400", label: "ESPERANTINOPOLIS" },
		{ value: "0405", label: "ESTREITO" },
		{ value: "0407", label: "FEIRA NOVA DO MARANHAO" },
		{ value: "0408", label: "FERNANDO FALCAO" },
		{ value: "0409", label: "FORMOSA DA SERRA NEGRA" },
		{ value: "0410", label: "FORTALEZA DOS NOGUEIRAS" },
		{ value: "0420", label: "FORTUNA" },
		{ value: "0430", label: "GODOFREDO VIANA" },
		{ value: "0440", label: "GONCALVES DIAS" },
		{ value: "0450", label: "GOVERNADOR ARCHER" },
		{ value: "0455", label: "GOVERNADOR EDISON LOBAO" },
		{ value: "0460", label: "GOVERNADOR EUGENIO BARROS" },
		{ value: "0462", label: "GOVERNADOR LUIZ ROCHA" },
		{ value: "0465", label: "GOVERNADOR NEWTON BELLO" },
		{ value: "0467", label: "GOVERNADOR NUNES FREIRE" },
		{ value: "0470", label: "GRACA ARANHA" },
		{ value: "0480", label: "GRAJAU" },
		{ value: "0490", label: "GUIMARAES" },
		{ value: "0500", label: "HUMBERTO DE CAMPOS" },
		{ value: "0510", label: "ICATU" },
		{ value: "0515", label: "IGARAPE DO MEIO" },
		{ value: "0520", label: "IGARAPE GRANDE" },
		{ value: "0530", label: "IMPERATRIZ" },
		{ value: "0535", label: "ITAIPAVA DO GRAJAU" },
		{ value: "0540", label: "ITAPECURU MIRIM" },
		{ value: "0542", label: "ITINGA DO MARANHAO" },
		{ value: "0545", label: "JATOBA" },
		{ value: "0547", label: "JENIPAPO DOS VIEIRAS" },
		{ value: "0550", label: "JOAO LISBOA" },
		{ value: "0560", label: "JOSELANDIA" },
		{ value: "0565", label: "JUNCO DO MARANHAO" },
		{ value: "0570", label: "LAGO DA PEDRA" },
		{ value: "0580", label: "LAGO DO JUNCO" },
		{ value: "0594", label: "LAGO DOS RODRIGUES" },
		{ value: "0590", label: "LAGO VERDE" },
		{ value: "0592", label: "LAGOA DO MATO" },
		{ value: "0596", label: "LAGOA GRANDE DO MARANHAO" },
		{ value: "0598", label: "LAJEADO NOVO" },
		{ value: "0600", label: "LIMA CAMPOS" },
		{ value: "0610", label: "LORETO" },
		{ value: "0620", label: "LUIS DOMINGUES" },
		{ value: "0630", label: "MAGALHAES DE ALMEIDA" },
		{ value: "0632", label: "MARACACUME" },
		{ value: "0635", label: "MARAJA DO SENA" },
		{ value: "0637", label: "MARANHAOZINHO" },
		{ value: "0640", label: "MATA ROMA" },
		{ value: "0650", label: "MATINHA" },
		{ value: "0660", label: "MATOES" },
		{ value: "0663", label: "MATOES DO NORTE" },
		{ value: "0667", label: "MILAGRES DO MARANHAO" },
		{ value: "0670", label: "MIRADOR" },
		{ value: "0675", label: "MIRANDA DO NORTE" },
		{ value: "0680", label: "MIRINZAL" },
		{ value: "0690", label: "MONCAO" },
		{ value: "0700", label: "MONTES ALTOS" },
		{ value: "0710", label: "MORROS" },
		{ value: "0720", label: "NINA RODRIGUES" },
		{ value: "0725", label: "NOVA COLINAS" },
		{ value: "0730", label: "NOVA IORQUE" },
		{ value: "0735", label: "NOVA OLINDA DO MARANHAO" },
		{ value: "0740", label: "OLHO D'AGUA DAS CUNHAS" },
		{ value: "0745", label: "OLINDA NOVA DO MARANHAO" },
		{ value: "0750", label: "PACO DO LUMIAR" },
		{ value: "0760", label: "PALMEIRANDIA" },
		{ value: "0770", label: "PARAIBANO" },
		{ value: "0780", label: "PARNARAMA" },
		{ value: "0790", label: "PASSAGEM FRANCA" },
		{ value: "0800", label: "PASTOS BONS" },
		{ value: "0805", label: "PAULINO NEVES" },
		{ value: "0810", label: "PAULO RAMOS" },
		{ value: "0820", label: "PEDREIRAS" },
		{ value: "0825", label: "PEDRO DO ROSARIO" },
		{ value: "0830", label: "PENALVA" },
		{ value: "0840", label: "PERI MIRIM" },
		{ value: "0845", label: "PERITORO" },
		{ value: "0000", label: "PINDARE MIRIM" },
		{ value: "0850", label: "PINDARE-MIRIM" },
		{ value: "0860", label: "PINHEIRO" },
		{ value: "0870", label: "PIO XII" },
		{ value: "0880", label: "PIRAPEMAS" },
		{ value: "0890", label: "POCAO DE PEDRAS" },
		{ value: "0900", label: "PORTO FRANCO" },
		{ value: "0905", label: "PORTO RICO DO MARANHAO" },
		{ value: "0910", label: "PRESIDENTE DUTRA" },
		{ value: "0920", label: "PRESIDENTE JUSCELINO" },
		{ value: "0923", label: "PRESIDENTE MEDICI" },
		{ value: "0927", label: "PRESIDENTE SARNEY" },
		{ value: "0930", label: "PRESIDENTE VARGAS" },
		{ value: "0940", label: "PRIMEIRA CRUZ" },
		{ value: "0945", label: "RAPOSA" },
		{ value: "0950", label: "RIACHAO" },
		{ value: "0955", label: "RIBAMAR FIQUENE" },
		{ value: "0960", label: "ROSARIO" },
		{ value: "0970", label: "SAMBAIBA" },
		{ value: "0975", label: "SANTA FILOMENA DO MARANHAO" },
		{ value: "0980", label: "SANTA HELENA" },
		{ value: "0990", label: "SANTA INES" },
		{ value: "1000", label: "SANTA LUZIA" },
		{ value: "1003", label: "SANTA LUZIA DO PARUA" },
		{ value: "1010", label: "SANTA QUITERIA DO MARANHAO" },
		{ value: "1020", label: "SANTA RITA" },
		{ value: "1023", label: "SANTANA DO MARANHAO" },
		{ value: "1027", label: "SANTO AMARO DO MARANHAO" },
		{ value: "1030", label: "SANTO ANTONIO DOS LOPES" },
		{ value: "1040", label: "SAO BENEDITO DO RIO PRETO" },
		{ value: "1050", label: "SAO BENTO" },
		{ value: "1060", label: "SAO BERNARDO" },
		{ value: "1065", label: "SAO DOMINGOS DO AZEITAO" },
		{ value: "1070", label: "SAO DOMINGOS DO MARANHAO" },
		{ value: "1080", label: "SAO FELIX DE BALSAS" },
		{ value: "1085", label: "SAO FRANCISCO DO BREJAO" },
		{ value: "1090", label: "SAO FRANCISCO DO MARANHAO" },
		{ value: "1100", label: "SAO JOAO BATISTA" },
		{ value: "1102", label: "SAO JOAO DO CARU" },
		{ value: "1105", label: "SAO JOAO DO PARAISO" },
		{ value: "1107", label: "SAO JOAO DO SOTER" },
		{ value: "1110", label: "SAO JOAO DOS PATOS" },
		{ value: "1120", label: "SAO JOSE DE RIBAMAR" },
		{ value: "1125", label: "SAO JOSE DOS BASILIOS" },
		{ value: "1130", label: "SAO LUIS" },
		{ value: "1140", label: "SAO LUIS GONZAGA DO MARANHAO" },
		{ value: "1150", label: "SAO MATEUS DO MARANHAO" },
		{ value: "1153", label: "SAO PEDRO DA AGUA BRANCA" },
		{ value: "1157", label: "SAO PEDRO DOS CRENTES" },
		{ value: "1160", label: "SAO RAIMUNDO DAS MANGABEIRAS" },
		{ value: "1163", label: "SAO RAIMUNDO DO DOCA BEZERRA" },
		{ value: "1167", label: "SAO ROBERTO" },
		{ value: "1170", label: "SAO VICENTE FERRER" },
		{ value: "1172", label: "SATUBINHA" },
		{ value: "1174", label: "SENADOR ALEXANDRE COSTA" },
		{ value: "1176", label: "SENADOR LA ROCQUE" },
		{ value: "1178", label: "SERRANO DO MARANHAO" },
		{ value: "1180", label: "SITIO NOVO" },
		{ value: "1190", label: "SUCUPIRA DO NORTE" },
		{ value: "1195", label: "SUCUPIRA DO RIACHAO" },
		{ value: "1200", label: "TASSO FRAGOSO" },
		{ value: "1210", label: "TIMBIRAS" },
		{ value: "1220", label: "TIMON" },
		{ value: "1223", label: "TRIZIDELA DO VALE" },
		{ value: "1227", label: "TUFILANDIA" },
		{ value: "1230", label: "TUNTUM" },
		{ value: "1240", label: "TURIACU" },
		{ value: "1245", label: "TURILANDIA" },
		{ value: "1250", label: "TUTOIA" },
		{ value: "1260", label: "URBANO SANTOS" },
		{ value: "1270", label: "VARGEM GRANDE" },
		{ value: "1280", label: "VIANA" },
		{ value: "1285", label: "VILA NOVA DOS MARTIRIOS" },
		{ value: "1290", label: "VITORIA DO MEARIM" },
		{ value: "1300", label: "VITORINO FREIRE" },
		{ value: "1400", label: "ZE DOCA" },
	],
	PI: [
		{ value: "0005", label: "ACAUA" },
		{ value: "0010", label: "AGRICOLANDIA" },
		{ value: "0020", label: "AGUA BRANCA" },
		{ value: "0025", label: "ALAGOINHA DO PIAUI" },
		{ value: "0027", label: "ALEGRETE DO PIAUI" },
		{ value: "0030", label: "ALTO LONGA" },
		{ value: "0040", label: "ALTOS" },
		{ value: "0045", label: "ALVORADA DO GURGUEIA" },
		{ value: "0050", label: "AMARANTE" },
		{ value: "0060", label: "ANGICAL DO PIAUI" },
		{ value: "0070", label: "ANISIO DE ABREU" },
		{ value: "0080", label: "ANTONIO ALMEIDA" },
		{ value: "0090", label: "AROAZES" },
		{ value: "0095", label: "AROEIRAS DO ITAIM" },
		{ value: "0100", label: "ARRAIAL" },
		{ value: "0105", label: "ASSUNCAO DO PIAUI" },
		{ value: "0110", label: "AVELINO LOPES" },
		{ value: "0115", label: "BAIXA GRANDE DO RIBEIRO" },
		{ value: "0117", label: "BARRA D'ALCANTARA" },
		{ value: "0120", label: "BARRAS" },
		{ value: "0130", label: "BARREIRAS DO PIAUI" },
		{ value: "0140", label: "BARRO DURO" },
		{ value: "0150", label: "BATALHA" },
		{ value: "0155", label: "BELA VISTA DO PIAUI" },
		{ value: "0157", label: "BELEM DO PIAUI" },
		{ value: "0160", label: "BENEDITINOS" },
		{ value: "0170", label: "BERTOLINIA" },
		{ value: "0173", label: "BETANIA DO PIAUI" },
		{ value: "0177", label: "BOA HORA" },
		{ value: "0180", label: "BOCAINA" },
		{ value: "0190", label: "BOM JESUS" },
		{ value: "0191", label: "BOM PRINCIPIO DO PIAUI" },
		{ value: "0192", label: "BONFIM DO PIAUI" },
		{ value: "0194", label: "BOQUEIRAO DO PIAUI" },
		{ value: "0196", label: "BRASILEIRA" },
		{ value: "0198", label: "BREJO DO PIAUI" },
		{ value: "0200", label: "BURITI DOS LOPES" },
		{ value: "0202", label: "BURITI DOS MONTES" },
		{ value: "0205", label: "CABECEIRAS DO PIAUI" },
		{ value: "0207", label: "CAJAZEIRAS DO PIAUI" },
		{ value: "0208", label: "CAJUEIRO DA PRAIA" },
		{ value: "0209", label: "CALDEIRAO GRANDE DO PIAUI" },
		{ value: "0210", label: "CAMPINAS DO PIAUI" },
		{ value: "0211", label: "CAMPO ALEGRE DO FIDALGO" },
		{ value: "0213", label: "CAMPO GRANDE DO PIAUI" },
		{ value: "0217", label: "CAMPO LARGO DO PIAUI" },
		{ value: "0220", label: "CAMPO MAIOR" },
		{ value: "0225", label: "CANAVIEIRA" },
		{ value: "0230", label: "CANTO DO BURITI" },
		{ value: "0240", label: "CAPITAO DE CAMPOS" },
		{ value: "0245", label: "CAPITAO GERVASIO OLIVEIRA" },
		{ value: "0250", label: "CARACOL" },
		{ value: "0253", label: "CARAUBAS DO PIAUI" },
		{ value: "0255", label: "CARIDADE DO PIAUI" },
		{ value: "0260", label: "CASTELO DO PIAUI" },
		{ value: "0265", label: "CAXINGO" },
		{ value: "0270", label: "COCAL" },
		{ value: "0271", label: "COCAL DE TELHA" },
		{ value: "0272", label: "COCAL DOS ALVES" },
		{ value: "0273", label: "COIVARAS" },
		{ value: "0275", label: "COLONIA DO GURGUEIA" },
		{ value: "0277", label: "COLONIA DO PIAUI" },
		{ value: "0280", label: "CONCEICAO DO CANINDE" },
		{ value: "0285", label: "CORONEL JOSE DIAS" },
		{ value: "0290", label: "CORRENTE" },
		{ value: "0300", label: "CRISTALANDIA DO PIAUI" },
		{ value: "0310", label: "CRISTINO CASTRO" },
		{ value: "0320", label: "CURIMATA" },
		{ value: "0323", label: "CURRAIS" },
		{ value: "0327", label: "CURRAL NOVO DO PIAUI" },
		{ value: "0325", label: "CURRALINHOS" },
		{ value: "0330", label: "DEMERVAL LOBAO" },
		{ value: "0335", label: "DIRCEU ARCOVERDE" },
		{ value: "0340", label: "DOM EXPEDITO LOPES" },
		{ value: "0345", label: "DOM INOCENCIO" },
		{ value: "0342", label: "DOMINGOS MOURAO" },
		{ value: "0350", label: "ELESBAO VELOSO" },
		{ value: "0360", label: "ELISEU MARTINS" },
		{ value: "0370", label: "ESPERANTINA" },
		{ value: "0375 ", label: "FARTURA DO PIAUI" },
		{ value: "0380 ", label: "FLORES DO PIAUI" },
		{ value: "0385 ", label: "FLORESTA DO PIAUI" },
		{ value: "0390 ", label: "FLORIANO" },
		{ value: "0400 ", label: "FRANCINOPOLIS" },
		{ value: "0410 ", label: "FRANCISCO AYRES" },
		{ value: "0415 ", label: "FRANCISCO MACEDO" },
		{ value: "0420 ", label: "FRANCISCO SANTOS" },
		{ value: "0430 ", label: "FRONTEIRAS" },
		{ value: "0435 ", label: "GEMINIANO" },
		{ value: "0440 ", label: "GILBUES" },
		{ value: "0450 ", label: "GUADALUPE" },
		{ value: "0455 ", label: "GUARIBAS" },
		{ value: "0460 ", label: "HUGO NAPOLEAO" },
		{ value: "0465 ", label: "ILHA GRANDE" },
		{ value: "0470 ", label: "INHUMA" },
		{ value: "0480 ", label: "IPIRANGA DO PIAUI" },
		{ value: "0490 ", label: "ISAIAS COELHO" },
		{ value: "0500 ", label: "ITAINOPOLIS" },
		{ value: "0510 ", label: "ITAUEIRA" },
		{ value: "0515 ", label: "JACOBINA DO PIAUI" },
		{ value: "0520 ", label: "JAICOS" },
		{ value: "0525 ", label: "JARDIM DO MULATO" },
		{ value: "0527 ", label: "JATOBA DO PIAUI" },
		{ value: "0530 ", label: "JERUMENHA" },
		{ value: "0535 ", label: "JOAO COSTA" },
		{ value: "0540 ", label: "JOAQUIM PIRES" },
		{ value: "0545 ", label: "JOCA MARQUES" },
		{ value: "0550 ", label: "JOSE DE FREITAS" },
		{ value: "0551 ", label: "JUAZEIRO DO PIAUI" },
		{ value: "0552 ", label: "JULIO BORGES" },
		{ value: "0553 ", label: "JUREMA" },
		{ value: "0555 ", label: "LAGOA ALEGRE" },
		{ value: "0557 ", label: "LAGOA DE SAO FRANCISCO" },
		{ value: "0556 ", label: "LAGOA DO BARRO DO PIAUI" },
		{ value: "0558 ", label: "LAGOA DO PIAUI" },
		{ value: "0559 ", label: "LAGOA DO SITIO" },
		{ value: "0554 ", label: "LAGOINHA DO PIAUI" },
		{ value: "0560 ", label: "LANDRI SALES" },
		{ value: "0570 ", label: "LUIS CORREIA" },
		{ value: "0580 ", label: "LUZILANDIA" },
		{ value: "0585 ", label: "MADEIRO" },
		{ value: "0590 ", label: "MANOEL EMIDIO" },
		{ value: "0595 ", label: "MARCOLANDIA" },
		{ value: "0600 ", label: "MARCOS PARENTE" },
		{ value: "0605 ", label: "MASSAPE DO PIAUI" },
		{ value: "0610 ", label: "MATIAS OLIMPIO" },
		{ value: "0620 ", label: "MIGUEL ALVES" },
		{ value: "0630 ", label: "MIGUEL LEAO" },
		{ value: "0635 ", label: "MILTON BRANDAO" },
		{ value: "0640 ", label: "MONSENHOR GIL" },
		{ value: "0650 ", label: "MONSENHOR HIPOLITO" },
		{ value: "0660 ", label: "MONTE ALEGRE DO PIAUI" },
		{ value: "0665 ", label: "MORRO CABECA NO TEMPO" },
		{ value: "0667 ", label: "MORRO DO CHAPEU DO PIAUI" },
		{ value: "0669 ", label: "MURICI DOS PORTELAS" },
		{ value: "0670 ", label: "NAZARE DO PIAUI" },
		{ value: "0672 ", label: "NAZARIA" },
		{ value: "0675 ", label: "NOSSA SENHORA DE NAZARE" },
		{ value: "0680 ", label: "NOSSA SENHORA DOS REMEDIOS" },
		{ value: "0795 ", label: "NOVA SANTA RITA" },
		{ value: "0690 ", label: "NOVO ORIENTE DO PIAUI" },
		{ value: "0695 ", label: "NOVO SANTO ANTONIO" },
		{ value: "0700 ", label: "OEIRAS" },
		{ value: "0710 ", label: "OLHO D'AGUA DO PIAUI" },
		{ value: "0720 ", label: "PADRE MARCOS" },
		{ value: "0730 ", label: "PAES LANDIM" },
		{ value: "0735 ", label: "PAJEU DO PIAUI" },
		{ value: "0740 ", label: "PALMEIRA DO PIAUI" },
		{ value: "0750 ", label: "PALMEIRAIS" },
		{ value: "0755", label: "PAQUETA" },
		{ value: "0760", label: "PARNAGUA" },
		{ value: "0770", label: "PARNAIBA" },
		{ value: "0775", label: "PASSAGEM FRANCA DO PIAUI" },
		{ value: "0777", label: "PATOS DO PIAUI" },
		{ value: "0779", label: "PAU D'ARCO DO PIAUI" },
		{ value: "0780", label: "PAULISTANA" },
		{ value: "0785", label: "PAVUSSU" },
		{ value: "0790", label: "PEDRO II" },
		{ value: "0793", label: "PEDRO LAURENTINO" },
		{ value: "0800", label: "PICOS" },
		{ value: "0810", label: "PIMENTEIRAS" },
		{ value: "0820", label: "PIO IX" },
		{ value: "0830", label: "PIRACURUCA" },
		{ value: "0840", label: "PIRIPIRI" },
		{ value: "0850", label: "PORTO" },
		{ value: "0855", label: "PORTO ALEGRE DO PIAUI" },
		{ value: "0860", label: "PRATA DO PIAUI" },
		{ value: "0865", label: "QUEIMADA NOVA" },
		{ value: "0870", label: "REDENCAO DO GURGUEIA" },
		{ value: "0880", label: "REGENERACAO" },
		{ value: "0885", label: "RIACHO FRIO" },
		{ value: "0887", label: "RIBEIRA DO PIAUI" },
		{ value: "0890", label: "RIBEIRO GONCALVES" },
		{ value: "0900", label: "RIO GRANDE DO PIAUI" },
		{ value: "0910", label: "SANTA CRUZ DO PIAUI" },
		{ value: "0915", label: "SANTA CRUZ DOS MILAGRES" },
		{ value: "0920", label: "SANTA FILOMENA" },
		{ value: "0930", label: "SANTA LUZ" },
		{ value: "0937", label: "SANTA ROSA DO PIAUI" },
		{ value: "0935", label: "SANTANA DO PIAUI" },
		{ value: "0940", label: "SANTO ANTONIO DE LISBOA" },
		{ value: "0945", label: "SANTO ANTONIO DOS MILAGRES" },
		{ value: "0950", label: "SANTO INACIO DO PIAUI" },
		{ value: "0955", label: "SAO BRAZ DO PIAUI" },
		{ value: "0960", label: "SAO FELIX DO PIAUI" },
		{ value: "0965", label: "SAO FRANCISCO DE ASSIS DO PIAUI" },
		{ value: "0970", label: "SAO FRANCISCO DO PIAUI" },
		{ value: "0975", label: "SAO GONCALO DO GURGUEIA" },
		{ value: "0980", label: "SAO GONCALO DO PIAUI" },
		{ value: "0985", label: "SAO JOAO DA CANABRAVA" },
		{ value: "0987", label: "SAO JOAO DA FRONTEIRA" },
		{ value: "0990", label: "SAO JOAO DA SERRA" },
		{ value: "0995", label: "SAO JOAO DA VARJOTA" },
		{ value: "0997", label: "SAO JOAO DO ARRAIAL" },
		{ value: "1000", label: "SAO JOAO DO PIAUI" },
		{ value: "1005", label: "SAO JOSE DO DIVINO" },
		{ value: "1010", label: "SAO JOSE DO PEIXE" },
		{ value: "1020", label: "SAO JOSE DO PIAUI" },
		{ value: "1030", label: "SAO JULIAO" },
		{ value: "1035", label: "SAO LOURENCO DO PIAUI" },
		{ value: "1037", label: "SAO LUIS DO PIAUI" },
		{ value: "1038", label: "SAO MIGUEL DA BAIXA GRANDE" },
		{ value: "1039", label: "SAO MIGUEL DO FIDALGO" },
		{ value: "1040", label: "SAO MIGUEL DO TAPUIO" },
		{ value: "1050", label: "SAO PEDRO DO PIAUI" },
		{ value: "1060", label: "SAO RAIMUNDO NONATO" },
		{ value: "1062", label: "SEBASTIAO BARROS" },
		{ value: "1063", label: "SEBASTIAO LEAL" },
		{ value: "1065", label: "SIGEFREDO PACHECO" },
		{ value: "1070", label: "SIMOES" },
		{ value: "1080", label: "SIMPLICIO MENDES" },
		{ value: "1090", label: "SOCORRO DO PIAUI" },
		{ value: "1093", label: "SUSSUAPARA" },
		{ value: "1095", label: "TAMBORIL DO PIAUI" },
		{ value: "1097", label: "TANQUE DO PIAUI" },
		{ value: "1100", label: "TERESINA" },
		{ value: "1110", label: "UNIAO" },
		{ value: "1120", label: "URUCUI" },
		{ value: "1130", label: "VALENCA DO PIAUI" },
		{ value: "1135", label: "VARZEA BRANCA" },
		{ value: "1140", label: "VARZEA GRANDE" },
		{ value: "1150", label: "VERA MENDES" },
		{ value: "1160", label: "VILA NOVA DO PIAUI" },
		{ value: "1170", label: "WALL FERRAZ" },
	],
	CE: [
		{ value: "0010", label: "ABAIARA" },
		{ value: "0015", label: "ACARAPE" },
		{ value: "0020", label: "ACARAU" },
		{ value: "0030", label: "ACOPIARA" },
		{ value: "0040", label: "AIUABA" },
		{ value: "0050", label: "ALCANTARAS" },
		{ value: "0060", label: "ALTANEIRA" },
		{ value: "0070", label: "ALTO SANTO" },
		{ value: "0075", label: "AMONTADA" },
		{ value: "0080", label: "ANTONINA DO NORTE" },
		{ value: "0090", label: "APUIARES" },
		{ value: "0100", label: "AQUIRAZ" },
		{ value: "0110", label: "ARACATI" },
		{ value: "0120", label: "ARACOIABA" },
		{ value: "0125", label: "ARARENDA" },
		{ value: "0130", label: "ARARIPE" },
		{ value: "0140", label: "ARATUBA" },
		{ value: "0150", label: "ARNEIROZ" },
		{ value: "0160", label: "ASSARE" },
		{ value: "0170", label: "AURORA" },
		{ value: "0180", label: "BAIXIO" },
		{ value: "0185", label: "BANABUIU" },
		{ value: "0190", label: "BARBALHA" },
		{ value: "0195", label: "BARREIRA" },
		{ value: "0200", label: "BARRO" },
		{ value: "0205", label: "BARROQUINHA" },
		{ value: "0210", label: "BATURITE" },
		{ value: "0220", label: "BEBERIBE" },
		{ value: "0230", label: "BELA CRUZ" },
		{ value: "0240", label: "BOA VIAGEM" },
		{ value: "0250", label: "BREJO SANTO" },
		{ value: "0260", label: "CAMOCIM" },
		{ value: "0270", label: "CAMPOS SALES" },
		{ value: "0280", label: "CANINDE" },
		{ value: "0290", label: "CAPISTRANO" },
		{ value: "0300", label: "CARIDADE" },
		{ value: "0310", label: "CARIRE" },
		{ value: "0320", label: "CARIRIACU" },
		{ value: "0330", label: "CARIUS" },
		{ value: "0340", label: "CARNAUBAL" },
		{ value: "0350", label: "CASCAVEL" },
		{ value: "0360", label: "CATARINA" },
		{ value: "0365", label: "CATUNDA" },
		{ value: "0370", label: "CAUCAIA" },
		{ value: "0380", label: "CEDRO" },
		{ value: "0390", label: "CHAVAL" },
		{ value: "0393", label: "CHORO" },
		{ value: "0395", label: "CHOROZINHO" },
		{ value: "0400", label: "COREAU" },
		{ value: "0410", label: "CRATEUS" },
		{ value: "0420", label: "CRATO" },
		{ value: "0423", label: "CROATA" },
		{ value: "0425", label: "CRUZ" },
		{ value: "0426", label: "DEPUTADO IRAPUAN PINHEIRO" },
		{ value: "0427", label: "ERERE" },
		{ value: "0428", label: "EUSEBIO" },
		{ value: "0430", label: "FARIAS BRITO" },
		{ value: "0435", label: "FORQUILHA" },
		{ value: "0440", label: "FORTALEZA" },
		{ value: "0445", label: "FORTIM" },
		{ value: "0450", label: "FRECHEIRINHA" },
		{ value: "0460", label: "GENERAL SAMPAIO" },
		{ value: "0465", label: "GRACA" },
		{ value: "0470", label: "GRANJA" },
		{ value: "0480", label: "GRANJEIRO" },
		{ value: "0490", label: "GROAIRAS" },
		{ value: "0495", label: "GUAIUBA" },
		{ value: "0500", label: "GUARACIABA DO NORTE" },
		{ value: "0510", label: "GUARAMIRANGA" },
		{ value: "0520", label: "HIDROLANDIA" },
		{ value: "0523", label: "HORIZONTE" },
		{ value: "0526", label: "IBARETAMA" },
		{ value: "0530", label: "IBIAPINA" },
		{ value: "0533", label: "IBICUITINGA" },
		{ value: "0535", label: "ICAPUI" },
		{ value: "0540", label: "ICO" },
		{ value: "0550", label: "IGUATU" },
		{ value: "0560", label: "INDEPENDENCIA" },
		{ value: "0565", label: "IPAPORANGA" },
		{ value: "0570", label: "IPAUMIRIM" },
		{ value: "0580", label: "IPU" },
		{ value: "0590", label: "IPUEIRAS" },
		{ value: "0600", label: "IRACEMA" },
		{ value: "0610", label: "IRAUCUBA" },
		{ value: "0620", label: "ITAICABA" },
		{ value: "0625", label: "ITAITINGA" },
		{ value: "0630", label: "ITAPAJE" },
		{ value: "0640", label: "ITAPIPOCA" },
		{ value: "0650", label: "ITAPIUNA" },
		{ value: "0655", label: "ITAREMA" },
		{ value: "0660", label: "ITATIRA" },
		{ value: "0670", label: "JAGUARETAMA" },
		{ value: "0680", label: "JAGUARIBARA" },
		{ value: "0690", label: "JAGUARIBE" },
		{ value: "0700", label: "JAGUARUANA" },
		{ value: "0710", label: "JARDIM" },
		{ value: "0720", label: "JATI" },
		{ value: "0725", label: "JIJOCA DE JERICOACOARA" },
		{ value: "0730", label: "JUAZEIRO DO NORTE" },
		{ value: "0740", label: "JUCAS" },
		{ value: "0750", label: "LAVRAS DA MANGABEIRA" },
		{ value: "0760", label: "LIMOEIRO DO NORTE" },
		{ value: "0763", label: "MADALENA" },
		{ value: "0765", label: "MARACANAU" },
		{ value: "0770", label: "MARANGUAPE" },
		{ value: "0780", label: "MARCO" },
		{ value: "0790", label: "MARTINOPOLE" },
		{ value: "0800", label: "MASSAPE" },
		{ value: "0810", label: "MAURITI" },
		{ value: "0820", label: "MERUOCA" },
		{ value: "0830", label: "MILAGRES" },
		{ value: "0835", label: "MILHA" },
		{ value: "0837", label: "MIRAIMA" },
		{ value: "0840", label: "MISSAO VELHA" },
		{ value: "0850", label: "MOMBACA" },
		{ value: "0860", label: "MONSENHOR TABOSA" },
		{ value: "0870", label: "MORADA NOVA" },
		{ value: "0880", label: "MORAUJO" },
		{ value: "0890", label: "MORRINHOS" },
		{ value: "0900", label: "MUCAMBO" },
		{ value: "0910", label: "MULUNGU" },
		{ value: "0920", label: "NOVA OLINDA" },
		{ value: "0930", label: "NOVA RUSSAS" },
		{ value: "0940", label: "NOVO ORIENTE" },
		{ value: "0945", label: "OCARA" },
		{ value: "0950", label: "OROS" },
		{ value: "0960", label: "PACAJUS" },
		{ value: "0970", label: "PACATUBA" },
		{ value: "0980", label: "PACOTI" },
		{ value: "0990", label: "PACUJA" },
		{ value: "1000", label: "PALHANO" },
		{ value: "1010", label: "PALMACIA" },
		{ value: "1020", label: "PARACURU" },
		{ value: "1025", label: "PARAIPABA" },
		{ value: "1030", label: "PARAMBU" },
		{ value: "1040", label: "PARAMOTI" },
		{ value: "1050", label: "PEDRA BRANCA" },
		{ value: "1060", label: "PENAFORTE" },
		{ value: "1070", label: "PENTECOSTE" },
		{ value: "1080", label: "PEREIRO" },
		{ value: "1085", label: "PINDORETAMA" },
		{ value: "1090", label: "PIQUET CARNEIRO" },
		{ value: "1095", label: "PIRES FERREIRA" },
		{ value: "1100", label: "PORANGA" },
		{ value: "1110", label: "PORTEIRAS" },
		{ value: "1120", label: "POTENGI" },
		{ value: "1123", label: "POTIRETAMA" },
		{ value: "1126", label: "QUITERIANOPOLIS" },
		{ value: "1130", label: "QUIXADA" },
		{ value: "1135", label: "QUIXELO" },
		{ value: "1140", label: "QUIXERAMOBIM" },
		{ value: "1150", label: "QUIXERE" },
		{ value: "1160", label: "REDENCAO" },
		{ value: "1170", label: "RERIUTABA" },
		{ value: "1180", label: "RUSSAS" },
		{ value: "1190", label: "SABOEIRO" },
		{ value: "1195", label: "SALITRE" },
		{ value: "1220", label: "SANTA QUITERIA" },
		{ value: "1200", label: "SANTANA DO ACARAU" },
		{ value: "1210", label: "SANTANA DO CARIRI" },
		{ value: "1230", label: "SAO BENEDITO" },
		{ value: "1240", label: "SAO GONCALO DO AMARANTE" },
		{ value: "1250", label: "SAO JOAO DO JAGUARIBE" },
		{ value: "1260", label: "SAO LUIS DO CURU" },
		{ value: "1270", label: "SENADOR POMPEU" },
		{ value: "1280", label: "SENADOR SA" },
		{ value: "1290", label: "SOBRAL" },
		{ value: "1300", label: "SOLONOPOLE" },
		{ value: "1310", label: "TABULEIRO DO NORTE" },
		{ value: "1320", label: "TAMBORIL" },
		{ value: "1325", label: "TARRAFAS" },
		{ value: "1330", label: "TAUA" },
		{ value: "1335", label: "TEJUCUOCA" },
		{ value: "1340", label: "TIANGUA" },
		{ value: "1350", label: "TRAIRI" },
		{ value: "1355", label: "TURURU" },
		{ value: "1360", label: "UBAJARA" },
		{ value: "1370", label: "UMARI" },
		{ value: "1375", label: "UMIRIM" },
		{ value: "1380", label: "URUBURETAMA" },
		{ value: "1390", label: "URUOCA" },
		{ value: "1395", label: "VARJOTA" },
		{ value: "1400", label: "VARZEA ALEGRE" },
		{ value: "1410", label: "VICOSA DO CEARA" },
	],
	RN: [
		{ value: "0010", label: "ACARI" },
		{ value: "0020", label: "ACU" },
		{ value: "0030", label: "AFONSO BEZERRA" },
		{ value: "0040", label: "AGUA NOVA" },
		{ value: "0050", label: "ALEXANDRIA" },
		{ value: "0060", label: "ALMINO AFONSO" },
		{ value: "0070", label: "ALTO DO RODRIGUES" },
		{ value: "0080", label: "ANGICOS" },
		{ value: "0090", label: "ANTONIO MARTINS" },
		{ value: "0100", label: "APODI" },
		{ value: "0110", label: "AREIA BRANCA" },
		{ value: "0120", label: "ARES" },
		{ value: "0000", label: "AREZ" },
		{ value: "0140", label: "BAIA FORMOSA" },
		{ value: "0145", label: "BARAUNA" },
		{ value: "0150", label: "BARCELONA" },
		{ value: "0160", label: "BENTO FERNANDES" },
		{ value: "0000", label: "BOA SAUDE" },
		{ value: "0165", label: "BODO" },
		{ value: "0170", label: "BOM JESUS" },
		{ value: "0180", label: "BREJINHO" },
		{ value: "0185", label: "CAICARA DO NORTE" },
		{ value: "0190", label: "CAICARA DO RIO DO VENTO" },
		{ value: "0200", label: "CAICO" },
		{ value: "0000", label: "CAMPO GRANDE" },
		{ value: "0130", label: "CAMPO GRANDE" },
		{ value: "0210", label: "CAMPO REDONDO" },
		{ value: "0220", label: "CANGUARETAMA" },
		{ value: "0230", label: "CARAUBAS" },
		{ value: "0240", label: "CARNAUBA DOS DANTAS" },
		{ value: "0250", label: "CARNAUBAIS" },
		{ value: "0260", label: "CEARA-MIRIM" },
		{ value: "0270", label: "CERRO CORA" },
		{ value: "0280", label: "CORONEL EZEQUIEL" },
		{ value: "0290", label: "CORONEL JOAO PESSOA" },
		{ value: "0300", label: "CRUZETA" },
		{ value: "0310", label: "CURRAIS NOVOS" },
		{ value: "0320", label: "DOUTOR SEVERIANO" },
		{ value: "0330", label: "ENCANTO" },
		{ value: "0340", label: "EQUADOR" },
		{ value: "0350", label: "ESPIRITO SANTO" },
		{ value: "0360", label: "EXTREMOZ" },
		{ value: "0370", label: "FELIPE GUERRA" },
		{ value: "0375", label: "FERNANDO PEDROZA" },
		{ value: "0380", label: "FLORANIA" },
		{ value: "0390", label: "FRANCISCO DANTAS" },
		{ value: "0400", label: "FRUTUOSO GOMES" },
		{ value: "0410", label: "GALINHOS" },
		{ value: "0420", label: "GOIANINHA" },
		{ value: "0430", label: "GOVERNADOR DIX-SEPT ROSADO" },
		{ value: "0440", label: "GROSSOS" },
		{ value: "0450", label: "GUAMARE" },
		{ value: "0460", label: "IELMO MARINHO" },
		{ value: "0470", label: "IPANGUACU" },
		{ value: "0480", label: "IPUEIRA" },
		{ value: "0485", label: "ITAJA" },
		{ value: "0490", label: "ITAU" },
		{ value: "0500", label: "JACANA" },
		{ value: "0510", label: "JANDAIRA" },
		{ value: "0520", label: "JANDUIS" },
		{ value: "0530", label: "JANUARIO CICCO" },
		{ value: "0540", label: "JAPI" },
		{ value: "0550", label: "JARDIM DE ANGICOS" },
		{ value: "0560", label: "JARDIM DE PIRANHAS" },
		{ value: "0570", label: "JARDIM DO SERIDO" },
		{ value: "0580", label: "JOAO CAMARA" },
		{ value: "0590", label: "JOAO DIAS" },
		{ value: "0600", label: "JOSE DA PENHA" },
		{ value: "0610", label: "JUCURUTU" },
		{ value: "0615", label: "JUNDIA" },
		{ value: "0620", label: "LAGOA D'ANTA" },
		{ value: "0630", label: "LAGOA DE PEDRAS" },
		{ value: "0640", label: "LAGOA DE VELHOS" },
		{ value: "0650", label: "LAGOA NOVA" },
		{ value: "0660", label: "LAGOA SALGADA" },
		{ value: "0670", label: "LAJES" },
		{ value: "0680", label: "LAJES PINTADAS" },
		{ value: "0690", label: "LUCRECIA" },
		{ value: "0700", label: "LUIS GOMES" },
		{ value: "0710", label: "MACAIBA" },
		{ value: "0720", label: "MACAU" },
		{ value: "0725", label: "MAJOR SALES" },
		{ value: "0730", label: "MARCELINO VIEIRA" },
		{ value: "0740", label: "MARTINS" },
		{ value: "0750", label: "MAXARANGUAPE" },
		{ value: "0760", label: "MESSIAS TARGINO" },
		{ value: "0770", label: "MONTANHAS" },
		{ value: "0780", label: "MONTE ALEGRE" },
		{ value: "0790", label: "MONTE DAS GAMELEIRAS" },
		{ value: "0800", label: "MOSSORO" },
		{ value: "0810", label: "NATAL" },
		{ value: "0820", label: "NISIA FLORESTA" },
		{ value: "0830", label: "NOVA CRUZ" },
		{ value: "0840", label: "OLHO-D'AGUA DO BORGES" },
		{ value: "0850", label: "OURO BRANCO" },
		{ value: "0860", label: "PARANA" },
		{ value: "0870", label: "PARAU" },
		{ value: "0880", label: "PARAZINHO" },
		{ value: "0890", label: "PARELHAS" },
		{ value: "0325", label: "PARNAMIRIM" },
		{ value: "0910", label: "PASSA E FICA" },
		{ value: "0920", label: "PASSAGEM" },
		{ value: "0930", label: "PATU" },
		{ value: "0940", label: "PAU DOS FERROS" },
		{ value: "0950", label: "PEDRA GRANDE" },
		{ value: "0960", label: "PEDRA PRETA" },
		{ value: "0970", label: "PEDRO AVELINO" },
		{ value: "0980", label: "PEDRO VELHO" },
		{ value: "0990", label: "PENDENCIAS" },
		{ value: "1000", label: "PILOES" },
		{ value: "1010", label: "POCO BRANCO" },
		{ value: "1020", label: "PORTALEGRE" },
		{ value: "1025", label: "PORTO DO MANGUE" },
		{ value: "1040", label: "PUREZA" },
		{ value: "1050", label: "RAFAEL FERNANDES" },
		{ value: "1060", label: "RAFAEL GODEIRO" },
		{ value: "1070", label: "RIACHO DA CRUZ" },
		{ value: "1080", label: "RIACHO DE SANTANA" },
		{ value: "1090", label: "RIACHUELO" },
		{ value: "0895", label: "RIO DO FOGO" },
		{ value: "1100", label: "RODOLFO FERNANDES" },
		{ value: "1110", label: "RUY BARBOSA" },
		{ value: "1120", label: "SANTA CRUZ" },
		{ value: "0933", label: "SANTA MARIA" },
		{ value: "1140", label: "SANTANA DO MATOS" },
		{ value: "1142", label: "SANTANA DO SERIDO" },
		{ value: "1150", label: "SANTO ANTONIO" },
		{ value: "1160", label: "SAO BENTO DO NORTE" },
		{ value: "1170", label: "SAO BENTO DO TRAIRI" },
		{ value: "1180", label: "SAO FERNANDO" },
		{ value: "1190", label: "SAO FRANCISCO DO OESTE" },
		{ value: "1200", label: "SAO GONCALO DO AMARANTE" },
		{ value: "1210", label: "SAO JOAO DO SABUGI" },
		{ value: "1220", label: "SAO JOSE DE MIPIBU" },
		{ value: "1230", label: "SAO JOSE DO CAMPESTRE" },
		{ value: "1240", label: "SAO JOSE DO SERIDO" },
		{ value: "1250", label: "SAO MIGUEL" },
		{ value: "1255", label: "SAO MIGUEL DO GOSTOSO" },
		{ value: "1260", label: "SAO PAULO DO POTENGI" },
		{ value: "1270", label: "SAO PEDRO" },
		{ value: "1280", label: "SAO RAFAEL" },
		{ value: "1290", label: "SAO TOME" },
		{ value: "1300", label: "SAO VICENTE" },
		{ value: "1310", label: "SENADOR ELOI DE SOUZA" },
		{ value: "1320", label: "SENADOR GEORGINO AVELINO" },
		{ value: "1030", label: "SERRA CAIADA" },
		{ value: "1330", label: "SERRA DE SAO BENTO" },
		{ value: "1335", label: "SERRA DO MEL" },
		{ value: "1340", label: "SERRA NEGRA DO NORTE" },
		{ value: "1350", label: "SERRINHA" },
		{ value: "1355", label: "SERRINHA DOS PINTOS" },
		{ value: "1360", label: "SEVERIANO MELO" },
		{ value: "1370", label: "SITIO NOVO" },
		{ value: "1380", label: "TABOLEIRO GRANDE" },
		{ value: "1390", label: "TAIPU" },
		{ value: "1400", label: "TANGARA" },
		{ value: "1410", label: "TENENTE ANANIAS" },
		{ value: "1415", label: "TENENTE LAURENTINO CRUZ" },
		{ value: "1105", label: "TIBAU" },
		{ value: "1420", label: "TIBAU DO SUL" },
		{ value: "1430", label: "TIMBAUBA DOS BATISTAS" },
		{ value: "1440", label: "TOUROS" },
		{ value: "1445", label: "TRIUNFO POTIGUAR" },
		{ value: "1450", label: "UMARIZAL" },
		{ value: "1460", label: "UPANEMA" },
		{ value: "1470", label: "VARZEA" },
		{ value: "1475", label: "VENHA-VER" },
		{ value: "1480", label: "VERA CRUZ" },
		{ value: "1490", label: "VICOSA" },
		{ value: "1500", label: "VILA FLOR" },
	],
	PB: [
		{ value: "0010", label: "AGUA BRANCA" },
		{ value: "0020", label: "AGUIAR" },
		{ value: "0030", label: "ALAGOA GRANDE" },
		{ value: "0040", label: "ALAGOA NOVA" },
		{ value: "0050", label: "ALAGOINHA" },
		{ value: "0053", label: "ALCANTIL" },
		{ value: "0057", label: "ALGODAO DE JANDAIRA" },
		{ value: "0060", label: "ALHANDRA" },
		{ value: "0073", label: "AMPARO" },
		{ value: "0077", label: "APARECIDA" },
		{ value: "0080", label: "ARACAGI" },
		{ value: "0090", label: "ARARA" },
		{ value: "0100", label: "ARARUNA" },
		{ value: "0110", label: "AREIA" },
		{ value: "0115", label: "AREIA DE BARAUNAS" },
		{ value: "0120", label: "AREIAL" },
		{ value: "0130", label: "AROEIRAS" },
		{ value: "0135", label: "ASSUNCAO" },
		{ value: "0140", label: "BAIA DA TRAICAO" },
		{ value: "0150", label: "BANANEIRAS" },
		{ value: "0153", label: "BARAUNA" },
		{ value: "0160", label: "BARRA DE SANTA ROSA" },
		{ value: "0157", label: "BARRA DE SANTANA" },
		{ value: "0170", label: "BARRA DE SAO MIGUEL" },
		{ value: "0180", label: "BAYEUX" },
		{ value: "0190", label: "BELEM" },
		{ value: "0200", label: "BELEM DO BREJO DO CRUZ" },
		{ value: "0205", label: "BERNARDINO BATISTA" },
		{ value: "0210", label: "BOA VENTURA" },
		{ value: "0215", label: "BOA VISTA" },
		{ value: "0220", label: "BOM JESUS" },
		{ value: "0230", label: "BOM SUCESSO" },
		{ value: "0240", label: "BONITO DE SANTA FE" },
		{ value: "0250", label: "BOQUEIRAO" },
		{ value: "0270", label: "BORBOREMA" },
		{ value: "0280", label: "BREJO DO CRUZ" },
		{ value: "0290", label: "BREJO DOS SANTOS" },
		{ value: "0300", label: "CAAPORA" },
		{ value: "0310", label: "CABACEIRAS" },
		{ value: "0320", label: "CABEDELO" },
		{ value: "0330", label: "CACHOEIRA DOS INDIOS" },
		{ value: "0340", label: "CACIMBA DE AREIA" },
		{ value: "0350", label: "CACIMBA DE DENTRO" },
		{ value: "0355", label: "CACIMBAS" },
		{ value: "0360", label: "CAICARA" },
		{ value: "0370", label: "CAJAZEIRAS" },
		{ value: "0375", label: "CAJAZEIRINHAS" },
		{ value: "0380", label: "CALDAS BRANDAO" },
		{ value: "0390", label: "CAMALAU" },
		{ value: "0400", label: "CAMPINA GRANDE" },
		{ value: "0403", label: "CAPIM" },
		{ value: "0407", label: "CARAUBAS" },
		{ value: "0410", label: "CARRAPATEIRA" },
		{ value: "0415", label: "CASSERENGUE" },
		{ value: "0420", label: "CATINGUEIRA" },
		{ value: "0430", label: "CATOLE DO ROCHA" },
		{ value: "0435", label: "CATURITE" },
		{ value: "0440", label: "CONCEICAO" },
		{ value: "0450", label: "CONDADO" },
		{ value: "0460", label: "CONDE" },
		{ value: "0470", label: "CONGO" },
		{ value: "0480", label: "COREMAS" },
		{ value: "0485", label: "COXIXOLA" },
		{ value: "0490", label: "CRUZ DO ESPIRITO SANTO" },
		{ value: "0500", label: "CUBATI" },
		{ value: "0510", label: "CUITE" },
		{ value: "0523", label: "CUITE DE MAMANGUAPE" },
		{ value: "0520", label: "CUITEGI" },
		{ value: "0527", label: "CURRAL DE CIMA" },
		{ value: "0530", label: "CURRAL VELHO" },
		{ value: "0535", label: "DAMIAO" },
		{ value: "0540", label: "DESTERRO" },
		{ value: "0560", label: "DIAMANTE" },
		{ value: "0570", label: "DONA INES" },
		{ value: "0580", label: "DUAS ESTRADAS" },
		{ value: "0590", label: "EMAS" },
		{ value: "0600", label: "ESPERANCA" },
		{ value: "0610", label: "FAGUNDES" },
		{ value: "0620", label: "FREI MARTINHO" },
		{ value: "0625", label: "GADO BRAVO" },
		{ value: "0630", label: "GUARABIRA" },
		{ value: "0640", label: "GURINHEM" },
		{ value: "0650", label: "GURJAO" },
		{ value: "0660", label: "IBIARA" },
		{ value: "0260", label: "IGARACY" },
		{ value: "0670", label: "IMACULADA" },
		{ value: "0680", label: "INGA" },
		{ value: "0690", label: "ITABAIANA" },
		{ value: "0700", label: "ITAPORANGA" },
		{ value: "0710", label: "ITAPOROROCA" },
		{ value: "0720", label: "ITATUBA" },
		{ value: "0730", label: "JACARAU" },
		{ value: "0740", label: "JERICO" },
		{ value: "0750", label: "JOAO PESSOA" },
		{ value: "0000", label: "JOCA CLAUDINO" },
		{ value: "1365", label: "JOCA CLAUDINO" },
		{ value: "0760", label: "JUAREZ TAVORA" },
		{ value: "0770", label: "JUAZEIRINHO" },
		{ value: "0780", label: "JUNCO DO SERIDO" },
		{ value: "0790", label: "JURIPIRANGA" },
		{ value: "0800", label: "JURU" },
		{ value: "0810", label: "LAGOA" },
		{ value: "0820", label: "LAGOA DE DENTRO" },
		{ value: "0830", label: "LAGOA SECA" },
		{ value: "0840", label: "LASTRO" },
		{ value: "0850", label: "LIVRAMENTO" },
		{ value: "0855", label: "LOGRADOURO" },
		{ value: "0860", label: "LUCENA" },
		{ value: "0870", label: "MAE D'AGUA" },
		{ value: "0880", label: "MALTA" },
		{ value: "0890", label: "MAMANGUAPE" },
		{ value: "0900", label: "MANAIRA" },
		{ value: "0905", label: "MARCACAO" },
		{ value: "0910", label: "MARI" },
		{ value: "0915", label: "MARIZOPOLIS" },
		{ value: "0920", label: "MASSARANDUBA" },
		{ value: "0930", label: "MATARACA" },
		{ value: "0933", label: "MATINHAS" },
		{ value: "0937", label: "MATO GROSSO" },
		{ value: "0939", label: "MATUREIA" },
		{ value: "0940", label: "MOGEIRO" },
		{ value: "0950", label: "MONTADAS" },
		{ value: "0960", label: "MONTE HOREBE" },
		{ value: "0970", label: "MONTEIRO" },
		{ value: "0980", label: "MULUNGU" },
		{ value: "0990", label: "NATUBA" },
		{ value: "1000", label: "NAZAREZINHO" },
		{ value: "1010", label: "NOVA FLORESTA" },
		{ value: "1020", label: "NOVA OLINDA" },
		{ value: "1030", label: "NOVA PALMEIRA" },
		{ value: "1040", label: "OLHO D'AGUA" },
		{ value: "1050", label: "OLIVEDOS" },
		{ value: "1060", label: "OURO VELHO" },
		{ value: "1065", label: "PARARI" },
		{ value: "1070", label: "PASSAGEM" },
		{ value: "1080", label: "PATOS" },
		{ value: "1090", label: "PAULISTA" },
		{ value: "1100", label: "PEDRA BRANCA" },
		{ value: "1110", label: "PEDRA LAVRADA" },
		{ value: "1120", label: "PEDRAS DE FOGO" },
		{ value: "1272", label: "PEDRO REGIS" },
		{ value: "1130", label: "PIANCO" },
		{ value: "1140", label: "PICUI" },
		{ value: "1150", label: "PILAR" },
		{ value: "1160", label: "PILOES" },
		{ value: "1170", label: "PILOEZINHOS" },
		{ value: "1180", label: "PIRPIRITUBA" },
		{ value: "1190", label: "PITIMBU" },
		{ value: "1200", label: "POCINHOS" },
		{ value: "1203", label: "POCO DANTAS" },
		{ value: "1207", label: "POCO DE JOSE DE MOURA" },
		{ value: "1210", label: "POMBAL" },
		{ value: "1220", label: "PRATA" },
		{ value: "1230", label: "PRINCESA ISABEL" },
		{ value: "1240", label: "PUXINANA" },
		{ value: "1250", label: "QUEIMADAS" },
		{ value: "1260", label: "QUIXABA" },
		{ value: "1270", label: "REMIGIO" },
		{ value: "1274", label: "RIACHAO" },
		{ value: "1275", label: "RIACHAO DO BACAMARTE" },
		{ value: "1276", label: "RIACHAO DO POCO" },
		{ value: "1278", label: "RIACHO DE SANTO ANTONIO" },
		{ value: "1280", label: "RIACHO DOS CAVALOS" },
		{ value: "1290", label: "RIO TINTO" },
		{ value: "1300", label: "SALGADINHO" },
		{ value: "1310", label: "SALGADO DE SAO FELIX" },
		{ value: "1315", label: "SANTA CECILIA" },
		{ value: "1320", label: "SANTA CRUZ" },
		{ value: "1330", label: "SANTA HELENA" },
		{ value: "1335", label: "SANTA INES" },
		{ value: "1340", label: "SANTA LUZIA" },
		{ value: "1370", label: "SANTA RITA" },
		{ value: "0000", label: "SANTA RITA" },
		{ value: "1380", label: "SANTA TERESINHA" },
		{ value: "1350", label: "SANTANA DE MANGUEIRA" },
		{ value: "1360", label: "SANTANA DOS GARROTES" },
		{ value: "1385", label: "SANTO ANDRE" },
		{ value: "1392", label: "SAO BENTINHO" },
		{ value: "1390", label: "SAO BENTO" },
		{ value: "1396", label: "SAO DOMINGOS" },
		{ value: "1394", label: "SAO DOMINGOS DO CARIRI" },
		{ value: "1398", label: "SAO FRANCISCO" },
		{ value: "1400", label: "SAO JOAO DO CARIRI" },
		{ value: "0070", label: "SAO JOAO DO RIO DO PEIXE" },
		{ value: "1410", label: "SAO JOAO DO TIGRE" },
		{ value: "1420", label: "SAO JOSE DA LAGOA TAPADA" },
		{ value: "1430", label: "SAO JOSE DE CAIANA" },
		{ value: "1440", label: "SAO JOSE DE ESPINHARAS" },
		{ value: "1450", label: "SAO JOSE DE PIRANHAS" },
		{ value: "1455", label: "SAO JOSE DE PRINCESA" },
		{ value: "1460", label: "SAO JOSE DO BONFIM" },
		{ value: "1465", label: "SAO JOSE DO BREJO DO CRUZ" },
		{ value: "1470", label: "SAO JOSE DO SABUGI" },
		{ value: "1480", label: "SAO JOSE DOS CORDEIROS" },
		{ value: "1445", label: "SAO JOSE DOS RAMOS" },
		{ value: "1490", label: "SAO MAMEDE" },
		{ value: "1500", label: "SAO MIGUEL DE TAIPU" },
		{ value: "1510", label: "SAO SEBASTIAO DE LAGOA DE ROCA" },
		{ value: "1520", label: "SAO SEBASTIAO DO UMBUZEIRO" },
		{ value: "1540", label: "SAO VICENTE DO SERIDO" },
		{ value: "1530", label: "SAPE" },
		{ value: "1550", label: "SERRA BRANCA" },
		{ value: "1560", label: "SERRA DA RAIZ" },
		{ value: "1570", label: "SERRA GRANDE" },
		{ value: "1580", label: "SERRA REDONDA" },
		{ value: "1590", label: "SERRARIA" },
		{ value: "1593", label: "SERTAOZINHO" },
		{ value: "1597", label: "SOBRADO" },
		{ value: "1600", label: "SOLANEA" },
		{ value: "1610", label: "SOLEDADE" },
		{ value: "1615", label: "SOSSEGO" },
		{ value: "1620", label: "SOUSA" },
		{ value: "1630", label: "SUME" },
		{ value: "1640", label: "TACIMA" },
		{ value: "1650", label: "TAPEROA" },
		{ value: "1660", label: "TAVARES" },
		{ value: "1670", label: "TEIXEIRA" },
		{ value: "1675", label: "TENORIO" },
		{ value: "1680", label: "TRIUNFO" },
		{ value: "1690", label: "UIRAUNA" },
		{ value: "1700", label: "UMBUZEIRO" },
		{ value: "1710", label: "VARZEA" },
		{ value: "1720", label: "VIEIROPOLIS" },
		{ value: "0550", label: "VISTA SERRANA" },
		{ value: "1740", label: "ZABELE" },
	],
	PE: [
		{ value: "0005", label: "ABREU E LIMA" },
		{ value: "0010", label: "AFOGADOS DA INGAZEIRA" },
		{ value: "0020", label: "AFRANIO" },
		{ value: "0030", label: "AGRESTINA" },
		{ value: "0040", label: "AGUA PRETA" },
		{ value: "0050", label: "AGUAS BELAS" },
		{ value: "0060", label: "ALAGOINHA" },
		{ value: "0070", label: "ALIANCA" },
		{ value: "0080", label: "ALTINHO" },
		{ value: "0090", label: "AMARAJI" },
		{ value: "0100", label: "ANGELIM" },
		{ value: "0105", label: "ARACOIABA" },
		{ value: "0110", label: "ARARIPINA" },
		{ value: "0120", label: "ARCOVERDE" },
		{ value: "0130", label: "BARRA DE GUABIRABA" },
		{ value: "0140", label: "BARREIROS" },
		{ value: "0150", label: "BELEM DE MARIA" },
		{ value: "0160", label: "BELEM DE SAO FRANCISCO" },
		{ value: "0000", label: "BELEM DO SAO FRANCISCO" },
		{ value: "0170", label: "BELO JARDIM" },
		{ value: "0180", label: "BETANIA" },
		{ value: "0190", label: "BEZERROS" },
		{ value: "0200", label: "BODOCO" },
		{ value: "0210", label: "BOM CONSELHO" },
		{ value: "0220", label: "BOM JARDIM" },
		{ value: "0230", label: "BONITO" },
		{ value: "0240", label: "BREJAO" },
		{ value: "0250", label: "BREJINHO" },
		{ value: "0260", label: "BREJO DA MADRE DE DEUS" },
		{ value: "0270", label: "BUENOS AIRES" },
		{ value: "0280", label: "BUIQUE" },
		{ value: "0290", label: "CABO DE SANTO AGOSTINHO" },
		{ value: "0300", label: "CABROBO" },
		{ value: "0310", label: "CACHOEIRINHA" },
		{ value: "0320", label: "CAETES" },
		{ value: "0330", label: "CALCADO" },
		{ value: "0340", label: "CALUMBI" },
		{ value: "0345", label: "CAMARAGIBE" },
		{ value: "0350", label: "CAMOCIM DE SAO FELIX" },
		{ value: "0360", label: "CAMUTANGA" },
		{ value: "0370", label: "CANHOTINHO" },
		{ value: "0380", label: "CAPOEIRAS" },
		{ value: "0390", label: "CARNAIBA" },
		{ value: "0392", label: "CARNAUBEIRA DA PENHA" },
		{ value: "0400", label: "CARPINA" },
		{ value: "0410", label: "CARUARU" },
		{ value: "0415", label: "CASINHAS" },
		{ value: "0420", label: "CATENDE" },
		{ value: "0430", label: "CEDRO" },
		{ value: "0440", label: "CHA DE ALEGRIA" },
		{ value: "0450", label: "CHA GRANDE" },
		{ value: "0460", label: "CONDADO" },
		{ value: "0470", label: "CORRENTES" },
		{ value: "0480", label: "CORTES" },
		{ value: "0490", label: "CUMARU" },
		{ value: "0500", label: "CUPIRA" },
		{ value: "0510", label: "CUSTODIA" },
		{ value: "0515", label: "DORMENTES" },
		{ value: "0520", label: "ESCADA" },
		{ value: "0530", label: "EXU" },
		{ value: "0540", label: "FEIRA NOVA" },
		{ value: "0545", label: "FERNANDO DE NORONHA" },
		{ value: "0550", label: "FERREIROS" },
		{ value: "0560", label: "FLORES" },
		{ value: "0570", label: "FLORESTA" },
		{ value: "0580", label: "FREI MIGUELINHO" },
		{ value: "0590", label: "GAMELEIRA" },
		{ value: "0600", label: "GARANHUNS" },
		{ value: "0610", label: "GLORIA DO GOITA" },
		{ value: "0620", label: "GOIANA" },
		{ value: "0630", label: "GRANITO" },
		{ value: "0640", label: "GRAVATA" },
		{ value: "0650", label: "IATI" },
		{ value: "0660", label: "IBIMIRIM" },
		{ value: "0670", label: "IBIRAJUBA" },
		{ value: "0680", label: "IGARASSU" },
		{ value: "0690", label: "IGUARACI" },
		{ value: "0760", label: "ILHA DE ITAMARACA" },
		{ value: "0700", label: "INAJA" },
		{ value: "0710", label: "INGAZEIRA" },
		{ value: "0720", label: "IPOJUCA" },
		{ value: "0730", label: "IPUBI" },
		{ value: "0740", label: "ITACURUBA" },
		{ value: "0750", label: "ITAIBA" },
		{ value: "0765", label: "ITAMBE" },
		{ value: "0770", label: "ITAPETIM" },
		{ value: "0775", label: "ITAPISSUMA" },
		{ value: "0780", label: "ITAQUITINGA" },
		{ value: "0790", label: "JABOATAO DOS GUARARAPES" },
		{ value: "0795", label: "JAQUEIRA" },
		{ value: "0800", label: "JATAUBA" },
		{ value: "0805", label: "JATOBA" },
		{ value: "0810", label: "JOAO ALFREDO" },
		{ value: "0820", label: "JOAQUIM NABUCO" },
		{ value: "0825", label: "JUCATI" },
		{ value: "0830", label: "JUPI" },
		{ value: "0840", label: "JUREMA" },
		{ value: "0845", label: "LAGOA DO CARRO" },
		{ value: "0850", label: "LAGOA DO ITAENGA" },
		{ value: "0860", label: "LAGOA DO OURO" },
		{ value: "0870", label: "LAGOA DOS GATOS" },
		{ value: "0875", label: "LAGOA GRANDE" },
		{ value: "0880", label: "LAJEDO" },
		{ value: "0890", label: "LIMOEIRO" },
		{ value: "0900", label: "MACAPARANA" },
		{ value: "0910", label: "MACHADOS" },
		{ value: "0915", label: "MANARI" },
		{ value: "0920", label: "MARAIAL" },
		{ value: "0930", label: "MIRANDIBA" },
		{ value: "1430", label: "MOREILANDIA" },
		{ value: "0940", label: "MORENO" },
		{ value: "0950", label: "NAZARE DA MATA" },
		{ value: "0960", label: "OLINDA" },
		{ value: "0970", label: "OROBO" },
		{ value: "0980", label: "OROCO" },
		{ value: "0990", label: "OURICURI" },
		{ value: "1000", label: "PALMARES" },
		{ value: "1010", label: "PALMEIRINA" },
		{ value: "1020", label: "PANELAS" },
		{ value: "1030", label: "PARANATAMA" },
		{ value: "1040", label: "PARNAMIRIM" },
		{ value: "1050", label: "PASSIRA" },
		{ value: "1060", label: "PAUDALHO" },
		{ value: "1070", label: "PAULISTA" },
		{ value: "1080", label: "PEDRA" },
		{ value: "1090", label: "PESQUEIRA" },
		{ value: "1100", label: "PETROLANDIA" },
		{ value: "1110", label: "PETROLINA" },
		{ value: "1120", label: "POCAO" },
		{ value: "1130", label: "POMBOS" },
		{ value: "1140", label: "PRIMAVERA" },
		{ value: "1150", label: "QUIPAPA" },
		{ value: "1153", label: "QUIXABA" },
		{ value: "1160", label: "RECIFE" },
		{ value: "1170", label: "RIACHO DAS ALMAS" },
		{ value: "1180", label: "RIBEIRAO" },
		{ value: "1190", label: "RIO FORMOSO" },
		{ value: "1200", label: "SAIRE" },
		{ value: "1210", label: "SALGADINHO" },
		{ value: "1220", label: "SALGUEIRO" },
		{ value: "1230", label: "SALOA" },
		{ value: "1240", label: "SANHARO" },
		{ value: "1245", label: "SANTA CRUZ" },
		{ value: "1247", label: "SANTA CRUZ DA BAIXA VERDE" },
		{ value: "1250", label: "SANTA CRUZ DO CAPIBARIBE" },
		{ value: "1255", label: "SANTA FILOMENA" },
		{ value: "1260", label: "SANTA MARIA DA BOA VISTA" },
		{ value: "1270", label: "SANTA MARIA DO CAMBUCA" },
		{ value: "1280", label: "SANTA TEREZINHA" },
		{ value: "1290", label: "SAO BENEDITO DO SUL" },
		{ value: "1300", label: "SAO BENTO DO UNA" },
		{ value: "1310", label: "SAO CAITANO" },
		{ value: "1320", label: "SAO JOAO" },
		{ value: "1330", label: "SAO JOAQUIM DO MONTE" },
		{ value: "1340", label: "SAO JOSE DA COROA GRANDE" },
		{ value: "1350", label: "SAO JOSE DO BELMONTE" },
		{ value: "1360", label: "SAO JOSE DO EGITO" },
		{ value: "1370", label: "SAO LOURENCO DA MATA" },
		{ value: "1380", label: "SAO VICENTE FERRER" },
		{ value: "1390", label: "SERRA TALHADA" },
		{ value: "1400", label: "SERRITA" },
		{ value: "1410", label: "SERTANIA" },
		{ value: "1420", label: "SIRINHAEM" },
		{ value: "1440", label: "SOLIDAO" },
		{ value: "1450", label: "SURUBIM" },
		{ value: "1460", label: "TABIRA" },
		{ value: "1470", label: "TACAIMBO" },
		{ value: "1480", label: "TACARATU" },
		{ value: "1485", label: "TAMANDARE" },
		{ value: "1500", label: "TAQUARITINGA DO NORTE" },
		{ value: "1510", label: "TEREZINHA" },
		{ value: "1520", label: "TERRA NOVA" },
		{ value: "1530", label: "TIMBAUBA" },
		{ value: "1540", label: "TORITAMA" },
		{ value: "1550", label: "TRACUNHAEM" },
		{ value: "1560", label: "TRINDADE" },
		{ value: "1570", label: "TRIUNFO" },
		{ value: "1580", label: "TUPANATINGA" },
		{ value: "1590", label: "TUPARETAMA" },
		{ value: "1600", label: "VENTUROSA" },
		{ value: "1610", label: "VERDEJANTE" },
		{ value: "1618", label: "VERTENTE DO LERIO" },
		{ value: "1620", label: "VERTENTES" },
		{ value: "1630", label: "VICENCIA" },
		{ value: "1640", label: "VITORIA DE SANTO ANTAO" },
		{ value: "1650", label: "XEXEU" },
	],
	AL: [
		{ value: "0010", label: "AGUA BRANCA" },
		{ value: "0020", label: "ANADIA" },
		{ value: "0030", label: "ARAPIRACA" },
		{ value: "0040", label: "ATALAIA" },
		{ value: "0050", label: "BARRA DE SANTO ANTONIO" },
		{ value: "0060", label: "BARRA DE SAO MIGUEL" },
		{ value: "0070", label: "BATALHA" },
		{ value: "0080", label: "BELEM" },
		{ value: "0090", label: "BELO MONTE" },
		{ value: "0100", label: "BOCA DA MATA" },
		{ value: "0110", label: "BRANQUINHA" },
		{ value: "0120", label: "CACIMBINHAS" },
		{ value: "0130", label: "CAJUEIRO" },
		{ value: "0135", label: "CAMPESTRE" },
		{ value: "0140", label: "CAMPO ALEGRE" },
		{ value: "0150", label: "CAMPO GRANDE" },
		{ value: "0160", label: "CANAPI" },
		{ value: "0170", label: "CAPELA" },
		{ value: "0180", label: "CARNEIROS" },
		{ value: "0190", label: "CHA PRETA" },
		{ value: "0200", label: "COITE DO NOIA" },
		{ value: "0210", label: "COLONIA LEOPOLDINA" },
		{ value: "0220", label: "COQUEIRO SECO" },
		{ value: "0230", label: "CORURIPE" },
		{ value: "0235", label: "CRAIBAS" },
		{ value: "0240", label: "DELMIRO GOUVEIA" },
		{ value: "0250", label: "DOIS RIACHOS" },
		{ value: "0255", label: "ESTRELA DE ALAGOAS" },
		{ value: "0260", label: "FEIRA GRANDE" },
		{ value: "0270", label: "FELIZ DESERTO" },
		{ value: "0280", label: "FLEXEIRAS" },
		{ value: "0290", label: "GIRAU DO PONCIANO" },
		{ value: "0300", label: "IBATEGUARA" },
		{ value: "0310", label: "IGACI" },
		{ value: "0320", label: "IGREJA NOVA" },
		{ value: "0330", label: "INHAPI" },
		{ value: "0340", label: "JACARE DOS HOMENS" },
		{ value: "0350", label: "JACUIPE" },
		{ value: "0360", label: "JAPARATINGA" },
		{ value: "0370", label: "JARAMATAIA" },
		{ value: "0375", label: "JEQUIA DA PRAIA" },
		{ value: "0380", label: "JOAQUIM GOMES" },
		{ value: "0390", label: "JUNDIA" },
		{ value: "0400", label: "JUNQUEIRO" },
		{ value: "0410", label: "LAGOA DA CANOA" },
		{ value: "0420", label: "LIMOEIRO DE ANADIA" },
		{ value: "0430", label: "MACEIO" },
		{ value: "0440", label: "MAJOR ISIDORO" },
		{ value: "0490", label: "MAR VERMELHO" },
		{ value: "0450", label: "MARAGOGI" },
		{ value: "0460", label: "MARAVILHA" },
		{ value: "0470", label: "MARECHAL DEODORO" },
		{ value: "0480", label: "MARIBONDO" },
		{ value: "0500", label: "MATA GRANDE" },
		{ value: "0510", label: "MATRIZ DE CAMARAGIBE" },
		{ value: "0520", label: "MESSIAS" },
		{ value: "0530", label: "MINADOR DO NEGRAO" },
		{ value: "0540", label: "MONTEIROPOLIS" },
		{ value: "0550", label: "MURICI" },
		{ value: "0560", label: "NOVO LINO" },
		{ value: "0570", label: "OLHO D'AGUA DAS FLORES" },
		{ value: "0580", label: "OLHO D'AGUA DO CASADO" },
		{ value: "0590", label: "OLHO D'AGUA GRANDE" },
		{ value: "0600", label: "OLIVENCA" },
		{ value: "0610", label: "OURO BRANCO" },
		{ value: "0620", label: "PALESTINA" },
		{ value: "0630", label: "PALMEIRA DOS INDIOS" },
		{ value: "0640", label: "PAO DE ACUCAR" },
		{ value: "0642", label: "PARICONHA" },
		{ value: "0644", label: "PARIPUEIRA" },
		{ value: "0650", label: "PASSO DE CAMARAGIBE" },
		{ value: "0660", label: "PAULO JACINTO" },
		{ value: "0670", label: "PENEDO" },
		{ value: "0680", label: "PIACABUCU" },
		{ value: "0690", label: "PILAR" },
		{ value: "0700", label: "PINDOBA" },
		{ value: "0710", label: "PIRANHAS" },
		{ value: "0720", label: "POCO DAS TRINCHEIRAS" },
		{ value: "0730", label: "PORTO CALVO" },
		{ value: "0740", label: "PORTO DE PEDRAS" },
		{ value: "0750", label: "PORTO REAL DO COLEGIO" },
		{ value: "0760", label: "QUEBRANGULO" },
		{ value: "0770", label: "RIO LARGO" },
		{ value: "0780", label: "ROTEIRO" },
		{ value: "0790", label: "SANTA LUZIA DO NORTE" },
		{ value: "0800", label: "SANTANA DO IPANEMA" },
		{ value: "0810", label: "SANTANA DO MUNDAU" },
		{ value: "0820", label: "SAO BRAS" },
		{ value: "0830", label: "SAO JOSE DA LAJE" },
		{ value: "0840", label: "SAO JOSE DA TAPERA" },
		{ value: "0850", label: "SAO LUIS DO QUITUNDE" },
		{ value: "0860", label: "SAO MIGUEL DOS CAMPOS" },
		{ value: "0870", label: "SAO MIGUEL DOS MILAGRES" },
		{ value: "0880", label: "SAO SEBASTIAO" },
		{ value: "0890", label: "SATUBA" },
		{ value: "0895", label: "SENADOR RUI PALMEIRA" },
		{ value: "0900", label: "TANQUE D'ARCA" },
		{ value: "0910", label: "TAQUARANA" },
		{ value: "0915", label: "TEOTONIO VILELA" },
		{ value: "0920", label: "TRAIPU" },
		{ value: "0930", label: "UNIAO DOS PALMARES" },
		{ value: "0940", label: "VICOSA" },
	],
	SE: [
		{ value: "0010", label: "AMPARO DE SAO FRANCISCO" },
		{ value: "0020", label: "AQUIDABA" },
		{ value: "0030", label: "ARACAJU" },
		{ value: "0040", label: "ARAUA" },
		{ value: "0050", label: "AREIA BRANCA" },
		{ value: "0060", label: "BARRA DOS COQUEIROS" },
		{ value: "0067", label: "BOQUIM" },
		{ value: "0070", label: "BREJO GRANDE" },
		{ value: "0100", label: "CAMPO DO BRITO" },
		{ value: "0110", label: "CANHOBA" },
		{ value: "0120", label: "CANINDE DE SAO FRANCISCO" },
		{ value: "0130", label: "CAPELA" },
		{ value: "0140", label: "CARIRA" },
		{ value: "0150", label: "CARMOPOLIS" },
		{ value: "0160", label: "CEDRO DE SAO JOAO" },
		{ value: "0170", label: "CRISTINAPOLIS" },
		{ value: "0190", label: "CUMBE" },
		{ value: "0200", label: "DIVINA PASTORA" },
		{ value: "0210", label: "ESTANCIA" },
		{ value: "0220", label: "FEIRA NOVA" },
		{ value: "0230", label: "FREI PAULO" },
		{ value: "0240", label: "GARARU" },
		{ value: "0250", label: "GENERAL MAYNARD" },
		{ value: "0000", label: "GRACCHO CARDOSO" },
		{ value: "0260", label: "GRACHO CARDOSO" },
		{ value: "0270", label: "ILHA DAS FLORES" },
		{ value: "0280", label: "INDIAROBA" },
		{ value: "0290", label: "ITABAIANA" },
		{ value: "0300", label: "ITABAIANINHA" },
		{ value: "0310", label: "ITABI" },
		{ value: "0320", label: "ITAPORANGA D'AJUDA" },
		{ value: "0330", label: "JAPARATUBA" },
		{ value: "0340", label: "JAPOATA" },
		{ value: "0350", label: "LAGARTO" },
		{ value: "0360", label: "LARANJEIRAS" },
		{ value: "0370", label: "MACAMBIRA" },
		{ value: "0380", label: "MALHADA DOS BOIS" },
		{ value: "0390", label: "MALHADOR" },
		{ value: "0400", label: "MARUIM" },
		{ value: "0410", label: "MOITA BONITA" },
		{ value: "0420", label: "MONTE ALEGRE DE SERGIPE" },
		{ value: "0430", label: "MURIBECA" },
		{ value: "0440", label: "NEOPOLIS" },
		{ value: "0445", label: "NOSSA SENHORA APARECIDA" },
		{ value: "0450", label: "NOSSA SENHORA DA GLORIA" },
		{ value: "0460", label: "NOSSA SENHORA DAS DORES" },
		{ value: "0470", label: "NOSSA SENHORA DE LOURDES" },
		{ value: "0480", label: "NOSSA SENHORA DO SOCORRO" },
		{ value: "0490", label: "PACATUBA" },
		{ value: "0500", label: "PEDRA MOLE" },
		{ value: "0510", label: "PEDRINHAS" },
		{ value: "0520", label: "PINHAO" },
		{ value: "0530", label: "PIRAMBU" },
		{ value: "0540", label: "POCO REDONDO" },
		{ value: "0550", label: "POCO VERDE" },
		{ value: "0560", label: "PORTO DA FOLHA" },
		{ value: "0570", label: "PROPRIA" },
		{ value: "0580", label: "RIACHAO DO DANTAS" },
		{ value: "0590", label: "RIACHUELO" },
		{ value: "0600", label: "RIBEIROPOLIS" },
		{ value: "0610", label: "ROSARIO DO CATETE" },
		{ value: "0620", label: "SALGADO" },
		{ value: "0630", label: "SANTA LUZIA DO ITANHY" },
		{ value: "0650", label: "SANTA ROSA DE LIMA" },
		{ value: "0640", label: "SANTANA DO SAO FRANCISCO" },
		{ value: "0660", label: "SANTO AMARO DAS BROTAS" },
		{ value: "0670", label: "SAO CRISTOVAO" },
		{ value: "0680", label: "SAO DOMINGOS" },
		{ value: "0690", label: "SAO FRANCISCO" },
		{ value: "0700", label: "SAO MIGUEL DO ALEIXO" },
		{ value: "0710", label: "SIMAO DIAS" },
		{ value: "0720", label: "SIRIRI" },
		{ value: "0730", label: "TELHA" },
		{ value: "0740", label: "TOBIAS BARRETO" },
		{ value: "0750", label: "TOMAR DO GERU" },
		{ value: "0760", label: "UMBAUBA" },
	],
	BA: [
		{ value: "0010", label: "ABAIRA" },
		{ value: "0020", label: "ABARE" },
		{ value: "0030", label: "ACAJUTIBA" },
		{ value: "0035", label: "ADUSTINA" },
		{ value: "0040", label: "AGUA FRIA" },
		{ value: "0060", label: "AIQUARA" },
		{ value: "0070", label: "ALAGOINHAS" },
		{ value: "0080", label: "ALCOBACA" },
		{ value: "0090", label: "ALMADINA" },
		{ value: "0100", label: "AMARGOSA" },
		{ value: "0110", label: "AMELIA RODRIGUES" },
		{ value: "0115", label: "AMERICA DOURADA" },
		{ value: "0120", label: "ANAGE" },
		{ value: "0130", label: "ANDARAI" },
		{ value: "0135", label: "ANDORINHA" },
		{ value: "0140", label: "ANGICAL" },
		{ value: "0150", label: "ANGUERA" },
		{ value: "0160", label: "ANTAS" },
		{ value: "0170", label: "ANTONIO CARDOSO" },
		{ value: "0180", label: "ANTONIO GONCALVES" },
		{ value: "0190", label: "APORA" },
		{ value: "0195", label: "APUAREMA" },
		{ value: "0205", label: "ARACAS" },
		{ value: "0200", label: "ARACATU" },
		{ value: "0210", label: "ARACI" },
		{ value: "0220", label: "ARAMARI" },
		{ value: "0225", label: "ARATACA" },
		{ value: "0230", label: "ARATUIPE" },
		{ value: "0240", label: "AURELINO LEAL" },
		{ value: "0250", label: "BAIANOPOLIS" },
		{ value: "0260", label: "BAIXA GRANDE" },
		{ value: "0265", label: "BANZAE" },
		{ value: "0270", label: "BARRA" },
		{ value: "0280", label: "BARRA DA ESTIVA" },
		{ value: "0290", label: "BARRA DO CHOCA" },
		{ value: "0300", label: "BARRA DO MENDES" },
		{ value: "0310", label: "BARRA DO ROCHA" },
		{ value: "0320", label: "BARREIRAS" },
		{ value: "0323", label: "BARRO ALTO" },
		{ value: "0330", label: "BARRO PRETO" },
		{ value: "0327", label: "BARROCAS" },
		{ value: "0340", label: "BELMONTE" },
		{ value: "0350", label: "BELO CAMPO" },
		{ value: "0360", label: "BIRITINGA" },
		{ value: "0370", label: "BOA NOVA" },
		{ value: "0380", label: "BOA VISTA DO TUPIM" },
		{ value: "0390", label: "BOM JESUS DA LAPA" },
		{ value: "0395", label: "BOM JESUS DA SERRA" },
		{ value: "0400", label: "BONINAL" },
		{ value: "0405", label: "BONITO" },
		{ value: "0410", label: "BOQUIRA" },
		{ value: "0420", label: "BOTUPORA" },
		{ value: "0430", label: "BREJOES" },
		{ value: "0440", label: "BREJOLANDIA" },
		{ value: "0450", label: "BROTAS DE MACAUBAS" },
		{ value: "0460", label: "BRUMADO" },
		{ value: "0470", label: "BUERAREMA" },
		{ value: "0475", label: "BURITIRAMA" },
		{ value: "0480", label: "CAATIBA" },
		{ value: "0485", label: "CABACEIRAS DO PARAGUACU" },
		{ value: "0490", label: "CACHOEIRA" },
		{ value: "0500", label: "CACULE" },
		{ value: "0510", label: "CAEM" },
		{ value: "0515", label: "CAETANOS" },
		{ value: "0520", label: "CAETITE" },
		{ value: "0530", label: "CAFARNAUM" },
		{ value: "0540", label: "CAIRU" },
		{ value: "0550", label: "CALDEIRAO GRANDE" },
		{ value: "0560", label: "CAMACAN" },
		{ value: "0570", label: "CAMACARI" },
		{ value: "0580", label: "CAMAMU" },
		{ value: "0590", label: "CAMPO ALEGRE DE LOURDES" },
		{ value: "0600", label: "CAMPO FORMOSO" },
		{ value: "0610", label: "CANAPOLIS" },
		{ value: "0620", label: "CANARANA" },
		{ value: "0630", label: "CANAVIEIRAS" },
		{ value: "0640", label: "CANDEAL" },
		{ value: "0650", label: "CANDEIAS" },
		{ value: "0660", label: "CANDIBA" },
		{ value: "0670", label: "CANDIDO SALES" },
		{ value: "0680", label: "CANSANCAO" },
		{ value: "0682", label: "CANUDOS" },
		{ value: "0685", label: "CAPELA DO ALTO ALEGRE" },
		{ value: "0687", label: "CAPIM GROSSO" },
		{ value: "0689", label: "CARAIBAS" },
		{ value: "0690", label: "CARAVELAS" },
		{ value: "0700", label: "CARDEAL DA SILVA" },
		{ value: "0710", label: "CARINHANHA" },
		{ value: "0720", label: "CASA NOVA" },
		{ value: "0730", label: "CASTRO ALVES" },
		{ value: "0740", label: "CATOLANDIA" },
		{ value: "0750", label: "CATU" },
		{ value: "0755", label: "CATURAMA" },
		{ value: "0760", label: "CENTRAL" },
		{ value: "0770", label: "CHORROCHO" },
		{ value: "0780", label: "CICERO DANTAS" },
		{ value: "0790", label: "CIPO" },
		{ value: "0800", label: "COARACI" },
		{ value: "0810", label: "COCOS" },
		{ value: "0820", label: "CONCEICAO DA FEIRA" },
		{ value: "0830", label: "CONCEICAO DO ALMEIDA" },
		{ value: "0840", label: "CONCEICAO DO COITE" },
		{ value: "0850", label: "CONCEICAO DO JACUIPE" },
		{ value: "0860", label: "CONDE" },
		{ value: "0870", label: "CONDEUBA" },
		{ value: "0880", label: "CONTENDAS DO SINCORA" },
		{ value: "0890", label: "CORACAO DE MARIA" },
		{ value: "0900", label: "CORDEIROS" },
		{ value: "0910", label: "CORIBE" },
		{ value: "0920", label: "CORONEL JOAO SA" },
		{ value: "0930", label: "CORRENTINA" },
		{ value: "0940", label: "COTEGIPE" },
		{ value: "0950", label: "CRAVOLANDIA" },
		{ value: "0960", label: "CRISOPOLIS" },
		{ value: "0970", label: "CRISTOPOLIS" },
		{ value: "0980", label: "CRUZ DAS ALMAS" },
		{ value: "0990", label: "CURACA" },
		{ value: "1000", label: "DARIO MEIRA" },
		{ value: "1005", label: "DIAS D'AVILA" },
		{ value: "1010", label: "DOM BASILIO" },
		{ value: "1020", label: "DOM MACEDO COSTA" },
		{ value: "1030", label: "ELISIO MEDRADO" },
		{ value: "1040", label: "ENCRUZILHADA" },
		{ value: "1050", label: "ENTRE RIOS" },
		{ value: "0050", label: "ERICO CARDOSO" },
		{ value: "1060", label: "ESPLANADA" },
		{ value: "1070", label: "EUCLIDES DA CUNHA" },
		{ value: "1072", label: "EUNAPOLIS" },
		{ value: "1075", label: "FATIMA" },
		{ value: "1077", label: "FEIRA DA MATA" },
		{ value: "1080", label: "FEIRA DE SANTANA" },
		{ value: "1085", label: "FILADELFIA" },
		{ value: "1090", label: "FIRMINO ALVES" },
		{ value: "1100", label: "FLORESTA AZUL" },
		{ value: "1110", label: "FORMOSA DO RIO PRETO" },
		{ value: "1120", label: "GANDU" },
		{ value: "1125", label: "GAVIAO" },
		{ value: "1130", label: "GENTIO DO OURO" },
		{ value: "1140", label: "GLORIA" },
		{ value: "1150", label: "GONGOGI" },
		{ value: "1160", label: "GOVERNADOR MANGABEIRA" },
		{ value: "1165", label: "GUAJERU" },
		{ value: "1170", label: "GUANAMBI" },
		{ value: "1180", label: "GUARATINGA" },
		{ value: "1185", label: "HELIOPOLIS" },
		{ value: "1190", label: "IACU" },
		{ value: "1200", label: "IBIASSUCE" },
		{ value: "1210", label: "IBICARAI" },
		{ value: "1220", label: "IBICOARA" },
		{ value: "1230", label: "IBICUI" },
		{ value: "1240", label: "IBIPEBA" },
		{ value: "1250", label: "IBIPITANGA" },
		{ value: "1260", label: "IBIQUERA" },
		{ value: "1270", label: "IBIRAPITANGA" },
		{ value: "1280", label: "IBIRAPUA" },
		{ value: "1290", label: "IBIRATAIA" },
		{ value: "1300", label: "IBITIARA" },
		{ value: "1310", label: "IBITITA" },
		{ value: "1320", label: "IBOTIRAMA" },
		{ value: "1330", label: "ICHU" },
		{ value: "1340", label: "IGAPORA" },
		{ value: "1345", label: "IGRAPIUNA" },
		{ value: "1350", label: "IGUAI" },
		{ value: "1360", label: "ILHEUS" },
		{ value: "1370", label: "INHAMBUPE" },
		{ value: "1380", label: "IPECAETA" },
		{ value: "1390", label: "IPIAU" },
		{ value: "1400", label: "IPIRA" },
		{ value: "1410", label: "IPUPIARA" },
		{ value: "1420", label: "IRAJUBA" },
		{ value: "1430", label: "IRAMAIA" },
		{ value: "1440", label: "IRAQUARA" },
		{ value: "1450", label: "IRARA" },
		{ value: "1460", label: "IRECE" },
		{ value: "1465", label: "ITABELA" },
		{ value: "1470", label: "ITABERABA" },
		{ value: "1480", label: "ITABUNA" },
		{ value: "1490", label: "ITACARE" },
		{ value: "1500", label: "ITAETE" },
		{ value: "1510", label: "ITAGI" },
		{ value: "1520", label: "ITAGIBA" },
		{ value: "1530", label: "ITAGIMIRIM" },
		{ value: "1535", label: "ITAGUACU DA BAHIA" },
		{ value: "1540", label: "ITAJU DO COLONIA" },
		{ value: "1550", label: "ITAJUIPE" },
		{ value: "1560", label: "ITAMARAJU" },
		{ value: "1570", label: "ITAMARI" },
		{ value: "1580", label: "ITAMBE" },
		{ value: "1590", label: "ITANAGRA" },
		{ value: "1600", label: "ITANHEM" },
		{ value: "1610", label: "ITAPARICA" },
		{ value: "1620", label: "ITAPE" },
		{ value: "1630", label: "ITAPEBI" },
		{ value: "1640", label: "ITAPETINGA" },
		{ value: "1650", label: "ITAPICURU" },
		{ value: "1660", label: "ITAPITANGA" },
		{ value: "1670", label: "ITAQUARA" },
		{ value: "1680", label: "ITARANTIM" },
		{ value: "1685", label: "ITATIM" },
		{ value: "1690", label: "ITIRUCU" },
		{ value: "1700", label: "ITIUBA" },
		{ value: "1710", label: "ITORORO" },
		{ value: "1720", label: "ITUACU" },
		{ value: "1730", label: "ITUBERA" },
		{ value: "1733", label: "IUIU" },
		{ value: "1735", label: "JABORANDI" },
		{ value: "1740", label: "JACARACI" },
		{ value: "1750", label: "JACOBINA" },
		{ value: "1760", label: "JAGUAQUARA" },
		{ value: "1770", label: "JAGUARARI" },
		{ value: "1780", label: "JAGUARIPE" },
		{ value: "1790", label: "JANDAIRA" },
		{ value: "1800", label: "JEQUIE" },
		{ value: "1810", label: "JEREMOABO" },
		{ value: "1820", label: "JIQUIRICA" },
		{ value: "1830", label: "JITAUNA" },
		{ value: "1835", label: "JOAO DOURADO" },
		{ value: "1840", label: "JUAZEIRO" },
		{ value: "1845", label: "JUCURUCU" },
		{ value: "1850", label: "JUSSARA" },
		{ value: "1855", label: "JUSSARI" },
		{ value: "1860", label: "JUSSIAPE" },
		{ value: "1870", label: "LAFAIETE COUTINHO" },
		{ value: "1875", label: "LAGOA REAL" },
		{ value: "1880", label: "LAJE" },
		{ value: "1890", label: "LAJEDAO" },
		{ value: "1900", label: "LAJEDINHO" },
		{ value: "1905", label: "LAJEDO DO TABOCAL" },
		{ value: "1910", label: "LAMARAO" },
		{ value: "1915", label: "LAPAO" },
		{ value: "1920", label: "LAURO DE FREITAS" },
		{ value: "1930", label: "LENCOIS" },
		{ value: "1940", label: "LICINIO DE ALMEIDA" },
		{ value: "1950", label: "LIVRAMENTO DE NOSSA SENHORA" },
		{ value: "1955", label: "LUIS EDUARDO MAGALHAES" },
		{ value: "1960", label: "MACAJUBA" },
		{ value: "1970", label: "MACARANI" },
		{ value: "1980", label: "MACAUBAS" },
		{ value: "1990", label: "MACURURE" },
		{ value: "1992", label: "MADRE DE DEUS" },
		{ value: "1995", label: "MAETINGA" },
		{ value: "2000", label: "MAIQUINIQUE" },
		{ value: "2010", label: "MAIRI" },
		{ value: "2020", label: "MALHADA" },
		{ value: "2030", label: "MALHADA DE PEDRAS" },
		{ value: "2040", label: "MANOEL VITORINO" },
		{ value: "2045", label: "MANSIDAO" },
		{ value: "2050", label: "MARACAS" },
		{ value: "2060", label: "MARAGOGIPE" },
		{ value: "2070", label: "MARAU" },
		{ value: "2080", label: "MARCIONILIO SOUZA" },
		{ value: "2090", label: "MASCOTE" },
		{ value: "2100", label: "MATA DE SAO JOAO" },
		{ value: "2105", label: "MATINA" },
		{ value: "2110", label: "MEDEIROS NETO" },
		{ value: "2120", label: "MIGUEL CALMON" },
		{ value: "2130", label: "MILAGRES" },
		{ value: "2140", label: "MIRANGABA" },
		{ value: "2145", label: "MIRANTE" },
		{ value: "2150", label: "MONTE SANTO" },
		{ value: "2160", label: "MORPARA" },
		{ value: "2170", label: "MORRO DO CHAPEU" },
		{ value: "2180", label: "MORTUGABA" },
		{ value: "2190", label: "MUCUGE" },
		{ value: "2200", label: "MUCURI" },
		{ value: "2205", label: "MULUNGU DO MORRO" },
		{ value: "2210", label: "MUNDO NOVO" },
		{ value: "2220", label: "MUNIZ FERREIRA" },
		{ value: "2225", label: "MUQUEM DE SAO FRANCISCO" },
		{ value: "2230", label: "MURITIBA" },
		{ value: "2240", label: "MUTUIPE" },
		{ value: "2250", label: "NAZARE" },
		{ value: "2260", label: "NILO PECANHA" },
		{ value: "2265", label: "NORDESTINA" },
		{ value: "2270", label: "NOVA CANAA" },
		{ value: "2273", label: "NOVA FATIMA" },
		{ value: "2275", label: "NOVA IBIA" },
		{ value: "2280", label: "NOVA ITARANA" },
		{ value: "2285", label: "NOVA REDENCAO" },
		{ value: "2290", label: "NOVA SOURE" },
		{ value: "2300", label: "NOVA VICOSA" },
		{ value: "2303", label: "NOVO HORIZONTE" },
		{ value: "2305", label: "NOVO TRIUNFO" },
		{ value: "2310", label: "OLINDINA" },
		{ value: "2320", label: "OLIVEIRA DOS BREJINHOS" },
		{ value: "2330", label: "OURICANGAS" },
		{ value: "2335", label: "OUROLANDIA" },
		{ value: "2340", label: "PALMAS DE MONTE ALTO" },
		{ value: "2350", label: "PALMEIRAS" },
		{ value: "2360", label: "PARAMIRIM" },
		{ value: "2370", label: "PARATINGA" },
		{ value: "2380", label: "PARIPIRANGA" },
		{ value: "2390", label: "PAU BRASIL" },
		{ value: "2400", label: "PAULO AFONSO" },
		{ value: "2405", label: "PE DE SERRA" },
		{ value: "2410", label: "PEDRAO" },
		{ value: "2420", label: "PEDRO ALEXANDRE" },
		{ value: "2430", label: "PIATA" },
		{ value: "2440", label: "PILAO ARCADO" },
		{ value: "2450", label: "PINDAI" },
		{ value: "2460", label: "PINDOBACU" },
		{ value: "2465", label: "PINTADAS" },
		{ value: "2467", label: "PIRAI DO NORTE" },
		{ value: "2470", label: "PIRIPA" },
		{ value: "2480", label: "PIRITIBA" },
		{ value: "2490", label: "PLANALTINO" },
		{ value: "2500", label: "PLANALTO" },
		{ value: "2510", label: "POCOES" },
		{ value: "2520", label: "POJUCA" },
		{ value: "2525", label: "PONTO NOVO" },
		{ value: "2530", label: "PORTO SEGURO" },
		{ value: "2540", label: "POTIRAGUA" },
		{ value: "2550", label: "PRADO" },
		{ value: "2560", label: "PRESIDENTE DUTRA" },
		{ value: "2570", label: "PRESIDENTE JANIO QUADROS" },
		{ value: "2575", label: "PRESIDENTE TANCREDO NEVES" },
		{ value: "2580", label: "QUEIMADAS" },
		{ value: "2590", label: "QUIJINGUE" },
		{ value: "2593", label: "QUIXABEIRA" },
		{ value: "2595", label: "RAFAEL JAMBEIRO" },
		{ value: "2600", label: "REMANSO" },
		{ value: "2610", label: "RETIROLANDIA" },
		{ value: "2620", label: "RIACHAO DAS NEVES" },
		{ value: "2630", label: "RIACHAO DO JACUIPE" },
		{ value: "2640", label: "RIACHO DE SANTANA" },
		{ value: "2650", label: "RIBEIRA DO AMPARO" },
		{ value: "2660", label: "RIBEIRA DO POMBAL" },
		{ value: "2665", label: "RIBEIRAO DO LARGO" },
		{ value: "2670", label: "RIO DE CONTAS" },
		{ value: "2680", label: "RIO DO ANTONIO" },
		{ value: "2690", label: "RIO DO PIRES" },
		{ value: "2700", label: "RIO REAL" },
		{ value: "2710", label: "RODELAS" },
		{ value: "2720", label: "RUY BARBOSA" },
		{ value: "2730", label: "SALINAS DA MARGARIDA" },
		{ value: "2740", label: "SALVADOR" },
		{ value: "2750", label: "SANTA BARBARA" },
		{ value: "2760", label: "SANTA BRIGIDA" },
		{ value: "2770", label: "SANTA CRUZ CABRALIA" },
		{ value: "2780", label: "SANTA CRUZ DA VITORIA" },
		{ value: "2790", label: "SANTA INES" },
		{ value: "2805", label: "SANTA LUZIA" },
		{ value: "2810", label: "SANTA MARIA DA VITORIA" },
		{ value: "2840", label: "SANTA RITA DE CASSIA" },
		{ value: "2850", label: "SANTA TERESINHA" },
		{ value: "2800", label: "SANTALUZ" },
		{ value: "2820", label: "SANTANA" },
		{ value: "2830", label: "SANTANOPOLIS" },
		{ value: "2860", label: "SANTO AMARO" },
		{ value: "2870", label: "SANTO ANTONIO DE JESUS" },
		{ value: "2880", label: "SANTO ESTEVAO" },
		{ value: "2890", label: "SAO DESIDERIO" },
		{ value: "2895", label: "SAO DOMINGOS" },
		{ value: "2910", label: "SAO FELIPE" },
		{ value: "2900", label: "SAO FELIX" },
		{ value: "2905", label: "SAO FELIX DO CORIBE" },
		{ value: "2920", label: "SAO FRANCISCO DO CONDE" },
		{ value: "2925", label: "SAO GABRIEL" },
		{ value: "2930", label: "SAO GONCALO DOS CAMPOS" },
		{ value: "2935", label: "SAO JOSE DA VITORIA" },
		{ value: "2937", label: "SAO JOSE DO JACUIPE" },
		{ value: "2940", label: "SAO MIGUEL DAS MATAS" },
		{ value: "2950", label: "SAO SEBASTIAO DO PASSE" },
		{ value: "2960", label: "SAPEACU" },
		{ value: "2970", label: "SATIRO DIAS" },
		{ value: "2975", label: "SAUBARA" },
		{ value: "2980", label: "SAUDE" },
		{ value: "2990", label: "SEABRA" },
		{ value: "3000", label: "SEBASTIAO LARANJEIRAS" },
		{ value: "3010", label: "SENHOR DO BONFIM" },
		{ value: "3020", label: "SENTO SE" },
		{ value: "3015", label: "SERRA DO RAMALHO" },
		{ value: "3030", label: "SERRA DOURADA" },
		{ value: "3040", label: "SERRA PRETA" },
		{ value: "3050", label: "SERRINHA" },
		{ value: "3060", label: "SERROLANDIA" },
		{ value: "3070", label: "SIMOES FILHO" },
		{ value: "3075", label: "SITIO DO MATO" },
		{ value: "3076", label: "SITIO DO QUINTO" },
		{ value: "3077", label: "SOBRADINHO" },
		{ value: "3080", label: "SOUTO SOARES" },
		{ value: "3090", label: "TABOCAS DO BREJO VELHO" },
		{ value: "3100", label: "TANHACU" },
		{ value: "3105", label: "TANQUE NOVO" },
		{ value: "3110", label: "TANQUINHO" },
		{ value: "3120", label: "TAPEROA" },
		{ value: "3130", label: "TAPIRAMUTA" },
		{ value: "3135", label: "TEIXEIRA DE FREITAS" },
		{ value: "3140", label: "TEODORO SAMPAIO" },
		{ value: "3150", label: "TEOFILANDIA" },
		{ value: "3160", label: "TEOLANDIA" },
		{ value: "3170", label: "TERRA NOVA" },
		{ value: "3180", label: "TREMEDAL" },
		{ value: "3190", label: "TUCANO" },
		{ value: "3200", label: "UAUA" },
		{ value: "3210", label: "UBAIRA" },
		{ value: "3220", label: "UBAITABA" },
		{ value: "3230", label: "UBATA" },
		{ value: "3240", label: "UIBAI" },
		{ value: "3245", label: "UMBURANAS" },
		{ value: "3250", label: "UNA" },
		{ value: "3260", label: "URANDI" },
		{ value: "3270", label: "URUCUCA" },
		{ value: "3280", label: "UTINGA" },
		{ value: "3290", label: "VALENCA" },
		{ value: "3300", label: "VALENTE" },
		{ value: "3305", label: "VARZEA DA ROCA" },
		{ value: "3310", label: "VARZEA DO POCO" },
		{ value: "3315", label: "VARZEA NOVA" },
		{ value: "3317", label: "VARZEDO" },
		{ value: "3320", label: "VERA CRUZ" },
		{ value: "3325", label: "VEREDA" },
		{ value: "3330", label: "VITORIA DA CONQUISTA" },
		{ value: "3340", label: "WAGNER" },
		{ value: "3345", label: "WANDERLEY" },
		{ value: "3350", label: "WENCESLAU GUIMARAES" },
		{ value: "3360", label: "XIQUE-XIQUE" },
	],
	MG: [
		{ value: "0010", label: "ABADIA DOS DOURADOS" },
		{ value: "0020", label: "ABAETE" },
		{ value: "0030", label: "ABRE CAMPO" },
		{ value: "0040", label: "ACAIACA" },
		{ value: "0050", label: "ACUCENA" },
		{ value: "0060", label: "AGUA BOA" },
		{ value: "0070", label: "AGUA COMPRIDA" },
		{ value: "0080", label: "AGUANIL" },
		{ value: "0090", label: "AGUAS FORMOSAS" },
		{ value: "0100", label: "AGUAS VERMELHAS" },
		{ value: "0110", label: "AIMORES" },
		{ value: "0120", label: "AIURUOCA" },
		{ value: "0130", label: "ALAGOA" },
		{ value: "0140", label: "ALBERTINA" },
		{ value: "0150", label: "ALEM PARAIBA" },
		{ value: "0160", label: "ALFENAS" },
		{ value: "0163", label: "ALFREDO VASCONCELOS" },
		{ value: "0170", label: "ALMENARA" },
		{ value: "0180", label: "ALPERCATA" },
		{ value: "0190", label: "ALPINOPOLIS" },
		{ value: "0200", label: "ALTEROSA" },
		{ value: "0205", label: "ALTO CAPARAO" },
		{ value: "5350", label: "ALTO JEQUITIBA" },
		{ value: "0210", label: "ALTO RIO DOCE" },
		{ value: "0220", label: "ALVARENGA" },
		{ value: "0230", label: "ALVINOPOLIS" },
		{ value: "0240", label: "ALVORADA DE MINAS" },
		{ value: "0000", label: "AMPARO DA SERRA" },
		{ value: "0250", label: "AMPARO DO SERRA" },
		{ value: "0260", label: "ANDRADAS" },
		{ value: "0280", label: "ANDRELANDIA" },
		{ value: "0285", label: "ANGELANDIA" },
		{ value: "0290", label: "ANTONIO CARLOS" },
		{ value: "0300", label: "ANTONIO DIAS" },
		{ value: "0310", label: "ANTONIO PRADO DE MINAS" },
		{ value: "0320", label: "ARACAI" },
		{ value: "0330", label: "ARACITABA" },
		{ value: "0340", label: "ARACUAI" },
		{ value: "0350", label: "ARAGUARI" },
		{ value: "0360", label: "ARANTINA" },
		{ value: "0370", label: "ARAPONGA" },
		{ value: "0375", label: "ARAPORA" },
		{ value: "0380", label: "ARAPUA" },
		{ value: "0390", label: "ARAUJOS" },
		{ value: "0400", label: "ARAXA" },
		{ value: "0410", label: "ARCEBURGO" },
		{ value: "0420", label: "ARCOS" },
		{ value: "0430", label: "AREADO" },
		{ value: "0440", label: "ARGIRITA" },
		{ value: "0445", label: "ARICANDUVA" },
		{ value: "0450", label: "ARINOS" },
		{ value: "0460", label: "ASTOLFO DUTRA" },
		{ value: "0470", label: "ATALEIA" },
		{ value: "0480", label: "AUGUSTO DE LIMA" },
		{ value: "0490", label: "BAEPENDI" },
		{ value: "0500", label: "BALDIM" },
		{ value: "0510", label: "BAMBUI" },
		{ value: "0520", label: "BANDEIRA" },
		{ value: "0530", label: "BANDEIRA DO SUL" },
		{ value: "0540", label: "BARAO DE COCAIS" },
		{ value: "0550", label: "BARAO DE MONTE ALTO" },
		{ value: "0560", label: "BARBACENA" },
		{ value: "0570", label: "BARRA LONGA" },
		{ value: "0590", label: "BARROSO" },
		{ value: "0600", label: "BELA VISTA DE MINAS" },
		{ value: "0610", label: "BELMIRO BRAGA" },
		{ value: "0620", label: "BELO HORIZONTE" },
		{ value: "0630", label: "BELO ORIENTE" },
		{ value: "0640", label: "BELO VALE" },
		{ value: "0650", label: "BERILO" },
		{ value: "0665", label: "BERIZAL" },
		{ value: "0660", label: "BERTOPOLIS" },
		{ value: "0670", label: "BETIM" },
		{ value: "0680", label: "BIAS FORTES" },
		{ value: "0690", label: "BICAS" },
		{ value: "0700", label: "BIQUINHAS" },
		{ value: "0710", label: "BOA ESPERANCA" },
		{ value: "0720", label: "BOCAINA DE MINAS" },
		{ value: "0730", label: "BOCAIUVA" },
		{ value: "0740", label: "BOM DESPACHO" },
		{ value: "0750", label: "BOM JARDIM DE MINAS" },
		{ value: "0760", label: "BOM JESUS DA PENHA" },
		{ value: "0770", label: "BOM JESUS DO AMPARO" },
		{ value: "0780", label: "BOM JESUS DO GALHO" },
		{ value: "0790", label: "BOM REPOUSO" },
		{ value: "0800", label: "BOM SUCESSO" },
		{ value: "0810", label: "BONFIM" },
		{ value: "0820", label: "BONFINOPOLIS DE MINAS" },
		{ value: "0825", label: "BONITO DE MINAS" },
		{ value: "0830", label: "BORDA DA MATA" },
		{ value: "0840", label: "BOTELHOS" },
		{ value: "0850", label: "BOTUMIRIM" },
		{ value: "0870", label: "BRAS PIRES" },
		{ value: "0855", label: "BRASILANDIA DE MINAS" },
		{ value: "0860", label: "BRASILIA DE MINAS" },
		{ value: "0890", label: "BRASOPOLIS" },
		{ value: "0880", label: "BRAUNAS" },
		{ value: "0000", label: "BRAZOPOLIS" },
		{ value: "0900", label: "BRUMADINHO" },
		{ value: "0910", label: "BUENO BRANDAO" },
		{ value: "0920", label: "BUENOPOLIS" },
		{ value: "0925", label: "BUGRE" },
		{ value: "0930", label: "BURITIS" },
		{ value: "0940", label: "BURITIZEIRO" },
		{ value: "0945", label: "CABECEIRA GRANDE" },
		{ value: "0950", label: "CABO VERDE" },
		{ value: "0960", label: "CACHOEIRA DA PRATA" },
		{ value: "0970", label: "CACHOEIRA DE MINAS" },
		{ value: "0270", label: "CACHOEIRA DE PAJEU" },
		{ value: "0980", label: "CACHOEIRA DOURADA" },
		{ value: "0990", label: "CAETANOPOLIS" },
		{ value: "1000", label: "CAETE" },
		{ value: "1010", label: "CAIANA" },
		{ value: "1020", label: "CAJURI" },
		{ value: "1030", label: "CALDAS" },
		{ value: "1040", label: "CAMACHO" },
		{ value: "1050", label: "CAMANDUCAIA" },
		{ value: "1060", label: "CAMBUI" },
		{ value: "1070", label: "CAMBUQUIRA" },
		{ value: "1080", label: "CAMPANARIO" },
		{ value: "1090", label: "CAMPANHA" },
		{ value: "1100", label: "CAMPESTRE" },
		{ value: "1110", label: "CAMPINA VERDE" },
		{ value: "1115", label: "CAMPO AZUL" },
		{ value: "1120", label: "CAMPO BELO" },
		{ value: "1130", label: "CAMPO DO MEIO" },
		{ value: "1140", label: "CAMPO FLORIDO" },
		{ value: "1150", label: "CAMPOS ALTOS" },
		{ value: "1160", label: "CAMPOS GERAIS" },
		{ value: "1190", label: "CANA VERDE" },
		{ value: "1170", label: "CANAA" },
		{ value: "1180", label: "CANAPOLIS" },
		{ value: "1200", label: "CANDEIAS" },
		{ value: "1205", label: "CANTAGALO" },
		{ value: "1210", label: "CAPARAO" },
		{ value: "1220", label: "CAPELA NOVA" },
		{ value: "1230", label: "CAPELINHA" },
		{ value: "1240", label: "CAPETINGA" },
		{ value: "1250", label: "CAPIM BRANCO" },
		{ value: "1260", label: "CAPINOPOLIS" },
		{ value: "1265", label: "CAPITAO ANDRADE" },
		{ value: "1270", label: "CAPITAO ENEAS" },
		{ value: "1280", label: "CAPITOLIO" },
		{ value: "1290", label: "CAPUTIRA" },
		{ value: "1300", label: "CARAI" },
		{ value: "1310", label: "CARANAIBA" },
		{ value: "1320", label: "CARANDAI" },
		{ value: "1330", label: "CARANGOLA" },
		{ value: "1340", label: "CARATINGA" },
		{ value: "1350", label: "CARBONITA" },
		{ value: "1360", label: "CAREACU" },
		{ value: "1370", label: "CARLOS CHAGAS" },
		{ value: "1380", label: "CARMESIA" },
		{ value: "1390", label: "CARMO DA CACHOEIRA" },
		{ value: "1400", label: "CARMO DA MATA" },
		{ value: "1410", label: "CARMO DE MINAS" },
		{ value: "1420", label: "CARMO DO CAJURU" },
		{ value: "1430", label: "CARMO DO PARANAIBA" },
		{ value: "1440", label: "CARMO DO RIO CLARO" },
		{ value: "1450", label: "CARMOPOLIS DE MINAS" },
		{ value: "1455", label: "CARNEIRINHO" },
		{ value: "1460", label: "CARRANCAS" },
		{ value: "1470", label: "CARVALHOPOLIS" },
		{ value: "1480", label: "CARVALHOS" },
		{ value: "1490", label: "CASA GRANDE" },
		{ value: "1500", label: "CASCALHO RICO" },
		{ value: "1510", label: "CASSIA" },
		{ value: "1530", label: "CATAGUASES" },
		{ value: "1535", label: "CATAS ALTAS" },
		{ value: "1540", label: "CATAS ALTAS DA NORUEGA" },
		{ value: "1545", label: "CATUJI" },
		{ value: "1547", label: "CATUTI" },
		{ value: "1550", label: "CAXAMBU" },
		{ value: "1560", label: "CEDRO DO ABAETE" },
		{ value: "1570", label: "CENTRAL DE MINAS" },
		{ value: "1580", label: "CENTRALINA" },
		{ value: "1590", label: "CHACARA" },
		{ value: "1600", label: "CHALE" },
		{ value: "1610", label: "CHAPADA DO NORTE" },
		{ value: "1615", label: "CHAPADA GAUCHA" },
		{ value: "1620", label: "CHIADOR" },
		{ value: "1630", label: "CIPOTANEA" },
		{ value: "1640", label: "CLARAVAL" },
		{ value: "1650", label: "CLARO DOS POCOES" },
		{ value: "1660", label: "CLAUDIO" },
		{ value: "1670", label: "COIMBRA" },
		{ value: "1680", label: "COLUNA" },
		{ value: "1690", label: "COMENDADOR GOMES" },
		{ value: "1700", label: "COMERCINHO" },
		{ value: "1710", label: "CONCEICAO DA APARECIDA" },
		{ value: "1520", label: "CONCEICAO DA BARRA DE MINAS" },
		{ value: "1730", label: "CONCEICAO DAS ALAGOAS" },
		{ value: "1720", label: "CONCEICAO DAS PEDRAS" },
		{ value: "1740", label: "CONCEICAO DE IPANEMA" },
		{ value: "1750", label: "CONCEICAO DO MATO DENTRO" },
		{ value: "1760", label: "CONCEICAO DO PARA" },
		{ value: "1770", label: "CONCEICAO DO RIO VERDE" },
		{ value: "1780", label: "CONCEICAO DOS OUROS" },
		{ value: "1783", label: "CONEGO MARINHO" },
		{ value: "1787", label: "CONFINS" },
		{ value: "1790", label: "CONGONHAL" },
		{ value: "1800", label: "CONGONHAS" },
		{ value: "1810", label: "CONGONHAS DO NORTE" },
		{ value: "1820", label: "CONQUISTA" },
		{ value: "1830", label: "CONSELHEIRO LAFAIETE" },
		{ value: "1840", label: "CONSELHEIRO PENA" },
		{ value: "1850", label: "CONSOLACAO" },
		{ value: "1860", label: "CONTAGEM" },
		{ value: "1870", label: "COQUEIRAL" },
		{ value: "1880", label: "CORACAO DE JESUS" },
		{ value: "1890", label: "CORDISBURGO" },
		{ value: "1900", label: "CORDISLANDIA" },
		{ value: "1910", label: "CORINTO" },
		{ value: "1920", label: "COROACI" },
		{ value: "1930", label: "COROMANDEL" },
		{ value: "1940", label: "CORONEL FABRICIANO" },
		{ value: "1950", label: "CORONEL MURTA" },
		{ value: "1960", label: "CORONEL PACHECO" },
		{ value: "1970", label: "CORONEL XAVIER CHAVES" },
		{ value: "1980", label: "CORREGO DANTA" },
		{ value: "1990", label: "CORREGO DO BOM JESUS" },
		{ value: "1995", label: "CORREGO FUNDO" },
		{ value: "2000", label: "CORREGO NOVO" },
		{ value: "2010", label: "COUTO DE MAGALHAES DE MINAS" },
		{ value: "2015", label: "CRISOLITA" },
		{ value: "2020", label: "CRISTAIS" },
		{ value: "2030", label: "CRISTALIA" },
		{ value: "2040", label: "CRISTIANO OTONI" },
		{ value: "2050", label: "CRISTINA" },
		{ value: "2060", label: "CRUCILANDIA" },
		{ value: "2070", label: "CRUZEIRO DA FORTALEZA" },
		{ value: "2080", label: "CRUZILIA" },
		{ value: "2083", label: "CUPARAQUE" },
		{ value: "2087", label: "CURRAL DE DENTRO" },
		{ value: "2090", label: "CURVELO" },
		{ value: "2100", label: "DATAS" },
		{ value: "2110", label: "DELFIM MOREIRA" },
		{ value: "2120", label: "DELFINOPOLIS" },
		{ value: "2125", label: "DELTA" },
		{ value: "2130", label: "DESCOBERTO" },
		{ value: "2140", label: "DESTERRO DE ENTRE RIOS" },
		{ value: "2150", label: "DESTERRO DO MELO" },
		{ value: "2160", label: "DIAMANTINA" },
		{ value: "2170", label: "DIOGO DE VASCONCELOS" },
		{ value: "2180", label: "DIONISIO" },
		{ value: "2190", label: "DIVINESIA" },
		{ value: "2200", label: "DIVINO" },
		{ value: "2210", label: "DIVINO DAS LARANJEIRAS" },
		{ value: "2220", label: "DIVINOLANDIA DE MINAS" },
		{ value: "2230", label: "DIVINOPOLIS" },
		{ value: "2235", label: "DIVISA ALEGRE" },
		{ value: "2240", label: "DIVISA NOVA" },
		{ value: "2245", label: "DIVISOPOLIS" },
		{ value: "2247", label: "DOM BOSCO" },
		{ value: "2250", label: "DOM CAVATI" },
		{ value: "2260", label: "DOM JOAQUIM" },
		{ value: "2270", label: "DOM SILVERIO" },
		{ value: "2280", label: "DOM VICOSO" },
		{ value: "2290", label: "DONA EUSEBIA" },
		{ value: "0000", label: "DONA EUZEBIA" },
		{ value: "2300", label: "DORES DE CAMPOS" },
		{ value: "2310", label: "DORES DE GUANHAES" },
		{ value: "2320", label: "DORES DO INDAIA" },
		{ value: "2330", label: "DORES DO TURVO" },
		{ value: "2340", label: "DORESOPOLIS" },
		{ value: "2350", label: "DOURADOQUARA" },
		{ value: "2352", label: "DURANDE" },
		{ value: "2360", label: "ELOI MENDES" },
		{ value: "2370", label: "ENGENHEIRO CALDAS" },
		{ value: "2380", label: "ENGENHEIRO NAVARRO" },
		{ value: "2385", label: "ENTRE FOLHAS" },
		{ value: "2390", label: "ENTRE RIOS DE MINAS" },
		{ value: "2400", label: "ERVALIA" },
		{ value: "2410", label: "ESMERALDAS" },
		{ value: "2420", label: "ESPERA FELIZ" },
		{ value: "2430", label: "ESPINOSA" },
		{ value: "2440", label: "ESPIRITO SANTO DO DOURADO" },
		{ value: "2450", label: "ESTIVA" },
		{ value: "2460", label: "ESTRELA DALVA" },
		{ value: "2470", label: "ESTRELA DO INDAIA" },
		{ value: "2480", label: "ESTRELA DO SUL" },
		{ value: "2490", label: "EUGENOPOLIS" },
		{ value: "2500", label: "EWBANK DA CAMARA" },
		{ value: "2510", label: "EXTREMA" },
		{ value: "2520", label: "FAMA" },
		{ value: "2530", label: "FARIA LEMOS" },
		{ value: "2540", label: "FELICIO DOS SANTOS" },
		{ value: "2560", label: "FELISBURGO" },
		{ value: "2570", label: "FELIXLANDIA" },
		{ value: "2580", label: "FERNANDES TOURINHO" },
		{ value: "2590", label: "FERROS" },
		{ value: "2595", label: "FERVEDOURO" },
		{ value: "2600", label: "FLORESTAL" },
		{ value: "2610", label: "FORMIGA" },
		{ value: "2620", label: "FORMOSO" },
		{ value: "2630", label: "FORTALEZA DE MINAS" },
		{ value: "2640", label: "FORTUNA DE MINAS" },
		{ value: "2650", label: "FRANCISCO BADARO" },
		{ value: "2660", label: "FRANCISCO DUMONT" },
		{ value: "2670", label: "FRANCISCO SA" },
		{ value: "2675", label: "FRANCISCOPOLIS" },
		{ value: "2680", label: "FREI GASPAR" },
		{ value: "2690", label: "FREI INOCENCIO" },
		{ value: "2695", label: "FREI LAGONEGRO" },
		{ value: "2700", label: "FRONTEIRA" },
		{ value: "2705", label: "FRONTEIRA DOS VALES" },
		{ value: "2707", label: "FRUTA DE LEITE" },
		{ value: "2710", label: "FRUTAL" },
		{ value: "2720", label: "FUNILANDIA" },
		{ value: "2730", label: "GALILEIA" },
		{ value: "2733", label: "GAMELEIRAS" },
		{ value: "2735", label: "GLAUCILANDIA" },
		{ value: "2737", label: "GOIABEIRA" },
		{ value: "2738", label: "GOIANA" },
		{ value: "2740", label: "GONCALVES" },
		{ value: "2750", label: "GONZAGA" },
		{ value: "2760", label: "GOUVEIA" },
		{ value: "2770", label: "GOVERNADOR VALADARES" },
		{ value: "2780", label: "GRAO MOGOL" },
		{ value: "2790", label: "GRUPIARA" },
		{ value: "2800", label: "GUANHAES" },
		{ value: "2810", label: "GUAPE" },
		{ value: "2820", label: "GUARACIABA" },
		{ value: "2825", label: "GUARACIAMA" },
		{ value: "2830", label: "GUARANESIA" },
		{ value: "2840", label: "GUARANI" },
		{ value: "2850", label: "GUARARA" },
		{ value: "2860", label: "GUARDA-MOR" },
		{ value: "2870", label: "GUAXUPE" },
		{ value: "2880", label: "GUIDOVAL" },
		{ value: "2890", label: "GUIMARANIA" },
		{ value: "2900", label: "GUIRICEMA" },
		{ value: "2910", label: "GURINHATA" },
		{ value: "2920", label: "HELIODORA" },
		{ value: "2930", label: "IAPU" },
		{ value: "2940", label: "IBERTIOGA" },
		{ value: "2950", label: "IBIA" },
		{ value: "2960", label: "IBIAI" },
		{ value: "2965", label: "IBIRACATU" },
		{ value: "2970", label: "IBIRACI" },
		{ value: "2980", label: "IBIRITE" },
		{ value: "2990", label: "IBITIURA DE MINAS" },
		{ value: "3000", label: "IBITURUNA" },
		{ value: "3005", label: "ICARAI DE MINAS" },
		{ value: "3010", label: "IGARAPE" },
		{ value: "3020", label: "IGARATINGA" },
		{ value: "3030", label: "IGUATAMA" },
		{ value: "3040", label: "IJACI" },
		{ value: "3050", label: "ILICINEA" },
		{ value: "3055", label: "IMBE DE MINAS" },
		{ value: "3060", label: "INCONFIDENTES" },
		{ value: "3065", label: "INDAIABIRA" },
		{ value: "3070", label: "INDIANOPOLIS" },
		{ value: "3080", label: "INGAI" },
		{ value: "3090", label: "INHAPIM" },
		{ value: "3100", label: "INHAUMA" },
		{ value: "3110", label: "INIMUTABA" },
		{ value: "3115", label: "IPABA" },
		{ value: "3120", label: "IPANEMA" },
		{ value: "3130", label: "IPATINGA" },
		{ value: "3140", label: "IPIACU" },
		{ value: "3150", label: "IPUIUNA" },
		{ value: "3160", label: "IRAI DE MINAS" },
		{ value: "3170", label: "ITABIRA" },
		{ value: "3180", label: "ITABIRINHA" },
		{ value: "3190", label: "ITABIRITO" },
		{ value: "3200", label: "ITACAMBIRA" },
		{ value: "3210", label: "ITACARAMBI" },
		{ value: "3220", label: "ITAGUARA" },
		{ value: "3230", label: "ITAIPE" },
		{ value: "3240", label: "ITAJUBA" },
		{ value: "3250", label: "ITAMARANDIBA" },
		{ value: "3260", label: "ITAMARATI DE MINAS" },
		{ value: "3270", label: "ITAMBACURI" },
		{ value: "3280", label: "ITAMBE DO MATO DENTRO" },
		{ value: "3290", label: "ITAMOGI" },
		{ value: "3300", label: "ITAMONTE" },
		{ value: "3310", label: "ITANHANDU" },
		{ value: "3320", label: "ITANHOMI" },
		{ value: "3330", label: "ITAOBIM" },
		{ value: "3340", label: "ITAPAGIPE" },
		{ value: "3350", label: "ITAPECERICA" },
		{ value: "3360", label: "ITAPEVA" },
		{ value: "3370", label: "ITATIAIUCU" },
		{ value: "3375", label: "ITAU DE MINAS" },
		{ value: "3380", label: "ITAUNA" },
		{ value: "3390", label: "ITAVERAVA" },
		{ value: "3400", label: "ITINGA" },
		{ value: "3410", label: "ITUETA" },
		{ value: "3420", label: "ITUIUTABA" },
		{ value: "3430", label: "ITUMIRIM" },
		{ value: "3440", label: "ITURAMA" },
		{ value: "3450", label: "ITUTINGA" },
		{ value: "3460", label: "JABOTICATUBAS" },
		{ value: "3470", label: "JACINTO" },
		{ value: "3480", label: "JACUI" },
		{ value: "3490", label: "JACUTINGA" },
		{ value: "3500", label: "JAGUARACU" },
		{ value: "3505", label: "JAIBA" },
		{ value: "3507", label: "JAMPRUCA" },
		{ value: "3510", label: "JANAUBA" },
		{ value: "3520", label: "JANUARIA" },
		{ value: "3530", label: "JAPARAIBA" },
		{ value: "3535", label: "JAPONVAR" },
		{ value: "3540", label: "JECEABA" },
		{ value: "3545", label: "JENIPAPO DE MINAS" },
		{ value: "3550", label: "JEQUERI" },
		{ value: "3560", label: "JEQUITAI" },
		{ value: "3570", label: "JEQUITIBA" },
		{ value: "3580", label: "JEQUITINHONHA" },
		{ value: "3590", label: "JESUANIA" },
		{ value: "3600", label: "JOAIMA" },
		{ value: "3610", label: "JOANESIA" },
		{ value: "3620", label: "JOAO MONLEVADE" },
		{ value: "3630", label: "JOAO PINHEIRO" },
		{ value: "3640", label: "JOAQUIM FELICIO" },
		{ value: "3650", label: "JORDANIA" },
		{ value: "3652", label: "JOSE GONCALVES DE MINAS" },
		{ value: "3655", label: "JOSE RAYDAN" },
		{ value: "3657", label: "JOSENOPOLIS" },
		{ value: "3665", label: "JUATUBA" },
		{ value: "3670", label: "JUIZ DE FORA" },
		{ value: "3680", label: "JURAMENTO" },
		{ value: "3690", label: "JURUAIA" },
		{ value: "3695", label: "JUVENILIA" },
		{ value: "3700", label: "LADAINHA" },
		{ value: "3710", label: "LAGAMAR" },
		{ value: "3720", label: "LAGOA DA PRATA" },
		{ value: "3730", label: "LAGOA DOS PATOS" },
		{ value: "3740", label: "LAGOA DOURADA" },
		{ value: "3750", label: "LAGOA FORMOSA" },
		{ value: "3753", label: "LAGOA GRANDE" },
		{ value: "3760", label: "LAGOA SANTA" },
		{ value: "3770", label: "LAJINHA" },
		{ value: "3780", label: "LAMBARI" },
		{ value: "3790", label: "LAMIM" },
		{ value: "3800", label: "LARANJAL" },
		{ value: "3810", label: "LASSANCE" },
		{ value: "3820", label: "LAVRAS" },
		{ value: "3830", label: "LEANDRO FERREIRA" },
		{ value: "3835", label: "LEME DO PRADO" },
		{ value: "3840", label: "LEOPOLDINA" },
		{ value: "3850", label: "LIBERDADE" },
		{ value: "3860", label: "LIMA DUARTE" },
		{ value: "3862", label: "LIMEIRA DO OESTE" },
		{ value: "3865", label: "LONTRA" },
		{ value: "3867", label: "LUISBURGO" },
		{ value: "3868", label: "LUISLANDIA" },
		{ value: "3870", label: "LUMINARIAS" },
		{ value: "3880", label: "LUZ" },
		{ value: "3890", label: "MACHACALIS" },
		{ value: "3900", label: "MACHADO" },
		{ value: "3910", label: "MADRE DE DEUS DE MINAS" },
		{ value: "3920", label: "MALACACHETA" },
		{ value: "3925", label: "MAMONAS" },
		{ value: "3930", label: "MANGA" },
		{ value: "3940", label: "MANHUACU" },
		{ value: "3950", label: "MANHUMIRIM" },
		{ value: "3960", label: "MANTENA" },
		{ value: "3980", label: "MAR DE ESPANHA" },
		{ value: "3970", label: "MARAVILHAS" },
		{ value: "3990", label: "MARIA DA FE" },
		{ value: "4000", label: "MARIANA" },
		{ value: "4010", label: "MARILAC" },
		{ value: "4015", label: "MARIO CAMPOS" },
		{ value: "4020", label: "MARIPA DE MINAS" },
		{ value: "4030", label: "MARLIERIA" },
		{ value: "4040", label: "MARMELOPOLIS" },
		{ value: "4050", label: "MARTINHO CAMPOS" },
		{ value: "4053", label: "MARTINS SOARES" },
		{ value: "4055", label: "MATA VERDE" },
		{ value: "4060", label: "MATERLANDIA" },
		{ value: "4070", label: "MATEUS LEME" },
		{ value: "7150", label: "MATHIAS LOBATO" },
		{ value: "4080", label: "MATIAS BARBOSA" },
		{ value: "4085", label: "MATIAS CARDOSO" },
		{ value: "4090", label: "MATIPO" },
		{ value: "4100", label: "MATO VERDE" },
		{ value: "4110", label: "MATOZINHOS" },
		{ value: "4120", label: "MATUTINA" },
		{ value: "4130", label: "MEDEIROS" },
		{ value: "4140", label: "MEDINA" },
		{ value: "4150", label: "MENDES PIMENTEL" },
		{ value: "4160", label: "MERCES" },
		{ value: "4170", label: "MESQUITA" },
		{ value: "4180", label: "MINAS NOVAS" },
		{ value: "4190", label: "MINDURI" },
		{ value: "4200", label: "MIRABELA" },
		{ value: "4210", label: "MIRADOURO" },
		{ value: "4220", label: "MIRAI" },
		{ value: "4225", label: "MIRAVANIA" },
		{ value: "4230", label: "MOEDA" },
		{ value: "4240", label: "MOEMA" },
		{ value: "4250", label: "MONJOLOS" },
		{ value: "4260", label: "MONSENHOR PAULO" },
		{ value: "4270", label: "MONTALVANIA" },
		{ value: "4280", label: "MONTE ALEGRE DE MINAS" },
		{ value: "4290", label: "MONTE AZUL" },
		{ value: "4300", label: "MONTE BELO" },
		{ value: "4310", label: "MONTE CARMELO" },
		{ value: "0000", label: "AMPARO DA SERRA" },
		{ value: "0000", label: "BRAZOPOLIS" },
		{ value: "0000", label: "DONA EUZEBIA" },
		{ value: "4315", label: "MONTE FORMOSO" },
		{ value: "4320", label: "MONTE SANTO DE MINAS" },
		{ value: "4340", label: "MONTE SIAO" },
		{ value: "4330", label: "MONTES CLAROS" },
		{ value: "4345", label: "MONTEZUMA" },
		{ value: "4350", label: "MORADA NOVA DE MINAS" },
		{ value: "4360", label: "MORRO DA GARCA" },
		{ value: "4370", label: "MORRO DO PILAR" },
		{ value: "4380", label: "MUNHOZ" },
		{ value: "4390", label: "MURIAE" },
		{ value: "4400", label: "MUTUM" },
		{ value: "4410", label: "MUZAMBINHO" },
		{ value: "4420", label: "NACIP RAYDAN" },
		{ value: "4430", label: "NANUQUE" },
		{ value: "4435", label: "NAQUE" },
		{ value: "4437", label: "NATALANDIA" },
		{ value: "4440", label: "NATERCIA" },
		{ value: "4450", label: "NAZARENO" },
		{ value: "4460", label: "NEPOMUCENO" },
		{ value: "4465", label: "NINHEIRA" },
		{ value: "4467", label: "NOVA BELEM" },
		{ value: "4470", label: "NOVA ERA" },
		{ value: "4480", label: "NOVA LIMA" },
		{ value: "4490", label: "NOVA MODICA" },
		{ value: "4500", label: "NOVA PONTE" },
		{ value: "4505", label: "NOVA PORTEIRINHA" },
		{ value: "4510", label: "NOVA RESENDE" },
		{ value: "4520", label: "NOVA SERRANA" },
		{ value: "3660", label: "NOVA UNIAO" },
		{ value: "4530", label: "NOVO CRUZEIRO" },
		{ value: "4535", label: "NOVO ORIENTE DE MINAS" },
		{ value: "4537", label: "NOVORIZONTE" },
		{ value: "4540", label: "OLARIA" },
		{ value: "0000", label: "OLHOS D'AGUA" },
		{ value: "4545", label: "OLHOS-D'AGUA" },
		{ value: "4550", label: "OLIMPIO NORONHA" },
		{ value: "4560", label: "OLIVEIRA" },
		{ value: "4570", label: "OLIVEIRA FORTES" },
		{ value: "4580", label: "ONCA DE PITANGUI" },
		{ value: "4585", label: "ORATORIOS" },
		{ value: "4587", label: "ORIZANIA" },
		{ value: "4590", label: "OURO BRANCO" },
		{ value: "4600", label: "OURO FINO" },
		{ value: "4610", label: "OURO PRETO" },
		{ value: "4620", label: "OURO VERDE DE MINAS" },
		{ value: "4625", label: "PADRE CARVALHO" },
		{ value: "4630", label: "PADRE PARAISO" },
		{ value: "4655", label: "PAI PEDRO" },
		{ value: "4640", label: "PAINEIRAS" },
		{ value: "4650", label: "PAINS" },
		{ value: "4660", label: "PAIVA" },
		{ value: "4670", label: "PALMA" },
		{ value: "4675", label: "PALMOPOLIS" },
		{ value: "4690", label: "PAPAGAIOS" },
		{ value: "4710", label: "PARA DE MINAS" },
		{ value: "4700", label: "PARACATU" },
		{ value: "4720", label: "PARAGUACU" },
		{ value: "4730", label: "PARAISOPOLIS" },
		{ value: "4740", label: "PARAOPEBA" },
		{ value: "4760", label: "PASSA QUATRO" },
		{ value: "4770", label: "PASSA TEMPO" },
		{ value: "0000", label: "PASSA VINTE" },
		{ value: "4780", label: "PASSA-VINTE" },
		{ value: "4750", label: "PASSABEM" },
		{ value: "4790", label: "PASSOS" },
		{ value: "4795", label: "PATIS" },
		{ value: "4800", label: "PATOS DE MINAS" },
		{ value: "4810", label: "PATROCINIO" },
		{ value: "4820", label: "PATROCINIO DO MURIAE" },
		{ value: "4830", label: "PAULA CANDIDO" },
		{ value: "4840", label: "PAULISTAS" },
		{ value: "4850", label: "PAVAO" },
		{ value: "4860", label: "PECANHA" },
		{ value: "4870", label: "PEDRA AZUL" },
		{ value: "4875", label: "PEDRA BONITA" },
		{ value: "4880", label: "PEDRA DO ANTA" },
		{ value: "4890", label: "PEDRA DO INDAIA" },
		{ value: "4900", label: "PEDRA DOURADA" },
		{ value: "4910", label: "PEDRALVA" },
		{ value: "4915", label: "PEDRAS DE MARIA DA CRUZ" },
		{ value: "4920", label: "PEDRINOPOLIS" },
		{ value: "4930", label: "PEDRO LEOPOLDO" },
		{ value: "4940", label: "PEDRO TEIXEIRA" },
		{ value: "4950", label: "PEQUERI" },
		{ value: "4960", label: "PEQUI" },
		{ value: "4970", label: "PERDIGAO" },
		{ value: "4980", label: "PERDIZES" },
		{ value: "4990", label: "PERDOES" },
		{ value: "4995", label: "PERIQUITO" },
		{ value: "5000", label: "PESCADOR" },
		{ value: "5010", label: "PIAU" },
		{ value: "5015", label: "PIEDADE DE CARATINGA" },
		{ value: "5020", label: "PIEDADE DE PONTE NOVA" },
		{ value: "5030", label: "PIEDADE DO RIO GRANDE" },
		{ value: "5040", label: "PIEDADE DOS GERAIS" },
		{ value: "5050", label: "PIMENTA" },
		{ value: "5053", label: "PINGO-D'AGUA" },
		{ value: "5057", label: "PINTOPOLIS" },
		{ value: "5060", label: "PIRACEMA" },
		{ value: "5070", label: "PIRAJUBA" },
		{ value: "5080", label: "PIRANGA" },
		{ value: "5090", label: "PIRANGUCU" },
		{ value: "5100", label: "PIRANGUINHO" },
		{ value: "5110", label: "PIRAPETINGA" },
		{ value: "5120", label: "PIRAPORA" },
		{ value: "5130", label: "PIRAUBA" },
		{ value: "5140", label: "PITANGUI" },
		{ value: "5150", label: "PIUMHI" },
		{ value: "5160", label: "PLANURA" },
		{ value: "5170", label: "POCO FUNDO" },
		{ value: "5180", label: "POCOS DE CALDAS" },
		{ value: "5190", label: "POCRANE" },
		{ value: "5200", label: "POMPEU" },
		{ value: "5210", label: "PONTE NOVA" },
		{ value: "5213", label: "PONTO CHIQUE" },
		{ value: "5217", label: "PONTO DOS VOLANTES" },
		{ value: "5220", label: "PORTEIRINHA" },
		{ value: "5230", label: "PORTO FIRME" },
		{ value: "5240", label: "POTE" },
		{ value: "5250", label: "POUSO ALEGRE" },
		{ value: "5260", label: "POUSO ALTO" },
		{ value: "5270", label: "PRADOS" },
		{ value: "5280", label: "PRATA" },
		{ value: "5290", label: "PRATAPOLIS" },
		{ value: "5300", label: "PRATINHA" },
		{ value: "5310", label: "PRESIDENTE BERNARDES" },
		{ value: "5320", label: "PRESIDENTE JUSCELINO" },
		{ value: "5330", label: "PRESIDENTE KUBITSCHEK" },
		{ value: "5340", label: "PRESIDENTE OLEGARIO" },
		{ value: "5360", label: "PRUDENTE DE MORAIS" },
		{ value: "5370", label: "QUARTEL GERAL" },
		{ value: "5380", label: "QUELUZITO" },
		{ value: "5390", label: "RAPOSOS" },
		{ value: "5400", label: "RAUL SOARES" },
		{ value: "5410", label: "RECREIO" },
		{ value: "5415", label: "REDUTO" },
		{ value: "5420", label: "RESENDE COSTA" },
		{ value: "5430", label: "RESPLENDOR" },
		{ value: "5440", label: "RESSAQUINHA" },
		{ value: "5445", label: "RIACHINHO" },
		{ value: "5450", label: "RIACHO DOS MACHADOS" },
		{ value: "5460", label: "RIBEIRAO DAS NEVES" },
		{ value: "5470", label: "RIBEIRAO VERMELHO" },
		{ value: "5480", label: "RIO ACIMA" },
		{ value: "5490", label: "RIO CASCA" },
		{ value: "5510", label: "RIO DO PRADO" },
		{ value: "5500", label: "RIO DOCE" },
		{ value: "5520", label: "RIO ESPERA" },
		{ value: "5530", label: "RIO MANSO" },
		{ value: "5540", label: "RIO NOVO" },
		{ value: "5550", label: "RIO PARANAIBA" },
		{ value: "5560", label: "RIO PARDO DE MINAS" },
		{ value: "5570", label: "RIO PIRACICABA" },
		{ value: "5580", label: "RIO POMBA" },
		{ value: "5590", label: "RIO PRETO" },
		{ value: "5600", label: "RIO VERMELHO" },
		{ value: "5610", label: "RITAPOLIS" },
		{ value: "5620", label: "ROCHEDO DE MINAS" },
		{ value: "5630", label: "RODEIRO" },
		{ value: "5640", label: "ROMARIA" },
		{ value: "5645", label: "ROSARIO DA LIMEIRA" },
		{ value: "5650", label: "RUBELITA" },
		{ value: "5660", label: "RUBIM" },
		{ value: "5670", label: "SABARA" },
		{ value: "5680", label: "SABINOPOLIS" },
		{ value: "5690", label: "SACRAMENTO" },
		{ value: "5700", label: "SALINAS" },
		{ value: "5710", label: "SALTO DA DIVISA" },
		{ value: "5720", label: "SANTA BARBARA" },
		{ value: "5725", label: "SANTA BARBARA DO LESTE" },
		{ value: "5727", label: "SANTA BARBARA DO MONTE VERDE" },
		{ value: "5730", label: "SANTA BARBARA DO TUGURIO" },
		{ value: "5733", label: "SANTA CRUZ DE MINAS" },
		{ value: "5737", label: "SANTA CRUZ DE SALINAS" },
		{ value: "5740", label: "SANTA CRUZ DO ESCALVADO" },
		{ value: "5750", label: "SANTA EFIGENIA DE MINAS" },
		{ value: "5760", label: "SANTA FE DE MINAS" },
		{ value: "5765", label: "SANTA HELENA DE MINAS" },
		{ value: "5770", label: "SANTA JULIANA" },
		{ value: "5780", label: "SANTA LUZIA" },
		{ value: "5790", label: "SANTA MARGARIDA" },
		{ value: "5800", label: "SANTA MARIA DE ITABIRA" },
		{ value: "5810", label: "SANTA MARIA DO SALTO" },
		{ value: "5820", label: "SANTA MARIA DO SUACUI" },
		{ value: "5920", label: "SANTA RITA DE CALDAS" },
		{ value: "5940", label: "SANTA RITA DE IBITIPOCA" },
		{ value: "5930", label: "SANTA RITA DE JACUTINGA" },
		{ value: "5935", label: "SANTA RITA DE MINAS" },
		{ value: "0000", label: "SANTA RITA DO IBITIPOCA" },
		{ value: "5950", label: "SANTA RITA DO ITUETO" },
		{ value: "5960", label: "SANTA RITA DO SAPUCAI" },
		{ value: "5970", label: "SANTA ROSA DA SERRA" },
		{ value: "5980", label: "SANTA VITORIA" },
		{ value: "5830", label: "SANTANA DA VARGEM" },
		{ value: "5840", label: "SANTANA DE CATAGUASES" },
		{ value: "5850", label: "SANTANA DE PIRAPAMA" },
		{ value: "5860", label: "SANTANA DO DESERTO" },
		{ value: "5870", label: "SANTANA DO GARAMBEU" },
		{ value: "5880", label: "SANTANA DO JACARE" },
		{ value: "5890", label: "SANTANA DO MANHUACU" },
		{ value: "5895", label: "SANTANA DO PARAISO" },
		{ value: "5900", label: "SANTANA DO RIACHO" },
		{ value: "5910", label: "SANTANA DOS MONTES" },
		{ value: "5990", label: "SANTO ANTONIO DO AMPARO" },
		{ value: "6000", label: "SANTO ANTONIO DO AVENTUREIRO" },
		{ value: "6010", label: "SANTO ANTONIO DO GRAMA" },
		{ value: "6020", label: "SANTO ANTONIO DO ITAMBE" },
		{ value: "6030", label: "SANTO ANTONIO DO JACINTO" },
		{ value: "6040", label: "SANTO ANTONIO DO MONTE" },
		{ value: "6045", label: "SANTO ANTONIO DO RETIRO" },
		{ value: "6050", label: "SANTO ANTONIO DO RIO ABAIXO" },
		{ value: "6060", label: "SANTO HIPOLITO" },
		{ value: "6070", label: "SANTOS DUMONT" },
		{ value: "6080", label: "SAO BENTO ABADE" },
		{ value: "6090", label: "SAO BRAS DO SUACUI" },
		{ value: "6095", label: "SAO DOMINGOS DAS DORES" },
		{ value: "6100", label: "SAO DOMINGOS DO PRATA" },
		{ value: "6105", label: "SAO FELIX DE MINAS" },
		{ value: "6110", label: "SAO FRANCISCO" },
		{ value: "6120", label: "SAO FRANCISCO DE PAULA" },
		{ value: "6130", label: "SAO FRANCISCO DE SALES" },
		{ value: "6140", label: "SAO FRANCISCO DO GLORIA" },
		{ value: "6150", label: "SAO GERALDO" },
		{ value: "6160", label: "SAO GERALDO DA PIEDADE" },
		{ value: "6165", label: "SAO GERALDO DO BAIXIO" },
		{ value: "6170", label: "SAO GONCALO DO ABAETE" },
		{ value: "6180", label: "SAO GONCALO DO PARA" },
		{ value: "6190", label: "SAO GONCALO DO RIO ABAIXO" },
		{ value: "2550", label: "SAO GONCALO DO RIO PRETO" },
		{ value: "6200", label: "SAO GONCALO DO SAPUCAI" },
		{ value: "6210", label: "SAO GOTARDO" },
		{ value: "6220", label: "SAO JOAO BATISTA DO GLORIA" },
		{ value: "6225", label: "SAO JOAO DA LAGOA" },
		{ value: "6230", label: "SAO JOAO DA MATA" },
		{ value: "6240", label: "SAO JOAO DA PONTE" },
		{ value: "6245", label: "SAO JOAO DAS MISSOES" },
		{ value: "6250", label: "SAO JOAO DEL REI" },
		{ value: "6255", label: "SAO JOAO DO MANHUACU" },
		{ value: "6257", label: "SAO JOAO DO MANTENINHA" },
		{ value: "6260", label: "SAO JOAO DO ORIENTE" },
		{ value: "6265", label: "SAO JOAO DO PACUI" },
		{ value: "6270", label: "SAO JOAO DO PARAISO" },
		{ value: "6280", label: "SAO JOAO EVANGELISTA" },
		{ value: "6290", label: "SAO JOAO NEPOMUCENO" },
		{ value: "6292", label: "SAO JOAQUIM DE BICAS" },
		{ value: "6294", label: "SAO JOSE DA BARRA" },
		{ value: "6295", label: "SAO JOSE DA LAPA" },
		{ value: "6300", label: "SAO JOSE DA SAFIRA" },
		{ value: "6310", label: "SAO JOSE DA VARGINHA" },
		{ value: "6320", label: "SAO JOSE DO ALEGRE" },
		{ value: "6330", label: "SAO JOSE DO DIVINO" },
		{ value: "6340", label: "SAO JOSE DO GOIABAL" },
		{ value: "6350", label: "SAO JOSE DO JACURI" },
		{ value: "6360", label: "SAO JOSE DO MANTIMENTO" },
		{ value: "6370", label: "SAO LOURENCO" },
		{ value: "6380", label: "SAO MIGUEL DO ANTA" },
		{ value: "6390", label: "SAO PEDRO DA UNIAO" },
		{ value: "6410", label: "SAO PEDRO DO SUACUI" },
		{ value: "6400", label: "SAO PEDRO DOS FERROS" },
		{ value: "6420", label: "SAO ROMAO" },
		{ value: "6430", label: "SAO ROQUE DE MINAS" },
		{ value: "6440", label: "SAO SEBASTIAO DA BELA VISTA" },
		{ value: "6443", label: "SAO SEBASTIAO DA VARGEM ALEGRE" },
		{ value: "6447", label: "SAO SEBASTIAO DO ANTA" },
		{ value: "6450", label: "SAO SEBASTIAO DO MARANHAO" },
		{ value: "6460", label: "SAO SEBASTIAO DO OESTE" },
		{ value: "6470", label: "SAO SEBASTIAO DO PARAISO" },
		{ value: "6480", label: "SAO SEBASTIAO DO RIO PRETO" },
		{ value: "6490", label: "SAO SEBASTIAO DO RIO VERDE" },
		{ value: "6520", label: "SAO THOME DAS LETRAS" },
		{ value: "6500", label: "SAO TIAGO" },
		{ value: "6510", label: "SAO TOMAS DE AQUINO" },
		{ value: "6530", label: "SAO VICENTE DE MINAS" },
		{ value: "6540", label: "SAPUCAI-MIRIM" },
		{ value: "6550", label: "SARDOA" },
		{ value: "6553", label: "SARZEDO" },
		{ value: "0000", label: "SEM PEIXE" },
		{ value: "6556", label: "SEM-PEIXE" },
		{ value: "6557", label: "SENADOR AMARAL" },
		{ value: "6560", label: "SENADOR CORTES" },
		{ value: "6570", label: "SENADOR FIRMINO" },
		{ value: "6580", label: "SENADOR JOSE BENTO" },
		{ value: "6590", label: "SENADOR MODESTINO GONCALVES" },
		{ value: "6600", label: "SENHORA DE OLIVEIRA" },
		{ value: "6610", label: "SENHORA DO PORTO" },
		{ value: "6620", label: "SENHORA DOS REMEDIOS" },
		{ value: "6630", label: "SERICITA" },
		{ value: "6640", label: "SERITINGA" },
		{ value: "6650", label: "SERRA AZUL DE MINAS" },
		{ value: "6660", label: "SERRA DA SAUDADE" },
		{ value: "6680", label: "SERRA DO SALITRE" },
		{ value: "6670", label: "SERRA DOS AIMORES" },
		{ value: "6690", label: "SERRANIA" },
		{ value: "6695", label: "SERRANOPOLIS DE MINAS" },
		{ value: "6700", label: "SERRANOS" },
		{ value: "6710", label: "SERRO" },
		{ value: "6720", label: "SETE LAGOAS" },
		{ value: "6555", label: "SETUBINHA" },
		{ value: "6730", label: "SILVEIRANIA" },
		{ value: "6740", label: "SILVIANOPOLIS" },
		{ value: "6750", label: "SIMAO PEREIRA" },
		{ value: "6760", label: "SIMONESIA" },
		{ value: "6770", label: "SOBRALIA" },
		{ value: "6780", label: "SOLEDADE DE MINAS" },
		{ value: "6790", label: "TABULEIRO" },
		{ value: "6800", label: "TAIOBEIRAS" },
		{ value: "6805", label: "TAPARUBA" },
		{ value: "6810", label: "TAPIRA" },
		{ value: "6820", label: "TAPIRAI" },
		{ value: "6830", label: "TAQUARACU DE MINAS" },
		{ value: "6840", label: "TARUMIRIM" },
		{ value: "6850", label: "TEIXEIRAS" },
		{ value: "6860", label: "TEOFILO OTONI" },
		{ value: "6870", label: "TIMOTEO" },
		{ value: "6880", label: "TIRADENTES" },
		{ value: "6890", label: "TIROS" },
		{ value: "6900", label: "TOCANTINS" },
		{ value: "6905", label: "TOCOS DO MOJI" },
		{ value: "6910", label: "TOLEDO" },
		{ value: "6920", label: "TOMBOS" },
		{ value: "6930", label: "TRES CORACOES" },
		{ value: "6935", label: "TRES MARIAS" },
		{ value: "6940", label: "TRES PONTAS" },
		{ value: "6950", label: "TUMIRITINGA" },
		{ value: "6960", label: "TUPACIGUARA" },
		{ value: "6970", label: "TURMALINA" },
		{ value: "6980", label: "TURVOLANDIA" },
		{ value: "6990", label: "UBA" },
		{ value: "7000", label: "UBAI" },
		{ value: "7005", label: "UBAPORANGA" },
		{ value: "7010", label: "UBERABA" },
		{ value: "7020", label: "UBERLANDIA" },
		{ value: "7030", label: "UMBURATIBA" },
		{ value: "7040", label: "UNAI" },
		{ value: "7043", label: "UNIAO DE MINAS" },
		{ value: "7047", label: "URUANA DE MINAS" },
		{ value: "7050", label: "URUCANIA" },
		{ value: "7052", label: "URUCUIA" },
		{ value: "7057", label: "VARGEM ALEGRE" },
		{ value: "7060", label: "VARGEM BONITA" },
		{ value: "7065", label: "VARGEM GRANDE DO RIO PARDO" },
		{ value: "7070", label: "VARGINHA" },
		{ value: "7075", label: "VARJAO DE MINAS" },
		{ value: "7080", label: "VARZEA DA PALMA" },
		{ value: "7090", label: "VARZELANDIA" },
		{ value: "7100", label: "VAZANTE" },
		{ value: "7103", label: "VERDELANDIA" },
		{ value: "7107", label: "VEREDINHA" },
		{ value: "7110", label: "VERISSIMO" },
		{ value: "7115", label: "VERMELHO NOVO" },
		{ value: "7120", label: "VESPASIANO" },
		{ value: "7130", label: "VICOSA" },
		{ value: "7140", label: "VIEIRAS" },
		{ value: "7160", label: "VIRGEM DA LAPA" },
		{ value: "7170", label: "VIRGINIA" },
		{ value: "7180", label: "VIRGINOPOLIS" },
		{ value: "7190", label: "VIRGOLANDIA" },
		{ value: "7200", label: "VISCONDE DO RIO BRANCO" },
		{ value: "7210", label: "VOLTA GRANDE" },
		{ value: "7220", label: "WENCESLAU BRAZ" },
	],
	ES: [
		{ value: "0010", label: "AFONSO CLAUDIO" },
		{ value: "0016", label: "AGUA DOCE DO NORTE" },
		{ value: "0013", label: "AGUIA BRANCA" },
		{ value: "0020", label: "ALEGRE" },
		{ value: "0030", label: "ALFREDO CHAVES" },
		{ value: "0035", label: "ALTO RIO NOVO" },
		{ value: "0040", label: "ANCHIETA" },
		{ value: "0050", label: "APIACA" },
		{ value: "0060", label: "ARACRUZ" },
		{ value: "0070", label: "ATILIO VIVACQUA" },
		{ value: "0080", label: "BAIXO GUANDU" },
		{ value: "0090", label: "BARRA DE SAO FRANCISCO" },
		{ value: "0100", label: "BOA ESPERANCA" },
		{ value: "0110", label: "BOM JESUS DO NORTE" },
		{ value: "0115", label: "BREJETUBA" },
		{ value: "0120", label: "CACHOEIRO DE ITAPEMIRIM" },
		{ value: "0130", label: "CARIACICA" },
		{ value: "0140", label: "CASTELO" },
		{ value: "0150", label: "COLATINA" },
		{ value: "0160", label: "CONCEICAO DA BARRA" },
		{ value: "0170", label: "CONCEICAO DO CASTELO" },
		{ value: "0180", label: "DIVINO DE SAO LOURENCO" },
		{ value: "0190", label: "DOMINGOS MARTINS" },
		{ value: "0200", label: "DORES DO RIO PRETO" },
		{ value: "0210", label: "ECOPORANGA" },
		{ value: "0220", label: "FUNDAO" },
		{ value: "0225", label: "GOVERNADOR LINDENBERG" },
		{ value: "0230", label: "GUACUI" },
		{ value: "0240", label: "GUARAPARI" },
		{ value: "0245", label: "IBATIBA" },
		{ value: "0250", label: "IBIRACU" },
		{ value: "0255", label: "IBITIRAMA" },
		{ value: "0260", label: "ICONHA" },
		{ value: "0265", label: "IRUPI" },
		{ value: "0270", label: "ITAGUACU" },
		{ value: "0280", label: "ITAPEMIRIM" },
		{ value: "0290", label: "ITARANA" },
		{ value: "0300", label: "IUNA" },
		{ value: "0305", label: "JAGUARE" },
		{ value: "0310", label: "JERONIMO MONTEIRO" },
		{ value: "0313", label: "JOAO NEIVA" },
		{ value: "0316", label: "LARANJA DA TERRA" },
		{ value: "0320", label: "LINHARES" },
		{ value: "0330", label: "MANTENOPOLIS" },
		{ value: "0332", label: "MARATAIZES" },
		{ value: "0334", label: "MARECHAL FLORIANO" },
		{ value: "0335", label: "MARILANDIA" },
		{ value: "0340", label: "MIMOSO DO SUL" },
		{ value: "0350", label: "MONTANHA" },
		{ value: "0360", label: "MUCURICI" },
		{ value: "0370", label: "MUNIZ FREIRE" },
		{ value: "0380", label: "MUQUI" },
		{ value: "0390", label: "NOVA VENECIA" },
		{ value: "0400", label: "PANCAS" },
		{ value: "0405", label: "PEDRO CANARIO" },
		{ value: "0410", label: "PINHEIROS" },
		{ value: "0420", label: "PIUMA" },
		{ value: "0425", label: "PONTO BELO" },
		{ value: "0430", label: "PRESIDENTE KENNEDY" },
		{ value: "0435", label: "RIO BANANAL" },
		{ value: "0440", label: "RIO NOVO DO SUL" },
		{ value: "0450", label: "SANTA LEOPOLDINA" },
		{ value: "0455", label: "SANTA MARIA DE JETIBA" },
		{ value: "0460", label: "SANTA TERESA" },
		{ value: "0465", label: "SAO DOMINGOS DO NORTE" },
		{ value: "0470", label: "SAO GABRIEL DA PALHA" },
		{ value: "0480", label: "SAO JOSE DO CALCADO" },
		{ value: "0490", label: "SAO MATEUS" },
		{ value: "0495", label: "SAO ROQUE DO CANAA" },
		{ value: "0500", label: "SERRA" },
		{ value: "0501", label: "SOORETAMA" },
		{ value: "0503", label: "VARGEM ALTA" },
		{ value: "0506", label: "VENDA NOVA DO IMIGRANTE" },
		{ value: "0510", label: "VIANA" },
		{ value: "0515", label: "VILA PAVAO" },
		{ value: "0517", label: "VILA VALERIO" },
		{ value: "0520", label: "VILA VELHA" },
		{ value: "0530", label: "VITORIA" },
	],
	RJ: [
		{ value: "0010", label: "ANGRA DOS REIS" },
		{ value: "0015", label: "APERIBE" },
		{ value: "0020", label: "ARARUAMA" },
		{ value: "0022", label: "AREAL" },
		{ value: "0023", label: "ARMACAO DOS BUZIOS" },
		{ value: "0025", label: "ARRAIAL DO CABO" },
		{ value: "0030", label: "BARRA DO PIRAI" },
		{ value: "0040", label: "BARRA MANSA" },
		{ value: "0045", label: "BELFORD ROXO" },
		{ value: "0050", label: "BOM JARDIM" },
		{ value: "0060", label: "BOM JESUS DO ITABAPOANA" },
		{ value: "0070", label: "CABO FRIO" },
		{ value: "0080", label: "CACHOEIRAS DE MACACU" },
		{ value: "0090", label: "CAMBUCI" },
		{ value: "0100", label: "CAMPOS DOS GOYTACAZES" },
		{ value: "0110", label: "CANTAGALO" },
		{ value: "0093", label: "CARAPEBUS" },
		{ value: "0115", label: "CARDOSO MOREIRA" },
		{ value: "0120", label: "CARMO" },
		{ value: "0130", label: "CASIMIRO DE ABREU" },
		{ value: "0095", label: "COMENDADOR LEVY GASPARIAN" },
		{ value: "0140", label: "CONCEICAO DE MACABU" },
		{ value: "0150", label: "CORDEIRO" },
		{ value: "0160", label: "DUAS BARRAS" },
		{ value: "0170", label: "DUQUE DE CAXIAS" },
		{ value: "0180", label: "ENGENHEIRO PAULO DE FRONTIN" },
		{ value: "0185", label: "GUAPIMIRIM" },
		{ value: "0187", label: "IGUABA GRANDE" },
		{ value: "0190", label: "ITABORAI" },
		{ value: "0200", label: "ITAGUAI" },
		{ value: "0205", label: "ITALVA" },
		{ value: "0210", label: "ITAOCARA" },
		{ value: "0220", label: "ITAPERUNA" },
		{ value: "0225", label: "ITATIAIA" },
		{ value: "0227", label: "JAPERI" },
		{ value: "0230", label: "LAJE DO MURIAE" },
		{ value: "0240", label: "MACAE" },
		{ value: "0245", label: "MACUCO" },
		{ value: "0250", label: "MAGE" },
		{ value: "0260", label: "MANGARATIBA" },
		{ value: "0270", label: "MARICA" },
		{ value: "0280", label: "MENDES" },
		{ value: "0285", label: "MESQUITA" },
		{ value: "0290", label: "MIGUEL PEREIRA" },
		{ value: "0300", label: "MIRACEMA" },
		{ value: "0310", label: "NATIVIDADE" },
		{ value: "0320", label: "NILOPOLIS" },
		{ value: "0330", label: "NITEROI" },
		{ value: "0340", label: "NOVA FRIBURGO" },
		{ value: "0350", label: "NOVA IGUACU" },
		{ value: "0360", label: "PARACAMBI" },
		{ value: "0370", label: "PARAIBA DO SUL" },
		{ value: "0380", label: "PARATY" },
		{ value: "0385", label: "PATY DO ALFERES" },
		{ value: "0390", label: "PETROPOLIS" },
		{ value: "0395", label: "PINHEIRAL" },
		{ value: "0400", label: "PIRAI" },
		{ value: "0410", label: "PORCIUNCULA" },
		{ value: "0411", label: "PORTO REAL" },
		{ value: "0412", label: "QUATIS" },
		{ value: "0414", label: "QUEIMADOS" },
		{ value: "0415", label: "QUISSAMA" },
		{ value: "0420", label: "RESENDE" },
		{ value: "0430", label: "RIO BONITO" },
		{ value: "0440", label: "RIO CLARO" },
		{ value: "0450", label: "RIO DAS FLORES" },
		{ value: "0452", label: "RIO DAS OSTRAS" },
		{ value: "0455", label: "RIO DE JANEIRO" },
		{ value: "0460", label: "SANTA MARIA MADALENA" },
		{ value: "0470", label: "SANTO ANTONIO DE PADUA" },
		{ value: "0480", label: "SAO FIDELIS" },
		{ value: "0475", label: "SAO FRANCISCO DE ITABAPOANA" },
		{ value: "0490", label: "SAO GONCALO" },
		{ value: "0500", label: "SAO JOAO DA BARRA" },
		{ value: "0510", label: "SAO JOAO DE MERITI" },
		{ value: "0513", label: "SAO JOSE DE UBA" },
		{ value: "0515", label: "SAO JOSE DO VALE DO RIO PRETO" },
		{ value: "0520", label: "SAO PEDRO DA ALDEIA" },
		{ value: "0530", label: "SAO SEBASTIAO DO ALTO" },
		{ value: "0540", label: "SAPUCAIA" },
		{ value: "0550", label: "SAQUAREMA" },
		{ value: "0555", label: "SEROPEDICA" },
		{ value: "0560", label: "SILVA JARDIM" },
		{ value: "0570", label: "SUMIDOURO" },
		{ value: "0575", label: "TANGUA" },
		{ value: "0580", label: "TERESOPOLIS" },
		{ value: "0590", label: "TRAJANO DE MORAES" },
		{ value: "0600", label: "TRES RIOS" },
		{ value: "0610", label: "VALENCA" },
		{ value: "0615", label: "VARRE-SAI" },
		{ value: "0620", label: "VASSOURAS" },
		{ value: "0630", label: "VOLTA REDONDA" },
	],
	SP: [
		{ value: "0010", label: "ADAMANTINA" },
		{ value: "0020", label: "ADOLFO" },
		{ value: "0030", label: "AGUAI" },
		{ value: "0040", label: "AGUAS DA PRATA" },
		{ value: "0050", label: "AGUAS DE LINDOIA" },
		{ value: "0055", label: "AGUAS DE SANTA BARBARA" },
		{ value: "0060", label: "AGUAS DE SAO PEDRO" },
		{ value: "0070", label: "AGUDOS" },
		{ value: "0075", label: "ALAMBARI" },
		{ value: "0080", label: "ALFREDO MARCONDES" },
		{ value: "0090", label: "ALTAIR" },
		{ value: "0100", label: "ALTINOPOLIS" },
		{ value: "0110", label: "ALTO ALEGRE" },
		{ value: "0115", label: "ALUMINIO" },
		{ value: "0120", label: "ALVARES FLORENCE" },
		{ value: "0130", label: "ALVARES MACHADO" },
		{ value: "0140", label: "ALVARO DE CARVALHO" },
		{ value: "0150", label: "ALVINLANDIA" },
		{ value: "0160", label: "AMERICANA" },
		{ value: "0170", label: "AMERICO BRASILIENSE" },
		{ value: "0180", label: "AMERICO DE CAMPOS" },
		{ value: "0190", label: "AMPARO" },
		{ value: "0200", label: "ANALANDIA" },
		{ value: "0210", label: "ANDRADINA" },
		{ value: "0220", label: "ANGATUBA" },
		{ value: "0230", label: "ANHEMBI" },
		{ value: "0240", label: "ANHUMAS" },
		{ value: "0250", label: "APARECIDA" },
		{ value: "0260", label: "APARECIDA D'OESTE" },
		{ value: "0270", label: "APIAI" },
		{ value: "0275", label: "ARACARIGUAMA" },
		{ value: "0280", label: "ARACATUBA" },
		{ value: "0290", label: "ARACOIABA DA SERRA" },
		{ value: "0300", label: "ARAMINA" },
		{ value: "0310", label: "ARANDU" },
		{ value: "0315", label: "ARAPEI" },
		{ value: "0320", label: "ARARAQUARA" },
		{ value: "0330", label: "ARARAS" },
		{ value: "0335", label: "ARCO-IRIS" },
		{ value: "0340", label: "AREALVA" },
		{ value: "0350", label: "AREIAS" },
		{ value: "0360", label: "AREIOPOLIS" },
		{ value: "0370", label: "ARIRANHA" },
		{ value: "0380", label: "ARTUR NOGUEIRA" },
		{ value: "0390", label: "ARUJA" },
		{ value: "0395", label: "ASPASIA" },
		{ value: "0400", label: "ASSIS" },
		{ value: "0410", label: "ATIBAIA" },
		{ value: "0420", label: "AURIFLAMA" },
		{ value: "0430", label: "AVAI" },
		{ value: "0440", label: "AVANHANDAVA" },
		{ value: "0450", label: "AVARE" },
		{ value: "0460", label: "BADY BASSITT" },
		{ value: "0470", label: "BALBINOS" },
		{ value: "0480", label: "BALSAMO" },
		{ value: "0490", label: "BANANAL" },
		{ value: "0500", label: "BARAO DE ANTONINA" },
		{ value: "0510", label: "BARBOSA" },
		{ value: "0520", label: "BARIRI" },
		{ value: "0530", label: "BARRA BONITA" },
		{ value: "0535", label: "BARRA DO CHAPEU" },
		{ value: "0540", label: "BARRA DO TURVO" },
		{ value: "0550", label: "BARRETOS" },
		{ value: "0560", label: "BARRINHA" },
		{ value: "0570", label: "BARUERI" },
		{ value: "0580", label: "BASTOS" },
		{ value: "0590", label: "BATATAIS" },
		{ value: "0600", label: "BAURU" },
		{ value: "0610", label: "BEBEDOURO" },
		{ value: "0620", label: "BENTO DE ABREU" },
		{ value: "0630", label: "BERNARDINO DE CAMPOS" },
		{ value: "0635", label: "BERTIOGA" },
		{ value: "0640", label: "BILAC" },
		{ value: "0650", label: "BIRIGUI" },
		{ value: "0660", label: "BIRITIBA-MIRIM" },
		{ value: "0670", label: "BOA ESPERANCA DO SUL" },
		{ value: "0680", label: "BOCAINA" },
		{ value: "0690", label: "BOFETE" },
		{ value: "0700", label: "BOITUVA" },
		{ value: "0710", label: "BOM JESUS DOS PERDOES" },
		{ value: "0715", label: "BOM SUCESSO DE ITARARE" },
		{ value: "0720", label: "BORA" },
		{ value: "0730", label: "BORACEIA" },
		{ value: "0740", label: "BORBOREMA" },
		{ value: "0745", label: "BOREBI" },
		{ value: "0750", label: "BOTUCATU" },
		{ value: "0760", label: "BRAGANCA PAULISTA" },
		{ value: "0770", label: "BRAUNA" },
		{ value: "0775", label: "BREJO ALEGRE" },
		{ value: "0780", label: "BRODOWSKI" },
		{ value: "0790", label: "BROTAS" },
		{ value: "0800", label: "BURI" },
		{ value: "0810", label: "BURITAMA" },
		{ value: "0820", label: "BURITIZAL" },
		{ value: "0830", label: "CABRALIA PAULISTA" },
		{ value: "0840", label: "CABREUVA" },
		{ value: "0850", label: "CACAPAVA" },
		{ value: "0860", label: "CACHOEIRA PAULISTA" },
		{ value: "0870", label: "CACONDE" },
		{ value: "0880", label: "CAFELANDIA" },
		{ value: "0890", label: "CAIABU" },
		{ value: "0900", label: "CAIEIRAS" },
		{ value: "0910", label: "CAIUA" },
		{ value: "0920", label: "CAJAMAR" },
		{ value: "0925", label: "CAJATI" },
		{ value: "0930", label: "CAJOBI" },
		{ value: "0940", label: "CAJURU" },
		{ value: "0945", label: "CAMPINA DO MONTE ALEGRE" },
		{ value: "0950", label: "CAMPINAS" },
		{ value: "0960", label: "CAMPO LIMPO PAULISTA" },
		{ value: "0970", label: "CAMPOS DO JORDAO" },
		{ value: "0980", label: "CAMPOS NOVOS PAULISTA" },
		{ value: "0990", label: "CANANEIA" },
		{ value: "0995", label: "CANAS" },
		{ value: "1000", label: "CANDIDO MOTA" },
		{ value: "1010", label: "CANDIDO RODRIGUES" },
		{ value: "1015", label: "CANITAR" },
		{ value: "1020", label: "CAPAO BONITO" },
		{ value: "1030", label: "CAPELA DO ALTO" },
		{ value: "1040", label: "CAPIVARI" },
		{ value: "1050", label: "CARAGUATATUBA" },
		{ value: "1060", label: "CARAPICUIBA" },
		{ value: "1070", label: "CARDOSO" },
		{ value: "1080", label: "CASA BRANCA" },
		{ value: "1090", label: "CASSIA DOS COQUEIROS" },
		{ value: "1100", label: "CASTILHO" },
		{ value: "1110", label: "CATANDUVA" },
		{ value: "1120", label: "CATIGUA" },
		{ value: "1130", label: "CEDRAL" },
		{ value: "1140", label: "CERQUEIRA CESAR" },
		{ value: "1150", label: "CERQUILHO" },
		{ value: "1160", label: "CESARIO LANGE" },
		{ value: "1170", label: "CHARQUEADA" },
		{ value: "5720", label: "CHAVANTES" },
		{ value: "1190", label: "CLEMENTINA" },
		{ value: "1200", label: "COLINA" },
		{ value: "1210", label: "COLOMBIA" },
		{ value: "1220", label: "CONCHAL" },
		{ value: "1230", label: "CONCHAS" },
		{ value: "1240", label: "CORDEIROPOLIS" },
		{ value: "1250", label: "COROADOS" },
		{ value: "1260", label: "CORONEL MACEDO" },
		{ value: "1270", label: "CORUMBATAI" },
		{ value: "1280", label: "COSMOPOLIS" },
		{ value: "1290", label: "COSMORAMA" },
		{ value: "1300", label: "COTIA" },
		{ value: "1310", label: "CRAVINHOS" },
		{ value: "1320", label: "CRISTAIS PAULISTA" },
		{ value: "1330", label: "CRUZALIA" },
		{ value: "1340", label: "CRUZEIRO" },
		{ value: "1350", label: "CUBATAO" },
		{ value: "1360", label: "CUNHA" },
		{ value: "1370", label: "DESCALVADO" },
		{ value: "1380", label: "DIADEMA" },
		{ value: "1385", label: "DIRCE REIS" },
		{ value: "1390", label: "DIVINOLANDIA" },
		{ value: "1400", label: "DOBRADA" },
		{ value: "1410", label: "DOIS CORREGOS" },
		{ value: "1420", label: "DOLCINOPOLIS" },
		{ value: "1430", label: "DOURADO" },
		{ value: "1440", label: "DRACENA" },
		{ value: "1450", label: "DUARTINA" },
		{ value: "1460", label: "DUMONT" },
		{ value: "1470", label: "ECHAPORA" },
		{ value: "1480", label: "ELDORADO" },
		{ value: "1490", label: "ELIAS FAUSTO" },
		{ value: "1492", label: "ELISIARIO" },
		{ value: "1495", label: "EMBAUBA" },
		{ value: "1500", label: "EMBU DAS ARTES" },
		{ value: "1510", label: "EMBU-GUACU" },
		{ value: "1512", label: "EMILIANOPOLIS" },
		{ value: "1515", label: "ENGENHEIRO COELHO" },
		{ value: "1518", label: "ESPIRITO SANTO DO PINHAL" },
		{ value: "1519", label: "ESPIRITO SANTO DO TURVO" },
		{ value: "5730", label: "ESTIVA GERBI" },
		{ value: "1520", label: "ESTRELA D'OESTE" },
		{ value: "1530", label: "ESTRELA DO NORTE" },
		{ value: "1535", label: "EUCLIDES DA CUNHA PAULISTA" },
		{ value: "1540", label: "FARTURA" },
		{ value: "1560", label: "FERNANDO PRESTES" },
		{ value: "1550", label: "FERNANDOPOLIS" },
		{ value: "1565", label: "FERNAO" },
		{ value: "1570", label: "FERRAZ DE VASCONCELOS" },
		{ value: "1580", label: "FLORA RICA" },
		{ value: "1590", label: "FLOREAL" },
		{ value: "1600", label: "FLORIDA PAULISTA" },
		{ value: "1610", label: "FLORINEA" },
		{ value: "0000", label: "FLORINEA" },
		{ value: "1620", label: "FRANCA" },
		{ value: "1630", label: "FRANCISCO MORATO" },
		{ value: "1640", label: "FRANCO DA ROCHA" },
		{ value: "1650", label: "GABRIEL MONTEIRO" },
		{ value: "1660", label: "GALIA" },
		{ value: "1670", label: "GARCA" },
		{ value: "1680", label: "GASTAO VIDIGAL" },
		{ value: "1685", label: "GAVIAO PEIXOTO" },
		{ value: "1690", label: "GENERAL SALGADO" },
		{ value: "1700", label: "GETULINA" },
		{ value: "1710", label: "GLICERIO" },
		{ value: "1720", label: "GUAICARA" },
		{ value: "1730", label: "GUAIMBE" },
		{ value: "1740", label: "GUAIRA" },
		{ value: "1750", label: "GUAPIACU" },
		{ value: "1760", label: "GUAPIARA" },
		{ value: "1770", label: "GUARA" },
		{ value: "1780", label: "GUARACAI" },
		{ value: "1790", label: "GUARACI" },
		{ value: "1800", label: "GUARANI D'OESTE" },
		{ value: "1810", label: "GUARANTA" },
		{ value: "1820", label: "GUARARAPES" },
		{ value: "1830", label: "GUARAREMA" },
		{ value: "1840", label: "GUARATINGUETA" },
		{ value: "1850", label: "GUAREI" },
		{ value: "1860", label: "GUARIBA" },
		{ value: "1870", label: "GUARUJA" },
		{ value: "1880", label: "GUARULHOS" },
		{ value: "1885", label: "GUATAPARA" },
		{ value: "1890", label: "GUZOLANDIA" },
		{ value: "1900", label: "HERCULANDIA" },
		{ value: "1905", label: "HOLAMBRA" },
		{ value: "1907", label: "HORTOLANDIA" },
		{ value: "1910", label: "IACANGA" },
		{ value: "1920", label: "IACRI" },
		{ value: "1925", label: "IARAS" },
		{ value: "1930", label: "IBATE" },
		{ value: "1940", label: "IBIRA" },
		{ value: "1950", label: "IBIRAREMA" },
		{ value: "1960", label: "IBITINGA" },
		{ value: "1970", label: "IBIUNA" },
		{ value: "1980", label: "ICEM" },
		{ value: "1990", label: "IEPE" },
		{ value: "2000", label: "IGARACU DO TIETE" },
		{ value: "2010", label: "IGARAPAVA" },
		{ value: "2020", label: "IGARATA" },
		{ value: "2030", label: "IGUAPE" },
		{ value: "2042", label: "ILHA COMPRIDA" },
		{ value: "2044", label: "ILHA SOLTEIRA" },
		{ value: "2040", label: "ILHABELA" },
		{ value: "2050", label: "INDAIATUBA" },
		{ value: "2060", label: "INDIANA" },
		{ value: "2070", label: "INDIAPORA" },
		{ value: "2080", label: "INUBIA PAULISTA" },
		{ value: "2090", label: "IPAUSSU" },
		{ value: "2100", label: "IPERO" },
		{ value: "2110", label: "IPEUNA" },
		{ value: "2115", label: "IPIGUA" },
		{ value: "2120", label: "IPORANGA" },
		{ value: "2130", label: "IPUA" },
		{ value: "2140", label: "IRACEMAPOLIS" },
		{ value: "2150", label: "IRAPUA" },
		{ value: "2160", label: "IRAPURU" },
		{ value: "2170", label: "ITABERA" },
		{ value: "2180", label: "ITAI" },
		{ value: "2190", label: "ITAJOBI" },
		{ value: "2200", label: "ITAJU" },
		{ value: "2210", label: "ITANHAEM" },
		{ value: "2215", label: "ITAOCA" },
		{ value: "2220", label: "ITAPECERICA DA SERRA" },
		{ value: "2230", label: "ITAPETININGA" },
		{ value: "2240", label: "ITAPEVA" },
		{ value: "2250", label: "ITAPEVI" },
		{ value: "2260", label: "ITAPIRA" },
		{ value: "2265", label: "ITAPIRAPUA PAULISTA" },
		{ value: "2270", label: "ITAPOLIS" },
		{ value: "2280", label: "ITAPORANGA" },
		{ value: "2290", label: "ITAPUI" },
		{ value: "2300", label: "ITAPURA" },
		{ value: "2310", label: "ITAQUAQUECETUBA" },
		{ value: "2320", label: "ITARARE" },
		{ value: "2330", label: "ITARIRI" },
		{ value: "2340", label: "ITATIBA" },
		{ value: "2350", label: "ITATINGA" },
		{ value: "2360", label: "ITIRAPINA" },
		{ value: "2370", label: "ITIRAPUA" },
		{ value: "2380", label: "ITOBI" },
		{ value: "2390", label: "ITU" },
		{ value: "2400", label: "ITUPEVA" },
		{ value: "2410", label: "ITUVERAVA" },
		{ value: "2420", label: "JABORANDI" },
		{ value: "2430", label: "JABOTICABAL" },
		{ value: "2440", label: "JACAREI" },
		{ value: "2450", label: "JACI" },
		{ value: "2460", label: "JACUPIRANGA" },
		{ value: "2470", label: "JAGUARIUNA" },
		{ value: "2480", label: "JALES" },
		{ value: "2490", label: "JAMBEIRO" },
		{ value: "2500", label: "JANDIRA" },
		{ value: "2510", label: "JARDINOPOLIS" },
		{ value: "2520", label: "JARINU" },
		{ value: "2530", label: "JAU" },
		{ value: "2540", label: "JERIQUARA" },
		{ value: "2550", label: "JOANOPOLIS" },
		{ value: "2560", label: "JOAO RAMALHO" },
		{ value: "2570", label: "JOSE BONIFACIO" },
		{ value: "2580", label: "JULIO MESQUITA" },
		{ value: "2585", label: "JUMIRIM" },
		{ value: "2590", label: "JUNDIAI" },
		{ value: "2600", label: "JUNQUEIROPOLIS" },
		{ value: "2610", label: "JUQUIA" },
		{ value: "2620", label: "JUQUITIBA" },
		{ value: "2630", label: "LAGOINHA" },
		{ value: "2640", label: "LARANJAL PAULISTA" },
		{ value: "2650", label: "LAVINIA" },
		{ value: "2660", label: "LAVRINHAS" },
		{ value: "2670", label: "LEME" },
		{ value: "2680", label: "LENCOIS PAULISTA" },
		{ value: "2690", label: "LIMEIRA" },
		{ value: "2700", label: "LINDOIA" },
		{ value: "2710", label: "LINS" },
		{ value: "2720", label: "LORENA" },
		{ value: "2725", label: "LOURDES" },
		{ value: "2730", label: "LOUVEIRA" },
		{ value: "2740", label: "LUCELIA" },
		{ value: "2750", label: "LUCIANOPOLIS" },
		{ value: "2760", label: "LUIS ANTONIO" },
		{ value: "2770", label: "LUIZIANIA" },
		{ value: "2780", label: "LUPERCIO" },
		{ value: "2790", label: "LUTECIA" },
		{ value: "2800", label: "MACATUBA" },
		{ value: "2810", label: "MACAUBAL" },
		{ value: "2820", label: "MACEDONIA" },
		{ value: "2830", label: "MAGDA" },
		{ value: "2840", label: "MAIRINQUE" },
		{ value: "2850", label: "MAIRIPORA" },
		{ value: "2860", label: "MANDURI" },
		{ value: "2870", label: "MARABA PAULISTA" },
		{ value: "2880", label: "MARACAI" },
		{ value: "2885", label: "MARAPOAMA" },
		{ value: "2890", label: "MARIAPOLIS" },
		{ value: "2900", label: "MARILIA" },
		{ value: "2910", label: "MARINOPOLIS" },
		{ value: "2920", label: "MARTINOPOLIS" },
		{ value: "2930", label: "MATAO" },
		{ value: "2940", label: "MAUA" },
		{ value: "2950", label: "MENDONCA" },
		{ value: "2960", label: "MERIDIANO" },
		{ value: "2965", label: "MESOPOLIS" },
		{ value: "2970", label: "MIGUELOPOLIS" },
		{ value: "2980", label: "MINEIROS DO TIETE" },
		{ value: "3000", label: "MIRA ESTRELA" },
		{ value: "2990", label: "MIRACATU" },
		{ value: "3010", label: "MIRANDOPOLIS" },
		{ value: "3020", label: "MIRANTE DO PARANAPANEMA" },
		{ value: "3030", label: "MIRASSOL" },
		{ value: "3040", label: "MIRASSOLANDIA" },
		{ value: "3050", label: "MOCOCA" },
		{ value: "3060", label: "MOGI DAS CRUZES" },
		{ value: "3070", label: "MOGI GUACU" },
		{ value: "3080", label: "MOGI MIRIM" },
		{ value: "3090", label: "MOMBUCA" },
		{ value: "3100", label: "MONCOES" },
		{ value: "3110", label: "MONGAGUA" },
		{ value: "3120", label: "MONTE ALEGRE DO SUL" },
		{ value: "3130", label: "MONTE ALTO" },
		{ value: "3140", label: "MONTE APRAZIVEL" },
		{ value: "3150", label: "MONTE AZUL PAULISTA" },
		{ value: "3160", label: "MONTE CASTELO" },
		{ value: "3180", label: "MONTE MOR" },
		{ value: "3170", label: "MONTEIRO LOBATO" },
		{ value: "3190", label: "MORRO AGUDO" },
		{ value: "3200", label: "MORUNGABA" },
		{ value: "3205", label: "MOTUCA" },
		{ value: "3210", label: "MURUTINGA DO SUL" },
		{ value: "3215", label: "NANTES" },
		{ value: "3220", label: "NARANDIBA" },
		{ value: "3230", label: "NATIVIDADE DA SERRA" },
		{ value: "3240", label: "NAZARE PAULISTA" },
		{ value: "3250", label: "NEVES PAULISTA" },
		{ value: "3260", label: "NHANDEARA" },
		{ value: "3270", label: "NIPOA" },
		{ value: "3280", label: "NOVA ALIANCA" },
		{ value: "3282", label: "NOVA CAMPINA" },
		{ value: "3284", label: "NOVA CANAA PAULISTA" },
		{ value: "3286", label: "NOVA CASTILHO" },
		{ value: "3290", label: "NOVA EUROPA" },
		{ value: "3300", label: "NOVA GRANADA" },
		{ value: "3310", label: "NOVA GUATAPORANGA" },
		{ value: "3320", label: "NOVA INDEPENDENCIA" },
		{ value: "3330", label: "NOVA LUZITANIA" },
		{ value: "3340", label: "NOVA ODESSA" },
		{ value: "3325", label: "NOVAIS" },
		{ value: "3350", label: "NOVO HORIZONTE" },
		{ value: "3360", label: "NUPORANGA" },
		{ value: "3370", label: "OCAUCU" },
		{ value: "3380", label: "OLEO" },
		{ value: "3390", label: "OLIMPIA" },
		{ value: "3400", label: "ONDA VERDE" },
		{ value: "3410", label: "ORIENTE" },
		{ value: "3420", label: "ORINDIUVA" },
		{ value: "3430", label: "ORLANDIA" },
		{ value: "3440", label: "OSASCO" },
		{ value: "3450", label: "OSCAR BRESSANE" },
		{ value: "3460", label: "OSVALDO CRUZ" },
		{ value: "3470", label: "OURINHOS" },
		{ value: "3480", label: "OURO VERDE" },
		{ value: "3475", label: "OUROESTE" },
		{ value: "3490", label: "PACAEMBU" },
		{ value: "3500", label: "PALESTINA" },
		{ value: "3510", label: "PALMARES PAULISTA" },
		{ value: "3520", label: "PALMEIRA D'OESTE" },
		{ value: "3530", label: "PALMITAL" },
		{ value: "3540", label: "PANORAMA" },
		{ value: "3550", label: "PARAGUACU PAULISTA" },
		{ value: "3560", label: "PARAIBUNA" },
		{ value: "3570", label: "PARAISO" },
		{ value: "3580", label: "PARANAPANEMA" },
		{ value: "3590", label: "PARANAPUA" },
		{ value: "3600", label: "PARAPUA" },
		{ value: "3610", label: "PARDINHO" },
		{ value: "3620", label: "PARIQUERA-ACU" },
		{ value: "3625", label: "PARISI" },
		{ value: "3630", label: "PATROCINIO PAULISTA" },
		{ value: "3640", label: "PAULICEIA" },
		{ value: "3650", label: "PAULINIA" },
		{ value: "3657", label: "PAULISTANIA" },
		{ value: "3660", label: "PAULO DE FARIA" },
		{ value: "3670", label: "PEDERNEIRAS" },
		{ value: "3680", label: "PEDRA BELA" },
		{ value: "3690", label: "PEDRANOPOLIS" },
		{ value: "3700", label: "PEDREGULHO" },
		{ value: "3710", label: "PEDREIRA" },
		{ value: "3715", label: "PEDRINHAS PAULISTA" },
		{ value: "3720", label: "PEDRO DE TOLEDO" },
		{ value: "3730", label: "PENAPOLIS" },
		{ value: "3740", label: "PEREIRA BARRETO" },
		{ value: "3750", label: "PEREIRAS" },
		{ value: "3760", label: "PERUIBE" },
		{ value: "3770", label: "PIACATU" },
		{ value: "3780", label: "PIEDADE" },
		{ value: "3790", label: "PILAR DO SUL" },
		{ value: "3800", label: "PINDAMONHANGABA" },
		{ value: "3810", label: "PINDORAMA" },
		{ value: "3820", label: "PINHALZINHO" },
		{ value: "3830", label: "PIQUEROBI" },
		{ value: "3850", label: "PIQUETE" },
		{ value: "3860", label: "PIRACAIA" },
		{ value: "3870", label: "PIRACICABA" },
		{ value: "3880", label: "PIRAJU" },
		{ value: "3890", label: "PIRAJUI" },
		{ value: "3900", label: "PIRANGI" },
		{ value: "3910", label: "PIRAPORA DO BOM JESUS" },
		{ value: "3920", label: "PIRAPOZINHO" },
		{ value: "3930", label: "PIRASSUNUNGA" },
		{ value: "3940", label: "PIRATININGA" },
		{ value: "3950", label: "PITANGUEIRAS" },
		{ value: "3960", label: "PLANALTO" },
		{ value: "3970", label: "PLATINA" },
		{ value: "3980", label: "POA" },
		{ value: "3990", label: "POLONI" },
		{ value: "4000", label: "POMPEIA" },
		{ value: "4010", label: "PONGAI" },
		{ value: "4020", label: "PONTAL" },
		{ value: "4025", label: "PONTALINDA" },
		{ value: "4030", label: "PONTES GESTAL" },
		{ value: "4040", label: "POPULINA" },
		{ value: "4050", label: "PORANGABA" },
		{ value: "4060", label: "PORTO FELIZ" },
		{ value: "4070", label: "PORTO FERREIRA" },
		{ value: "4075", label: "POTIM" },
		{ value: "4080", label: "POTIRENDABA" },
		{ value: "4085", label: "PRACINHA" },
		{ value: "4090", label: "PRADOPOLIS" },
		{ value: "4100", label: "PRAIA GRANDE" },
		{ value: "4105", label: "PRATANIA" },
		{ value: "4110", label: "PRESIDENTE ALVES" },
		{ value: "4120", label: "PRESIDENTE BERNARDES" },
		{ value: "4130", label: "PRESIDENTE EPITACIO" },
		{ value: "4140", label: "PRESIDENTE PRUDENTE" },
		{ value: "4150", label: "PRESIDENTE VENCESLAU" },
		{ value: "4160", label: "PROMISSAO" },
		{ value: "4165", label: "QUADRA" },
		{ value: "4170", label: "QUATA" },
		{ value: "4180", label: "QUEIROZ" },
		{ value: "4190", label: "QUELUZ" },
		{ value: "4200", label: "QUINTANA" },
		{ value: "4210", label: "RAFARD" },
		{ value: "4220", label: "RANCHARIA" },
		{ value: "4230", label: "REDENCAO DA SERRA" },
		{ value: "4240", label: "REGENTE FEIJO" },
		{ value: "4250", label: "REGINOPOLIS" },
		{ value: "4260", label: "REGISTRO" },
		{ value: "4270", label: "RESTINGA" },
		{ value: "4280", label: "RIBEIRA" },
		{ value: "4290", label: "RIBEIRAO BONITO" },
		{ value: "4300", label: "RIBEIRAO BRANCO" },
		{ value: "4310", label: "RIBEIRAO CORRENTE" },
		{ value: "4320", label: "RIBEIRAO DO SUL" },
		{ value: "4323", label: "RIBEIRAO DOS INDIOS" },
		{ value: "4325", label: "RIBEIRAO GRANDE" },
		{ value: "4330", label: "RIBEIRAO PIRES" },
		{ value: "4340", label: "RIBEIRAO PRETO" },
		{ value: "4360", label: "RIFAINA" },
		{ value: "4370", label: "RINCAO" },
		{ value: "4380", label: "RINOPOLIS" },
		{ value: "4390", label: "RIO CLARO" },
		{ value: "4400", label: "RIO DAS PEDRAS" },
		{ value: "4410", label: "RIO GRANDE DA SERRA" },
		{ value: "4420", label: "RIOLANDIA" },
		{ value: "4350", label: "RIVERSUL" },
		{ value: "4425", label: "ROSANA" },
		{ value: "0000", label: "FLORINEA" },
		{ value: "4430", label: "ROSEIRA" },
		{ value: "4440", label: "RUBIACEA" },
		{ value: "4450", label: "RUBINEIA" },
		{ value: "4460", label: "SABINO" },
		{ value: "4470", label: "SAGRES" },
		{ value: "4480", label: "SALES" },
		{ value: "4490", label: "SALES OLIVEIRA" },
		{ value: "4500", label: "SALESOPOLIS" },
		{ value: "4510", label: "SALMOURAO" },
		{ value: "4515", label: "SALTINHO" },
		{ value: "4520", label: "SALTO" },
		{ value: "4530", label: "SALTO DE PIRAPORA" },
		{ value: "4540", label: "SALTO GRANDE" },
		{ value: "4550", label: "SANDOVALINA" },
		{ value: "4560", label: "SANTA ADELIA" },
		{ value: "4570", label: "SANTA ALBERTINA" },
		{ value: "4580", label: "SANTA BARBARA D'OESTE" },
		{ value: "4600", label: "SANTA BRANCA" },
		{ value: "4610", label: "SANTA CLARA D'OESTE" },
		{ value: "4620", label: "SANTA CRUZ DA CONCEICAO" },
		{ value: "4625", label: "SANTA CRUZ DA ESPERANCA" },
		{ value: "4630", label: "SANTA CRUZ DAS PALMEIRAS" },
		{ value: "4640", label: "SANTA CRUZ DO RIO PARDO" },
		{ value: "4650", label: "SANTA ERNESTINA" },
		{ value: "4660", label: "SANTA FE DO SUL" },
		{ value: "4670", label: "SANTA GERTRUDES" },
		{ value: "4680", label: "SANTA ISABEL" },
		{ value: "4690", label: "SANTA LUCIA" },
		{ value: "4700", label: "SANTA MARIA DA SERRA" },
		{ value: "4710", label: "SANTA MERCEDES" },
		{ value: "4740", label: "SANTA RITA D'OESTE" },
		{ value: "4750", label: "SANTA RITA DO PASSA QUATRO" },
		{ value: "4760", label: "SANTA ROSA DE VITERBO" },
		{ value: "4765", label: "SANTA SALETE" },
		{ value: "4720", label: "SANTANA DA PONTE PENSA" },
		{ value: "4730", label: "SANTANA DE PARNAIBA" },
		{ value: "4770", label: "SANTO ANASTACIO" },
		{ value: "4780", label: "SANTO ANDRE" },
		{ value: "4790", label: "SANTO ANTONIO DA ALEGRIA" },
		{ value: "4800", label: "SANTO ANTONIO DE POSSE" },
		{ value: "4805", label: "SANTO ANTONIO DO ARACANGUA" },
		{ value: "4810", label: "SANTO ANTONIO DO JARDIM" },
		{ value: "4820", label: "SANTO ANTONIO DO PINHAL" },
		{ value: "4830", label: "SANTO EXPEDITO" },
		{ value: "4840", label: "SANTOPOLIS DO AGUAPEI" },
		{ value: "4850", label: "SANTOS" },
		{ value: "4860", label: "SAO BENTO DO SAPUCAI" },
		{ value: "4870", label: "SAO BERNARDO DO CAMPO" },
		{ value: "4880", label: "SAO CAETANO DO SUL" },
		{ value: "4890", label: "SAO CARLOS" },
		{ value: "4900", label: "SAO FRANCISCO" },
		{ value: "4910", label: "SAO JOAO DA BOA VISTA" },
		{ value: "4920", label: "SAO JOAO DAS DUAS PONTES" },
		{ value: "4925", label: "SAO JOAO DE IRACEMA" },
		{ value: "4930", label: "SAO JOAO DO PAU D'ALHO" },
		{ value: "4940", label: "SAO JOAQUIM DA BARRA" },
		{ value: "4950", label: "SAO JOSE DA BELA VISTA" },
		{ value: "4960", label: "SAO JOSE DO BARREIRO" },
		{ value: "4970", label: "SAO JOSE DO RIO PARDO" },
		{ value: "4980", label: "SAO JOSE DO RIO PRETO" },
		{ value: "4990", label: "SAO JOSE DOS CAMPOS" },
		{ value: "4995", label: "SAO LOURENCO DA SERRA" },
		{ value: "5000", label: "SAO LUIS DO PARAITINGA" },
		{ value: "0000", label: "SAO LUIZ DO PARAITINGA" },
		{ value: "5010", label: "SAO MANUEL" },
		{ value: "5020", label: "SAO MIGUEL ARCANJO" },
		{ value: "5030", label: "SAO PAULO" },
		{ value: "5040", label: "SAO PEDRO" },
		{ value: "5050", label: "SAO PEDRO DO TURVO" },
		{ value: "5060", label: "SAO ROQUE" },
		{ value: "5070", label: "SAO SEBASTIAO" },
		{ value: "5080", label: "SAO SEBASTIAO DA GRAMA" },
		{ value: "5090", label: "SAO SIMAO" },
		{ value: "5100", label: "SAO VICENTE" },
		{ value: "5110", label: "SARAPUI" },
		{ value: "5120", label: "SARUTAIA" },
		{ value: "5130", label: "SEBASTIANOPOLIS DO SUL" },
		{ value: "5140", label: "SERRA AZUL" },
		{ value: "5160", label: "SERRA NEGRA" },
		{ value: "5150", label: "SERRANA" },
		{ value: "5170", label: "SERTAOZINHO" },
		{ value: "5180", label: "SETE BARRAS" },
		{ value: "5190", label: "SEVERINIA" },
		{ value: "5200", label: "SILVEIRAS" },
		{ value: "5210", label: "SOCORRO" },
		{ value: "5220", label: "SOROCABA" },
		{ value: "5230", label: "SUD MENNUCCI" },
		{ value: "5240", label: "SUMARE" },
		{ value: "5255", label: "SUZANAPOLIS" },
		{ value: "5250", label: "SUZANO" },
		{ value: "5260", label: "TABAPUA" },
		{ value: "5270", label: "TABATINGA" },
		{ value: "5280", label: "TABOAO DA SERRA" },
		{ value: "5290", label: "TACIBA" },
		{ value: "5300", label: "TAGUAI" },
		{ value: "5310", label: "TAIACU" },
		{ value: "5320", label: "TAIUVA" },
		{ value: "5330", label: "TAMBAU" },
		{ value: "5340", label: "TANABI" },
		{ value: "5350", label: "TAPIRAI" },
		{ value: "5360", label: "TAPIRATIBA" },
		{ value: "5365", label: "TAQUARAL" },
		{ value: "5370", label: "TAQUARITINGA" },
		{ value: "5380", label: "TAQUARITUBA" },
		{ value: "5385", label: "TAQUARIVAI" },
		{ value: "5390", label: "TARABAI" },
		{ value: "5395", label: "TARUMA" },
		{ value: "5400", label: "TATUI" },
		{ value: "5410", label: "TAUBATE" },
		{ value: "5420", label: "TEJUPA" },
		{ value: "5430", label: "TEODORO SAMPAIO" },
		{ value: "5440", label: "TERRA ROXA" },
		{ value: "5450", label: "TIETE" },
		{ value: "5460", label: "TIMBURI" },
		{ value: "5465", label: "TORRE DE PEDRA" },
		{ value: "5470", label: "TORRINHA" },
		{ value: "5475", label: "TRABIJU" },
		{ value: "5480", label: "TREMEMBE" },
		{ value: "5490", label: "TRES FRONTEIRAS" },
		{ value: "5495", label: "TUIUTI" },
		{ value: "5500", label: "TUPA" },
		{ value: "5510", label: "TUPI PAULISTA" },
		{ value: "5520", label: "TURIUBA" },
		{ value: "5530", label: "TURMALINA" },
		{ value: "5535", label: "UBARANA" },
		{ value: "5540", label: "UBATUBA" },
		{ value: "5550", label: "UBIRAJARA" },
		{ value: "5560", label: "UCHOA" },
		{ value: "5570", label: "UNIAO PAULISTA" },
		{ value: "5580", label: "URANIA" },
		{ value: "5590", label: "URU" },
		{ value: "5600", label: "URUPES" },
		{ value: "5610", label: "VALENTIM GENTIL" },
		{ value: "5620", label: "VALINHOS" },
		{ value: "5630", label: "VALPARAISO" },
		{ value: "5635", label: "VARGEM" },
		{ value: "5640", label: "VARGEM GRANDE DO SUL" },
		{ value: "5645", label: "VARGEM GRANDE PAULISTA" },
		{ value: "5650", label: "VARZEA PAULISTA" },
		{ value: "5660", label: "VERA CRUZ" },
		{ value: "5670", label: "VINHEDO" },
		{ value: "5680", label: "VIRADOURO" },
		{ value: "5690", label: "VISTA ALEGRE DO ALTO" },
		{ value: "5695", label: "VITORIA BRASIL" },
		{ value: "5700", label: "VOTORANTIM" },
		{ value: "5710", label: "VOTUPORANGA" },
		{ value: "5715", label: "ZACARIAS" },
	],
	PR: [
		{ value: "", label: "" },
		{ value: "0010", label: "ABATIA" },
		{ value: "0020", label: "ADRIANOPOLIS" },
		{ value: "0030", label: "AGUDOS DO SUL" },
		{ value: "0040", label: "ALMIRANTE TAMANDARE" },
		{ value: "0045", label: "ALTAMIRA DO PARANA" },
		{ value: "2862", label: "ALTO PARAISO" },
		{ value: "0060", label: "ALTO PARANA" },
		{ value: "0070", label: "ALTO PIQUIRI" },
		{ value: "0050", label: "ALTONIA" },
		{ value: "0080", label: "ALVORADA DO SUL" },
		{ value: "0090", label: "AMAPORA" },
		{ value: "0100", label: "AMPERE" },
		{ value: "0105", label: "ANAHY" },
		{ value: "0110", label: "ANDIRA" },
		{ value: "0115", label: "ANGULO" },
		{ value: "0120", label: "ANTONINA" },
		{ value: "0130", label: "ANTONIO OLINTO" },
		{ value: "0140", label: "APUCARANA" },
		{ value: "0150", label: "ARAPONGAS" },
		{ value: "0160", label: "ARAPOTI" },
		{ value: "0165", label: "ARAPUA" },
		{ value: "0170", label: "ARARUNA" },
		{ value: "0180", label: "ARAUCARIA" },
		{ value: "0185", label: "ARIRANHA DO IVAI" },
		{ value: "0190", label: "ASSAI" },
		{ value: "0200", label: "ASSIS CHATEAUBRIAND" },
		{ value: "0210", label: "ASTORGA" },
		{ value: "0220", label: "ATALAIA" },
		{ value: "0230", label: "BALSA NOVA" },
		{ value: "0240", label: "BANDEIRANTES" },
		{ value: "0250", label: "BARBOSA FERRAZ" },
		{ value: "0270", label: "BARRA DO JACARE" },
		{ value: "0260", label: "BARRACAO" },
		{ value: "0275", label: "BELA VISTA DA CAROBA" },
		{ value: "0280", label: "BELA VISTA DO PARAISO" },
		{ value: "0290", label: "BITURUNA" },
		{ value: "0300", label: "BOA ESPERANCA" },
		{ value: "0302", label: "BOA ESPERANCA DO IGUACU" },
		{ value: "0304", label: "BOA VENTURA DE SAO ROQUE" },
		{ value: "0305", label: "BOA VISTA DA APARECIDA" },
		{ value: "0310", label: "BOCAIUVA DO SUL" },
		{ value: "0315", label: "BOM JESUS DO SUL" },
		{ value: "0320", label: "BOM SUCESSO" },
		{ value: "0322", label: "BOM SUCESSO DO SUL" },
		{ value: "0330", label: "BORRAZOPOLIS" },
		{ value: "0335", label: "BRAGANEY" },
		{ value: "0337", label: "BRASILANDIA DO SUL" },
		{ value: "0340", label: "CAFEARA" },
		{ value: "0345", label: "CAFELANDIA" },
		{ value: "0347", label: "CAFEZAL DO SUL" },
		{ value: "0350", label: "CALIFORNIA" },
		{ value: "0360", label: "CAMBARA" },
		{ value: "0370", label: "CAMBE" },
		{ value: "0380", label: "CAMBIRA" },
		{ value: "0390", label: "CAMPINA DA LAGOA" },
		{ value: "0395", label: "CAMPINA DO SIMAO" },
		{ value: "0400", label: "CAMPINA GRANDE DO SUL" },
		{ value: "0405", label: "CAMPO BONITO" },
		{ value: "0410", label: "CAMPO DO TENENTE" },
		{ value: "0420", label: "CAMPO LARGO" },
		{ value: "0425", label: "CAMPO MAGRO" },
		{ value: "0430", label: "CAMPO MOURAO" },
		{ value: "0440", label: "CANDIDO DE ABREU" },
		{ value: "0442", label: "CANDOI" },
		{ value: "0445", label: "CANTAGALO" },
		{ value: "0450", label: "CAPANEMA" },
		{ value: "0460", label: "CAPITAO LEONIDAS MARQUES" },
		{ value: "0465", label: "CARAMBEI" },
		{ value: "0470", label: "CARLOPOLIS" },
		{ value: "0480", label: "CASCAVEL" },
		{ value: "0490", label: "CASTRO" },
		{ value: "0500", label: "CATANDUVAS" },
		{ value: "0510", label: "CENTENARIO DO SUL" },
		{ value: "0520", label: "CERRO AZUL" },
		{ value: "0530", label: "CEU AZUL" },
		{ value: "0540", label: "CHOPINZINHO" },
		{ value: "0550", label: "CIANORTE" },
		{ value: "0560", label: "CIDADE GAUCHA" },
		{ value: "0570", label: "CLEVELANDIA" },
		{ value: "0580", label: "COLOMBO" },
		{ value: "0590", label: "COLORADO" },
		{ value: "0600", label: "CONGONHINHAS" },
		{ value: "0610", label: "CONSELHEIRO MAIRINCK" },
		{ value: "0620", label: "CONTENDA" },
		{ value: "0630", label: "CORBELIA" },
		{ value: "0640", label: "CORNELIO PROCOPIO" },
		{ value: "0645", label: "CORONEL DOMINGOS SOARES" },
		{ value: "0650", label: "CORONEL VIVIDA" },
		{ value: "0655", label: "CORUMBATAI DO SUL" },
		{ value: "0680", label: "CRUZ MACHADO" },
		{ value: "0657", label: "CRUZEIRO DO IGUACU" },
		{ value: "0660", label: "CRUZEIRO DO OESTE" },
		{ value: "0670", label: "CRUZEIRO DO SUL" },
		{ value: "0685", label: "CRUZMALTINA" },
		{ value: "0690", label: "CURITIBA" },
		{ value: "0700", label: "CURIUVA" },
		{ value: "0715", label: "DIAMANTE D'OESTE" },
		{ value: "0710", label: "DIAMANTE DO NORTE" },
		{ value: "0712", label: "DIAMANTE DO SUL" },
		{ value: "0720", label: "DOIS VIZINHOS" },
		{ value: "0725", label: "DOURADINA" },
		{ value: "0730", label: "DOUTOR CAMARGO" },
		{ value: "2863", label: "DOUTOR ULYSSES" },
		{ value: "0740", label: "ENEAS MARQUES" },
		{ value: "0750", label: "ENGENHEIRO BELTRAO" },
		{ value: "0753", label: "ENTRE RIOS DO OESTE" },
		{ value: "0752", label: "ESPERANCA NOVA" },
		{ value: "0754", label: "ESPIGAO ALTO DO IGUACU" },
		{ value: "0755", label: "FAROL" },
		{ value: "0760", label: "FAXINAL" },
		{ value: "0765", label: "FAZENDA RIO GRANDE" },
		{ value: "0770", label: "FENIX" },
		{ value: "0773", label: "FERNANDES PINHEIRO" },
		{ value: "0775", label: "FIGUEIRA" },
		{ value: "0785", label: "FLOR DA SERRA DO SUL" },
		{ value: "0780", label: "FLORAI" },
		{ value: "0790", label: "FLORESTA" },
		{ value: "0800", label: "FLORESTOPOLIS" },
		{ value: "0810", label: "FLORIDA" },
		{ value: "0820", label: "FORMOSA DO OESTE" },
		{ value: "0830", label: "FOZ DO IGUACU" },
		{ value: "0845", label: "FOZ DO JORDAO" },
		{ value: "0832", label: "FRANCISCO ALVES" },
		{ value: "0840", label: "FRANCISCO BELTRAO" },
		{ value: "0850", label: "GENERAL CARNEIRO" },
		{ value: "0855", label: "GODOY MOREIRA" },
		{ value: "0860", label: "GOIOERE" },
		{ value: "0865", label: "GOIOXIM" },
		{ value: "0870", label: "GRANDES RIOS" },
		{ value: "0880", label: "GUAIRA" },
		{ value: "0890", label: "GUAIRACA" },
		{ value: "0895", label: "GUAMIRANGA" },
		{ value: "0900", label: "GUAPIRAMA" },
		{ value: "0910", label: "GUAPOREMA" },
		{ value: "0920", label: "GUARACI" },
		{ value: "0930", label: "GUARANIACU" },
		{ value: "0940", label: "GUARAPUAVA" },
		{ value: "0950", label: "GUARAQUECABA" },
		{ value: "0960", label: "GUARATUBA" },
		{ value: "0965", label: "HONORIO SERPA" },
		{ value: "0970", label: "IBAITI" },
		{ value: "0975", label: "IBEMA" },
		{ value: "0980", label: "IBIPORA" },
		{ value: "0990", label: "ICARAIMA" },
		{ value: "1000", label: "IGUARACU" },
		{ value: "1005", label: "IGUATU" },
		{ value: "1007", label: "IMBAU" },
		{ value: "1010", label: "IMBITUVA" },
		{ value: "1020", label: "INACIO MARTINS" },
		{ value: "1030", label: "INAJA" },
		{ value: "1040", label: "INDIANOPOLIS" },
		{ value: "1050", label: "IPIRANGA" },
		{ value: "1060", label: "IPORA" },
		{ value: "1065", label: "IRACEMA DO OESTE" },
		{ value: "1070", label: "IRATI" },
		{ value: "1080", label: "IRETAMA" },
		{ value: "1090", label: "ITAGUAJE" },
		{ value: "1095", label: "ITAIPULANDIA" },
		{ value: "1100", label: "ITAMBARACA" },
		{ value: "1110", label: "ITAMBE" },
		{ value: "1120", label: "ITAPEJARA D'OESTE" },
		{ value: "1125", label: "ITAPERUCU" },
		{ value: "1130", label: "ITAUNA DO SUL" },
		{ value: "1140", label: "IVAI" },
		{ value: "1150", label: "IVAIPORA" },
		{ value: "1155", label: "IVATE" },
		{ value: "1160", label: "IVATUBA" },
		{ value: "1170", label: "JABOTI" },
		{ value: "1180", label: "JACAREZINHO" },
		{ value: "1190", label: "JAGUAPITA" },
		{ value: "1200", label: "JAGUARIAIVA" },
		{ value: "1210", label: "JANDAIA DO SUL" },
		{ value: "1220", label: "JANIOPOLIS" },
		{ value: "1230", label: "JAPIRA" },
		{ value: "1240", label: "JAPURA" },
		{ value: "1250", label: "JARDIM ALEGRE" },
		{ value: "1260", label: "JARDIM OLINDA" },
		{ value: "1270", label: "JATAIZINHO" },
		{ value: "1275", label: "JESUITAS" },
		{ value: "1280", label: "JOAQUIM TAVORA" },
		{ value: "1290", label: "JUNDIAI DO SUL" },
		{ value: "1295", label: "JURANDA" },
		{ value: "1300", label: "JUSSARA" },
		{ value: "1310", label: "KALORE" },
		{ value: "1320", label: "LAPA" },
		{ value: "1325", label: "LARANJAL" },
		{ value: "1330", label: "LARANJEIRAS DO SUL" },
		{ value: "1340", label: "LEOPOLIS" },
		{ value: "1342", label: "LIDIANOPOLIS" },
		{ value: "1345", label: "LINDOESTE" },
		{ value: "1350", label: "LOANDA" },
		{ value: "1360", label: "LOBATO" },
		{ value: "1370", label: "LONDRINA" },
		{ value: "1373", label: "LUIZIANA" },
		{ value: "1375", label: "LUNARDELLI" },
		{ value: "1380", label: "LUPIONOPOLIS" },
		{ value: "1390", label: "MALLET" },
		{ value: "1400", label: "MAMBORE" },
		{ value: "1410", label: "MANDAGUACU" },
		{ value: "1420", label: "MANDAGUARI" },
		{ value: "1430", label: "MANDIRITUBA" },
		{ value: "1435", label: "MANFRINOPOLIS" },
		{ value: "1440", label: "MANGUEIRINHA" },
		{ value: "1450", label: "MANOEL RIBAS" },
		{ value: "1460", label: "MARECHAL CANDIDO RONDON" },
		{ value: "1470", label: "MARIA HELENA" },
		{ value: "1480", label: "MARIALVA" },
		{ value: "1490", label: "MARILANDIA DO SUL" },
		{ value: "1500", label: "MARILENA" },
		{ value: "1510", label: "MARILUZ" },
		{ value: "1520", label: "MARINGA" },
		{ value: "1530", label: "MARIOPOLIS" },
		{ value: "1535", label: "MARIPA" },
		{ value: "1540", label: "MARMELEIRO" },
		{ value: "1545", label: "MARQUINHO" },
		{ value: "1550", label: "MARUMBI" },
		{ value: "1560", label: "MATELANDIA" },
		{ value: "1570", label: "MATINHOS" },
		{ value: "1573", label: "MATO RICO" },
		{ value: "1575", label: "MAUA DA SERRA" },
		{ value: "1580", label: "MEDIANEIRA" },
		{ value: "1585", label: "MERCEDES" },
		{ value: "1590", label: "MIRADOR" },
		{ value: "1600", label: "MIRASELVA" },
		{ value: "1605", label: "MISSAL" },
		{ value: "1610", label: "MOREIRA SALES" },
		{ value: "1620", label: "MORRETES" },
		{ value: "1630", label: "MUNHOZ DE MELO" },
		{ value: "1640", label: "NOSSA SENHORA DAS GRACAS" },
		{ value: "1650", label: "NOVA ALIANCA DO IVAI" },
		{ value: "1660", label: "NOVA AMERICA DA COLINA" },
		{ value: "1670", label: "NOVA AURORA" },
		{ value: "1680", label: "NOVA CANTU" },
		{ value: "1690", label: "NOVA ESPERANCA" },
		{ value: "1695", label: "NOVA ESPERANCA DO SUDOESTE" },
		{ value: "1700", label: "NOVA FATIMA" },
		{ value: "1705", label: "NOVA LARANJEIRAS" },
		{ value: "1710", label: "NOVA LONDRINA" },
		{ value: "1720", label: "NOVA OLIMPIA" },
		{ value: "1725", label: "NOVA PRATA DO IGUACU" },
		{ value: "1721", label: "NOVA SANTA BARBARA" },
		{ value: "1722", label: "NOVA SANTA ROSA" },
		{ value: "1727", label: "NOVA TEBAS" },
		{ value: "1729", label: "NOVO ITACOLOMI" },
		{ value: "1730", label: "ORTIGUEIRA" },
		{ value: "1740", label: "OURIZONA" },
		{ value: "1745", label: "OURO VERDE DO OESTE" },
		{ value: "1750", label: "PAICANDU" },
		{ value: "1760", label: "PALMAS" },
		{ value: "1770", label: "PALMEIRA" },
		{ value: "1780", label: "PALMITAL" },
		{ value: "1790", label: "PALOTINA" },
		{ value: "1800", label: "PARAISO DO NORTE" },
		{ value: "1810", label: "PARANACITY" },
		{ value: "1820", label: "PARANAGUA" },
		{ value: "1830", label: "PARANAPOEMA" },
		{ value: "1840", label: "PARANAVAI" },
		{ value: "1845", label: "PATO BRAGADO" },
		{ value: "1850", label: "PATO BRANCO" },
		{ value: "1860", label: "PAULA FREITAS" },
		{ value: "1870", label: "PAULO FRONTIN" },
		{ value: "1880", label: "PEABIRU" },
		{ value: "1885", label: "PEROBAL" },
		{ value: "1890", label: "PEROLA" },
		{ value: "1900", label: "PEROLA D'OESTE" },
		{ value: "1910", label: "PIEN" },
		{ value: "1915", label: "PINHAIS" },
		{ value: "1925", label: "PINHAL DE SAO BENTO" },
		{ value: "1920", label: "PINHALAO" },
		{ value: "1930", label: "PINHAO" },
		{ value: "1940", label: "PIRAI DO SUL" },
		{ value: "1950", label: "PIRAQUARA" },
		{ value: "1960", label: "PITANGA" },
		{ value: "1965", label: "PITANGUEIRAS" },
		{ value: "1970", label: "PLANALTINA DO PARANA" },
		{ value: "1980", label: "PLANALTO" },
		{ value: "1990", label: "PONTA GROSSA" },
		{ value: "1995", label: "PONTAL DO PARANA" },
		{ value: "2000", label: "PORECATU" },
		{ value: "2010", label: "PORTO AMAZONAS" },
		{ value: "2015", label: "PORTO BARREIRO" },
		{ value: "2020", label: "PORTO RICO" },
		{ value: "2030", label: "PORTO VITORIA" },
		{ value: "2033", label: "PRADO FERREIRA" },
		{ value: "2035", label: "PRANCHITA" },
		{ value: "2040", label: "PRESIDENTE CASTELO BRANCO" },
		{ value: "2050", label: "PRIMEIRO DE MAIO" },
		{ value: "2060", label: "PRUDENTOPOLIS" },
		{ value: "2065", label: "QUARTO CENTENARIO" },
		{ value: "2070", label: "QUATIGUA" },
		{ value: "2080", label: "QUATRO BARRAS" },
		{ value: "2085", label: "QUATRO PONTES" },
		{ value: "2090", label: "QUEDAS DO IGUACU" },
		{ value: "2100", label: "QUERENCIA DO NORTE" },
		{ value: "2110", label: "QUINTA DO SOL" },
		{ value: "2120", label: "QUITANDINHA" },
		{ value: "2125", label: "RAMILANDIA" },
		{ value: "2130", label: "RANCHO ALEGRE" },
		{ value: "2135", label: "RANCHO ALEGRE D'OESTE" },
		{ value: "2140", label: "REALEZA" },
		{ value: "2150", label: "REBOUCAS" },
		{ value: "2160", label: "RENASCENCA" },
		{ value: "2170", label: "RESERVA" },
		{ value: "2175", label: "RESERVA DO IGUACU" },
		{ value: "2180", label: "RIBEIRAO CLARO" },
		{ value: "2190", label: "RIBEIRAO DO PINHAL" },
		{ value: "2200", label: "RIO AZUL" },
		{ value: "2210", label: "RIO BOM" },
		{ value: "2215", label: "RIO BONITO DO IGUACU" },
		{ value: "2217", label: "RIO BRANCO DO IVAI" },
		{ value: "2220", label: "RIO BRANCO DO SUL" },
		{ value: "2230", label: "RIO NEGRO" },
		{ value: "2240", label: "ROLANDIA" },
		{ value: "2250", label: "RONCADOR" },
		{ value: "2260", label: "RONDON" },
		{ value: "2265", label: "ROSARIO DO IVAI" },
		{ value: "2270", label: "SABAUDIA" },
		{ value: "2280", label: "SALGADO FILHO" },
		{ value: "2290", label: "SALTO DO ITARARE" },
		{ value: "2300", label: "SALTO DO LONTRA" },
		{ value: "2310", label: "SANTA AMELIA" },
		{ value: "2320", label: "SANTA CECILIA DO PAVAO" },
		{ value: "2330", label: "SANTA CRUZ DE MONTE CASTELO" },
		{ value: "2340", label: "SANTA FE" },
		{ value: "2350", label: "SANTA HELENA" },
		{ value: "2360", label: "SANTA INES" },
		{ value: "2370", label: "SANTA ISABEL DO IVAI" },
		{ value: "2380", label: "SANTA IZABEL DO OESTE" },
		{ value: "2382", label: "SANTA LUCIA" },
		{ value: "2385", label: "SANTA MARIA DO OESTE" },
		{ value: "2390", label: "SANTA MARIANA" },
		{ value: "2395", label: "SANTA MONICA" },
		{ value: "2402", label: "SANTA TEREZA DO OESTE" },
		{ value: "2405", label: "SANTA TEREZINHA DE ITAIPU" },
		{ value: "2400", label: "SANTANA DO ITARARE" },
		{ value: "2410", label: "SANTO ANTONIO DA PLATINA" },
		{ value: "2420", label: "SANTO ANTONIO DO CAIUA" },
		{ value: "2430", label: "SANTO ANTONIO DO PARAISO" },
		{ value: "2440", label: "SANTO ANTONIO DO SUDOESTE" },
		{ value: "2450", label: "SANTO INACIO" },
		{ value: "2460", label: "SAO CARLOS DO IVAI" },
		{ value: "2470", label: "SAO JERONIMO DA SERRA" },
		{ value: "2480", label: "SAO JOAO" },
		{ value: "2490", label: "SAO JOAO DO CAIUA" },
		{ value: "2500", label: "SAO JOAO DO IVAI" },
		{ value: "2510", label: "SAO JOAO DO TRIUNFO" },
		{ value: "2520", label: "SAO JORGE D'OESTE" },
		{ value: "2530", label: "SAO JORGE DO IVAI" },
		{ value: "2535", label: "SAO JORGE DO PATROCINIO" },
		{ value: "2540", label: "SAO JOSE DA BOA VISTA" },
		{ value: "2545", label: "SAO JOSE DAS PALMEIRAS" },
		{ value: "2550", label: "SAO JOSE DOS PINHAIS" },
		{ value: "2555", label: "SAO MANOEL DO PARANA" },
		{ value: "2560", label: "SAO MATEUS DO SUL" },
		{ value: "2570", label: "SAO MIGUEL DO IGUACU" },
		{ value: "2575", label: "SAO PEDRO DO IGUACU" },
		{ value: "2580", label: "SAO PEDRO DO IVAI" },
		{ value: "2590", label: "SAO PEDRO DO PARANA" },
		{ value: "2600", label: "SAO SEBASTIAO DA AMOREIRA" },
		{ value: "2610", label: "SAO TOME" },
		{ value: "2620", label: "SAPOPEMA" },
		{ value: "2625", label: "SARANDI" },
		{ value: "0000", label: "SARANDI" },
		{ value: "2627", label: "SAUDADE DO IGUACU" },
		{ value: "2630", label: "SENGES" },
		{ value: "2635", label: "SERRANOPOLIS DO IGUACU" },
		{ value: "2640", label: "SERTANEJA" },
		{ value: "2650", label: "SERTANOPOLIS" },
		{ value: "2660", label: "SIQUEIRA CAMPOS" },
		{ value: "2665", label: "SULINA" },
		{ value: "2667", label: "TAMARANA" },
		{ value: "2670", label: "TAMBOARA" },
		{ value: "2680", label: "TAPEJARA" },
		{ value: "2690", label: "TAPIRA" },
		{ value: "2700", label: "TEIXEIRA SOARES" },
		{ value: "2710", label: "TELEMACO BORBA" },
		{ value: "2720", label: "TERRA BOA" },
		{ value: "2730", label: "TERRA RICA" },
		{ value: "2740", label: "TERRA ROXA" },
		{ value: "2750", label: "TIBAGI" },
		{ value: "2760", label: "TIJUCAS DO SUL" },
		{ value: "2770", label: "TOLEDO" },
		{ value: "2780", label: "TOMAZINA" },
		{ value: "2785", label: "TRES BARRAS DO PARANA" },
		{ value: "2788", label: "TUNAS DO PARANA" },
		{ value: "2790", label: "TUNEIRAS DO OESTE" },
		{ value: "2795", label: "TUPASSI" },
		{ value: "2796", label: "TURVO" },
		{ value: "2800", label: "UBIRATA" },
		{ value: "2810", label: "UMUARAMA" },
		{ value: "2820", label: "UNIAO DA VITORIA" },
		{ value: "2830", label: "UNIFLOR" },
		{ value: "2840", label: "URAI" },
		{ value: "2853", label: "VENTANIA" },
		{ value: "2855", label: "VERA CRUZ DO OESTE" },
		{ value: "2860", label: "VERE" },
		{ value: "2865", label: "VIRMOND" },
		{ value: "2870", label: "VITORINO" },
		{ value: "2850", label: "WENCESLAU BRAZ" },
		{ value: "2880", label: "XAMBRE" },
	],
	SC: [
		{ value: "0005", label: "ABDON BATISTA" },
		{ value: "0010", label: "ABELARDO LUZ" },
		{ value: "0020", label: "AGROLANDIA" },
		{ value: "0030", label: "AGRONOMICA" },
		{ value: "0040", label: "AGUA DOCE" },
		{ value: "0050", label: "AGUAS DE CHAPECO" },
		{ value: "0055", label: "AGUAS FRIAS" },
		{ value: "0060", label: "AGUAS MORNAS" },
		{ value: "0070", label: "ALFREDO WAGNER" },
		{ value: "0075", label: "ALTO BELA VISTA" },
		{ value: "0080", label: "ANCHIETA" },
		{ value: "0090", label: "ANGELINA" },
		{ value: "0100", label: "ANITA GARIBALDI" },
		{ value: "0110", label: "ANITAPOLIS" },
		{ value: "0120", label: "ANTONIO CARLOS" },
		{ value: "0125", label: "APIUNA" },
		{ value: "0127", label: "ARABUTA" },
		{ value: "0130", label: "ARAQUARI" },
		{ value: "0140", label: "ARARANGUA" },
		{ value: "0150", label: "ARMAZEM" },
		{ value: "0160", label: "ARROIO TRINTA" },
		{ value: "0165", label: "ARVOREDO" },
		{ value: "0170", label: "ASCURRA" },
		{ value: "0180", label: "ATALANTA" },
		{ value: "0190", label: "AURORA" },
		{ value: "0195", label: "BALNEARIO ARROIO DO SILVA" },
		{ value: "0205", label: "BALNEARIO BARRA DO SUL" },
		{ value: "0200", label: "BALNEARIO CAMBORIU" },
		{ value: "0207", label: "BALNEARIO GAIVOTA" },
		{ value: "1280", label: "BALNEARIO PICARRAS" },
		{ value: "2000", label: "BALNEARIO RINCAO" },
		{ value: "2000", label: "BALNEARIO RINCAO" },
		{ value: "0208", label: "BANDEIRANTE" },
		{ value: "0209", label: "BARRA BONITA" },
		{ value: "0210", label: "BARRA VELHA" },
		{ value: "0213", label: "BELA VISTA DO TOLDO" },
		{ value: "0215", label: "BELMONTE" },
		{ value: "0220", label: "BENEDITO NOVO" },
		{ value: "0230", label: "BIGUACU" },
		{ value: "0240", label: "BLUMENAU" },
		{ value: "0243", label: "BOCAINA DO SUL" },
		{ value: "0250", label: "BOM JARDIM DA SERRA" },
		{ value: "0253", label: "BOM JESUS" },
		{ value: "0257", label: "BOM JESUS DO OESTE" },
		{ value: "0260", label: "BOM RETIRO" },
		{ value: "0245", label: "BOMBINHAS" },
		{ value: "0270", label: "BOTUVERA" },
		{ value: "0280", label: "BRACO DO NORTE" },
		{ value: "0285", label: "BRACO DO TROMBUDO" },
		{ value: "0287", label: "BRUNOPOLIS" },
		{ value: "0290", label: "BRUSQUE" },
		{ value: "0300", label: "CACADOR" },
		{ value: "0310", label: "CAIBI" },
		{ value: "0315", label: "CALMON" },
		{ value: "0320", label: "CAMBORIU" },
		{ value: "0330", label: "CAMPO ALEGRE" },
		{ value: "0340", label: "CAMPO BELO DO SUL" },
		{ value: "0350", label: "CAMPO ERE" },
		{ value: "0360", label: "CAMPOS NOVOS" },
		{ value: "0370", label: "CANELINHA" },
		{ value: "0380", label: "CANOINHAS" },
		{ value: "0325", label: "CAPAO ALTO" },
		{ value: "0390", label: "CAPINZAL" },
		{ value: "0395", label: "CAPIVARI DE BAIXO" },
		{ value: "0400", label: "CATANDUVAS" },
		{ value: "0410", label: "CAXAMBU DO SUL" },
		{ value: "0415", label: "CELSO RAMOS" },
		{ value: "0417", label: "CERRO NEGRO" },
		{ value: "0419", label: "CHAPADAO DO LAGEADO" },
		{ value: "0420", label: "CHAPECO" },
		{ value: "0425", label: "COCAL DO SUL" },
		{ value: "0430", label: "CONCORDIA" },
		{ value: "0435", label: "CORDILHEIRA ALTA" },
		{ value: "0440", label: "CORONEL FREITAS" },
		{ value: "0445", label: "CORONEL MARTINS" },
		{ value: "0455", label: "CORREIA PINTO" },
		{ value: "0450", label: "CORUPA" },
		{ value: "0460", label: "CRICIUMA" },
		{ value: "0470", label: "CUNHA PORA" },
		{ value: "0475", label: "CUNHATAI" },
		{ value: "0480", label: "CURITIBANOS" },
		{ value: "0490", label: "DESCANSO" },
		{ value: "0500", label: "DIONISIO CERQUEIRA" },
		{ value: "0510", label: "DONA EMMA" },
		{ value: "0515", label: "DOUTOR PEDRINHO" },
		{ value: "0517", label: "ENTRE RIOS" },
		{ value: "0519", label: "ERMO" },
		{ value: "0520", label: "ERVAL VELHO" },
		{ value: "0530", label: "FAXINAL DOS GUEDES" },
		{ value: "0535", label: "FLOR DO SERTAO" },
		{ value: "0540", label: "FLORIANOPOLIS" },
		{ value: "0543", label: "FORMOSA DO SUL" },
		{ value: "0545", label: "FORQUILHINHA" },
		{ value: "0550", label: "FRAIBURGO" },
		{ value: "0555", label: "FREI ROGERIO" },
		{ value: "0560", label: "GALVAO" },
		{ value: "0570", label: "GAROPABA" },
		{ value: "0580", label: "GARUVA" },
		{ value: "0590", label: "GASPAR" },
		{ value: "0600", label: "GOVERNADOR CELSO RAMOS" },
		{ value: "0610", label: "GRAO PARA" },
		{ value: "0620", label: "GRAVATAL" },
		{ value: "0630", label: "GUABIRUBA" },
		{ value: "0640", label: "GUARACIABA" },
		{ value: "0650", label: "GUARAMIRIM" },
		{ value: "0660", label: "GUARUJA DO SUL" },
		{ value: "0665", label: "GUATAMBU" },
		{ value: "0670", label: "HERVAL D'OESTE" },
		{ value: "0675", label: "IBIAM" },
		{ value: "0680", label: "IBICARE" },
		{ value: "0690", label: "IBIRAMA" },
		{ value: "0700", label: "ICARA" },
		{ value: "0710", label: "ILHOTA" },
		{ value: "0720", label: "IMARUI" },
		{ value: "0730", label: "IMBITUBA" },
		{ value: "0740", label: "IMBUIA" },
		{ value: "0750", label: "INDAIAL" },
		{ value: "0757", label: "IOMERE" },
		{ value: "0760", label: "IPIRA" },
		{ value: "0765", label: "IPORA DO OESTE" },
		{ value: "0768", label: "IPUACU" },
		{ value: "0770", label: "IPUMIRIM" },
		{ value: "0775", label: "IRACEMINHA" },
		{ value: "0780", label: "IRANI" },
		{ value: "0785", label: "IRATI" },
		{ value: "0790", label: "IRINEOPOLIS" },
		{ value: "0800", label: "ITA" },
		{ value: "0810", label: "ITAIOPOLIS" },
		{ value: "0820", label: "ITAJAI" },
		{ value: "0830", label: "ITAPEMA" },
		{ value: "0840", label: "ITAPIRANGA" },
		{ value: "0845", label: "ITAPOA" },
		{ value: "0850", label: "ITUPORANGA" },
		{ value: "0860", label: "JABORA" },
		{ value: "0870", label: "JACINTO MACHADO" },
		{ value: "0880", label: "JAGUARUNA" },
		{ value: "0890", label: "JARAGUA DO SUL" },
		{ value: "0895", label: "JARDINOPOLIS" },
		{ value: "0900", label: "JOACABA" },
		{ value: "0910", label: "JOINVILLE" },
		{ value: "0915", label: "JOSE BOITEUX" },
		{ value: "0917", label: "JUPIA" },
		{ value: "0920", label: "LACERDOPOLIS" },
		{ value: "0930", label: "LAGES" },
		{ value: "0940", label: "LAGUNA" },
		{ value: "0945", label: "LAJEADO GRANDE" },
		{ value: "0950", label: "LAURENTINO" },
		{ value: "0960", label: "LAURO MULLER" },
		{ value: "0970", label: "LEBON REGIS" },
		{ value: "0980", label: "LEOBERTO LEAL" },
		{ value: "0985", label: "LINDOIA DO SUL" },
		{ value: "0990", label: "LONTRAS" },
		{ value: "1000", label: "LUIZ ALVES" },
		{ value: "1003", label: "LUZERNA" },
		{ value: "1005", label: "MACIEIRA" },
		{ value: "1010", label: "MAFRA" },
		{ value: "1020", label: "MAJOR GERCINO" },
		{ value: "1030", label: "MAJOR VIEIRA" },
		{ value: "1040", label: "MARACAJA" },
		{ value: "1050", label: "MARAVILHA" },
		{ value: "1055", label: "MAREMA" },
		{ value: "1060", label: "MASSARANDUBA" },
		{ value: "1070", label: "MATOS COSTA" },
		{ value: "1080", label: "MELEIRO" },
		{ value: "1085", label: "MIRIM DOCE" },
		{ value: "1090", label: "MODELO" },
		{ value: "1100", label: "MONDAI" },
		{ value: "1105", label: "MONTE CARLO" },
		{ value: "1110", label: "MONTE CASTELO" },
		{ value: "1120", label: "MORRO DA FUMACA" },
		{ value: "1125", label: "MORRO GRANDE" },
		{ value: "1130", label: "NAVEGANTES" },
		{ value: "1140", label: "NOVA ERECHIM" },
		{ value: "1145", label: "NOVA ITABERABA" },
		{ value: "1150", label: "NOVA TRENTO" },
		{ value: "1160", label: "NOVA VENEZA" },
		{ value: "1165", label: "NOVO HORIZONTE" },
		{ value: "1170", label: "ORLEANS" },
		{ value: "1175", label: "OTACILIO COSTA" },
		{ value: "1180", label: "OURO" },
		{ value: "1185", label: "OURO VERDE" },
		{ value: "1187", label: "PAIAL" },
		{ value: "1189", label: "PAINEL" },
		{ value: "1190", label: "PALHOCA" },
		{ value: "1200", label: "PALMA SOLA" },
		{ value: "1205", label: "PALMEIRA" },
		{ value: "1210", label: "PALMITOS" },
		{ value: "1220", label: "PAPANDUVA" },
		{ value: "1223", label: "PARAISO" },
		{ value: "1225", label: "PASSO DE TORRES" },
		{ value: "1227", label: "PASSOS MAIA" },
		{ value: "1230", label: "PAULO LOPES" },
		{ value: "1240", label: "PEDRAS GRANDES" },
		{ value: "1250", label: "PENHA" },
		{ value: "1260", label: "PERITIBA" },
		{ value: "1265", label: "PESCARIA BRAVA" },
		{ value: "1265", label: "PESCARIA BRAVA" },
		{ value: "1270", label: "PETROLANDIA" },
		{ value: "1290", label: "PINHALZINHO" },
		{ value: "1300", label: "PINHEIRO PRETO" },
		{ value: "1310", label: "PIRATUBA" },
		{ value: "1315", label: "PLANALTO ALEGRE" },
		{ value: "1320", label: "POMERODE" },
		{ value: "1330", label: "PONTE ALTA" },
		{ value: "1335", label: "PONTE ALTA DO NORTE" },
		{ value: "1340", label: "PONTE SERRADA" },
		{ value: "1350", label: "PORTO BELO" },
		{ value: "1360", label: "PORTO UNIAO" },
		{ value: "1370", label: "POUSO REDONDO" },
		{ value: "1380", label: "PRAIA GRANDE" },
		{ value: "1390", label: "PRESIDENTE CASTELLO BRANCO" },
		{ value: "1400", label: "PRESIDENTE GETULIO" },
		{ value: "1410", label: "PRESIDENTE NEREU" },
		{ value: "1415", label: "PRINCESA" },
		{ value: "1420", label: "QUILOMBO" },
		{ value: "1430", label: "RANCHO QUEIMADO" },
		{ value: "1440", label: "RIO DAS ANTAS" },
		{ value: "1450", label: "RIO DO CAMPO" },
		{ value: "1460", label: "RIO DO OESTE" },
		{ value: "1480", label: "RIO DO SUL" },
		{ value: "1470", label: "RIO DOS CEDROS" },
		{ value: "1490", label: "RIO FORTUNA" },
		{ value: "1500", label: "RIO NEGRINHO" },
		{ value: "1505", label: "RIO RUFINO" },
		{ value: "1507", label: "RIQUEZA" },
		{ value: "1510", label: "RODEIO" },
		{ value: "1520", label: "ROMELANDIA" },
		{ value: "1530", label: "SALETE" },
		{ value: "1535", label: "SALTINHO" },
		{ value: "1540", label: "SALTO VELOSO" },
		{ value: "1545", label: "SANGAO" },
		{ value: "1550", label: "SANTA CECILIA" },
		{ value: "1555", label: "SANTA HELENA" },
		{ value: "1560", label: "SANTA ROSA DE LIMA" },
		{ value: "1565", label: "SANTA ROSA DO SUL" },
		{ value: "1567", label: "SANTA TEREZINHA" },
		{ value: "1568", label: "SANTA TEREZINHA DO PROGRESSO" },
		{ value: "1569", label: "SANTIAGO DO SUL" },
		{ value: "1570", label: "SANTO AMARO DA IMPERATRIZ" },
		{ value: "1580", label: "SAO BENTO DO SUL" },
		{ value: "1575", label: "SAO BERNARDINO" },
		{ value: "1590", label: "SAO BONIFACIO" },
		{ value: "1600", label: "SAO CARLOS" },
		{ value: "1605", label: "SAO CRISTOVAO DO SUL" },
		{ value: "1610", label: "SAO DOMINGOS" },
		{ value: "1620", label: "SAO FRANCISCO DO SUL" },
		{ value: "1630", label: "SAO JOAO BATISTA" },
		{ value: "1635", label: "SAO JOAO DO ITAPERIU" },
		{ value: "1625", label: "SAO JOAO DO OESTE" },
		{ value: "1640", label: "SAO JOAO DO SUL" },
		{ value: "1650", label: "SAO JOAQUIM" },
		{ value: "1660", label: "SAO JOSE" },
		{ value: "1670", label: "SAO JOSE DO CEDRO" },
		{ value: "1680", label: "SAO JOSE DO CERRITO" },
		{ value: "1690", label: "SAO LOURENCO DO OESTE" },
		{ value: "1700", label: "SAO LUDGERO" },
		{ value: "1710", label: "SAO MARTINHO" },
		{ value: "1715", label: "SAO MIGUEL DA BOA VISTA" },
		{ value: "1720", label: "SAO MIGUEL DO OESTE" },
		{ value: "1725", label: "SAO PEDRO DE ALCANTARA" },
		{ value: "1730", label: "SAUDADES" },
		{ value: "1740", label: "SCHROEDER" },
		{ value: "1750", label: "SEARA" },
		{ value: "1755", label: "SERRA ALTA" },
		{ value: "1760", label: "SIDEROPOLIS" },
		{ value: "1770", label: "SOMBRIO" },
		{ value: "1775", label: "SUL BRASIL" },
		{ value: "1780", label: "TAIO" },
		{ value: "1790", label: "TANGARA" },
		{ value: "1795", label: "TIGRINHOS" },
		{ value: "1800", label: "TIJUCAS" },
		{ value: "1810", label: "TIMBE DO SUL" },
		{ value: "1820", label: "TIMBO" },
		{ value: "1825", label: "TIMBO GRANDE" },
		{ value: "1830", label: "TRES BARRAS" },
		{ value: "1835", label: "TREVISO" },
		{ value: "1840", label: "TREZE DE MAIO" },
		{ value: "1850", label: "TREZE TILIAS" },
		{ value: "1860", label: "TROMBUDO CENTRAL" },
		{ value: "1870", label: "TUBARAO" },
		{ value: "1875", label: "TUNAPOLIS" },
		{ value: "1880", label: "TURVO" },
		{ value: "1885", label: "UNIAO DO OESTE" },
		{ value: "1890", label: "URUBICI" },
		{ value: "1895", label: "URUPEMA" },
		{ value: "1900", label: "URUSSANGA" },
		{ value: "1910", label: "VARGEAO" },
		{ value: "1915", label: "VARGEM" },
		{ value: "1917", label: "VARGEM BONITA" },
		{ value: "1920", label: "VIDAL RAMOS" },
		{ value: "1930", label: "VIDEIRA" },
		{ value: "1935", label: "VITOR MEIRELES" },
		{ value: "1940", label: "WITMARSUM" },
		{ value: "1950", label: "XANXERE" },
		{ value: "1960", label: "XAVANTINA" },
		{ value: "1970", label: "XAXIM" },
		{ value: "1985", label: "ZORTEA" },
	],
	RS: [
		{ value: "0003", label: "ACEGUA" },
		{ value: "0005", label: "AGUA SANTA" },
		{ value: "0010", label: "AGUDO" },
		{ value: "0020", label: "AJURICABA" },
		{ value: "0030", label: "ALECRIM" },
		{ value: "0040", label: "ALEGRETE" },
		{ value: "0045", label: "ALEGRIA" },
		{ value: "0047", label: "ALMIRANTE TAMANDARE DO SUL" },
		{ value: "0050", label: "ALPESTRE" },
		{ value: "0055", label: "ALTO ALEGRE" },
		{ value: "0057", label: "ALTO FELIZ" },
		{ value: "0060", label: "ALVORADA" },
		{ value: "0063", label: "AMARAL FERRADOR" },
		{ value: "0064", label: "AMETISTA DO SUL" },
		{ value: "0066", label: "ANDRE DA ROCHA" },
		{ value: "0070", label: "ANTA GORDA" },
		{ value: "0080", label: "ANTONIO PRADO" },
		{ value: "0085", label: "ARAMBARE" },
		{ value: "0087", label: "ARARICA" },
		{ value: "0090", label: "ARATIBA" },
		{ value: "0100", label: "ARROIO DO MEIO" },
		{ value: "0107", label: "ARROIO DO PADRE" },
		{ value: "0105", label: "ARROIO DO SAL" },
		{ value: "0120", label: "ARROIO DO TIGRE" },
		{ value: "0110", label: "ARROIO DOS RATOS" },
		{ value: "0130", label: "ARROIO GRANDE" },
		{ value: "0140", label: "ARVOREZINHA" },
		{ value: "0150", label: "AUGUSTO PESTANA" },
		{ value: "0155", label: "AUREA" },
		{ value: "0160", label: "BAGE" },
		{ value: "0163", label: "BALNEARIO PINHAL" },
		{ value: "0165", label: "BARAO" },
		{ value: "0170", label: "BARAO DE COTEGIPE" },
		{ value: "0175", label: "BARAO DO TRIUNFO" },
		{ value: "0185", label: "BARRA DO GUARITA" },
		{ value: "0187", label: "BARRA DO QUARAI" },
		{ value: "0190", label: "BARRA DO RIBEIRO" },
		{ value: "0192", label: "BARRA DO RIO AZUL" },
		{ value: "0195", label: "BARRA FUNDA" },
		{ value: "0180", label: "BARRACAO" },
		{ value: "0200", label: "BARROS CASSAL" },
		{ value: "0205", label: "BENJAMIN CONSTANT DO SUL" },
		{ value: "0210", label: "BENTO GONCALVES" },
		{ value: "0215", label: "BOA VISTA DAS MISSOES" },
		{ value: "0220", label: "BOA VISTA DO BURICA" },
		{ value: "0222", label: "BOA VISTA DO CADEADO" },
		{ value: "0223", label: "BOA VISTA DO INCRA" },
		{ value: "0225", label: "BOA VISTA DO SUL" },
		{ value: "0230", label: "BOM JESUS" },
		{ value: "0235", label: "BOM PRINCIPIO" },
		{ value: "0237", label: "BOM PROGRESSO" },
		{ value: "0240", label: "BOM RETIRO DO SUL" },
		{ value: "0245", label: "BOQUEIRAO DO LEAO" },
		{ value: "0250", label: "BOSSOROCA" },
		{ value: "0258", label: "BOZANO" },
		{ value: "0260", label: "BRAGA" },
		{ value: "0265", label: "BROCHIER" },
		{ value: "0270", label: "BUTIA" },
		{ value: "0280", label: "CACAPAVA DO SUL" },
		{ value: "0290", label: "CACEQUI" },
		{ value: "0300", label: "CACHOEIRA DO SUL" },
		{ value: "0310", label: "CACHOEIRINHA" },
		{ value: "0320", label: "CACIQUE DOBLE" },
		{ value: "0330", label: "CAIBATE" },
		{ value: "0340", label: "CAICARA" },
		{ value: "0350", label: "CAMAQUA" },
		{ value: "0355", label: "CAMARGO" },
		{ value: "0360", label: "CAMBARA DO SUL" },
		{ value: "0367", label: "CAMPESTRE DA SERRA" },
		{ value: "0370", label: "CAMPINA DAS MISSOES" },
		{ value: "0380", label: "CAMPINAS DO SUL" },
		{ value: "0390", label: "CAMPO BOM" },
		{ value: "0400", label: "CAMPO NOVO" },
		{ value: "0410", label: "CAMPOS BORGES" },
		{ value: "0420", label: "CANDELARIA" },
		{ value: "0430", label: "CANDIDO GODOI" },
		{ value: "0435", label: "CANDIOTA" },
		{ value: "0440", label: "CANELA" },
		{ value: "0450", label: "CANGUCU" },
		{ value: "0460", label: "CANOAS" },
		{ value: "0461", label: "CANUDOS DO VALE" },
		{ value: "0462", label: "CAPAO BONITO DO SUL" },
		{ value: "0463", label: "CAPAO DA CANOA" },
		{ value: "0465", label: "CAPAO DO CIPO" },
		{ value: "0466", label: "CAPAO DO LEAO" },
		{ value: "0468", label: "CAPELA DE SANTANA" },
		{ value: "0469", label: "CAPITAO" },
		{ value: "0467", label: "CAPIVARI DO SUL" },
		{ value: "0471", label: "CARAA" },
		{ value: "0470", label: "CARAZINHO" },
		{ value: "0480", label: "CARLOS BARBOSA" },
		{ value: "0485", label: "CARLOS GOMES" },
		{ value: "0490", label: "CASCA" },
		{ value: "0495", label: "CASEIROS" },
		{ value: "0500", label: "CATUIPE" },
		{ value: "0510", label: "CAXIAS DO SUL" },
		{ value: "0511", label: "CENTENARIO" },
		{ value: "0512", label: "CERRITO" },
		{ value: "0513", label: "CERRO BRANCO" },
		{ value: "0515", label: "CERRO GRANDE" },
		{ value: "0517", label: "CERRO GRANDE DO SUL" },
		{ value: "0520", label: "CERRO LARGO" },
		{ value: "0530", label: "CHAPADA" },
		{ value: "0535", label: "CHARQUEADAS" },
		{ value: "0537", label: "CHARRUA" },
		{ value: "0540", label: "CHIAPETTA" },
		{ value: "0543", label: "CHUI" },
		{ value: "0544", label: "CHUVISCA" },
		{ value: "0545", label: "CIDREIRA" },
		{ value: "0550", label: "CIRIACO" },
		{ value: "0558", label: "COLINAS" },
		{ value: "0560", label: "COLORADO" },
		{ value: "0570", label: "CONDOR" },
		{ value: "0580", label: "CONSTANTINA" },
		{ value: "0583", label: "COQUEIRO BAIXO" },
		{ value: "0585", label: "COQUEIROS DO SUL" },
		{ value: "0587", label: "CORONEL BARROS" },
		{ value: "0590", label: "CORONEL BICACO" },
		{ value: "0593", label: "CORONEL PILAR" },
		{ value: "0595", label: "COTIPORA" },
		{ value: "0597", label: "COXILHA" },
		{ value: "0600", label: "CRISSIUMAL" },
		{ value: "0605", label: "CRISTAL" },
		{ value: "0607", label: "CRISTAL DO SUL" },
		{ value: "0610", label: "CRUZ ALTA" },
		{ value: "0613", label: "CRUZALTENSE" },
		{ value: "0620", label: "CRUZEIRO DO SUL" },
		{ value: "0630", label: "DAVID CANABARRO" },
		{ value: "0632", label: "DERRUBADAS" },
		{ value: "0635", label: "DEZESSEIS DE NOVEMBRO" },
		{ value: "0637", label: "DILERMANDO DE AGUIAR" },
		{ value: "0640", label: "DOIS IRMAOS" },
		{ value: "0642", label: "DOIS IRMAOS DAS MISSOES" },
		{ value: "0645", label: "DOIS LAJEADOS" },
		{ value: "0650", label: "DOM FELICIANO" },
		{ value: "0660", label: "DOM PEDRITO" },
		{ value: "0655", label: "DOM PEDRO DE ALCANTARA" },
		{ value: "0670", label: "DONA FRANCISCA" },
		{ value: "0673", label: "DOUTOR MAURICIO CARDOSO" },
		{ value: "0675", label: "DOUTOR RICARDO" },
		{ value: "0676", label: "ELDORADO DO SUL" },
		{ value: "0680", label: "ENCANTADO" },
		{ value: "0690", label: "ENCRUZILHADA DO SUL" },
		{ value: "0692", label: "ENGENHO VELHO" },
		{ value: "0695", label: "ENTRE RIOS DO SUL" },
		{ value: "0693", label: "ENTRE-IJUIS" },
		{ value: "0697", label: "EREBANGO" },
		{ value: "0700", label: "ERECHIM" },
		{ value: "0705", label: "ERNESTINA" },
		{ value: "0720", label: "ERVAL GRANDE" },
		{ value: "0730", label: "ERVAL SECO" },
		{ value: "0740", label: "ESMERALDA" },
		{ value: "0745", label: "ESPERANCA DO SUL" },
		{ value: "0750", label: "ESPUMOSO" },
		{ value: "0755", label: "ESTACAO" },
		{ value: "0760", label: "ESTANCIA VELHA" },
		{ value: "0770", label: "ESTEIO" },
		{ value: "0780", label: "ESTRELA" },
		{ value: "0781", label: "ESTRELA VELHA" },
		{ value: "0783", label: "EUGENIO DE CASTRO" },
		{ value: "0786", label: "FAGUNDES VARELA" },
		{ value: "0790", label: "FARROUPILHA" },
		{ value: "0800", label: "FAXINAL DO SOTURNO" },
		{ value: "0805", label: "FAXINALZINHO" },
		{ value: "0807", label: "FAZENDA VILANOVA" },
		{ value: "0810", label: "FELIZ" },
		{ value: "0820", label: "FLORES DA CUNHA" },
		{ value: "0825", label: "FLORIANO PEIXOTO" },
		{ value: "0830", label: "FONTOURA XAVIER" },
		{ value: "0840", label: "FORMIGUEIRO" },
		{ value: "0843", label: "FORQUETINHA" },
		{ value: "0845", label: "FORTALEZA DOS VALOS" },
		{ value: "0850", label: "FREDERICO WESTPHALEN" },
		{ value: "0860", label: "GARIBALDI" },
		{ value: "0865", label: "GARRUCHOS" },
		{ value: "0870", label: "GAURAMA" },
		{ value: "0880", label: "GENERAL CAMARA" },
		{ value: "0885", label: "GENTIL" },
		{ value: "0890", label: "GETULIO VARGAS" },
		{ value: "0900", label: "GIRUA" },
		{ value: "0905", label: "GLORINHA" },
		{ value: "0910", label: "GRAMADO" },
		{ value: "0912", label: "GRAMADO DOS LOUREIROS" },
		{ value: "0915", label: "GRAMADO XAVIER" },
		{ value: "0920", label: "GRAVATAI" },
		{ value: "0925", label: "GUABIJU" },
		{ value: "0930", label: "GUAIBA" },
		{ value: "0940", label: "GUAPORE" },
		{ value: "0950", label: "GUARANI DAS MISSOES" },
		{ value: "0955", label: "HARMONIA" },
		{ value: "0710", label: "HERVAL" },
		{ value: "0957", label: "HERVEIRAS" },
		{ value: "0960", label: "HORIZONTINA" },
		{ value: "0965", label: "HULHA NEGRA" },
		{ value: "0970", label: "HUMAITA" },
		{ value: "0975", label: "IBARAMA" },
		{ value: "0980", label: "IBIACA" },
		{ value: "0990", label: "IBIRAIARAS" },
		{ value: "0995", label: "IBIRAPUITA" },
		{ value: "1000", label: "IBIRUBA" },
		{ value: "1010", label: "IGREJINHA" },
		{ value: "1020", label: "IJUI" },
		{ value: "1030", label: "ILOPOLIS" },
		{ value: "1033", label: "IMBE" },
		{ value: "1036", label: "IMIGRANTE" },
		{ value: "1040", label: "INDEPENDENCIA" },
		{ value: "1041", label: "INHACORA" },
		{ value: "1043", label: "IPE" },
		{ value: "1046", label: "IPIRANGA DO SUL" },
		{ value: "1050", label: "IRAI" },
		{ value: "1053", label: "ITAARA" },
		{ value: "1055", label: "ITACURUBI" },
		{ value: "1057", label: "ITAPUCA" },
		{ value: "1060", label: "ITAQUI" },
		{ value: "1065", label: "ITATI" },
		{ value: "1070", label: "ITATIBA DO SUL" },
		{ value: "1075", label: "IVORA" },
		{ value: "1080", label: "IVOTI" },
		{ value: "1085", label: "JABOTICABA" },
		{ value: "1087", label: "JACUIZINHO" },
		{ value: "1090", label: "JACUTINGA" },
		{ value: "1100", label: "JAGUARAO" },
		{ value: "1110", label: "JAGUARI" },
		{ value: "1112", label: "JAQUIRANA" },
		{ value: "1113", label: "JARI" },
		{ value: "1115", label: "JOIA" },
		{ value: "1120", label: "JULIO DE CASTILHOS" },
		{ value: "1123", label: "LAGOA BONITA DO SUL" },
		{ value: "1127", label: "LAGOA DOS TRES CANTOS" },
		{ value: "1130", label: "LAGOA VERMELHA" },
		{ value: "1125", label: "LAGOAO" },
		{ value: "1140", label: "LAJEADO" },
		{ value: "1142", label: "LAJEADO DO BUGRE" },
		{ value: "1150", label: "LAVRAS DO SUL" },
		{ value: "1160", label: "LIBERATO SALZANO" },
		{ value: "1162", label: "LINDOLFO COLLOR" },
		{ value: "1164", label: "LINHA NOVA" },
		{ value: "1171", label: "MACAMBARA" },
		{ value: "1170", label: "MACHADINHO" },
		{ value: "1173", label: "MAMPITUBA" },
		{ value: "1175", label: "MANOEL VIANA" },
		{ value: "1177", label: "MAQUINE" },
		{ value: "1179", label: "MARATA" },
		{ value: "1180", label: "MARAU" },
		{ value: "1190", label: "MARCELINO RAMOS" },
		{ value: "1198", label: "MARIANA PIMENTEL" },
		{ value: "1200", label: "MARIANO MORO" },
		{ value: "1205", label: "MARQUES DE SOUZA" },
		{ value: "1210", label: "MATA" },
		{ value: "1213", label: "MATO CASTELHANO" },
		{ value: "1215", label: "MATO LEITAO" },
		{ value: "1217", label: "MATO QUEIMADO" },
		{ value: "1220", label: "MAXIMILIANO DE ALMEIDA" },
		{ value: "1225", label: "MINAS DO LEAO" },
		{ value: "1230", label: "MIRAGUAI" },
		{ value: "1235", label: "MONTAURI" },
		{ value: "1237", label: "MONTE ALEGRE DOS CAMPOS" },
		{ value: "1238", label: "MONTE BELO DO SUL" },
		{ value: "1240", label: "MONTENEGRO" },
		{ value: "1242", label: "MORMACO" },
		{ value: "1244", label: "MORRINHOS DO SUL" },
		{ value: "1245", label: "MORRO REDONDO" },
		{ value: "1247", label: "MORRO REUTER" },
		{ value: "1250", label: "MOSTARDAS" },
		{ value: "1260", label: "MUCUM" },
		{ value: "1261", label: "MUITOS CAPOES" },
		{ value: "1262", label: "MULITERNO" },
		{ value: "1265", label: "NAO-ME-TOQUE" },
		{ value: "1267", label: "NICOLAU VERGUEIRO" },
		{ value: "1270", label: "NONOAI" },
		{ value: "1275", label: "NOVA ALVORADA" },
		{ value: "1280", label: "NOVA ARACA" },
		{ value: "1290", label: "NOVA BASSANO" },
		{ value: "1295", label: "NOVA BOA VISTA" },
		{ value: "1300", label: "NOVA BRESCIA" },
		{ value: "1301", label: "NOVA CANDELARIA" },
		{ value: "1303", label: "NOVA ESPERANCA DO SUL" },
		{ value: "1306", label: "NOVA HARTZ" },
		{ value: "1308", label: "NOVA PADUA" },
		{ value: "1310", label: "NOVA PALMA" },
		{ value: "1320", label: "NOVA PETROPOLIS" },
		{ value: "1330", label: "NOVA PRATA" },
		{ value: "1333", label: "NOVA RAMADA" },
		{ value: "1335", label: "NOVA ROMA DO SUL" },
		{ value: "1337", label: "NOVA SANTA RITA" },
		{ value: "1349", label: "NOVO BARREIRO" },
		{ value: "1339", label: "NOVO CABRAIS" },
		{ value: "1340", label: "NOVO HAMBURGO" },
		{ value: "1342", label: "NOVO MACHADO" },
		{ value: "1344", label: "NOVO TIRADENTES" },
		{ value: "1346", label: "NOVO XINGU" },
		{ value: "1350", label: "OSORIO" },
		{ value: "1360", label: "PAIM FILHO" },
		{ value: "1365", label: "PALMARES DO SUL" },
		{ value: "1370", label: "PALMEIRA DAS MISSOES" },
		{ value: "1380", label: "PALMITINHO" },
		{ value: "1390", label: "PANAMBI" },
		{ value: "1395", label: "PANTANO GRANDE" },
		{ value: "1400", label: "PARAI" },
		{ value: "1402", label: "PARAISO DO SUL" },
		{ value: "1403", label: "PARECI NOVO" },
		{ value: "1405", label: "PAROBE" },
		{ value: "1406", label: "PASSA SETE" },
		{ value: "1407", label: "PASSO DO SOBRADO" },
		{ value: "1410", label: "PASSO FUNDO" },
		{ value: "1413", label: "PAULO BENTO" },
		{ value: "1415", label: "PAVERAMA" },
		{ value: "1417", label: "PEDRAS ALTAS" },
		{ value: "1420", label: "PEDRO OSORIO" },
		{ value: "1430", label: "PEJUCARA" },
		{ value: "1440", label: "PELOTAS" },
		{ value: "1442", label: "PICADA CAFE" },
		{ value: "1445", label: "PINHAL" },
		{ value: "1446", label: "PINHAL DA SERRA" },
		{ value: "1447", label: "PINHAL GRANDE" },
		{ value: "1449", label: "PINHEIRINHO DO VALE" },
		{ value: "1450", label: "PINHEIRO MACHADO" },
		{ value: "1454", label: "PINTO BANDEIRA" },
		{ value: "1455", label: "PIRAPO" },
		{ value: "1460", label: "PIRATINI" },
		{ value: "1470", label: "PLANALTO" },
		{ value: "1475", label: "POCO DAS ANTAS" },
		{ value: "1477", label: "PONTAO" },
		{ value: "1478", label: "PONTE PRETA" },
		{ value: "1480", label: "PORTAO" },
		{ value: "1490", label: "PORTO ALEGRE" },
		{ value: "1500", label: "PORTO LUCENA" },
		{ value: "1505", label: "PORTO MAUA" },
		{ value: "1507", label: "PORTO VERA CRUZ" },
		{ value: "1510", label: "PORTO XAVIER" },
		{ value: "1513", label: "POUSO NOVO" },
		{ value: "1514", label: "PRESIDENTE LUCENA" },
		{ value: "1515", label: "PROGRESSO" },
		{ value: "1517", label: "PROTASIO ALVES" },
		{ value: "1520", label: "PUTINGA" },
		{ value: "1530", label: "QUARAI" },
		{ value: "1531", label: "QUATRO IRMAOS" },
		{ value: "1532", label: "QUEVEDOS" },
		{ value: "1535", label: "QUINZE DE NOVEMBRO" },
		{ value: "1540", label: "REDENTORA" },
		{ value: "1545", label: "RELVADO" },
		{ value: "1550", label: "RESTINGA SECA" },
		{ value: "1555", label: "RIO DOS INDIOS" },
		{ value: "1560", label: "RIO GRANDE" },
		{ value: "1570", label: "RIO PARDO" },
		{ value: "1575", label: "RIOZINHO" },
		{ value: "1580", label: "ROCA SALES" },
		{ value: "1590", label: "RODEIO BONITO" },
		{ value: "1595", label: "ROLADOR" },
		{ value: "1600", label: "ROLANTE" },
		{ value: "1610", label: "RONDA ALTA" },
		{ value: "1620", label: "RONDINHA" },
		{ value: "1630", label: "ROQUE GONZALES" },
		{ value: "1640", label: "ROSARIO DO SUL" },
		{ value: "1642", label: "SAGRADA FAMILIA" },
		{ value: "1643", label: "SALDANHA MARINHO" },
		{ value: "1645", label: "SALTO DO JACUI" },
		{ value: "1647", label: "SALVADOR DAS MISSOES" },
		{ value: "1650", label: "SALVADOR DO SUL" },
		{ value: "1660", label: "SANANDUVA" },
		{ value: "1710", label: "SANT' ANA DO LIVRAMENTO" },
		{ value: "1670", label: "SANTA BARBARA DO SUL" },
		{ value: "1673", label: "SANTA CECILIA DO SUL" },
		{ value: "1675", label: "SANTA CLARA DO SUL" },
		{ value: "1680", label: "SANTA CRUZ DO SUL" },
		{ value: "1697", label: "SANTA MARGARIDA DO SUL" },
		{ value: "1690", label: "SANTA MARIA" },
		{ value: "1695", label: "SANTA MARIA DO HERVAL" },
		{ value: "1720", label: "SANTA ROSA" },
		{ value: "1725", label: "SANTA TEREZA" },
		{ value: "1730", label: "SANTA VITORIA DO PALMAR" },
		{ value: "1700", label: "SANTANA DA BOA VISTA" },
		{ value: "0000", label: "SANTANA DO LIVRAMENTO" },
		{ value: "1740", label: "SANTIAGO" },
		{ value: "1750", label: "SANTO ANGELO" },
		{ value: "1760", label: "SANTO ANTONIO DA PATRULHA" },
		{ value: "1770", label: "SANTO ANTONIO DAS MISSOES" },
		{ value: "1755", label: "SANTO ANTONIO DO PALMA" },
		{ value: "1775", label: "SANTO ANTONIO DO PLANALTO" },
		{ value: "1780", label: "SANTO AUGUSTO" },
		{ value: "1790", label: "SANTO CRISTO" },
		{ value: "1795", label: "SANTO EXPEDITO DO SUL" },
		{ value: "1800", label: "SAO BORJA" },
		{ value: "1805", label: "SAO DOMINGOS DO SUL" },
		{ value: "1810", label: "SAO FRANCISCO DE ASSIS" },
		{ value: "1820", label: "SAO FRANCISCO DE PAULA" },
		{ value: "1830", label: "SAO GABRIEL" },
		{ value: "1840", label: "SAO JERONIMO" },
		{ value: "1842", label: "SAO JOAO DA URTIGA" },
		{ value: "1843", label: "SAO JOAO DO POLESINE" },
		{ value: "1844", label: "SAO JORGE" },
		{ value: "1845", label: "SAO JOSE DAS MISSOES" },
		{ value: "1846", label: "SAO JOSE DO HERVAL" },
		{ value: "1848", label: "SAO JOSE DO HORTENCIO" },
		{ value: "1849", label: "SAO JOSE DO INHACORA" },
		{ value: "1850", label: "SAO JOSE DO NORTE" },
		{ value: "1860", label: "SAO JOSE DO OURO" },
		{ value: "1861", label: "SAO JOSE DO SUL" },
		{ value: "1862", label: "SAO JOSE DOS AUSENTES" },
		{ value: "1870", label: "SAO LEOPOLDO" },
		{ value: "1880", label: "SAO LOURENCO DO SUL" },
		{ value: "1890", label: "SAO LUIZ GONZAGA" },
		{ value: "1900", label: "SAO MARCOS" },
		{ value: "1910", label: "SAO MARTINHO" },
		{ value: "1912", label: "SAO MARTINHO DA SERRA" },
		{ value: "1915", label: "SAO MIGUEL DAS MISSOES" },
		{ value: "1920", label: "SAO NICOLAU" },
		{ value: "1930", label: "SAO PAULO DAS MISSOES" },
		{ value: "1935", label: "SAO PEDRO DA SERRA" },
		{ value: "1936", label: "SAO PEDRO DAS MISSOES" },
		{ value: "1937", label: "SAO PEDRO DO BUTIA" },
		{ value: "1940", label: "SAO PEDRO DO SUL" },
		{ value: "1950", label: "SAO SEBASTIAO DO CAI" },
		{ value: "1960", label: "SAO SEPE" },
		{ value: "1970", label: "SAO VALENTIM" },
		{ value: "1971", label: "SAO VALENTIM DO SUL" },
		{ value: "1973", label: "SAO VALERIO DO SUL" },
		{ value: "1975", label: "SAO VENDELINO" },
		{ value: "1980", label: "SAO VICENTE DO SUL" },
		{ value: "1990", label: "SAPIRANGA" },
		{ value: "2000", label: "SAPUCAIA DO SUL" },
		{ value: "2010", label: "SARANDI" },
		{ value: "2020", label: "SEBERI" },
		{ value: "2023", label: "SEDE NOVA" },
		{ value: "2026", label: "SEGREDO" },
		{ value: "2030", label: "SELBACH" },
		{ value: "2032", label: "SENADOR SALGADO FILHO" },
		{ value: "2035", label: "SENTINELA DO SUL" },
		{ value: "2040", label: "SERAFINA CORREA" },
		{ value: "2045", label: "SERIO" },
		{ value: "2050", label: "SERTAO" },
		{ value: "2055", label: "SERTAO SANTANA" },
		{ value: "2057", label: "SETE DE SETEMBRO" },
		{ value: "2060", label: "SEVERIANO DE ALMEIDA" },
		{ value: "2065", label: "SILVEIRA MARTINS" },
		{ value: "2067", label: "SINIMBU" },
		{ value: "2070", label: "SOBRADINHO" },
		{ value: "2080", label: "SOLEDADE" },
		{ value: "2085", label: "TABAI" },
		{ value: "2090", label: "TAPEJARA" },
		{ value: "2100", label: "TAPERA" },
		{ value: "2110", label: "TAPES" },
		{ value: "2120", label: "TAQUARA" },
		{ value: "2130", label: "TAQUARI" },
		{ value: "2132", label: "TAQUARUCU DO SUL" },
		{ value: "2135", label: "TAVARES" },
		{ value: "2140", label: "TENENTE PORTELA" },
		{ value: "2143", label: "TERRA DE AREIA" },
		{ value: "2145", label: "TEUTONIA" },
		{ value: "2146", label: "TIO HUGO" },
		{ value: "2147", label: "TIRADENTES DO SUL" },
		{ value: "2149", label: "TOROPI" },
		{ value: "2150", label: "TORRES" },
		{ value: "2160", label: "TRAMANDAI" },
		{ value: "2162", label: "TRAVESSEIRO" },
		{ value: "2163", label: "TRES ARROIOS" },
		{ value: "2166", label: "TRES CACHOEIRAS" },
		{ value: "2170", label: "TRES COROAS" },
		{ value: "2180", label: "TRES DE MAIO" },
		{ value: "2183", label: "TRES FORQUILHAS" },
		{ value: "2185", label: "TRES PALMEIRAS" },
		{ value: "2190", label: "TRES PASSOS" },
		{ value: "2195", label: "TRINDADE DO SUL" },
		{ value: "2200", label: "TRIUNFO" },
		{ value: "2210", label: "TUCUNDUVA" },
		{ value: "2215", label: "TUNAS" },
		{ value: "2218", label: "TUPANCI DO SUL" },
		{ value: "2220", label: "TUPANCIRETA" },
		{ value: "2225", label: "TUPANDI" },
		{ value: "2230", label: "TUPARENDI" },
		{ value: "2232", label: "TURUCU" },
		{ value: "2234", label: "UBIRETAMA" },
		{ value: "2235", label: "UNIAO DA SERRA" },
		{ value: "2237", label: "UNISTALDA" },
		{ value: "2240", label: "URUGUAIANA" },
		{ value: "2250", label: "VACARIA" },
		{ value: "2253", label: "VALE DO SOL" },
		{ value: "2254", label: "VALE REAL" },
		{ value: "2252", label: "VALE VERDE" },
		{ value: "2255", label: "VANINI" },
		{ value: "2260", label: "VENANCIO AIRES" },
		{ value: "2270", label: "VERA CRUZ" },
		{ value: "2280", label: "VERANOPOLIS" },
		{ value: "2285", label: "VESPASIANO CORREA" },
		{ value: "2290", label: "VIADUTOS" },
		{ value: "2300", label: "VIAMAO" },
		{ value: "2310", label: "VICENTE DUTRA" },
		{ value: "2320", label: "VICTOR GRAEFF" },
		{ value: "2330", label: "VILA FLORES" },
		{ value: "2335", label: "VILA LANGARO" },
		{ value: "2340", label: "VILA MARIA" },
		{ value: "2345", label: "VILA NOVA DO SUL" },
		{ value: "2350", label: "VISTA ALEGRE" },
		{ value: "2360", label: "VISTA ALEGRE DO PRATA" },
		{ value: "2370", label: "VISTA GAUCHA" },
		{ value: "2375", label: "VITORIA DAS MISSOES" },
		{ value: "2377", label: "WESTFALIA" },
		{ value: "2380", label: "XANGRI-LA" },
	],
	MS: [
		{ value: "0020", label: "AGUA CLARA" },
		{ value: "0025", label: "ALCINOPOLIS" },
		{ value: "0060", label: "AMAMBAI" },
		{ value: "0070", label: "ANASTACIO" },
		{ value: "0080", label: "ANAURILANDIA" },
		{ value: "0085", label: "ANGELICA" },
		{ value: "0090", label: "ANTONIO JOAO" },
		{ value: "0100", label: "APARECIDA DO TABOADO" },
		{ value: "0110", label: "AQUIDAUANA" },
		{ value: "0124", label: "ARAL MOREIRA" },
		{ value: "0150", label: "BANDEIRANTES" },
		{ value: "0190", label: "BATAGUASSU" },
		{ value: "0200", label: "BATAYPORA" },
		{ value: "0210", label: "BELA VISTA" },
		{ value: "0215", label: "BODOQUENA" },
		{ value: "0220", label: "BONITO" },
		{ value: "0230", label: "BRASILANDIA" },
		{ value: "0240", label: "CAARAPO" },
		{ value: "0260", label: "CAMAPUA" },
		{ value: "0270", label: "CAMPO GRANDE" },
		{ value: "0280", label: "CARACOL" },
		{ value: "0290", label: "CASSILANDIA" },
		{ value: "0295", label: "CHAPADAO DO SUL" },
		{ value: "0310", label: "CORGUINHO" },
		{ value: "0315", label: "CORONEL SAPUCAIA" },
		{ value: "0320", label: "CORUMBA" },
		{ value: "0325", label: "COSTA RICA" },
		{ value: "0330", label: "COXIM" },
		{ value: "0345", label: "DEODAPOLIS" },
		{ value: "0348", label: "DOIS IRMAOS DO BURITI" },
		{ value: "0350", label: "DOURADINA" },
		{ value: "0370", label: "DOURADOS" },
		{ value: "0375", label: "ELDORADO" },
		{ value: "0380", label: "FATIMA DO SUL" },
		{ value: "0390", label: "FIGUEIRAO" },
		{ value: "0400", label: "GLORIA DE DOURADOS" },
		{ value: "0410", label: "GUIA LOPES DA LAGUNA" },
		{ value: "0430", label: "IGUATEMI" },
		{ value: "0440", label: "INOCENCIA" },
		{ value: "0450", label: "ITAPORA" },
		{ value: "0460", label: "ITAQUIRAI" },
		{ value: "0470", label: "IVINHEMA" },
		{ value: "0480", label: "JAPORA" },
		{ value: "0490", label: "JARAGUARI" },
		{ value: "0500", label: "JARDIM" },
		{ value: "0510", label: "JATEI" },
		{ value: "0515", label: "JUTI" },
		{ value: "0520", label: "LADARIO" },
		{ value: "0525", label: "LAGUNA CARAPA" },
		{ value: "0540", label: "MARACAJU" },
		{ value: "0560", label: "MIRANDA" },
		{ value: "0568", label: "MUNDO NOVO" },
		{ value: "0570", label: "NAVIRAI" },
		{ value: "0580", label: "NIOAQUE" },
		{ value: "0600", label: "NOVA ALVORADA DO SUL" },
		{ value: "0620", label: "NOVA ANDRADINA" },
		{ value: "0625", label: "NOVO HORIZONTE DO SUL" },
		{ value: "0627", label: "PARAISO DAS AGUAS" },
		{ value: "0627", label: "PARAISO DAS AGUAS" },
		{ value: "0630", label: "PARANAIBA" },
		{ value: "0635", label: "PARANHOS" },
		{ value: "0640", label: "PEDRO GOMES" },
		{ value: "0660", label: "PONTA PORA" },
		{ value: "0690", label: "PORTO MURTINHO" },
		{ value: "0710", label: "RIBAS DO RIO PARDO" },
		{ value: "0720", label: "RIO BRILHANTE" },
		{ value: "0730", label: "RIO NEGRO" },
		{ value: "0740", label: "RIO VERDE DE MATO GROSSO" },
		{ value: "0750", label: "ROCHEDO" },
		{ value: "0755", label: "SANTA RITA DO PARDO" },
		{ value: "0769", label: "SAO GABRIEL DO OESTE" },
		{ value: "0780", label: "SELVIRIA" },
		{ value: "0770", label: "SETE QUEDAS" },
		{ value: "0790", label: "SIDROLANDIA" },
		{ value: "0793", label: "SONORA" },
		{ value: "0795", label: "TACURU" },
		{ value: "0797", label: "TAQUARUSSU" },
		{ value: "0800", label: "TERENOS" },
		{ value: "0830", label: "TRES LAGOAS" },
		{ value: "0840", label: "VICENTINA" },
	],
	MT: [
		{ value: "0010", label: "ACORIZAL" },
		{ value: "0020", label: "AGUA BOA" },
		{ value: "0025", label: "ALTA FLORESTA" },
		{ value: "0030", label: "ALTO ARAGUAIA" },
		{ value: "0035", label: "ALTO BOA VISTA" },
		{ value: "0040", label: "ALTO GARCAS" },
		{ value: "0050", label: "ALTO PARAGUAI" },
		{ value: "0060", label: "ALTO TAQUARI" },
		{ value: "0080", label: "APIACAS" },
		{ value: "0100", label: "ARAGUAIANA" },
		{ value: "0120", label: "ARAGUAINHA" },
		{ value: "0125", label: "ARAPUTANGA" },
		{ value: "0130", label: "ARENAPOLIS" },
		{ value: "0140", label: "ARIPUANA" },
		{ value: "0160", label: "BARAO DE MELGACO" },
		{ value: "0170", label: "BARRA DO BUGRES" },
		{ value: "0180", label: "BARRA DO GARCAS" },
		{ value: "0185", label: "BOM JESUS DO ARAGUAIA" },
		{ value: "0190", label: "BRASNORTE" },
		{ value: "0250", label: "CACERES" },
		{ value: "0260", label: "CAMPINAPOLIS" },
		{ value: "0263", label: "CAMPO NOVO DO PARECIS" },
		{ value: "0267", label: "CAMPO VERDE" },
		{ value: "0268", label: "CAMPOS DE JULIO" },
		{ value: "0269", label: "CANABRAVA DO NORTE" },
		{ value: "0270", label: "CANARANA" },
		{ value: "0279", label: "CARLINDA" },
		{ value: "0285", label: "CASTANHEIRA" },
		{ value: "0300", label: "CHAPADA DOS GUIMARAES" },
		{ value: "0305", label: "CLAUDIA" },
		{ value: "0310", label: "COCALINHO" },
		{ value: "0320", label: "COLIDER" },
		{ value: "0325", label: "COLNIZA" },
		{ value: "0330", label: "COMODORO" },
		{ value: "0335", label: "CONFRESA" },
		{ value: "0336", label: "CONQUISTA D'OESTE" },
		{ value: "0337", label: "COTRIGUACU" },
		{ value: "0340", label: "CUIABA" },
		{ value: "0343", label: "CURVELANDIA" },
		{ value: "0345", label: "DENISE" },
		{ value: "0350", label: "DIAMANTINO" },
		{ value: "0360", label: "DOM AQUINO" },
		{ value: "0370", label: "FELIZ NATAL" },
		{ value: "0380", label: "FIGUEIROPOLIS D'OESTE" },
		{ value: "0385", label: "GAUCHA DO NORTE" },
		{ value: "0390", label: "GENERAL CARNEIRO" },
		{ value: "0395", label: "GLORIA D'OESTE" },
		{ value: "0410", label: "GUARANTA DO NORTE" },
		{ value: "0420", label: "GUIRATINGA" },
		{ value: "0450", label: "INDIAVAI" },
		{ value: "0452", label: "IPIRANGA DO NORTE" },
		{ value: "0454", label: "ITANHANGA" },
		{ value: "0455", label: "ITAUBA" },
		{ value: "0460", label: "ITIQUIRA" },
		{ value: "0480", label: "JACIARA" },
		{ value: "0490", label: "JANGADA" },
		{ value: "0500", label: "JAURU" },
		{ value: "0510", label: "JUARA" },
		{ value: "0515", label: "JUINA" },
		{ value: "0517", label: "JURUENA" },
		{ value: "0520", label: "JUSCIMEIRA" },
		{ value: "0523", label: "LAMBARI D'OESTE" },
		{ value: "0525", label: "LUCAS DO RIO VERDE" },
		{ value: "0530", label: "LUCIARA" },
		{ value: "0558", label: "MARCELANDIA" },
		{ value: "0560", label: "MATUPA" },
		{ value: "0562", label: "MIRASSOL D'OESTE" },
		{ value: "0590", label: "NOBRES" },
		{ value: "0600", label: "NORTELANDIA" },
		{ value: "0610", label: "NOSSA SENHORA DO LIVRAMENTO" },
		{ value: "0615", label: "NOVA BANDEIRANTES" },
		{ value: "0620", label: "NOVA BRASILANDIA" },
		{ value: "0621", label: "NOVA CANAA DO NORTE" },
		{ value: "0880", label: "NOVA GUARITA" },
		{ value: "0618", label: "NOVA LACERDA" },
		{ value: "0885", label: "NOVA MARILANDIA" },
		{ value: "0890", label: "NOVA MARINGA" },
		{ value: "0895", label: "NOVA MONTE VERDE" },
		{ value: "0622", label: "NOVA MUTUM" },
		{ value: "0617", label: "NOVA NAZARE" },
		{ value: "0623", label: "NOVA OLIMPIA" },
		{ value: "0619", label: "NOVA SANTA HELENA" },
		{ value: "0624", label: "NOVA UBIRATA" },
		{ value: "0625", label: "NOVA XAVANTINA" },
		{ value: "0627", label: "NOVO HORIZONTE DO NORTE" },
		{ value: "0626", label: "NOVO MUNDO" },
		{ value: "0631", label: "NOVO SANTO ANTONIO" },
		{ value: "0628", label: "NOVO SAO JOAQUIM" },
		{ value: "0629", label: "PARANAITA" },
		{ value: "0630", label: "PARANATINGA" },
		{ value: "0637", label: "PEDRA PRETA" },
		{ value: "0642", label: "PEIXOTO DE AZEVEDO" },
		{ value: "0645", label: "PLANALTO DA SERRA" },
		{ value: "0650", label: "POCONE" },
		{ value: "0665", label: "PONTAL DO ARAGUAIA" },
		{ value: "0670", label: "PONTE BRANCA" },
		{ value: "0675", label: "PONTES E LACERDA" },
		{ value: "0677", label: "PORTO ALEGRE DO NORTE" },
		{ value: "0680", label: "PORTO DOS GAUCHOS" },
		{ value: "0682", label: "PORTO ESPERIDIAO" },
		{ value: "0685", label: "PORTO ESTRELA" },
		{ value: "0700", label: "POXOREU" },
		{ value: "0000", label: "POXOREU" },
		{ value: "0704", label: "PRIMAVERA DO LESTE" },
		{ value: "0706", label: "QUERENCIA" },
		{ value: "0715", label: "RESERVA DO CABACAL" },
		{ value: "0718", label: "RIBEIRAO CASCALHEIRA" },
		{ value: "0719", label: "RIBEIRAOZINHO" },
		{ value: "0720", label: "RIO BRANCO" },
		{ value: "0757", label: "RONDOLANDIA" },
		{ value: "0760", label: "RONDONOPOLIS" },
		{ value: "0770", label: "ROSARIO OESTE" },
		{ value: "0775", label: "SALTO DO CEU" },
		{ value: "0724", label: "SANTA CARMEM" },
		{ value: "0774", label: "SANTA CRUZ DO XINGU" },
		{ value: "0776", label: "SANTA RITA DO TRIVELATO" },
		{ value: "0777", label: "SANTA TEREZINHA" },
		{ value: "0726", label: "SANTO AFONSO" },
		{ value: "0779", label: "SANTO ANTONIO DO LESTE" },
		{ value: "0780", label: "SANTO ANTONIO DO LEVERGER" },
		{ value: "0785", label: "SAO FELIX DO ARAGUAIA" },
		{ value: "0729", label: "SAO JOSE DO POVO" },
		{ value: "0730", label: "SAO JOSE DO RIO CLARO" },
		{ value: "0735", label: "SAO JOSE DO XINGU" },
		{ value: "0710", label: "SAO JOSE DOS QUATRO MARCOS" },
		{ value: "0740", label: "SAO PEDRO DA CIPA" },
		{ value: "0787", label: "SAPEZAL" },
		{ value: "0788", label: "SERRA NOVA DOURADA" },
		{ value: "0790", label: "SINOP" },
		{ value: "0792", label: "SORRISO" },
		{ value: "0794", label: "TABAPORA" },
		{ value: "0795", label: "TANGARA DA SERRA" },
		{ value: "0800", label: "TAPURAH" },
		{ value: "0805", label: "TERRA NOVA DO NORTE" },
		{ value: "0810", label: "TESOURO" },
		{ value: "0820", label: "TORIXOREU" },
		{ value: "0830", label: "UNIAO DO SUL" },
		{ value: "0835", label: "VALE DE SAO DOMINGOS" },
		{ value: "0840", label: "VARZEA GRANDE" },
		{ value: "0850", label: "VERA" },
		{ value: "0550", label: "VILA BELA DA SANTISSIMA TRINDADE" },
		{ value: "0860", label: "VILA RICA" },
	],
	GO: [
		{ value: "0005", label: "ABADIA DE GOIAS" },
		{ value: "0010", label: "ABADIANIA" },
		{ value: "0013", label: "ACREUNA" },
		{ value: "0015", label: "ADELANDIA" },
		{ value: "0017", label: "AGUA FRIA DE GOIAS" },
		{ value: "0020", label: "AGUA LIMPA" },
		{ value: "0025", label: "AGUAS LINDAS DE GOIAS" },
		{ value: "0030", label: "ALEXANIA" },
		{ value: "0050", label: "ALOANDIA" },
		{ value: "0055", label: "ALTO HORIZONTE" },
		{ value: "0060", label: "ALTO PARAISO DE GOIAS" },
		{ value: "0080", label: "ALVORADA DO NORTE" },
		{ value: "0082", label: "AMARALINA" },
		{ value: "0085", label: "AMERICANO DO BRASIL" },
		{ value: "0090", label: "AMORINOPOLIS" },
		{ value: "0110", label: "ANAPOLIS" },
		{ value: "0120", label: "ANHANGUERA" },
		{ value: "0130", label: "ANICUNS" },
		{ value: "0140", label: "APARECIDA DE GOIANIA" },
		{ value: "0145", label: "APARECIDA DO RIO DOCE" },
		{ value: "0150", label: "APORE" },
		{ value: "0160", label: "ARACU" },
		{ value: "0170", label: "ARAGARCAS" },
		{ value: "0180", label: "ARAGOIANIA" },
		{ value: "0215", label: "ARAGUAPAZ" },
		{ value: "0235", label: "ARENOPOLIS" },
		{ value: "0250", label: "ARUANA" },
		{ value: "0260", label: "AURILANDIA" },
		{ value: "0280", label: "AVELINOPOLIS" },
		{ value: "0310", label: "BALIZA" },
		{ value: "0320", label: "BARRO ALTO" },
		{ value: "0330", label: "BELA VISTA DE GOIAS" },
		{ value: "0340", label: "BOM JARDIM DE GOIAS" },
		{ value: "0000", label: "BOM JESUS" },
		{ value: "0350", label: "BOM JESUS DE GOIAS" },
		{ value: "0355", label: "BONFINOPOLIS" },
		{ value: "0357", label: "BONOPOLIS" },
		{ value: "0360", label: "BRAZABRANTES" },
		{ value: "0380", label: "BRITANIA" },
		{ value: "0390", label: "BURITI ALEGRE" },
		{ value: "0393", label: "BURITI DE GOIAS" },
		{ value: "0396", label: "BURITINOPOLIS" },
		{ value: "0400", label: "CABECEIRAS" },
		{ value: "0410", label: "CACHOEIRA ALTA" },
		{ value: "0420", label: "CACHOEIRA DE GOIAS" },
		{ value: "0425", label: "CACHOEIRA DOURADA" },
		{ value: "0430", label: "CACU" },
		{ value: "0440", label: "CAIAPONIA" },
		{ value: "0450", label: "CALDAS NOVAS" },
		{ value: "0455", label: "CALDAZINHA" },
		{ value: "0460", label: "CAMPESTRE DE GOIAS" },
		{ value: "0465", label: "CAMPINACU" },
		{ value: "0470", label: "CAMPINORTE" },
		{ value: "0480", label: "CAMPO ALEGRE DE GOIAS" },
		{ value: "0485", label: "CAMPO LIMPO DE GOIAS" },
		{ value: "0490", label: "CAMPOS BELOS" },
		{ value: "0495", label: "CAMPOS VERDES" },
		{ value: "0500", label: "CARMO DO RIO VERDE" },
		{ value: "0505", label: "CASTELANDIA" },
		{ value: "0510", label: "CATALAO" },
		{ value: "0520", label: "CATURAI" },
		{ value: "0530", label: "CAVALCANTE" },
		{ value: "0540", label: "CERES" },
		{ value: "0545", label: "CEZARINA" },
		{ value: "0547", label: "CHAPADAO DO CEU" },
		{ value: "0549", label: "CIDADE OCIDENTAL" },
		{ value: "0551", label: "COCALZINHO DE GOIAS" },
		{ value: "0552", label: "COLINAS DO SUL" },
		{ value: "0570", label: "CORREGO DO OURO" },
		{ value: "0580", label: "CORUMBA DE GOIAS" },
		{ value: "0590", label: "CORUMBAIBA" },
		{ value: "0620", label: "CRISTALINA" },
		{ value: "0630", label: "CRISTIANOPOLIS" },
		{ value: "0640", label: "CRIXAS" },
		{ value: "0650", label: "CROMINIA" },
		{ value: "0660", label: "CUMARI" },
		{ value: "0670", label: "DAMIANOPOLIS" },
		{ value: "0680", label: "DAMOLANDIA" },
		{ value: "0690", label: "DAVINOPOLIS" },
		{ value: "0710", label: "DIORAMA" },
		{ value: "0830", label: "DIVINOPOLIS DE GOIAS" },
		{ value: "0725", label: "DOVERLANDIA" },
		{ value: "0735", label: "EDEALINA" },
		{ value: "0740", label: "EDEIA" },
		{ value: "0750", label: "ESTRELA DO NORTE" },
		{ value: "0753", label: "FAINA" },
		{ value: "0760", label: "FAZENDA NOVA" },
		{ value: "0780", label: "FIRMINOPOLIS" },
		{ value: "0790", label: "FLORES DE GOIAS" },
		{ value: "0800", label: "FORMOSA" },
		{ value: "0810", label: "FORMOSO" },
		{ value: "0815", label: "GAMELEIRA DE GOIAS" },
		{ value: "0840", label: "GOIANAPOLIS" },
		{ value: "0850", label: "GOIANDIRA" },
		{ value: "0860", label: "GOIANESIA" },
		{ value: "0870", label: "GOIANIA" },
		{ value: "0880", label: "GOIANIRA" },
		{ value: "0890", label: "GOIAS" },
		{ value: "0910", label: "GOIATUBA" },
		{ value: "0915", label: "GOUVELANDIA" },
		{ value: "0920", label: "GUAPO" },
		{ value: "0929", label: "GUARAITA" },
		{ value: "0940", label: "GUARANI DE GOIAS" },
		{ value: "0945", label: "GUARINOS" },
		{ value: "0960", label: "HEITORAI" },
		{ value: "0970", label: "HIDROLANDIA" },
		{ value: "0980", label: "HIDROLINA" },
		{ value: "0990", label: "IACIARA" },
		{ value: "0993", label: "INACIOLANDIA" },
		{ value: "0995", label: "INDIARA" },
		{ value: "1000", label: "INHUMAS" },
		{ value: "1010", label: "IPAMERI" },
		{ value: "1015", label: "IPIRANGA DE GOIAS" },
		{ value: "1020", label: "IPORA" },
		{ value: "1030", label: "ISRAELANDIA" },
		{ value: "1040", label: "ITABERAI" },
		{ value: "1056", label: "ITAGUARI" },
		{ value: "1060", label: "ITAGUARU" },
		{ value: "1080", label: "ITAJA" },
		{ value: "1090", label: "ITAPACI" },
		{ value: "1100", label: "ITAPIRAPUA" },
		{ value: "1120", label: "ITAPURANGA" },
		{ value: "1130", label: "ITARUMA" },
		{ value: "1140", label: "ITAUCU" },
		{ value: "1150", label: "ITUMBIARA" },
		{ value: "1160", label: "IVOLANDIA" },
		{ value: "1170", label: "JANDAIA" },
		{ value: "1180", label: "JARAGUA" },
		{ value: "1190", label: "JATAI" },
		{ value: "1200", label: "JAUPACI" },
		{ value: "1205", label: "JESUPOLIS" },
		{ value: "1210", label: "JOVIANIA" },
		{ value: "1220", label: "JUSSARA" },
		{ value: "1225", label: "LAGOA SANTA" },
		{ value: "1230", label: "LEOPOLDO DE BULHOES" },
		{ value: "1250", label: "LUZIANIA" },
		{ value: "1260", label: "MAIRIPOTABA" },
		{ value: "1270", label: "MAMBAI" },
		{ value: "1280", label: "MARA ROSA" },
		{ value: "1290", label: "MARZAGAO" },
		{ value: "1295", label: "MATRINCHA" },
		{ value: "1300", label: "MAURILANDIA" },
		{ value: "1305", label: "MIMOSO DE GOIAS" },
		{ value: "1308", label: "MINACU" },
		{ value: "1310", label: "MINEIROS" },
		{ value: "1340", label: "MOIPORA" },
		{ value: "1350", label: "MONTE ALEGRE DE GOIAS" },
		{ value: "1370", label: "MONTES CLAROS DE GOIAS" },
		{ value: "1375", label: "MONTIVIDIU" },
		{ value: "1377", label: "MONTIVIDIU DO NORTE" },
		{ value: "1380", label: "MORRINHOS" },
		{ value: "1385", label: "MORRO AGUDO DE GOIAS" },
		{ value: "1390", label: "MOSSAMEDES" },
		{ value: "1400", label: "MOZARLANDIA" },
		{ value: "1405", label: "MUNDO NOVO" },
		{ value: "1410", label: "MUTUNOPOLIS" },
		{ value: "1440", label: "NAZARIO" },
		{ value: "1450", label: "NEROPOLIS" },
		{ value: "1460", label: "NIQUELANDIA" },
		{ value: "1470", label: "NOVA AMERICA" },
		{ value: "1480", label: "NOVA AURORA" },
		{ value: "1483", label: "NOVA CRIXAS" },
		{ value: "1486", label: "NOVA GLORIA" },
		{ value: "1487", label: "NOVA IGUACU DE GOIAS" },
		{ value: "1490", label: "NOVA ROMA" },
		{ value: "1500", label: "NOVA VENEZA" },
		{ value: "1520", label: "NOVO BRASIL" },
		{ value: "1523", label: "NOVO GAMA" },
		{ value: "1525", label: "NOVO PLANALTO" },
		{ value: "1530", label: "ORIZONA" },
		{ value: "1540", label: "OURO VERDE DE GOIAS" },
		{ value: "1550", label: "OUVIDOR" },
		{ value: "1560", label: "PADRE BERNARDO" },
		{ value: "1565", label: "PALESTINA DE GOIAS" },
		{ value: "1570", label: "PALMEIRAS DE GOIAS" },
		{ value: "1580", label: "PALMELO" },
		{ value: "1590", label: "PALMINOPOLIS" },
		{ value: "1600", label: "PANAMA" },
		{ value: "1630", label: "PARANAIGUARA" },
		{ value: "1640", label: "PARAUNA" },
		{ value: "1645", label: "PEROLANDIA" },
		{ value: "1680", label: "PETROLINA DE GOIAS" },
		{ value: "1690", label: "PILAR DE GOIAS" },
		{ value: "1710", label: "PIRACANJUBA" },
		{ value: "1720", label: "PIRANHAS" },
		{ value: "1730", label: "PIRENOPOLIS" },
		{ value: "1740", label: "PIRES DO RIO" },
		{ value: "1760", label: "PLANALTINA" },
		{ value: "1770", label: "PONTALINA" },
		{ value: "1800", label: "PORANGATU" },
		{ value: "1805", label: "PORTEIRAO" },
		{ value: "1810", label: "PORTELANDIA" },
		{ value: "1830", label: "POSSE" },
		{ value: "1839", label: "PROFESSOR JAMIL" },
		{ value: "1850", label: "QUIRINOPOLIS" },
		{ value: "1860", label: "RIALMA" },
		{ value: "1870", label: "RIANAPOLIS" },
		{ value: "1878", label: "RIO QUENTE" },
		{ value: "1880", label: "RIO VERDE" },
		{ value: "1890", label: "RUBIATABA" },
		{ value: "1900", label: "SANCLERLANDIA" },
		{ value: "1910", label: "SANTA BARBARA DE GOIAS" },
		{ value: "1920", label: "SANTA CRUZ DE GOIAS" },
		{ value: "1925", label: "SANTA FE DE GOIAS" },
		{ value: "1930", label: "SANTA HELENA DE GOIAS" },
		{ value: "1935", label: "SANTA ISABEL" },
		{ value: "1940", label: "SANTA RITA DO ARAGUAIA" },
		{ value: "1945", label: "SANTA RITA DO NOVO DESTINO" },
		{ value: "1950", label: "SANTA ROSA DE GOIAS" },
		{ value: "1960", label: "SANTA TEREZA DE GOIAS" },
		{ value: "1970", label: "SANTA TEREZINHA DE GOIAS" },
		{ value: "1971", label: "SANTO ANTONIO DA BARRA" },
		{ value: "1973", label: "SANTO ANTONIO DE GOIAS" },
		{ value: "1975", label: "SANTO ANTONIO DO DESCOBERTO" },
		{ value: "1980", label: "SAO DOMINGOS" },
		{ value: "1990", label: "SAO FRANCISCO DE GOIAS" },
		{ value: "2000", label: "SAO JOAO D'ALIANCA" },
		{ value: "2005", label: "SAO JOAO DA PARAUNA" },
		{ value: "2010", label: "SAO LUIS DE MONTES BELOS" },
		{ value: "2015", label: "SAO LUIZ DO NORTE" },
		{ value: "2020", label: "SAO MIGUEL DO ARAGUAIA" },
		{ value: "2026", label: "SAO MIGUEL DO PASSA QUATRO" },
		{ value: "2028", label: "SAO PATRICIO" },
		{ value: "2040", label: "SAO SIMAO" },
		{ value: "2045", label: "SENADOR CANEDO" },
		{ value: "2050", label: "SERRANOPOLIS" },
		{ value: "2060", label: "SILVANIA" },
		{ value: "2068", label: "SIMOLANDIA" },
		{ value: "2070", label: "SITIO D'ABADIA" },
		{ value: "2100", label: "TAQUARAL DE GOIAS" },
		{ value: "2108", label: "TERESINA DE GOIAS" },
		{ value: "2119", label: "TEREZOPOLIS DE GOIAS" },
		{ value: "2130", label: "TRES RANCHOS" },
		{ value: "2140", label: "TRINDADE" },
		{ value: "2145", label: "TROMBAS" },
		{ value: "2150", label: "TURVANIA" },
		{ value: "2155", label: "TURVELANDIA" },
		{ value: "2157", label: "UIRAPURU" },
		{ value: "2160", label: "URUACU" },
		{ value: "2170", label: "URUANA" },
		{ value: "2180", label: "URUTAI" },
		{ value: "2185", label: "VALPARAISO DE GOIAS" },
		{ value: "2190", label: "VARJAO" },
		{ value: "2200", label: "VIANOPOLIS" },
		{ value: "2205", label: "VICENTINOPOLIS" },
		{ value: "2220", label: "VILA BOA" },
		{ value: "2230", label: "VILA PROPICIO" },
	],
	DF: [{ value: "0010", label: "BRASILIA" }],
};

const countriesOptions = [
	{ value: "0021", label: "ARGENTINA" },
	{ value: "0022", label: "BOLIVIA" },
	{ value: "0023", label: "CHILE" },
	{ value: "0024", label: "PARAGUAI" },
	{ value: "0025", label: "URUGUAI" },
	{ value: "0026", label: "COLOMBIA" },
	{ value: "0027", label: "EQUADOR" },
	{ value: "0028", label: "ANTIGUA E BARBUDA" },
	{ value: "0029", label: "ANTILHAS HOLANDESAS" },
	{ value: "0030", label: "ALEMANHA" },
	{ value: "0031", label: "BELGICA" },
	{ value: "0032", label: "REINO UNIDO (EX GRA BRETANHA)" },
	{ value: "0033", label: "ARUBA" },
	{ value: "0034", label: "CANADA" },
	{ value: "0035", label: "ESPANHA" },
	{ value: "0036", label: "EUA" },
	{ value: "0037", label: "FRANCA" },
	{ value: "0038", label: "SUICA" },
	{ value: "0039", label: "ITALIA" },
	{ value: "0040", label: "BAHAMAS, COMUNIDADE DAS" },
	{ value: "0041", label: "JAPAO" },
	{ value: "0042", label: "CHINA" },
	{ value: "0043", label: "COREIA DO SUL" },
	{ value: "0044", label: "BARBADOS" },
	{ value: "0045", label: "PORTUGAL" },
	{ value: "0046", label: "BELIZE" },
	{ value: "0047", label: "TURKS E CAICOS, ILHAS" },
	{ value: "0051", label: "COSTA RICA" },
	{ value: "0052", label: "CUBA" },
	{ value: "0053", label: "CURACAO" },
	{ value: "0054", label: "DOMINICA, COMUNIDADE" },
	{ value: "0055", label: "DOMINICANA, REPUBLICA (OU SAO" },
	{ value: "0056", label: "EL SALVADOR, REPUBLICA DE" },
	{ value: "0057", label: "ANTILHAS, ESTADOS ASSOCIADOS D" },
	{ value: "0058", label: "FALKLANDS, ILHAS (MALVINAS)" },
	{ value: "0059", label: "GRANADA" },
	{ value: "0060", label: "GUADALUPE, ILHAS" },
	{ value: "0061", label: "GUATEMALA" },
	{ value: "0062", label: "HAITI, REPUBLICA DO" },
	{ value: "0063", label: "HONDURAS BRITANICAS" },
	{ value: "0064", label: "HONDURAS" },
	{ value: "0065", label: "SERRANAS, ILHAS" },
	{ value: "0066", label: "JAMAICA" },
	{ value: "0067", label: "MALVINAS, ILHAS" },
	{ value: "0068", label: "MARTINICA" },
	{ value: "0069", label: "MILHOS, ILHAS" },
	{ value: "0070", label: "MONTE SERRAT" },
	{ value: "0071", label: "NICARAGUA" },
	{ value: "0072", label: "PANAMA" },
	{ value: "0073", label: "PANAMA, ZONA DO CANAL" },
	{ value: "0074", label: "PORTO RICO" },
	{ value: "0075", label: "QUITASUENO" },
	{ value: "0076", label: "RONCADOR" },
	{ value: "0077", label: "SANTA LUCIA" },
	{ value: "0078", label: "SAO CRISTOVAO (E NEVIS)" },
	{ value: "0079", label: "SAO VICENTE (E GRANADINAS)" },
	{ value: "0080", label: "TURCA, ILHAS" },
	{ value: "0081", label: "VIRGENS BRITANICAS, ILHAS" },
	{ value: "0082", label: "VIRGENS AMERICANS, ILHAS" },
	{ value: "0083", label: "BERMUDAS" },
	{ value: "0084", label: "GROELANDIA" },
	{ value: "0085", label: "MEXICO" },
	{ value: "0086", label: "SAINT PIERRE ET MIQUELON" },
	{ value: "0087", label: "GUIANA FRANCESA" },
	{ value: "0088", label: "GUIANA, REPUBLICA" },
	{ value: "0089", label: "PERU" },
	{ value: "0090", label: "SURINAME" },
	{ value: "0091", label: "TRINIDAD E TOBAGO" },
	{ value: "0092", label: "VENEZUELA" },
	{ value: "0093", label: "ALBANIA" },
	{ value: "0094", label: "ANDORRA" },
	{ value: "0095", label: "AUSTRIA" },
	{ value: "0096", label: "BULGARIA" },
	{ value: "0097", label: "CHIPRE" },
	{ value: "0098", label: "DINAMARCA" },
	{ value: "0099", label: "EIRE" },
	{ value: "0100", label: "ESCOCIA" },
	{ value: "0101", label: "FEROES, ILHAS" },
	{ value: "0102", label: "FINLANDIA" },
	{ value: "0103", label: "GIBRALTAR" },
	{ value: "0104", label: "GRECIA" },
	{ value: "0105", label: "HOLANDA (OU PAISES BAIXOS)" },
	{ value: "0106", label: "HUNGRIA" },
	{ value: "0107", label: "BALEARES, ILHAS" },
	{ value: "0108", label: "COSMOLEDO, ILHAS" },
	{ value: "0109", label: "CANAL, ILHAS DO" },
	{ value: "0110", label: "INGLATERRA" },
	{ value: "0111", label: "IRLANDA DO NORTE" },
	{ value: "0112", label: "IRLANDA" },
	{ value: "0113", label: "ISLANDIA" },
	{ value: "0114", label: "IUGUSLAVIA" },
	{ value: "0115", label: "LIECHTENSTEIN" },
	{ value: "0116", label: "LUXEMBURGO" },
	{ value: "0117", label: "MAN, ILHAS DE" },
	{ value: "0118", label: "MONACO" },
	{ value: "0119", label: "NORUEGA" },
	{ value: "0120", label: "MALTA, REPUBLICA DE" },
	{ value: "0121", label: "PAIS DE GALES" },
	{ value: "0122", label: "PAISES BAIXOS (OU HOLANDA)" },
	{ value: "0123", label: "POLONIA" },
	{ value: "0124", label: "ROMENIA" },
	{ value: "0125", label: "SAO MARINHO" },
	{ value: "0126", label: "SUECIA" },
	{ value: "0127", label: "SVALBARD E JAN MAYER, ILHAS" },
	{ value: "0128", label: "TCHECOSLOVAQUIA (ATUAL REPUBLI" },
	{ value: "0129", label: "VATICANO, ESTADO DA CIDADE DO" },
	{ value: "0130", label: "CROACIA" },
	{ value: "0131", label: "SERVIA" },
	{ value: "0132", label: "ESLOVENIA" },
	{ value: "0133", label: "MACEDONIA, REPUBLICA DA" },
	{ value: "0134", label: "BOSNIA HERZEGOVINA" },
	{ value: "0135", label: "TCHECA, REPUBLICA (EX TCHECOSL" },
	{ value: "0136", label: "ESLOVAQUIA" },
	{ value: "0137", label: "MONTENEGRO" },
	{ value: "0138", label: "AZERBAIJAO" },
	{ value: "0139", label: "BASHKISTA" },
	{ value: "0140", label: "BELARUS (BIELORRUSSIA, REPUBLI" },
	{ value: "0141", label: "BURYAT" },
	{ value: "0142", label: "CARELIA" },
	{ value: "0143", label: "CASAQUISTAO" },
	{ value: "0144", label: "CHECHEN INGUSTH" },
	{ value: "0145", label: "CHUVASH" },
	{ value: "0146", label: "DAGESTA" },
	{ value: "0147", label: "ESTONIA" },
	{ value: "0148", label: "GEORGIA" },
	{ value: "0149", label: "GORNO ALTAI" },
	{ value: "0150", label: "KABARDINO BALKAR" },
	{ value: "0151", label: "KALMIR" },
	{ value: "0152", label: "KARACHAEVOCHERKESS" },
	{ value: "0153", label: "KHAKASS" },
	{ value: "0154", label: "KOMI" },
	{ value: "0155", label: "LETONIA" },
	{ value: "0156", label: "LITUANIA" },
	{ value: "0157", label: "MARI" },
	{ value: "0158", label: "MOLDAVIA" },
	{ value: "0159", label: "OSSETIA SETENTRIONAL" },
	{ value: "0160", label: "QUIRQUISTAO" },
	{ value: "0161", label: "TADJIQUISTAO" },
	{ value: "0162", label: "TARTARIA" },
	{ value: "0163", label: "TURCOMENISTAO (OU TURMOMENIA)" },
	{ value: "0164", label: "TUVIN" },
	{ value: "0165", label: "UCRANIA" },
	{ value: "0166", label: "UDMURT" },
	{ value: "0167", label: "UNIAO SOVIETICA" },
	{ value: "0168", label: "USBEQUISTAO" },
	{ value: "0169", label: "YAKUT" },
	{ value: "0170", label: "ABISSINIA (ATUAL ETIOPIA)" },
	{ value: "0171", label: "ACORES" },
	{ value: "0172", label: "AFAR FRANCES (ATUAL DJIBUTI)" },
	{ value: "0173", label: "AFRICA DO SUL, REPUBLICA DA" },
	{ value: "0174", label: "ALTO VOLTA (ATUAL BURKINA FASS" },
	{ value: "0175", label: "ANGOLA" },
	{ value: "0176", label: "ARGELIA" },
	{ value: "0177", label: "BECHUANA (ATUAL BTSUANA)" },
	{ value: "0178", label: "BENIN" },
	{ value: "0179", label: "BOTSWANA" },
	{ value: "0180", label: "BURUNDI" },
	{ value: "0181", label: "CAMAROES" },
	{ value: "0182", label: "CEUTA E MELILLA" },
	{ value: "0183", label: "CHADE" },
	{ value: "0184", label: "COMOROS, ILHAS" },
	{ value: "0185", label: "CONGO, REPUBLICA DO" },
	{ value: "0186", label: "COSTA DO MARFIM" },
	{ value: "0187", label: "DAOME (ATUAL BENIN)" },
	{ value: "0188", label: "DJIBUTI" },
	{ value: "0189", label: "EGITO, REBUPLICA ARABE DO" },
	{ value: "0190", label: "ETIOPIA" },
	{ value: "0191", label: "GABAO, REPUBLICA DO" },
	{ value: "0192", label: "GAMBIA" },
	{ value: "0193", label: "GANA" },
	{ value: "0194", label: "GAZA" },
	{ value: "0195", label: "GUINE" },
	{ value: "0196", label: "GUINE EQUATORIAL" },
	{ value: "0197", label: "INFNI" },
	{ value: "0198", label: "ASCENSAO E TRISTAO DA CUNHA, I" },
	{ value: "0199", label: "CANARIAS, ILHAS" },
	{ value: "0200", label: "LESOTO" },
	{ value: "0201", label: "LIBERIA" },
	{ value: "0202", label: "LIBIA" },
	{ value: "0203", label: "MADEIRA" },
	{ value: "0204", label: "MALAWI (OU MALAUI)" },
	{ value: "0205", label: "MADAGASCAR" },
	{ value: "0206", label: "MALI" },
	{ value: "0207", label: "MARROCOS" },
	{ value: "0208", label: "MAURICIO" },
	{ value: "0209", label: "MAURITANIA" },
	{ value: "0210", label: "MOCAMBIQUE" },
	{ value: "0211", label: "NGUANE" },
	{ value: "0212", label: "NIGER, REPUBLICA DO" },
	{ value: "0213", label: "NIGERIA" },
	{ value: "0214", label: "PAPUA NOVA GUINE" },
	{ value: "0215", label: "AFRICANA, PRACAS NORTE" },
	{ value: "0216", label: "AFRICANO,  PROTETOR DO SUDOEST" },
	{ value: "0217", label: "QUENIA" },
	{ value: "0218", label: "AFRICANA, REPUBLICA CENTRAL" },
	{ value: "0219", label: "REUNIAO" },
	{ value: "0220", label: "RODESIA (ATUAL ZIMBABWE)" },
	{ value: "0221", label: "RUANDA" },
	{ value: "0222", label: "SAARA ESPANHOL" },
	{ value: "0223", label: "SANTA HELENA" },
	{ value: "0224", label: "SAO TOME E PRINCIPE" },
	{ value: "0225", label: "SEYCHELLES" },
	{ value: "0226", label: "SERRA LEOA" },
	{ value: "0227", label: "SOMALIA, REPUBLICA" },
	{ value: "0228", label: "SUAZILANDIA" },
	{ value: "0229", label: "SUDAO" },
	{ value: "0230", label: "TANGANICA" },
	{ value: "0231", label: "OCEANO INDICO, TERRITORIO BRIT" },
	{ value: "0232", label: "TRANSKEI" },
	{ value: "0233", label: "TOGO" },
	{ value: "0234", label: "TUNISIA" },
	{ value: "0235", label: "UGANDA" },
	{ value: "0236", label: "CONGO, REPUBLICA DEMOCRATICA (" },
	{ value: "0237", label: "ZAMBIA" },
	{ value: "0238", label: "BURKINA FASSO" },
	{ value: "0239", label: "ZIMBABWE" },
	{ value: "0240", label: "NAMIBIA" },
	{ value: "0241", label: "AFEGANISTAO" },
	{ value: "0242", label: "ARABIA SAUDITA" },
	{ value: "0243", label: "BAHRAIN" },
	{ value: "0244", label: "BIRMANIA" },
	{ value: "0245", label: "BRUNEI" },
	{ value: "0246", label: "BUTAO" },
	{ value: "0247", label: "CATAR" },
	{ value: "0248", label: "CEILAO (ATUAL SRI-LANKA)" },
	{ value: "0249", label: "TAIWAN(REPUBLICA CHINA/ILHA FO" },
	{ value: "0250", label: "COVEITE (ATUAL KUWAIT)" },
	{ value: "0251", label: "EMIRADOS ARABES UNIDOS" },
	{ value: "0252", label: "FILIPINAS" },
	{ value: "0253", label: "HONG-KONG (CHINA)" },
	{ value: "0254", label: "IEMEN" },
	{ value: "0255", label: "INDIA" },
	{ value: "0256", label: "INDONESIA" },
	{ value: "0257", label: "IRA" },
	{ value: "0258", label: "IRAQUE" },
	{ value: "0259", label: "ISRAEL" },
	{ value: "0260", label: "JORDANIA" },
	{ value: "0261", label: "CAMBOJA (KMER)" },
	{ value: "0262", label: "KUWAIT" },
	{ value: "0263", label: "LAOS" },
	{ value: "0264", label: "LIBANO" },
	{ value: "0265", label: "MACAU (CHINA)" },
	{ value: "0266", label: "MALASIA" },
	{ value: "0267", label: "MALDIVAS, ILHAS" },
	{ value: "0268", label: "MASCATE" },
	{ value: "0269", label: "MONGOLIA" },
	{ value: "0270", label: "NEPAL" },
	{ value: "0271", label: "OMAN" },
	{ value: "0272", label: "PALESTINA" },
	{ value: "0273", label: "PAQUISTAO" },
	{ value: "0274", label: "RUIQUIU, ILHAS" },
	{ value: "0275", label: "SINGAPURA (OU CINGAPURA)" },
	{ value: "0276", label: "SEQUIN" },
	{ value: "0277", label: "SIRIA" },
	{ value: "0278", label: "SRI-LANKA" },
	{ value: "0279", label: "TAILANDIA" },
	{ value: "0280", label: "TREGUA, ESTADO" },
	{ value: "0281", label: "TURQUIA" },
	{ value: "0282", label: "VIETNA DO NORTE" },
	{ value: "0283", label: "VIETNA DO SUL" },
	{ value: "0284", label: "MIANMAR" },
	{ value: "0285", label: "MANAHIKI, ARQUIPELAGO" },
	{ value: "0286", label: "MIDWAY, ILHAS" },
	{ value: "0287", label: "ASHMORE E CARTIER" },
	{ value: "0288", label: "AUSTRALIA" },
	{ value: "0289", label: "BISMARK, ARQUIPELAGO DE" },
	{ value: "0290", label: "COOK, ILHAS" },
	{ value: "0291", label: "FIJI, REPUBLICA DE" },
	{ value: "0292", label: "GUAN" },
	{ value: "0293", label: "BAKER, ILHAS" },
	{ value: "0294", label: "CANTAO E ENDERBURG, ILHAS" },
	{ value: "0295", label: "CAROLINAS, ILHAS" },
	{ value: "0296", label: "PACIFICO, ILHAS DO" },
	{ value: "0297", label: "CHRISTMAS, ILHAS" },
	{ value: "0298", label: "KIRIBATI (ANTIGA GILBERT, ILHA" },
	{ value: "0299", label: "HOWLAND E JARVIS, ILHAS" },
	{ value: "0300", label: "JOHNSTON E SAND, ILHAS" },
	{ value: "0301", label: "KINGMAN REEF, ILHAS" },
	{ value: "0302", label: "MACQUAIRE, ILHAS" },
	{ value: "0303", label: "MARIANAS, ILHAS" },
	{ value: "0304", label: "MARSHALL, ILHAS" },
	{ value: "0305", label: "MACDONAL E HEARD, ILHAS" },
	{ value: "0306", label: "NIEU, ILHAS" },
	{ value: "0307", label: "NORFOLK, ILHAS" },
	{ value: "0308", label: "PALAU, ILHAS" },
	{ value: "0309", label: "SALOMAO, ILHAS" },
	{ value: "0310", label: "TOKELAU, ILHAS" },
	{ value: "0311", label: "WAKE, ILHAS" },
	{ value: "0312", label: "KALIMATAN" },
	{ value: "0313", label: "LINHA, ILHAS" },
	{ value: "0314", label: "NAURU" },
	{ value: "0315", label: "NOVA CALEDONIA, ILHAS" },
	{ value: "0316", label: "NOVA GUINE" },
	{ value: "0317", label: "NOVA ZELANDIA" },
	{ value: "0318", label: "NOVAS HEBRIDAS, ILHAS (EX VANU" },
	{ value: "0319", label: "PAPUA, TERRITORIO DE" },
	{ value: "0320", label: "PASCOA, ILHAS" },
	{ value: "0321", label: "PITCAIRIN, ILHAS" },
	{ value: "0322", label: "POLINESIA FRANCESA" },
	{ value: "0323", label: "SABAH" },
	{ value: "0324", label: "SAMOA AMERICANA (OU SAMOA ORIE" },
	{ value: "0325", label: "SAMOA OCIDENTAL" },
	{ value: "0326", label: "SANTA CRUZ, ILHAS" },
	{ value: "0327", label: "SARAWAK" },
	{ value: "0328", label: "COCOS, TERRITORIO DE" },
	{ value: "0329", label: "TIMOR (OU TIMOR LESTE)" },
	{ value: "0330", label: "TONGAS" },
	{ value: "0331", label: "TUVALU" },
	{ value: "0332", label: "WALLIS E FUTUNA, ILHAS" },
	{ value: "0333", label: "BRITANICO, TERRITORIO ANTARTIC" },
	{ value: "0334", label: "FRANCESA, ANTARTICA" },
	{ value: "0335", label: "AUSTRALIA, TERRITORIO ANTARTIC" },
	{ value: "0336", label: "CHILENO, ANTARTICO" },
	{ value: "0337", label: "ARGENTINO, ANTARTICO" },
	{ value: "0338", label: "NORUEGES, ANTARTICO" },
	{ value: "0339", label: "APATRIDA" },
	{ value: "0340", label: "ROSS, DEPENDENCIA DE (NOVA ZEL" },
	{ value: "0341", label: "TERRAS AUSTRAIS" },
	{ value: "0342", label: "BANGLADESH" },
	{ value: "0343", label: "CABO VERDE" },
	{ value: "0344", label: "GUINE BISSAU" },
	{ value: "0345", label: "IEMEN DO SUL" },
	{ value: "0346", label: "KARA KALPAK" },
	{ value: "0347", label: "ARMENIA" },
	{ value: "0348", label: "RUSSIA" },
	{ value: "0349", label: "SENEGAL" },
	{ value: "0350", label: "TANZANIA" },
	{ value: "0351", label: "COREIA DO NORTE" },
	{ value: "0352", label: "ANGUILLA" },
	{ value: "0353", label: "CAYMAN, ILHAS" },
	{ value: "0354", label: "LABUAN, ILHAS" },
	{ value: "0355", label: "MICRONESIA" },
	{ value: "0356", label: "NIUE" },
	{ value: "0357", label: "SAARA OCIDENTAL" },
	{ value: "0358", label: "VIETNA" },
	{ value: "0359", label: "ERITREIA" },
];

const passaporteOptions = [
	{ value: "", label: "" },

	{ value: "0010", label: "BRAZIL" },
	{ value: "0021", label: "ARGENTINA" },
	{ value: "0022", label: "BOLIVIA" },
	{ value: "0023", label: "CHILE" },
	{ value: "0024", label: "PARAGUAI" },
	{ value: "0025", label: "URUGUAI" },
	{ value: "0026", label: "COLOMBIA" },
	{ value: "0027", label: "EQUADOR" },
	{ value: "0028", label: "ANTIGUA E BARBUDA" },
	{ value: "0029", label: "ANTILHAS HOLANDESAS" },
	{ value: "0030", label: "ALEMANHA" },
	{ value: "0031", label: "BELGICA" },
	{ value: "0032", label: "REINO UNIDO (EX GRA BRETANHA)" },
	{ value: "0033", label: "ARUBA" },
	{ value: "0034", label: "CANADA" },
	{ value: "0035", label: "ESPANHA" },
	{ value: "0036", label: "EUA" },
	{ value: "0037", label: "FRANCA" },
	{ value: "0038", label: "SUICA" },
	{ value: "0039", label: "ITALIA" },
	{ value: "0040", label: "BAHAMAS, COMUNIDADE DAS" },
	{ value: "0041", label: "JAPAO" },
	{ value: "0042", label: "CHINA" },
	{ value: "0043", label: "COREIA DO SUL" },
	{ value: "0044", label: "BARBADOS" },
	{ value: "0045", label: "PORTUGAL" },
	{ value: "0046", label: "BELIZE" },
	{ value: "0047", label: "TURKS E CAICOS, ILHAS" },
	{ value: "0051", label: "COSTA RICA" },
	{ value: "0052", label: "CUBA" },
	{ value: "0053", label: "CURACAO" },
	{ value: "0054", label: "DOMINICA, COMUNIDADE" },
	{ value: "0055", label: "DOMINICANA, REPUBLICA (OU SAO" },
	{ value: "0056", label: "EL SALVADOR, REPUBLICA DE" },
	{ value: "0057", label: "ANTILHAS, ESTADOS ASSOCIADOS D" },
	{ value: "0058", label: "FALKLANDS, ILHAS (MALVINAS)" },
	{ value: "0059", label: "GRANADA" },
	{ value: "0060", label: "GUADALUPE, ILHAS" },
	{ value: "0061", label: "GUATEMALA" },
	{ value: "0062", label: "HAITI, REPUBLICA DO" },
	{ value: "0063", label: "HONDURAS BRITANICAS" },
	{ value: "0064", label: "HONDURAS" },
	{ value: "0065", label: "SERRANAS, ILHAS" },
	{ value: "0066", label: "JAMAICA" },
	{ value: "0067", label: "MALVINAS, ILHAS" },
	{ value: "0068", label: "MARTINICA" },
	{ value: "0069", label: "MILHOS, ILHAS" },
	{ value: "0070", label: "MONTE SERRAT" },
	{ value: "0071", label: "NICARAGUA" },
	{ value: "0072", label: "PANAMA" },
	{ value: "0073", label: "PANAMA, ZONA DO CANAL" },
	{ value: "0074", label: "PORTO RICO" },
	{ value: "0075", label: "QUITASUENO" },
	{ value: "0076", label: "RONCADOR" },
	{ value: "0077", label: "SANTA LUCIA" },
	{ value: "0078", label: "SAO CRISTOVAO (E NEVIS)" },
	{ value: "0079", label: "SAO VICENTE (E GRANADINAS)" },
	{ value: "0080", label: "TURCA, ILHAS" },
	{ value: "0081", label: "VIRGENS BRITANICAS, ILHAS" },
	{ value: "0082", label: "VIRGENS AMERICANS, ILHAS" },
	{ value: "0083", label: "BERMUDAS" },
	{ value: "0084", label: "GROELANDIA" },
	{ value: "0085", label: "MEXICO" },
	{ value: "0086", label: "SAINT PIERRE ET MIQUELON" },
	{ value: "0087", label: "GUIANA FRANCESA" },
	{ value: "0088", label: "GUIANA, REPUBLICA" },
	{ value: "0089", label: "PERU" },
	{ value: "0090", label: "SURINAME" },
	{ value: "0091", label: "TRINIDAD E TOBAGO" },
	{ value: "0092", label: "VENEZUELA" },
	{ value: "0093", label: "ALBANIA" },
	{ value: "0094", label: "ANDORRA" },
	{ value: "0095", label: "AUSTRIA" },
	{ value: "0096", label: "BULGARIA" },
	{ value: "0097", label: "CHIPRE" },
	{ value: "0098", label: "DINAMARCA" },
	{ value: "0099", label: "EIRE" },
	{ value: "0100", label: "ESCOCIA" },
	{ value: "0101", label: "FEROES, ILHAS" },
	{ value: "0102", label: "FINLANDIA" },
	{ value: "0103", label: "GIBRALTAR" },
	{ value: "0104", label: "GRECIA" },
	{ value: "0105", label: "HOLANDA (OU PAISES BAIXOS)" },
	{ value: "0106", label: "HUNGRIA" },
	{ value: "0107", label: "BALEARES, ILHAS" },
	{ value: "0108", label: "COSMOLEDO, ILHAS" },
	{ value: "0109", label: "CANAL, ILHAS DO" },
	{ value: "0110", label: "INGLATERRA" },
	{ value: "0111", label: "IRLANDA DO NORTE" },
	{ value: "0112", label: "IRLANDA" },
	{ value: "0113", label: "ISLANDIA" },
	{ value: "0114", label: "IUGUSLAVIA" },
	{ value: "0115", label: "LIECHTENSTEIN" },
	{ value: "0116", label: "LUXEMBURGO" },
	{ value: "0117", label: "MAN, ILHAS DE" },
	{ value: "0118", label: "MONACO" },
	{ value: "0119", label: "NORUEGA" },
	{ value: "0120", label: "MALTA, REPUBLICA DE" },
	{ value: "0121", label: "PAIS DE GALES" },
	{ value: "0122", label: "PAISES BAIXOS (OU HOLANDA)" },
	{ value: "0123", label: "POLONIA" },
	{ value: "0124", label: "ROMENIA" },
	{ value: "0125", label: "SAO MARINHO" },
	{ value: "0126", label: "SUECIA" },
	{ value: "0127", label: "SVALBARD E JAN MAYER, ILHAS" },
	{ value: "0128", label: "TCHECOSLOVAQUIA (ATUAL REPUBLI" },
	{ value: "0129", label: "VATICANO, ESTADO DA CIDADE DO" },
	{ value: "0130", label: "CROACIA" },
	{ value: "0131", label: "SERVIA" },
	{ value: "0132", label: "ESLOVENIA" },
	{ value: "0133", label: "MACEDONIA, REPUBLICA DA" },
	{ value: "0134", label: "BOSNIA HERZEGOVINA" },
	{ value: "0135", label: "TCHECA, REPUBLICA (EX TCHECOSL" },
	{ value: "0136", label: "ESLOVAQUIA" },
	{ value: "0137", label: "MONTENEGRO" },
	{ value: "0138", label: "AZERBAIJAO" },
	{ value: "0139", label: "BASHKISTA" },
	{ value: "0140", label: "BELARUS (BIELORRUSSIA, REPUBLI" },
	{ value: "0141", label: "BURYAT" },
	{ value: "0142", label: "CARELIA" },
	{ value: "0143", label: "CASAQUISTAO" },
	{ value: "0144", label: "CHECHEN INGUSTH" },
	{ value: "0145", label: "CHUVASH" },
	{ value: "0146", label: "DAGESTA" },
	{ value: "0147", label: "ESTONIA" },
	{ value: "0148", label: "GEORGIA" },
	{ value: "0149", label: "GORNO ALTAI" },
	{ value: "0150", label: "KABARDINO BALKAR" },
	{ value: "0151", label: "KALMIR" },
	{ value: "0152", label: "KARACHAEVOCHERKESS" },
	{ value: "0153", label: "KHAKASS" },
	{ value: "0154", label: "KOMI" },
	{ value: "0155", label: "LETONIA" },
	{ value: "0156", label: "LITUANIA" },
	{ value: "0157", label: "MARI" },
	{ value: "0158", label: "MOLDAVIA" },
	{ value: "0159", label: "OSSETIA SETENTRIONAL" },
	{ value: "0160", label: "QUIRQUISTAO" },
	{ value: "0161", label: "TADJIQUISTAO" },
	{ value: "0162", label: "TARTARIA" },
	{ value: "0163", label: "TURCOMENISTAO (OU TURMOMENIA)" },
	{ value: "0164", label: "TUVIN" },
	{ value: "0165", label: "UCRANIA" },
	{ value: "0166", label: "UDMURT" },
	{ value: "0167", label: "UNIAO SOVIETICA" },
	{ value: "0168", label: "USBEQUISTAO" },
	{ value: "0169", label: "YAKUT" },
	{ value: "0170", label: "ABISSINIA (ATUAL ETIOPIA)" },
	{ value: "0171", label: "ACORES" },
	{ value: "0172", label: "AFAR FRANCES (ATUAL DJIBUTI)" },
	{ value: "0173", label: "AFRICA DO SUL, REPUBLICA DA" },
	{ value: "0174", label: "ALTO VOLTA (ATUAL BURKINA FASS" },
	{ value: "0175", label: "ANGOLA" },
	{ value: "0176", label: "ARGELIA" },
	{ value: "0177", label: "BECHUANA (ATUAL BTSUANA)" },
	{ value: "0178", label: "BENIN" },
	{ value: "0179", label: "BOTSWANA" },
	{ value: "0180", label: "BURUNDI" },
	{ value: "0181", label: "CAMAROES" },
	{ value: "0182", label: "CEUTA E MELILLA" },
	{ value: "0183", label: "CHADE" },
	{ value: "0184", label: "COMOROS, ILHAS" },
	{ value: "0185", label: "CONGO, REPUBLICA DO" },
	{ value: "0186", label: "COSTA DO MARFIM" },
	{ value: "0187", label: "DAOME (ATUAL BENIN)" },
	{ value: "0188", label: "DJIBUTI" },
	{ value: "0189", label: "EGITO, REBUPLICA ARABE DO" },
	{ value: "0190", label: "ETIOPIA" },
	{ value: "0191", label: "GABAO, REPUBLICA DO" },
	{ value: "0192", label: "GAMBIA" },
	{ value: "0193", label: "GANA" },
	{ value: "0194", label: "GAZA" },
	{ value: "0195", label: "GUINE" },
	{ value: "0196", label: "GUINE EQUATORIAL" },
	{ value: "0197", label: "INFNI" },
	{ value: "0198", label: "ASCENSAO E TRISTAO DA CUNHA, I" },
	{ value: "0199", label: "CANARIAS, ILHAS" },
	{ value: "0200", label: "LESOTO" },
	{ value: "0201", label: "LIBERIA" },
	{ value: "0202", label: "LIBIA" },
	{ value: "0203", label: "MADEIRA" },
	{ value: "0204", label: "MALAWI (OU MALAUI)" },
	{ value: "0205", label: "MADAGASCAR" },
	{ value: "0206", label: "MALI" },
	{ value: "0207", label: "MARROCOS" },
	{ value: "0208", label: "MAURICIO" },
	{ value: "0209", label: "MAURITANIA" },
	{ value: "0210", label: "MOCAMBIQUE" },
	{ value: "0211", label: "NGUANE" },
	{ value: "0212", label: "NIGER, REPUBLICA DO" },
	{ value: "0213", label: "NIGERIA" },
	{ value: "0214", label: "PAPUA NOVA GUINE" },
	{ value: "0215", label: "AFRICANA, PRACAS NORTE" },
	{ value: "0216", label: "AFRICANO,  PROTETOR DO SUDOEST" },
	{ value: "0217", label: "QUENIA" },
	{ value: "0218", label: "AFRICANA, REPUBLICA CENTRAL" },
	{ value: "0219", label: "REUNIAO" },
	{ value: "0220", label: "RODESIA (ATUAL ZIMBABWE)" },
	{ value: "0221", label: "RUANDA" },
	{ value: "0222", label: "SAARA ESPANHOL" },
	{ value: "0223", label: "SANTA HELENA" },
	{ value: "0224", label: "SAO TOME E PRINCIPE" },
	{ value: "0225", label: "SEYCHELLES" },
	{ value: "0226", label: "SERRA LEOA" },
	{ value: "0227", label: "SOMALIA, REPUBLICA" },
	{ value: "0228", label: "SUAZILANDIA" },
	{ value: "0229", label: "SUDAO" },
	{ value: "0230", label: "TANGANICA" },
	{ value: "0231", label: "OCEANO INDICO, TERRITORIO BRIT" },
	{ value: "0232", label: "TRANSKEI" },
	{ value: "0233", label: "TOGO" },
	{ value: "0234", label: "TUNISIA" },
	{ value: "0235", label: "UGANDA" },
	{ value: "0236", label: "CONGO, REPUBLICA DEMOCRATICA (" },
	{ value: "0237", label: "ZAMBIA" },
	{ value: "0238", label: "BURKINA FASSO" },
	{ value: "0239", label: "ZIMBABWE" },
	{ value: "0240", label: "NAMIBIA" },
	{ value: "0241", label: "AFEGANISTAO" },
	{ value: "0242", label: "ARABIA SAUDITA" },
	{ value: "0243", label: "BAHRAIN" },
	{ value: "0244", label: "BIRMANIA" },
	{ value: "0245", label: "BRUNEI" },
	{ value: "0246", label: "BUTAO" },
	{ value: "0247", label: "CATAR" },
	{ value: "0248", label: "CEILAO (ATUAL SRI-LANKA)" },
	{ value: "0249", label: "TAIWAN(REPUBLICA CHINA/ILHA FO" },
	{ value: "0250", label: "COVEITE (ATUAL KUWAIT)" },
	{ value: "0251", label: "EMIRADOS ARABES UNIDOS" },
	{ value: "0252", label: "FILIPINAS" },
	{ value: "0253", label: "HONG-KONG (CHINA)" },
	{ value: "0254", label: "IEMEN" },
	{ value: "0255", label: "INDIA" },
	{ value: "0256", label: "INDONESIA" },
	{ value: "0257", label: "IRA" },
	{ value: "0258", label: "IRAQUE" },
	{ value: "0259", label: "ISRAEL" },
	{ value: "0260", label: "JORDANIA" },
	{ value: "0261", label: "CAMBOJA (KMER)" },
	{ value: "0262", label: "KUWAIT" },
	{ value: "0263", label: "LAOS" },
	{ value: "0264", label: "LIBANO" },
	{ value: "0265", label: "MACAU (CHINA)" },
	{ value: "0266", label: "MALASIA" },
	{ value: "0267", label: "MALDIVAS, ILHAS" },
	{ value: "0268", label: "MASCATE" },
	{ value: "0269", label: "MONGOLIA" },
	{ value: "0270", label: "NEPAL" },
	{ value: "0271", label: "OMAN" },
	{ value: "0272", label: "PALESTINA" },
	{ value: "0273", label: "PAQUISTAO" },
	{ value: "0274", label: "RUIQUIU, ILHAS" },
	{ value: "0275", label: "SINGAPURA (OU CINGAPURA)" },
	{ value: "0276", label: "SEQUIN" },
	{ value: "0277", label: "SIRIA" },
	{ value: "0278", label: "SRI-LANKA" },
	{ value: "0279", label: "TAILANDIA" },
	{ value: "0280", label: "TREGUA, ESTADO" },
	{ value: "0281", label: "TURQUIA" },
	{ value: "0282", label: "VIETNA DO NORTE" },
	{ value: "0283", label: "VIETNA DO SUL" },
	{ value: "0284", label: "MIANMAR" },
	{ value: "0285", label: "MANAHIKI, ARQUIPELAGO" },
	{ value: "0286", label: "MIDWAY, ILHAS" },
	{ value: "0287", label: "ASHMORE E CARTIER" },
	{ value: "0288", label: "AUSTRALIA" },
	{ value: "0289", label: "BISMARK, ARQUIPELAGO DE" },
	{ value: "0290", label: "COOK, ILHAS" },
	{ value: "0291", label: "FIJI, REPUBLICA DE" },
	{ value: "0292", label: "GUAN" },
	{ value: "0293", label: "BAKER, ILHAS" },
	{ value: "0294", label: "CANTAO E ENDERBURG, ILHAS" },
	{ value: "0295", label: "CAROLINAS, ILHAS" },
	{ value: "0296", label: "PACIFICO, ILHAS DO" },
	{ value: "0297", label: "CHRISTMAS, ILHAS" },
	{ value: "0298", label: "KIRIBATI (ANTIGA GILBERT, ILHA" },
	{ value: "0299", label: "HOWLAND E JARVIS, ILHAS" },
	{ value: "0300", label: "JOHNSTON E SAND, ILHAS" },
	{ value: "0301", label: "KINGMAN REEF, ILHAS" },
	{ value: "0302", label: "MACQUAIRE, ILHAS" },
	{ value: "0303", label: "MARIANAS, ILHAS" },
	{ value: "0304", label: "MARSHALL, ILHAS" },
	{ value: "0305", label: "MACDONAL E HEARD, ILHAS" },
	{ value: "0306", label: "NIEU, ILHAS" },
	{ value: "0307", label: "NORFOLK, ILHAS" },
	{ value: "0308", label: "PALAU, ILHAS" },
	{ value: "0309", label: "SALOMAO, ILHAS" },
	{ value: "0310", label: "TOKELAU, ILHAS" },
	{ value: "0311", label: "WAKE, ILHAS" },
	{ value: "0312", label: "KALIMATAN" },
	{ value: "0313", label: "LINHA, ILHAS" },
	{ value: "0314", label: "NAURU" },
	{ value: "0315", label: "NOVA CALEDONIA, ILHAS" },
	{ value: "0316", label: "NOVA GUINE" },
	{ value: "0317", label: "NOVA ZELANDIA" },
	{ value: "0318", label: "NOVAS HEBRIDAS, ILHAS (EX VANU" },
	{ value: "0319", label: "PAPUA, TERRITORIO DE" },
	{ value: "0320", label: "PASCOA, ILHAS" },
	{ value: "0321", label: "PITCAIRIN, ILHAS" },
	{ value: "0322", label: "POLINESIA FRANCESA" },
	{ value: "0323", label: "SABAH" },
	{ value: "0324", label: "SAMOA AMERICANA (OU SAMOA ORIE" },
	{ value: "0325", label: "SAMOA OCIDENTAL" },
	{ value: "0326", label: "SANTA CRUZ, ILHAS" },
	{ value: "0327", label: "SARAWAK" },
	{ value: "0328", label: "COCOS, TERRITORIO DE" },
	{ value: "0329", label: "TIMOR (OU TIMOR LESTE)" },
	{ value: "0330", label: "TONGAS" },
	{ value: "0331", label: "TUVALU" },
	{ value: "0332", label: "WALLIS E FUTUNA, ILHAS" },
	{ value: "0333", label: "BRITANICO, TERRITORIO ANTARTIC" },
	{ value: "0334", label: "FRANCESA, ANTARTICA" },
	{ value: "0335", label: "AUSTRALIA, TERRITORIO ANTARTIC" },
	{ value: "0336", label: "CHILENO, ANTARTICO" },
	{ value: "0337", label: "ARGENTINO, ANTARTICO" },
	{ value: "0338", label: "NORUEGES, ANTARTICO" },
	{ value: "0339", label: "APATRIDA" },
	{ value: "0340", label: "ROSS, DEPENDENCIA DE (NOVA ZEL" },
	{ value: "0341", label: "TERRAS AUSTRAIS" },
	{ value: "0342", label: "BANGLADESH" },
	{ value: "0343", label: "CABO VERDE" },
	{ value: "0344", label: "GUINE BISSAU" },
	{ value: "0345", label: "IEMEN DO SUL" },
	{ value: "0346", label: "KARA KALPAK" },
	{ value: "0347", label: "ARMENIA" },
	{ value: "0348", label: "RUSSIA" },
	{ value: "0349", label: "SENEGAL" },
	{ value: "0350", label: "TANZANIA" },
	{ value: "0351", label: "COREIA DO NORTE" },
	{ value: "0352", label: "ANGUILLA" },
	{ value: "0353", label: "CAYMAN, ILHAS" },
	{ value: "0354", label: "LABUAN, ILHAS" },
	{ value: "0355", label: "MICRONESIA" },
	{ value: "0356", label: "NIUE" },
	{ value: "0357", label: "SAARA OCIDENTAL" },
	{ value: "0358", label: "VIETNA" },
	{ value: "0359", label: "ERITREIA" },
];

const degreeOptions = [
	{ value: "", label: "" },

	{ value: "02", label: "Até a 4ª Série Incompleta do Ensino Fundamental" },
	{ value: "03", label: "Com 4ª Série Completa do ensino Fundamental" },
	{
		value: "04",
		label: "Da 5ª a 8ª Série Incompleta do Ensino Fundamental",
	},
	{ value: "05", label: "Ensino fundamental completo" },
	{ value: "06", label: "Ensino médio incompleto" },
	{ value: "07", label: "Ensino médio completo" },
	{ value: "08", label: "Superior incompleto" },
	{ value: "09", label: "Superior completo" },
	{ value: "10", label: "Especialização/Pós graduação" },
	{ value: "11", label: "Mestrado" },
	{ value: "12", label: "Doutorado" },
];
const docTypeOptions = [
	{ value: "", label: "" },

	{ value: "0372008", label: "Documento de identificação" },
	{ value: "0372102", label: "RIC - Registro de identidade Civil" },
	{ value: "0781", label: "Passaporte" },
	{ value: "0782", label: "CNH - Carteira Nacional de Identificação" },
];

const cnhTypeOptions = [{ value: "83", label: "Órgão de Transito" }];

const passTypeOptions = [
	{ value: "44", label: "Polícia Federal" },
	{ value: "82", label: "Órgão emissor estrangeiro" },
];

const ricTypeOptions = [
	{ value: "40", label: "Ministério da Justiça" },
	{ value: "95", label: "Outro tipo de orgão emissor de RIC" },
];

const idSubTypeOptions = [
	{ value: "CI", label: "Carteira de identidade" },
	{ value: "CF", label: "Carteira Funcional" },
	{ value: "IM", label: "Identidade Militar" },
	{ value: "CE", label: "Carteira de Identidade Estrangeira" },
];

const docEstOptions = [
	{ value: "44", label: "Polícia Federal" },
	{
		value: "94",
		label: "Outro tipo de órgão emissor de carteira estrangeiro",
	},
];

const docIdOptions = [
	{ value: "10", label: "Secretaria de Segurança Pública" },
	{ value: "81", label: "Outro tipo de órgão emissor" },
	{ value: "88", label: "Secretaria de Defesa Social" },
	{ value: "90", label: "Polícia Civil" },
	{ value: "91", label: "Secretaria de Estado da Casa Civil" },
];

const docFuncOptions = [
	{ value: "61", label: "Conselho regional de administração" },
	{ value: "62", label: "Conselho regional de assistência social" },
	{ value: "63", label: "Conselho regional de biblioteconomia" },
	{ value: "64", label: "Conselho regional de contabilidade" },
	{ value: "66", label: "Conselho regional de enfermagem" },
	{ value: "67", label: "Conselho regional de engenharia e agronomia" },
	{ value: "68", label: "Conselho regional de estatística" },
	{ value: "71", label: "Conselho regional de medicina" },
	{ value: "72", label: "Conselho regional de medicina veterinária" },
	{ value: "73", label: "Ordem dos músicos do brasil" },
	{ value: "75", label: "Conselho regional de odontologia" },
	{
		value: "76",
		label: "Conselho regional de profissionais de relações públicas",
	},
	{ value: "80", label: "Ordem dos advogados do brasil" },
	{ value: "84", label: "Conselho regional de economia" },
	{ value: "85", label: "Conselho regional de economia doméstica" },
	{ value: "86", label: "Conselho regional do museólogo" },
	{ value: "87", label: "Conselho regional dos jornalistas" },
	{ value: "89", label: "Conselho de arquitetura e urbanismo do brasil" },
	{
		value: "93",
		label: "Outro tipo de órgão emissor de carteira funcional",
	},
	{ value: "96", label: "Ministério da aeronáutica – cf" },
	{ value: "97", label: "Ministério do exército – cf" },
	{ value: "98", label: "Ministério da marinha – cf" },
];

const docArmyOptions = [
	{ value: "41", label: "Ministério da Aeronáutica" },
	{ value: "42", label: "Ministério do Exército" },
	{ value: "43", label: "Ministério da Marinha" },
	{
		value: "92",
		label: "Outro tipo de órgão emissor de identidade militar",
	},
];

const msOptions = [
	{ value: "1", label: "Solteiro(a)" },
	{ value: "3", label: "Divorciado(a)" },
	{ value: "4", label: "Separado (a) judicialmente" },
	{ value: "5", label: "Viuvo(a)" },
	{ value: "7", label: "Casado(a) Com comunhão total de bens" },
	{ value: "8", label: "Casado(a) com separação de Bens" },
	{ value: "9", label: "Casado(a) com comunhão parcial de bens" },
];

const occupationTypeOptions = [
	{ value: "01", label: "Formal" },
	{ value: "02", label: "Informal" },
];

const iOccupationOptions = [
	{ value: "187689", label: "ACOUGUEIRO" },
	{ value: "72980821", label: "ACUPUNTURISTA" },
	{ value: "72981095", label: "ADESTRADOR DE ANIMAIS" },
	{ value: "72981131", label: "ADMINISTRADOR" },
	{ value: "518729", label: "ADVOGADO" },
	{ value: "72981142", label: "AFIADOR" },
	{ value: "187690", label: "AGRICULTOR" },
	{ value: "551315", label: "AGRONOMO" },
	{ value: "72981148", label: "ALAMBIQUEIRO" },
	{ value: "187691", label: "ALFAIATE" },
	{ value: "547893", label: "ANALISTA DE SISTEMA" },
	{ value: "530056", label: "ARQUITETO" },
	{ value: "72981171", label: "ARTISTA DE CIRCO" },
	{ value: "594629", label: "ARTISTA DE DANÇA" },
	{ value: "187694", label: "ARTISTA VISUAL" },
	{ value: "72981178", label: "ASTROLOGO E NUMEROLOGO" },
	{ value: "2885158", label: "ATIVIDADES RELIGIOSAS" },
	{ value: "72981183", label: "ATLETA" },
	{ value: "594534", label: "ATOR" },
	{ value: "187698", label: "AUXILIAR GERAL" },
	{ value: "187699", label: "BABA" },
	{ value: "187702", label: "BARBEIRO" },
	{ value: "72981223", label: "BIOLOGO" },
	{ value: "72981229", label: "BIOMEDICO" },
	{ value: "187704", label: "BORDADOR" },
	{ value: "187705", label: "BORRACHEIRO" },
	{ value: "187708", label: "CABELEIREIRO(A)" },
	{ value: "551327", label: "CAMAREIRO(A)" },
	{ value: "187731", label: "CAMINHONEIRO AUTONOMO" },
	{ value: "551340", label: "CANTOR(A)" },
	{ value: "187710", label: "CARPINTEIRO" },
	{ value: "72981250", label: "CARREGADOR DE MERCADORIAS" },
	{ value: "187711", label: "CARROCEIRO" },
	{ value: "594226", label: "CARTOGRAFO" },
	{ value: "72981272", label: "CATADORES DE MATERIAL RECICLAVEL" },
	{ value: "72981281", label: "CERAMISTA" },
	{ value: "72981292", label: "CHAVEIRO" },
	{ value: "187712", label: "COBRADOR" },
	{ value: "594564", label: "COMENTARISTA DE RADIO E TELEVISAO" },
	{ value: "594668", label: "COMPOSITOR" },
	{ value: "187713", label: "CONFEITEIRO(A)" },
	{
		value: "594320",
		label: "CONSERTADOR DE APARELHO ELETRONICO ELETRODOMESTICO",
	},
	{ value: "548201", label: "CONSULTOR" },
	{ value: "530063", label: "CONTADOR" },
	{ value: "187714", label: "CORRETOR" },
	{ value: "187715", label: "COSTUREIRO(A)" },
	{ value: "187717", label: "COZINHEIRO(A)" },
	{ value: "72981314", label: "CROCHETEIRO A MAO" },
	{ value: "72981330", label: "CUIDADOR DE IDOSOS" },
	{ value: "187718", label: "DECORADOR(A)" },
	{ value: "187719", label: "DEDETIZADOR" },
	{ value: "701108", label: "DEPOSITOS PCI PAI" },
	{ value: "908743", label: "DESENHISTA" },
	{ value: "187720", label: "DESPACHANTE" },
	{ value: "187722", label: "DIGITADOR" },
	{ value: "551380", label: "ECONOMISTA" },
	{ value: "187724", label: "ELETRICISTA" },
	{ value: "187703", label: "ENCANADOR" },
	{ value: "187725", label: "ENFERMEIRO(A)" },
	{ value: "518730", label: "ENGENHEIRO" },
	{ value: "72981341", label: "ENGRAXATE" },
	{ value: "72981358", label: "ESOTERICO E PARANORMAL" },
	{ value: "72981345", label: "ESTETICISTA" },
	{ value: "187726", label: "ESTOFADOR" },
	{ value: "72981429", label: "EXTRATIVISTA" },
	{ value: "72981434", label: "FARMACEUTICO" },
	{ value: "187727", label: "FAXINEIRO(A)" },
	{ value: "187728", label: "FEIRANTE" },
	{ value: "784603", label: "FISIOTERAPEUTA" },
	{ value: "551383", label: "FONAUDIOLOGO" },
	{ value: "187730", label: "FOTOGRAFO(A)" },
	{ value: "187737", label: "FUNILEIRO" },
	{ value: "72981475", label: "GANDULA" },
	{ value: "187733", label: "GARCOM GARCONETE" },
	{ value: "578245", label: "GEOLOGO" },
	{ value: "72981490", label: "GESSEIRO" },
	{ value: "72981506", label: "GUARDADOR DE VEÍCULOS (FLANELINHA)" },
	{ value: "187735", label: "GUIA DE TURISMO" },
	{ value: "72981528", label: "INTERPRETE" },
	{ value: "187736", label: "JARDINEIRO" },
	{ value: "72981549", label: "JOALHEIRO E OURIVES" },
	{ value: "72981563", label: "JORNALEIRO" },
	{ value: "551392", label: "JORNALISTA" },
	{ value: "72981582", label: "LADRILHEIRO" },
	{ value: "187738", label: "LAVADOR DE VEÍCULOS" },
	{ value: "72981593", label: "LAVADOR E PASSADOR DE ROUPAS" },
	{ value: "72981607", label: "LIMPADOR DE FACHADAS" },
	{ value: "187741", label: "MANICURE, PEDICURE" },
	{ value: "72981611", label: "MANOBRISTA" },
	{ value: "187742", label: "MAQUIADOR" },
	{ value: "187745", label: "MARCENEIRO" },
	{ value: "72981622", label: "MASSAGISTA" },
	{ value: "187746", label: "MECÂNICO" },
	{ value: "72981634", label: "MINHOCULTOR" },
	{ value: "578459", label: "MODELO." },
	{ value: "72981649", label: "MONTADOR DE MÓVEIS" },
	{ value: "187747", label: "MOTOBOY" },
	{ value: "187748", label: "MOTORISTA" },
	{ value: "532571", label: "MUSICO" },
	{ value: "530049", label: "MÉDICO" },
	{ value: "552102", label: "NUTRICIONISTA" },
	{ value: "532818", label: "ODONTOLOGO" },
	{ value: "72981662", label: "OLEIRO (FAB TELHAS E TIJOLOS)" },
	{ value: "594234", label: "OPERADOR DE CÂMERA" },
	{ value: "187749", label: "PADEIRO" },
	{ value: "187750", label: "PECUARISTA" },
	{ value: "187751", label: "PEDREIRO" },
	{ value: "559587", label: "PENSÃO INFORMAL" },
	{ value: "188540", label: "PESCADOR." },
	{ value: "187753", label: "PESQUISADOR" },
	{ value: "85635245", label: "PILOTO DE AERONAVE" },
	{ value: "187754", label: "PINTOR" },
	{ value: "72981675", label: "PIPOQUEIRO" },
	{ value: "72981687", label: "PODÓLOGO" },
	{ value: "72981697", label: "POETA" },
	{ value: "187755", label: "PORTEIRO, VIGIA" },
	{ value: "531800", label: "PROFESSOR" },
	{ value: "72981710", label: "PROFISSIONAL DO SEXO" },
	{ value: "532425", label: "PROGRAMADOR" },
	{ value: "594222", label: "PROMOTOR DE EVENTOS" },
	{ value: "2604654", label: "PROTÉTICO" },
	{ value: "551534", label: "PSICÓLOGO" },
	{ value: "551586", label: "PUBLICITÁRIO" },
	{ value: "72981722", label: "QUIROPRAXISTA" },
	{ value: "72981731", label: "RAIZEIRO" },
	{ value: "187756", label: "RELOJOEIRO" },
	{ value: "187759", label: "REPRESETANTE COMERCIAL" },
	{ value: "187783", label: "SACOLEIRA" },
	{ value: "72981740", label: "SALVA-VIDAS" },
	{ value: "187785", label: "SAPATEIRO" },
	{ value: "187788", label: "SERRALHEIRO" },
	{ value: "187789", label: "SERVENTE DE OBRAS" },
	{ value: "187791", label: "SERVIÇOS GERAIS" },
	{ value: "582532", label: "SOCIO DE EMPRESA" },
	{ value: "72981890", label: "SOLDADOR" },
	{ value: "187792", label: "TAXISTA" },
	{ value: "72981899", label: "TELHADOR" },
	{ value: "784607", label: "TOPÓGRAFO" },
	{ value: "187721", label: "TRABALHADOR DOMÉSTICO" },
	{ value: "187695", label: "TRABALHADOR RURAL" },
	{ value: "72981910", label: "TRADUTOR" },
	{ value: "187793", label: "TRATORISTA" },
	{ value: "72981922", label: "VASSOUREIRO" },
	{ value: "187692", label: "VENDEDOR (DOMICÍLIO, AMBULANTES, BANCAS)" },
	{ value: "552310", label: "VETERINÁRIO" },
	{ value: "72981927", label: "VIDRACEIRO" },
	{ value: "187787", label: "VIGILANTE E GUARDA DE SEGURANÇA" },
	{ value: "187796", label: "ZELADOR" },
	{ value: "72981936", label: "ZOOTECNISTA" },
];

export function findAgency(agencyCode: string) {
	const optionAgency = agenciaOptions.find(
		(agencia) => agencia.value === agencyCode,
	);
	return optionAgency;
}

export function findAgencyLocal(localCode: string) {
	const optionLocal = munOptions.find((mun) => mun.value === localCode);
	return optionLocal;
}

const fOccupationOptions = [
	{ value: "125", label: "ADMINISTRADOR" },
	{ value: "131", label: "ADVOGADO" },
	{ value: "405", label: "AGENCIADOR DE PROPAGANDA" },
	{ value: "292", label: "AGENTE ADMINISTRATIVO" },
	{ value: "595", label: "AGENTE DE SERVICOS FUNERARIOS E EMBALSAMADOR" },
	{ value: "594", label: "AGENTE DE VIAGEM E GUIA DE TURISMO" },
	{ value: "103", label: "AGRONOMO" },
	{ value: "591", label: "ALFAIATE" },
	{ value: "126", label: "ANALISTA DE SISTEMAS" },
	{ value: "923", label: "APOSENTADO EXCETO FUNCIONARIO PUBLICO" },
	{ value: "102", label: "ARQUITETO" },
	{ value: "134", label: "ASSISTENTE SOCIAL" },
	{ value: "128", label: "ASTRONOMO E METEOROLOGISTA" },
	{ value: "168", label: "ATLETA PROFISSIONAL E TECNICO EM DESPORTOS" },
	{ value: "162", label: "ATOR E DIRETOR DE ESPETACULOS PUBLICOS" },
	{ value: "123", label: "ATUARIO E MATEMATICO" },
	{ value: "394", label: "AUXILIAR DE ESCRITORIO E ASSEMELHADOS" },
	{ value: "596", label: "AUXILIAR DE LABORATORIO" },
	{ value: "395", label: "BANCARIO E ECONOMIARIO" },
	{
		value: "135",
		label: "BIBLIOTECARIO ARQUIVISTA MUSEOLOGO E ARQUEOLOGO",
	},
	{ value: "116", label: "BIOLOGO E BIOMEDICO" },
	{ value: "931", label: "BOLSISTA ESTAGIARIO E ASSEMELHADOS" },
	{
		value: "544",
		label: "BOMBEIRO E INSTALADOR DE GAS AGUA ESGOTO E ASSEMELHADOS",
	},
	{
		value: "511",
		label: "CABELEIREIRO BARBEIRO MANICURE PEDICURE MAQUILADOR ESTETICISTA E MASSAGISTA",
	},
	{ value: "163", label: "CANTOR E COMPOSITOR" },
	{
		value: "907",
		label: "CAPITALISTA RECEBENDO RENDIMENTO DE APLICACAO DE CAPITAL EM ATIVOS FINANCEIROS",
	},
	{ value: "391", label: "CHEFE INTERMEDIARIO" },
	{ value: "183", label: "COMANDANTE DE EMBARCACOES" },
	{ value: "182", label: "COMISSARIO DE BORDO" },
	{ value: "136", label: "COMUNICOLOGO" },
	{ value: "124", label: "CONTADOR" },
	{ value: "533", label: "CONTRAMESTRE DE EMBARCACOES" },
	{ value: "165", label: "COREOGRAFO E BAILARINO" },
	{
		value: "403",
		label: "CORRETOR DE IMOVEIS, SEGUROS, TITULOS E VALORES",
	},
	{ value: "193", label: "DECORADOR" },
	{ value: "214", label: "DELEGADO DE POLICIA" },
	{ value: "491", label: "DEMONSTRADOR" },
	{ value: "192", label: "DESENHISTA COMERCIAL" },
	{ value: "105", label: "DESENHISTA INDUSTRIAL" },
	{ value: "158", label: "DESENHISTA TECNICO" },
	{ value: "593", label: "DESPACHANTE INCLUSIVE O ADUANEIRO" },
	{ value: "212", label: "DIPLOMATA" },
	{ value: "301", label: "DIRETOR DE EMPRESAS" },
	{ value: "144", label: "DIRETOR DE ESTABELECIMENTO DE ENSINO" },
	{ value: "121", label: "ECONOMISTA" },
	{ value: "703", label: "ELETRICISTA E ASSEMELHADOS" },
	{
		value: "542",
		label: "ELETRICISTA MANUTENCAO VEICULO AUTO MAQ APARELHOS ELETRICO ELETRONICO E TELECOM",
	},
	{ value: "598", label: "EMPREGADO DOMESTICO" },
	{ value: "161", label: "EMPRESARIO E PRODUTOR DE ESPETACULOS PUBLICOS" },
	{ value: "113", label: "ENFERMEIRO E NUTRICIONISTA" },
	{ value: "101", label: "ENGENHEIRO" },
	{ value: "191", label: "ESCULTOR, PINTOR E ASSEMELHADOS" },
	{ value: "949", label: "ESPOLIO" },
	{ value: "122", label: "ESTATISTICO" },
	{ value: "597", label: "ESTIVADOR CARREGADOR EMBALADOR E ASSEMELHADOS" },
	{ value: "117", label: "FARMACEUTICO" },
	{ value: "413", label: "FEIRANTE" },
	{ value: "213", label: "FISCAL" },
	{ value: "106", label: "FISICO" },
	{ value: "114", label: "FISIOTERAPEUTA E TERAPEUTA OCUPACIONAL" },
	{ value: "118", label: "FONOAUDIOLOGO" },
	{ value: "922", label: "FUNCIONARIO PUBLICO CIVIL APOSENTADO" },
	{ value: "605", label: "GARIMPEIRO" },
	{ value: "127", label: "GEOGRAFO" },
	{ value: "107", label: "GEOLOGO" },
	{ value: "303", label: "GERENTE" },
	{
		value: "521",
		label: "GOVERNANTA DE HOTEL CAMAREIRO PORTEIRO COZINHEIRO E GARCOM",
	},
	{ value: "717", label: "JOALHEIROS E OURIVES" },
	{ value: "412", label: "JORNALEIRO" },
	{ value: "171", label: "JORNALISTA" },
	{ value: "543", label: "LANTERNEIRO E PINTOR DE VEICULOS METALICOS" },
	{ value: "404", label: "LEILOEIRO, AVALIADOR E ASSEMELHADOS" },
	{
		value: "166",
		label: "LOCUTOR E COMENTARISTA DE RADIO E TELEVISAO E RADIALISTA",
	},
	{
		value: "535",
		label: "MAQUINISTA E FOGUISTA DE EMBARCACOES, LOCOMOTIVAS E ASSEMELH",
	},
	{ value: "534", label: "MARINHEIRO E ASSEMELHADOS" },
	{
		value: "541",
		label: "MECANICO DE MANUTENCAO DE VEICULOS AUTOMOTORES E MAQUINAS",
	},
	{
		value: "702",
		label: "MECANICO MANUTENCAO MONTADOR PREPARADOR OPERADOR DE MAQ E APARELHOS PROD INDUST",
	},
	{ value: "111", label: "MEDICO" },
	{ value: "701", label: "MESTRE E CONTRAMESTRE" },
	{ value: "295", label: "MILITAR EM GERAL" },
	{ value: "921", label: "MILITAR REFORMADO" },
	{ value: "492", label: "MODELO DE MODAS" },
	{ value: "532", label: "MOTORISTA DE VEICULOS DE TRANSPORTE DE CARGA" },
	{
		value: "531",
		label: "MOTORISTA DE VEICULOS DE TRANSPORTE DE PASSAGEIROS",
	},
	{ value: "164", label: "MUSICO" },
	{
		value: "291",
		label: "OCUPANTE DE CARGO DE DIRECAO E ASSESSORAMENTO INTERMEDIARIO",
	},
	{
		value: "215",
		label: "OCUPANTE DE CARGO DE DIRECAO E ASSESSORAMENTO SUPERIOR",
	},
	{ value: "115", label: "ODONTOLOGO" },
	{
		value: "216",
		label: "OFICIAIS DAS FORCAS ARMADAS E FORCAS AUXILIARES",
	},
	{ value: "167", label: "OPERADOR DE CAMERAS DE CINEMA E TELEVISAO" },
	{
		value: "145",
		label: "OUTROS TRABALHADORES DE NIVEL SUPERIOR LIGADOS AO ENSINO",
	},
	{ value: "924", label: "PENSIONISTA" },
	{ value: "181", label: "PILOTO DE AERONAVES" },
	{
		value: "203",
		label: "PODER EXECUTIVO PRESIDENTE MINISTRO GOVERNADOR SECRETARIO E MEMBROS DO MP",
	},
	{
		value: "205",
		label: "PODER JUDICIARIO MINISTRO DE TRIBUNAL SUPERIOR DESEMBARGADOR E JUIZ",
	},
	{
		value: "201",
		label: "PODER LEGISLATIVO SENADOR DEPUTADO FEDERAL DEPUTADO ESTADUAL E VEREADOR",
	},
	{
		value: "501",
		label: "PORTEIRO DE EDIFICIO ASCENSORISTA GARAGISTA E FAXINEIRO",
	},
	{ value: "211", label: "PROCURADOR E ASSEMELHADOS" },
	{
		value: "143",
		label: "PROFESSORES DE ENSINO DE PRIMEIRO E SEGUNDO GRAUS",
	},
	{ value: "142", label: "PROFESSORES DE ENSINO SUPERIOR" },
	{ value: "456", label: "PROFISSAO CRIADA PARA TESTE" },
	{ value: "138", label: "PROFISSIONAIS DE LETRAS E DE ARTES" },
	{
		value: "901",
		label: "PROPRIETARIO DE ESTABELECIMENTO AGRICOLA DA PECUARIA FLORESTAL",
	},
	{ value: "902", label: "PROPRIETARIO DE ESTABELECIMENTO COMERCIAL" },
	{
		value: "904",
		label: "PROPRIETARIO DE ESTABELECIMENTO DE PRESTACAO DE SERVICOS",
	},
	{ value: "903", label: "PROPRIETARIO DE ESTABELECIMENTO INDUSTRIAL" },
	{
		value: "906",
		label: "PROPRIETARIO DE IMOVEL, RECEBENDO RENDIMENTO DE ALUGUEL",
	},
	{ value: "905", label: "PROPRIETARIO DE MICROEMPRESA" },
	{ value: "592", label: "PROTETICO" },
	{ value: "132", label: "PSICOLOGO" },
	{ value: "172", label: "PUBLICITARIO" },
	{ value: "104", label: "QUIMICO" },
	{ value: "137", label: "RELACOES PUBLICAS" },
	{
		value: "910",
		label: "SACERDOTES OU MEMBROS DE ORDENS OU SEITAS RELIGIOSAS",
	},
	{
		value: "393",
		label: "SECRETARIO ESTENOGRAFO DATILOGRAFO RECEPCIONISTA TELEFONISTA E ASSEMELHADOS",
	},
	{ value: "396", label: "SECURITARIO" },
	{ value: "293", label: "SERVENTUARIO DE JUSTICA" },
	{ value: "297", label: "SERVIDOR PUBLICO ESTADUAL" },
	{ value: "296", label: "SERVIDOR PUBLICO FEDERAL" },
	{ value: "298", label: "SERVIDOR PUBLICO MUNICIPAL" },
	{ value: "133", label: "SOCIOLOGO" },
	{
		value: "401",
		label: "SUPERVISOR, INSPETOR E AGENTE DE COMPRAS E VENDAS",
	},
	{ value: "294", label: "TABELIAO" },
	{ value: "152", label: "TECNICO DE BIOLOGIA" },
	{ value: "151", label: "TECNICO DE CONTABILIDADE E DE ESTATISTICA" },
	{
		value: "156",
		label: "TECNICO DE ELETRICIDADE, ELETRONICA E TELECOMUNICACOES",
	},
	{ value: "157", label: "TECNICO DE LABORATORIO E RAIO X" },
	{ value: "155", label: "TECNICO DE MECANICA" },
	{ value: "154", label: "TECNICO DE QUIMICA" },
	{ value: "153", label: "TECNICO EM AGRONOMIA E AGRIMENSURA" },
	{ value: "108", label: "TECNOLOGO" },
	{ value: "601", label: "TRABALHADOR AGRICOLA" },
	{ value: "602", label: "TRABALHADOR DA PECUARIA" },
	{ value: "604", label: "TRABALHADOR DA PESCA" },
	{ value: "711", label: "TRABALHADOR DE ARTES GRAFICAS" },
	{ value: "709", label: "TRABALHADOR DE CONSTRUCAO CIVIL" },
	{
		value: "713",
		label: "TRABALHADOR DE FABRICACAO DE ARTEFATOS DE MADEIRA",
	},
	{
		value: "715",
		label: "TRABALHADOR DE FABRICACAO DE CALCADOS E ARTEFATOS DE COURO",
	},
	{ value: "714", label: "TRABALHADOR DE FABRICACAO DE PAPEL E PAPELAO" },
	{
		value: "716",
		label: "TRABALHADOR DE FABRICACAO DE PRODUTOS DE BORRACHA E PLASTICO",
	},
	{
		value: "712",
		label: "TRABALHADOR DE FABRICACAO DE PRODUTOS TEXTEIS EXCETO ROUPAS",
	},
	{ value: "705", label: "TRABALHADOR DE FABRICACAO DE ROUPAS" },
	{
		value: "710",
		label: "TRABALHADOR DE FABRICACAO E PREPARACAO DE ALIMENTOS E BEBIDA",
	},
	{
		value: "704",
		label: "TRABALHADOR DE INSTALACOES DE PROCESSAMENTO QUIMICO",
	},
	{
		value: "706",
		label: "TRABALHADOR DE TRATAMENTO DE FUMO E DE FABRICACAO DE CIGARROS E CHARUTOS",
	},
	{ value: "708", label: "TRABALHADOR DE USINAGEM DE METAIS" },
	{
		value: "392",
		label: "TRABALHADOR DOS SERVICOS DE CONTABILIDADE DE CAIXA E TRABALHADORES ASSEMELHADOS",
	},
	{ value: "603", label: "TRABALHADOR FLORESTAL" },
	{ value: "707", label: "TRABALHADOR METALURGICO E SIDERURGICO" },
	{
		value: "517",
		label: "TRABALHADORES DOS SERVICOS DE PROTECAO E SEGURANCA EXCETO MILITAR",
	},
	{ value: "411", label: "VENDEDOR DE COMERCIO VAREJISTA E ATACADISTA" },
	{
		value: "402",
		label: "VENDEDOR PRACISTA REPRESENTANTE COMERCIAL CAIXEIRO VIAJANTE E ASSEMELHADOS",
	},
	{ value: "112", label: "VETERINARIO E ZOOTECNISTA" },
];

const incType = [
	{ value: "1", label: "Fisica" },
	{ value: "2", label: "Juridica" },
];

const caracRenda = [
	{ value: "6", label: "Comprovada" },
	{ value: "2", label: "Sem renda" },
];

const docsIncProof = [
	{ value: "65220851", label: "Comprovante de recebimento no exterior" },
	{ value: "64522009", label: "Contracheque/Holerite" },
	{ value: "64522097", label: "Contrato de aluguel" },
	{ value: "64522120", label: "Contrato de estágio" },
	{ value: "64524568", label: "Declaração de imposto de renda" },
	{ value: "64522404", label: "Declaração empregador/previdenciária" },
	{ value: "64524328", label: "DECORE" },
	{ value: "64522451", label: "DECORE c/ DARF" },
	{ value: "64522484", label: "Extrato aplicacão financeira/poupança" },
	{ value: "64522568", label: "Extrato de benefício previdenciário" },
	{ value: "64522614", label: "Extrato de conta salário/aposentadoria" },
	{ value: "64522635", label: "Extrato de FGTS" },
	{ value: "64522681", label: "Notas fiscais de vendas (Atividade rural)" },
	{ value: "65129926", label: "Recibo pagamento autonomo (RPA)" },
	{ value: "65129980", label: "Recolhimento ISS" },
	{ value: "65130033", label: "Sentença judicial" },
];

const ppOptions = [
	{ value: "ACA", label: "ACAMPAMENTO" },
	{ value: "AC ", label: "ACESSO" },
	{ value: "ACL", label: "ACESSO LOCAL" },
	{ value: "AD ", label: "ADRO" },
	{ value: "AER", label: "AEROPORTO" },
	{ value: "AL ", label: "ALAMEDA" },
	{ value: "AT ", label: "ALTO" },
	{ value: "ANT", label: "ANTIGA ESTRADA" },
	{ value: "A  ", label: "ÁREA" },
	{ value: "AE ", label: "ÁREA ESPECIAL" },
	{ value: "ART", label: "ARTERIA" },
	{ value: "ATL", label: "ATALHO" },
	{ value: "AV ", label: "AVENIDA" },
	{ value: "AVC", label: "AVENIDA CONTORN" },
	{ value: "AVM", label: "AVENIDA MARGDIR" },
	{ value: "AME", label: "AVENIDA MARGESQ" },
	{ value: "AMD", label: "AVENIDA MARGINA" },
	{ value: "AVV", label: "AVENIDA VELHA" },
	{ value: "BX ", label: "BAIXA" },
	{ value: "BLO", label: "BALÃO" },
	{ value: "BAL", label: "BALNEÁRIO" },
	{ value: "BC ", label: "BECO" },
	{ value: "BEL", label: "BELVEDERE" },
	{ value: "BL ", label: "BLOCO" },
	{ value: "BLS", label: "BLOCOS" },
	{ value: "BSQ", label: "BOSQUE" },
	{ value: "BVD", label: "BOULEVARD" },
	{ value: "BLV", label: "BULEVAR" },
	{ value: "BCO", label: "BURACO" },
	{ value: "C  ", label: "CAIS" },
	{ value: "CAL", label: "CALCADA" },
	{ value: "CAM", label: "CAMINHO" },
	{ value: "CPO", label: "CAMPO" },
	{ value: "CAN", label: "CANAL" },
	{ value: "CH ", label: "CHACARA" },
	{ value: "CHA", label: "CHAPADAO" },
	{ value: "CIC", label: "CICLOVIA" },
	{ value: "CIR", label: "CIRCULAR" },
	{ value: "COL", label: "COLONIA" },
	{ value: "CMP", label: "COMPLEXO VIARIO" },
	{ value: "CON", label: "CONDOMINIO" },
	{ value: "CJ ", label: "CONJUNTO" },
	{ value: "CJM", label: "CONJUNTO MUTIRA" },
	{ value: "CTN", label: "CONTORNO" },
	{ value: "COR", label: "CORREDOR" },
	{ value: "CRG", label: "CORREGO" },
	{ value: "DSC", label: "DESCIDA" },
	{ value: "DSV", label: "DESVIO" },
	{ value: "DT ", label: "DISTRITO" },
	{ value: "EVD", label: "ELEVADA" },
	{ value: "ENT", label: "ENTRADA PARTICU" },
	{ value: "EQ ", label: "ENTRE QUADRA" },
	{ value: "ESC", label: "ESCADA" },
	{ value: "ESD", label: "ESCADARIA" },
	{ value: "ESP", label: "ESPLANADA" },
	{ value: "ETC", label: "ESTACAO" },
	{ value: "ETT", label: "ESTACIONAMENTO" },
	{ value: "ETD", label: "ESTADIO" },
	{ value: "ETN", label: "ESTANCIA" },
	{ value: "EST", label: "ESTRADA" },
	{ value: "ETA", label: "ESTRADA ANTIGA" },
	{ value: "ESL", label: "ESTRADA DE LIGA" },
	{ value: "ESE", label: "ESTRADA ESTADUA" },
	{ value: "ESM", label: "ESTRADA MUNICIP" },
	{ value: "ETP", label: "ESTRADA PARTICU" },
	{ value: "ESV", label: "ESTRADA VELHA" },
	{ value: "FAV", label: "FAVELA" },
	{ value: "FAZ", label: "FAZENDA" },
	{ value: "FRA", label: "FEIRA" },
	{ value: "FER", label: "FERROVIA" },
	{ value: "FNT", label: "FONTE" },
	{ value: "FTE", label: "FORTE" },
	{ value: "GAL", label: "GALERIA" },
	{ value: "GJA", label: "GRANJA" },
	{ value: "HAB", label: "HABITACIONAL" },
	{ value: "IA ", label: "ILHA" },
	{ value: "JD ", label: "JARDIM" },
	{ value: "JDE", label: "JARDINETE" },
	{ value: "LD ", label: "LADEIRA" },
	{ value: "LG ", label: "LAGO" },
	{ value: "LGA", label: "LAGOA" },
	{ value: "LRG", label: "LARGO" },
	{ value: "LOT", label: "LOTEAMENTO" },
	{ value: "MNA", label: "MARINA" },
	{ value: "MOD", label: "MÓDULO" },
	{ value: "MTE", label: "MONTE" },
	{ value: "MRO", label: "MORRO" },
	{ value: "NUC", label: "NÚCLEO" },
	{ value: "PDA", label: "PARADA" },
	{ value: "PDO", label: "PARADOURO" },
	{ value: "PAR", label: "PARALELA" },
	{ value: "PRQ", label: "PARQUE" },
	{ value: "PRM", label: "PARQUE MUNICIPA" },
	{ value: "PRR", label: "PARQUE RESIDÊNC" },
	{ value: "PSG", label: "PASSAGEM" },
	{ value: "PSP", label: "PASSAGEM DE PED" },
	{ value: "PSS", label: "PASSAGEM SUBTER" },
	{ value: "PSA", label: "PASSARELA" },
	{ value: "PAS", label: "PASSEIO" },
	{ value: "PAT", label: "PATIO" },
	{ value: "PNT", label: "PONTA" },
	{ value: "PTE", label: "PONTE" },
	{ value: "PTO", label: "PORTO" },
	{ value: "PC ", label: "PRACA" },
	{ value: "PCE", label: "PRAÇA DE ESPORT" },
	{ value: "PR ", label: "PRAIA" },
	{ value: "1AL", label: "PRIMEIRA LADEIR" },
	{ value: "PRL", label: "PROLONGAMENTO" },
	{ value: "Q  ", label: "QUADRA" },
	{ value: "4AL", label: "QUARTA LADEIRA" },
	{ value: "QTA", label: "QUINTA" },
	{ value: "5AL", label: "QUINTA LADEIRA" },
	{ value: "QTS", label: "QUINTAS" },
	{ value: "RAM", label: "RAMAL" },
	{ value: "RMP", label: "RAMPA" },
	{ value: "REC", label: "RECANTO" },
	{ value: "RCR", label: "RECREIO" },
	{ value: "RES", label: "RESIDENCIAL" },
	{ value: "RET", label: "RETA" },
	{ value: "RER", label: "RETIRO" },
	{ value: "RTN", label: "RETORNO" },
	{ value: "ROA", label: "RODO ANEL" },
	{ value: "ROD", label: "RODOVIA" },
	{ value: "RTT", label: "ROTATORIA" },
	{ value: "ROT", label: "RÓTULA" },
	{ value: "R  ", label: "RUA" },
	{ value: "R L", label: "RUA DE LIGAÇÃO" },
	{ value: "RPE", label: "RUA DE PEDESTRE" },
	{ value: "R I", label: "RUA INTEGRAÇÃO" },
	{ value: "R P", label: "RUA PARTICULAR" },
	{ value: "R V", label: "RUA VELHA" },
	{ value: "2AL", label: "SEGUNDA LADEIRA" },
	{ value: "SRV", label: "SERVIDÃO" },
	{ value: "ST ", label: "SETOR" },
	{ value: "SIT", label: "SÍTIO" },
	{ value: "SUB", label: "SUBIDA" },
	{ value: "3AL", label: "TERCEIRA LADEIR" },
	{ value: "TER", label: "TERMINAL" },
	{ value: "TV ", label: "TRAVESSA" },
	{ value: "TVP", label: "TRAVESSA PARTIC" },
	{ value: "TVV", label: "TRAVESSA VELHA" },
	{ value: "TR ", label: "TRECHO" },
	{ value: "TRV", label: "TREVO" },
	{ value: "TCH", label: "TRINCHEIRA" },
	{ value: "TUN", label: "TUNEL" },
	{ value: "UNI", label: "UNIDADE" },
	{ value: "VAL", label: "VALA" },
	{ value: "VLE", label: "VALE" },
	{ value: "VRT", label: "VARIANTE" },
	{ value: "VER", label: "VEREDA" },
	{ value: "V  ", label: "VIA" },
	{ value: "V C", label: "VIA COLETORA" },
	{ value: "VAC", label: "VIA DE ACESSO" },
	{ value: "VPE", label: "VIA DE PEDESTRE" },
	{ value: "VEV", label: "VIA ELEVADO" },
	{ value: "V-E", label: "VIA EXPRESSA" },
	{ value: "VLT", label: "VIA LITORANEA" },
	{ value: "V L", label: "VIA LOCAL" },
	{ value: "VD ", label: "VIADUTO" },
	{ value: "VLA", label: "VIELA" },
	{ value: "VL ", label: "VILA" },
	{ value: "ZIG", label: "ZIGUE-ZAGUE" },
	{ value: "1A ", label: "1A AVENIDA" },
	{ value: "1PA", label: "1A PARALELA" },
	{ value: "1R ", label: "1A RUA" },
	{ value: "1SU", label: "1A SUBIDA" },
	{ value: "1TV", label: "1A TRAVESSA" },
	{ value: "1VL", label: "1A VILA" },
	{ value: "1AT", label: "1O ALTO" },
	{ value: "1BC", label: "1O BECO" },
	{ value: "1PR", label: "1O PARQUE" },
	{ value: "10R", label: "10A RUA" },
	{ value: "10T", label: "10A TRAVESSA" },
	{ value: "11R", label: "11A RUA" },
	{ value: "11T", label: "11A TRAVESSA" },
	{ value: "12R", label: "12A RUA" },
	{ value: "12T", label: "12A TRAVESSA" },
	{ value: "13T", label: "13A TRAVESSA" },
	{ value: "14T", label: "14A TRAVESSA" },
	{ value: "15T", label: "15A TRAVESSA" },
	{ value: "16T", label: "16A TRAVESSA" },
	{ value: "18A", label: "18A TRAVESSA" },
	{ value: "19A", label: "19A TRAVESSA" },
	{ value: "2A ", label: "2A AVENIDA" },
	{ value: "2PA", label: "2A PARALELA" },
	{ value: "2R ", label: "2A RUA" },
	{ value: "2SU", label: "2A SUBIDA" },
	{ value: "2TV", label: "2A TRAVESSA" },
	{ value: "2VL", label: "2A VILA" },
	{ value: "2AT", label: "2O ALTO" },
	{ value: "2BC", label: "2O BECO" },
	{ value: "2PR", label: "2O PARQUE" },
	{ value: "3A ", label: "3A AVENIDA" },
	{ value: "3PA", label: "3A PARALELA" },
	{ value: "3R ", label: "3A RUA" },
	{ value: "3SU", label: "3A SUBIDA" },
	{ value: "3TV", label: "3A TRAVESSA" },
	{ value: "3VL", label: "3A VILA" },
	{ value: "3AT", label: "3O ALTO" },
	{ value: "3BC", label: "3O BECO" },
	{ value: "3PR", label: "3O PARQUE" },
	{ value: "4A ", label: "4A AVENIDA" },
	{ value: "4PA", label: "4A PARALELA" },
	{ value: "4R ", label: "4A RUA" },
	{ value: "4SU", label: "4A SUBIDA" },
	{ value: "4TV", label: "4A TRAVESSA" },
	{ value: "4VL", label: "4A VILA" },
	{ value: "4AT", label: "4O ALTO" },
	{ value: "4BC", label: "4O BECO" },
	{ value: "5A ", label: "5A AVENIDA" },
	{ value: "5PA", label: "5A PARALELA" },
	{ value: "5R ", label: "5A RUA" },
	{ value: "5SU", label: "5A SUBIDA" },
	{ value: "5TV", label: "5A TRAVESSA" },
	{ value: "5VL", label: "5A VILA" },
	{ value: "5AT", label: "5O ALTO" },
	{ value: "5BC", label: "5O BECO" },
	{ value: "6AV", label: "6A AVENIDA" },
	{ value: "6R ", label: "6A RUA" },
	{ value: "6SU", label: "6A SUBIDA" },
	{ value: "6TV", label: "6A TRAVESSA" },
	{ value: "7R ", label: "7A RUA" },
	{ value: "7TV", label: "7A TRAVESSA" },
	{ value: "8R ", label: "8A RUA" },
	{ value: "8TV", label: "8A TRAVESSA" },
	{ value: "9R ", label: "9A RUA" },
	{ value: "9TV", label: "9A TRAVESSA" },
	{ value: "8R ", label: "8A RUA" },
	{ value: "8TV", label: "8A TRAVESSA" },
	{ value: "9R ", label: "9A RUA" },
	{ value: "9TV", label: "9A TRAVESSA" },
];

const propertyTypeOptions = [
	{ value: "01", label: "Casa" },
	{ value: "03", label: "Sítio" },
	{ value: "04", label: "Chácara" },
	{ value: "05", label: "Apartamento" },
	{ value: "08", label: "Fazenda" },
	{ value: "10", label: "Outro tipos de imóveis" },
];

const propertyOccupationOptions = [
	{ value: "01", label: "Própria quitada" },
	{ value: "02", label: "Própria financiada CAIXA" },
	{ value: "03", label: "Própria financiada outras entidades" },
	{ value: "04", label: "Alugada" },
	{ value: "05", label: "Mora com pais/parentes" },
	{ value: "06", label: "Cedida" },
	{ value: "07", label: "Funcional" },
	{ value: "08", label: "Outros" },
];

const agenciaOptions = [
	{ value: "0428", label: "0428 PRACA DA ALFANDEGA, RS" },
	{ value: "0429", label: "0429 SHOPPING IGUATEMI, RS" },
	{ value: "0430", label: "0430 RUA DA PRAIA, RS" },
	{ value: "0431", label: "0431 ASSIS BRASIL, RS" },
	{ value: "0432", label: "0432 AZENHA, RS" },
	{ value: "0434", label: "0434 CORONEL BORDINI, RS" },
	{ value: "0435", label: "0435 BOM FIM, RS" },
	{ value: "0436", label: "0436 CAVALHADA, RS" },
	{ value: "0437", label: "0437 BOURBON WALLIG, RS" },
	{ value: "0439", label: "0439 SHOPPING TOTAL, RS" },
	{ value: "0441", label: "0441 JOSE DO PATROCINIO, RS" },
	{ value: "0442", label: "0442 MENINO DEUS, RS" },
	{ value: "0443", label: "0443 MOINHOS DE VENTO, RS" },
	{ value: "0444", label: "0444 NAVEGANTES, RS" },
	{ value: "0445", label: "0445 PARTENON, RS" },
	{ value: "0446", label: "0446 PASSO DA AREIA, RS" },
	{ value: "0447", label: "0447 PROTASIO ALVES, RS" },
	{ value: "0448", label: "0448 ACORIANOS, RS" },
	{ value: "0449", label: "0449 SAO JOAO, RS" },
	{ value: "0450", label: "0450 GUIA LOPES, RS" },
	{ value: "0451", label: "0451 OTAVIO ROCHA, RS" },
	{ value: "0452", label: "0452 AVENIDA DO FORTE, RS" },
	{ value: "0453", label: "0453 PRACA RUI BARBOSA, RS" },
	{ value: "0454", label: "0454 INDEPENDENCIA, RS" },
	{ value: "0623", label: "0623 PRAIA DE BELAS, RS" },
	{ value: "0652", label: "0652 JUSTICA FEDERAL PORTO ALEGRE, RS" },
	{ value: "0827", label: "0827 BAIRRO RESTINGA, RS" },
	{ value: "0911", label: "0911 ALTO PETROPOLIS, RS" },
	{ value: "0958", label: "0958 TRISTEZA, RS" },
	{ value: "1587", label: "1587 SHOPPING JOAO PESSOA, RS" },
	{ value: "1588", label: "1588 AVENIDA CARLOS GOMES, RS" },
	{ value: "1591", label: "1591 VOLTA DO GUERINO, RS" },
	{ value: "1592", label: "1592 BOURBON IPIRANGA, RS" },
	{ value: "1596", label: "1596 JUCA BATISTA, RS" },
	{ value: "1645", label: "1645 ERICO VERISSIMO, RS" },
	{ value: "1851", label: "1851 LUPICINIO RODRIGUES, RS" },
	{ value: "1852", label: "1852 DOM PEDRO II, RS" },
	{ value: "2232", label: "2232 MONTE CRISTO, RS" },
	{ value: "2515", label: "2515 EMPRESARIAL PORTO ALEGRE, RS" },
	{ value: "2716", label: "2716 JUST TRABALHO PORTO ALEGRE, RS" },
	{ value: "2822", label: "2822 GOVERNO PORTO ALEGRE, RS" },
	{ value: "2866", label: "2866 PLATAFORMA HABITACAO PORTO ALEGRE" },
	{ value: "3344", label: "3344 AVENIDA PROFESSOR OSCAR PEREIRA, RS" },
	{ value: "3445", label: "3445 CRISTAL, RS" },
	{ value: "3447", label: "3447 JARDIM PLANALTO, RS" },
	{ value: "3453", label: "3453 SERTORIO, RS" },
	{ value: "3460", label: "3460 INTERCAP, RS" },
	{ value: "3480", label: "3480 LOMBA DO PINHEIRO, RS" },
	{ value: "3481", label: "3481 ABERTA DOS MORROS, RS" },
	{ value: "3482", label: "3482 LUIS DE CAMOES, RS" },
	{ value: "3567", label: "3567 SETE DE SETEMBRO, RS" },
	{ value: "3752", label: "3752 DIGITAL PORTO ALEGRE NORTE, RS" },
	{ value: "3757", label: "3757 DIGITAL PORTO ALEGRE SUL, RS" },
	{ value: "3882", label: "3882 VICENTE DA FONTOURA, RS" },
	{ value: "3889", label: "3889 VAREJO DIGITAL PORTO ALEGRE" },
	{ value: "3916", label: "3916 TRF 4A REGIAO PORTO ALEGRE, RS" },
	{ value: "3942", label: "3942 DPF, RS" },
	{ value: "4017", label: "4017 TRT 4A REGIAO PORTO ALEGRE, RS" },
	{ value: "4265", label: "4265 CORPORATIVO PORTO ALEGRE" },
	{ value: "4436", label: "4436 PRACA DO PORTAO, RS" },
	{ value: "4508", label: "4508 AV OTTO NIEMEYER, RS" },
	{ value: "4810", label: "4810 PARCAO, RS" },
];

export const munOptions = [
	{ label: "", value: "" },
	{ label: "ACEGUA", value: "000007551" },
	{ label: "AGUA SANTA", value: "000007553" },
	{ label: "AGUDO", value: "000007555" },
	{ label: "AJURICABA", value: "000007556" },
	{ label: "ALECRIM", value: "000007558" },
	{ label: "ALEGRETE", value: "000007559" },
	{ label: "ALEGRIA", value: "000007560" },
	{ label: "ALMIRANTE TAMANDARE DO SUL", value: "000010162" },
	{ label: "ALPESTRE", value: "000007563" },
	{ label: "ALTO ALEGRE", value: "000007564" },
	{ label: "ALTO FELIZ", value: "000007567" },
	{ label: "ALVORADA", value: "000007571" },
	{ label: "AMARAL FERRADOR", value: "000007572" },
	{ label: "AMETISTA DO SUL", value: "000007573" },
	{ label: "ANDRE DA ROCHA", value: "000007574" },
	{ label: "ANTA GORDA", value: "000007575" },
	{ label: "ANTONIO PRADO", value: "000007577" },
	{ label: "ARAMBARE", value: "000007578" },
	{ label: "ARARICA", value: "000007579" },
	{ label: "ARATIBA", value: "000007580" },
	{ label: "ARROIO DO MEIO", value: "000007584" },
	{ label: "ARROIO DO PADRE", value: "000007585" },
	{ label: "ARROIO DO SAL", value: "000007586" },
	{ label: "ARROIO DO TIGRE", value: "000007588" },
	{ label: "ARROIO DOS RATOS", value: "000007589" },
	{ label: "ARROIO GRANDE", value: "000007590" },
	{ label: "ARVOREZINHA", value: "000007594" },
	{ label: "AUGUSTO PESTANA", value: "000007597" },
	{ label: "AUREA", value: "000007598" },
	{ label: "BAGE", value: "000007602" },
	{ label: "BALNEARIO PINHAL", value: "000007604" },
	{ label: "BARAO", value: "000007606" },
	{ label: "BARAO DE COTEGIPE", value: "000007607" },
	{ label: "BARAO DO TRIUNFO", value: "000007608" },
	{ label: "BARRA DO GUARITA", value: "000007609" },
	{ label: "BARRA DO QUARAI", value: "000007611" },
	{ label: "BARRA DO RIBEIRO", value: "000007612" },
	{ label: "BARRA DO RIO AZUL", value: "000007613" },
	{ label: "BARRA FUNDA", value: "000007614" },
	{ label: "BARRACAO", value: "000007615" },
	{ label: "BARROS CASSAL", value: "000007621" },
	{ label: "BENJAMIN CONSTANT DO SUL", value: "000007628" },
	{ label: "BENTO GONCALVES", value: "000007629" },
	{ label: "BOA VISTA DAS MISSOES", value: "000007635" },
	{ label: "BOA VISTA DO BURICA", value: "000007636" },
	{ label: "BOA VISTA DO CADEADO", value: "000007637" },
	{ label: "BOA VISTA DO INCRA", value: "000007638" },
	{ label: "BOA VISTA DO SUL", value: "000007639" },
	{ label: "BOM JESUS", value: "000007644" },
	{ label: "BOM PRINCIPIO", value: "000007645" },
	{ label: "BOM PROGRESSO", value: "000007646" },
	{ label: "BOM RETIRO DO SUL", value: "000007649" },
	{ label: "BOQUEIRAO DO LEAO", value: "000007653" },
	{ label: "BOSSOROCA", value: "000007655" },
	{ label: "BOZANO", value: "000010163" },
	{ label: "BRAGA", value: "000007657" },
	{ label: "BROCHIER", value: "000007658" },
	{ label: "BUTIA", value: "000007661" },
	{ label: "CACAPAVA DO SUL", value: "000007663" },
	{ label: "CACEQUI", value: "000007664" },
	{ label: "CACHOEIRA DO SUL", value: "000007665" },
	{ label: "CACHOEIRINHA", value: "000007666" },
	{ label: "CACIQUE DOBLE", value: "000007667" },
	{ label: "CAIBATE", value: "000007669" },
	{ label: "CAICARA", value: "000007670" },
	{ label: "CAMAQUA", value: "000007671" },
	{ label: "CAMARGO", value: "000007672" },
	{ label: "CAMBARA DO SUL", value: "000007673" },
	{ label: "CAMPESTRE DA SERRA", value: "000007676" },
	{ label: "CAMPINA DAS MISSOES", value: "000007677" },
	{ label: "CAMPINAS DO SUL", value: "000007680" },
	{ label: "CAMPO BOM", value: "000007681" },
	{ label: "CAMPO NOVO", value: "000007684" },
	{ label: "CAMPOS BORGES", value: "000007689" },
	{ label: "CANDELARIA", value: "000007690" },
	{ label: "CANDIDO GODOI", value: "000007692" },
	{ label: "CANDIOTA", value: "000007693" },
	{ label: "CANELA", value: "000007694" },
	{ label: "CANGUCU", value: "000007695" },
	{ label: "CANOAS", value: "000007697" },
	{ label: "CANUDOS DO VALE", value: "000010164" },
	{ label: "CAPAO BONITO DO SUL", value: "000010165" },
	{ label: "CAPAO DA CANOA", value: "000007703" },
	{ label: "CAPAO DO CIPO", value: "000007706" },
	{ label: "CAPAO DO LEAO", value: "000007707" },
	{ label: "CAPELA DE SANTANA", value: "000007708" },
	{ label: "CAPITAO", value: "000007711" },
	{ label: "CAPIVARI DO SUL", value: "000007712" },
	{ label: "CARAA", value: "000007716" },
	{ label: "CARAZINHO", value: "000007718" },
	{ label: "CARLOS BARBOSA", value: "000007719" },
	{ label: "CARLOS GOMES", value: "000007720" },
	{ label: "CASCA", value: "000007722" },
	{ label: "CASEIROS", value: "000007725" },
	{ label: "CATUIPE", value: "000007727" },
	{ label: "CAXIAS DO SUL", value: "000007730" },
	{ label: "CENTENARIO", value: "000007733" },
	{ label: "CERRITO", value: "000007736" },
	{ label: "CERRO BRANCO", value: "000007740" },
	{ label: "CERRO GRANDE", value: "000007744" },
	{ label: "CERRO GRANDE DO SUL", value: "000007745" },
	{ label: "CERRO LARGO", value: "000007746" },
	{ label: "CHAPADA", value: "000007747" },
	{ label: "CHARQUEADAS", value: "000007749" },
	{ label: "CHARRUA", value: "000007750" },
	{ label: "CHIAPETTA", value: "000007751" },
	{ label: "CHUI", value: "000007756" },
	{ label: "CHUVISCA", value: "000007757" },
	{ label: "CIDREIRA", value: "000007758" },
	{ label: "CIRIACO", value: "000007760" },
	{ label: "COLINAS", value: "000007764" },
	{ label: "COLORADO", value: "000007772" },
	{ label: "CONDOR", value: "000007774" },
	{ label: "CONSTANTINA", value: "000007776" },
	{ label: "COQUEIRO BAIXO", value: "000007777" },
	{ label: "COQUEIROS DO SUL", value: "000007778" },
	{ label: "CORONEL BARROS", value: "000007781" },
	{ label: "CORONEL BICACO", value: "000007782" },
	{ label: "CORONEL PILAR", value: "000007784" },
	{ label: "COTIPORA", value: "000007789" },
	{ label: "COXILHA", value: "000007790" },
	{ label: "CRISSIUMAL", value: "000007793" },
	{ label: "CRISTAL", value: "000007794" },
	{ label: "CRISTAL DO SUL", value: "000007795" },
	{ label: "CRUZ ALTA", value: "000007797" },
	{ label: "CRUZALTENSE", value: "000010166" },
	{ label: "CRUZEIRO DO SUL", value: "000007800" },
	{ label: "DAVID CANABARRO", value: "000007807" },
	{ label: "DERRUBADAS", value: "000007811" },
	{ label: "DEZESSEIS DE NOVEMBRO", value: "000007812" },
	{ label: "DILERMANDO DE AGUIAR", value: "000007813" },
	{ label: "DOIS IRMAOS", value: "000007815" },
	{ label: "DOIS IRMAOS DAS MISSOES", value: "000007816" },
	{ label: "DOIS LAJEADOS", value: "000007817" },
	{ label: "DOM FELICIANO", value: "000007819" },
	{ label: "DOM PEDRITO", value: "000007821" },
	{ label: "DOM PEDRO DE ALCANTARA", value: "000007822" },
	{ label: "DONA FRANCISCA", value: "000007823" },
	{ label: "DOUTOR MAURICIO CARDOSO", value: "000007828" },
	{ label: "DOUTOR RICARDO", value: "000007829" },
	{ label: "ELDORADO DO SUL", value: "000007830" },
	{ label: "ENCANTADO", value: "000007832" },
	{ label: "ENCRUZILHADA DO SUL", value: "000007834" },
	{ label: "ENGENHO VELHO", value: "000007835" },
	{ label: "ENTRE RIOS DO SUL", value: "000007836" },
	{ label: "ENTRE-IJUIS", value: "000007837" },
	{ label: "EREBANGO", value: "000007839" },
	{ label: "ERECHIM", value: "000007840" },
	{ label: "ERNESTINA", value: "000007841" },
	{ label: "ERVAL GRANDE", value: "000007844" },
	{ label: "ERVAL SECO", value: "000007845" },
	{ label: "ESMERALDA", value: "000007847" },
	{ label: "ESPERANCA DO SUL", value: "000007848" },
	{ label: "ESPUMOSO", value: "000007853" },
	{ label: "ESTACAO", value: "000007860" },
	{ label: "ESTANCIA VELHA", value: "000007862" },
	{ label: "ESTEIO", value: "000007863" },
	{ label: "ESTRELA", value: "000007866" },
	{ label: "ESTRELA VELHA", value: "000007868" },
	{ label: "EUGENIO DE CASTRO", value: "000007869" },
	{ label: "FAGUNDES VARELA", value: "000007871" },
	{ label: "FARROUPILHA", value: "000007876" },
	{ label: "FAXINAL DO SOTURNO", value: "000007878" },
	{ label: "FAXINALZINHO", value: "000007879" },
	{ label: "FAZENDA VILANOVA", value: "000007882" },
	{ label: "FELIZ", value: "000007883" },
	{ label: "FLORES DA CUNHA", value: "000007885" },
	{ label: "FLORIANO PEIXOTO", value: "000007888" },
	{ label: "FONTOURA XAVIER", value: "000007890" },
	{ label: "FORMIGUEIRO", value: "000007891" },
	{ label: "FORQUETINHA", value: "000007894" },
	{ label: "FORTALEZA DOS VALOS", value: "000007895" },
	{ label: "FREDERICO WESTPHALEN", value: "000007896" },
	{ label: "GARIBALDI", value: "000007899" },
	{ label: "GARRUCHOS", value: "000007901" },
	{ label: "GAURAMA", value: "000007902" },
	{ label: "GENERAL CAMARA", value: "000007903" },
	{ label: "GENTIL", value: "000007904" },
	{ label: "GETULIO VARGAS", value: "000007905" },
	{ label: "GIRUA", value: "000007906" },
	{ label: "GLORINHA", value: "000007908" },
	{ label: "GRAMADO", value: "000007910" },
	{ label: "GRAMADO DOS LOUREIROS", value: "000007911" },
	{ label: "GRAMADO XAVIER", value: "000007913" },
	{ label: "GRAVATAI", value: "000007914" },
	{ label: "GUABIJU", value: "000007915" },
	{ label: "GUAIBA", value: "000007916" },
	{ label: "GUAPORE", value: "000007918" },
	{ label: "GUARANI DAS MISSOES", value: "000007919" },
	{ label: "HARMONIA", value: "000007921" },
	{ label: "HERVAL", value: "000007922" },
	{ label: "HERVEIRAS", value: "000007923" },
	{ label: "HORIZONTINA", value: "000007925" },
	{ label: "HULHA NEGRA", value: "000007926" },
	{ label: "HUMAITA", value: "000007927" },
	{ label: "IBARAMA", value: "000007928" },
	{ label: "IBIACA", value: "000007930" },
	{ label: "IBIRAIARAS", value: "000007931" },
	{ label: "IBIRAPUITA", value: "000007932" },
	{ label: "IBIRUBA", value: "000007933" },
	{ label: "IGREJINHA", value: "000007934" },
	{ label: "IJUI", value: "000007937" },
	{ label: "ILOPOLIS", value: "000007939" },
	{ label: "IMBE", value: "000007940" },
	{ label: "IMIGRANTE", value: "000007941" },
	{ label: "INDEPENDENCIA", value: "000007942" },
	{ label: "INHACORA", value: "000007943" },
	{ label: "IPE", value: "000007944" },
	{ label: "IPIRANGA DO SUL", value: "000007946" },
	{ label: "IRAI", value: "000007948" },
	{ label: "ITAARA", value: "000007950" },
	{ label: "ITACURUBI", value: "000007953" },
	{ label: "ITAPUCA", value: "000007959" },
	{ label: "ITAQUI", value: "000007960" },
	{ label: "ITATI", value: "000007961" },
	{ label: "ITATIBA DO SUL", value: "000007962" },
	{ label: "IVORA", value: "000007966" },
	{ label: "IVOTI", value: "000007967" },
	{ label: "JABOTICABA", value: "000007968" },
	{ label: "JACUIZINHO", value: "000007969" },
	{ label: "JACUTINGA", value: "000007970" },
	{ label: "JAGUARAO", value: "000007971" },
	{ label: "JAGUARI", value: "000007973" },
	{ label: "JAQUIRANA", value: "000007975" },
	{ label: "JARI", value: "000007976" },
	{ label: "JOIA", value: "000007981" },
	{ label: "JULIO DE CASTILHOS", value: "000007984" },
	{ label: "LAGOA BONITA DO SUL", value: "000010167" },
	{ label: "LAGOA DOS TRES CANTOS", value: "000007986" },
	{ label: "LAGOA VERMELHA", value: "000007987" },
	{ label: "LAGOAO", value: "000007988" },
	{ label: "LAJEADO", value: "000007989" },
	{ label: "LAJEADO DO BUGRE", value: "000007993" },
	{ label: "LAVRAS DO SUL", value: "000007999" },
	{ label: "LIBERATO SALZANO", value: "000008001" },
	{ label: "LINDOLFO COLLOR", value: "000008002" },
	{ label: "LINHA NOVA", value: "000008004" },
	{ label: "MACAMBARA", value: "000008007" },
	{ label: "MACHADINHO", value: "000008008" },
	{ label: "MAMPITUBA", value: "000008010" },
	{ label: "MANOEL VIANA", value: "000008013" },
	{ label: "MAQUINE", value: "000008014" },
	{ label: "MARATA", value: "000008015" },
	{ label: "MARAU", value: "000008016" },
	{ label: "MARCELINO RAMOS", value: "000008017" },
	{ label: "MARIANA PIMENTEL", value: "000008019" },
	{ label: "MARIANO MORO", value: "000008020" },
	{ label: "MARQUES DE SOUZA", value: "000008023" },
	{ label: "MATA", value: "000008024" },
	{ label: "MATO CASTELHANO", value: "000008026" },
	{ label: "MATO LEITAO", value: "000008028" },
	{ label: "MATO QUEIMADO", value: "000008029" },
	{ label: "MAXIMILIANO DE ALMEIDA", value: "000008032" },
	{ label: "MINAS DO LEAO", value: "000008034" },
	{ label: "MIRAGUAI", value: "000008035" },
	{ label: "MONTAURI", value: "000008039" },
	{ label: "MONTE ALEGRE DOS CAMPOS", value: "000008042" },
	{ label: "MONTE BELO DO SUL", value: "000008044" },
	{ label: "MONTENEGRO", value: "000008046" },
	{ label: "MORMACO", value: "000008047" },
	{ label: "MORRINHOS DO SUL", value: "000008049" },
	{ label: "MORRO REDONDO", value: "000008052" },
	{ label: "MORRO REUTER", value: "000008053" },
	{ label: "MOSTARDAS", value: "000008055" },
	{ label: "MUCUM", value: "000008056" },
	{ label: "MUITOS CAPOES", value: "000008057" },
	{ label: "MULITERNO", value: "000008058" },
	{ label: "NAO-ME-TOQUE", value: "000008059" },
	{ label: "NICOLAU VERGUEIRO", value: "000008061" },
	{ label: "NONOAI", value: "000008062" },
	{ label: "NOVA ALVORADA", value: "000008065" },
	{ label: "NOVA ARACA", value: "000008066" },
	{ label: "NOVA BASSANO", value: "000008067" },
	{ label: "NOVA BOA VISTA", value: "000008068" },
	{ label: "NOVA BRESCIA", value: "000008069" },
	{ label: "NOVA CANDELARIA", value: "000008070" },
	{ label: "NOVA ESPERANCA DO SUL", value: "000008071" },
	{ label: "NOVA HARTZ", value: "000008072" },
	{ label: "NOVA PADUA", value: "000008074" },
	{ label: "NOVA PALMA", value: "000008075" },
	{ label: "NOVA PETROPOLIS", value: "000008076" },
	{ label: "NOVA PRATA", value: "000008077" },
	{ label: "NOVA RAMADA", value: "000008078" },
	{ label: "NOVA ROMA DO SUL", value: "000008079" },
	{ label: "NOVA SANTA RITA", value: "000008080" },
	{ label: "NOVO BARREIRO", value: "000008082" },
	{ label: "NOVO CABRAIS", value: "000008083" },
	{ label: "NOVO HAMBURGO", value: "000008084" },
	{ label: "NOVO MACHADO", value: "000008086" },
	{ label: "NOVO TIRADENTES", value: "000008088" },
	{ label: "NOVO XINGU", value: "000010168" },
	{ label: "OSORIO", value: "000008091" },
	{ label: "PAIM FILHO", value: "000008098" },
	{ label: "PALMARES DO SUL", value: "000008099" },
	{ label: "PALMEIRA DAS MISSOES", value: "000008101" },
	{ label: "PALMITINHO", value: "000008102" },
	{ label: "PANAMBI", value: "000008104" },
	{ label: "PANTANO GRANDE", value: "000008105" },
	{ label: "PARAI", value: "000008106" },
	{ label: "PARAISO DO SUL", value: "000008107" },
	{ label: "PARECI NOVO", value: "000008108" },
	{ label: "PAROBE", value: "000008109" },
	{ label: "PASSA SETE", value: "000008110" },
	{ label: "PASSO DO SOBRADO", value: "000008118" },
	{ label: "PASSO FUNDO", value: "000008119" },
	{ label: "PAULO BENTO", value: "000008122" },
	{ label: "PAVERAMA", value: "000008124" },
	{ label: "PEDRAS ALTAS", value: "000008125" },
	{ label: "PEDRO OSORIO", value: "000008128" },
	{ label: "PEJUCARA", value: "000008130" },
	{ label: "PELOTAS", value: "000008131" },
	{ label: "PICADA CAFE", value: "000008132" },
	{ label: "PINHAL", value: "000008133" },
	{ label: "PINHAL DA SERRA", value: "000008138" },
	{ label: "PINHAL GRANDE", value: "000008139" },
	{ label: "PINHEIRINHO DO VALE", value: "000008142" },
	{ label: "PINHEIRO MACHADO", value: "000008143" },
	{ label: "PINTO BANDEIRA", value: "000008146" },
	{ label: "PIRAPO", value: "000008148" },
	{ label: "PIRATINI", value: "000008149" },
	{ label: "PLANALTO", value: "000008151" },
	{ label: "POCO DAS ANTAS", value: "000008154" },
	{ label: "PONTAO", value: "000008157" },
	{ label: "PONTE PRETA", value: "000008158" },
	{ label: "PORTAO", value: "000008159" },
	{ label: "PORTO ALEGRE", value: "000008160" },
	{ label: "PORTO LUCENA", value: "000008162" },
	{ label: "PORTO MAUA", value: "000008163" },
	{ label: "PORTO VERA CRUZ", value: "000008164" },
	{ label: "PORTO XAVIER", value: "000008165" },
	{ label: "POUSO NOVO", value: "000008166" },
	{ label: "PRESIDENTE LUCENA", value: "000008171" },
	{ label: "PROGRESSO", value: "000008175" },
	{ label: "PROTASIO ALVES", value: "000008176" },
	{ label: "PUTINGA", value: "000008178" },
	{ label: "QUARAI", value: "000008179" },
	{ label: "QUATRO IRMAOS", value: "000008181" },
	{ label: "QUEVEDOS", value: "000008182" },
	{ label: "QUINZE DE NOVEMBRO", value: "000008186" },
	{ label: "REDENTORA", value: "000008189" },
	{ label: "RELVADO", value: "000008191" },
	{ label: "RESTINGA SECA", value: "000008192" },
	{ label: "RIO DOS INDIOS", value: "000008206" },
	{ label: "RIO GRANDE", value: "000008207" },
	{ label: "RIO PARDO", value: "000008209" },
	{ label: "RIOZINHO", value: "000008213" },
	{ label: "ROCA SALES", value: "000008214" },
	{ label: "RODEIO BONITO", value: "000008215" },
	{ label: "ROLADOR", value: "000008216" },
	{ label: "ROLANTE", value: "000008217" },
	{ label: "RONDA ALTA", value: "000008219" },
	{ label: "RONDINHA", value: "000008220" },
	{ label: "ROQUE GONZALES", value: "000008221" },
	{ label: "ROSARIO DO SUL", value: "000008223" },
	{ label: "SAGRADA FAMILIA", value: "000008224" },
	{ label: "SALDANHA MARINHO", value: "000008226" },
	{ label: "SALTO DO JACUI", value: "000008230" },
	{ label: "SALVADOR DAS MISSOES", value: "000008231" },
	{ label: "SALVADOR DO SUL", value: "000008232" },
	{ label: "SANANDUVA", value: "000008233" },
	{ label: "SANT' ANA DO LIVRAMENTO", value: "000008267" },
	{ label: "SANTA BARBARA DO SUL", value: "000008237" },
	{ label: "SANTA CECILIA DO SUL", value: "000010169" },
	{ label: "SANTA CLARA DO SUL", value: "000008241" },
	{ label: "SANTA CRUZ DO SUL", value: "000008245" },
	{ label: "SANTA MARGARIDA DO SUL", value: "000010170" },
	{ label: "SANTA MARIA", value: "000008253" },
	{ label: "SANTA MARIA DO HERVAL", value: "000008254" },
	{ label: "SANTA ROSA", value: "000008256" },
	{ label: "SANTA TEREZA", value: "000008260" },
	{ label: "SANTA VITORIA DO PALMAR", value: "000008262" },
	{ label: "SANTANA DA BOA VISTA", value: "000008266" },
	{ label: "SANTANA DO LIVRAMENTO", value: "000019890" },
	{ label: "SANTIAGO", value: "000008268" },
	{ label: "SANTO ANGELO", value: "000008270" },
	{ label: "SANTO ANTONIO DA PATRULHA", value: "000008274" },
	{ label: "SANTO ANTONIO DAS MISSOES", value: "000008275" },
	{ label: "SANTO ANTONIO DO PALMA", value: "000008278" },
	{ label: "SANTO ANTONIO DO PLANALTO", value: "000008279" },
	{ label: "SANTO AUGUSTO", value: "000008280" },
	{ label: "SANTO CRISTO", value: "000008281" },
	{ label: "SANTO EXPEDITO DO SUL", value: "000008282" },
	{ label: "SAO BORJA", value: "000008286" },
	{ label: "SAO DOMINGOS DO SUL", value: "000008288" },
	{ label: "SAO FRANCISCO DE ASSIS", value: "000008290" },
	{ label: "SAO FRANCISCO DE PAULA", value: "000008291" },
	{ label: "SAO GABRIEL", value: "000008292" },
	{ label: "SAO JERONIMO", value: "000008293" },
	{ label: "SAO JOAO DA URTIGA", value: "000008297" },
	{ label: "SAO JOAO DO POLESINE", value: "000008298" },
	{ label: "SAO JORGE", value: "000008299" },
	{ label: "SAO JOSE DAS MISSOES", value: "000008303" },
	{ label: "SAO JOSE DO HERVAL", value: "000008306" },
	{ label: "SAO JOSE DO HORTENCIO", value: "000008307" },
	{ label: "SAO JOSE DO INHACORA", value: "000008308" },
	{ label: "SAO JOSE DO NORTE", value: "000008309" },
	{ label: "SAO JOSE DO OURO", value: "000008310" },
	{ label: "SAO JOSE DO SUL", value: "000010171" },
	{ label: "SAO JOSE DOS AUSENTES", value: "000008311" },
	{ label: "SAO LEOPOLDO", value: "000008312" },
	{ label: "SAO LOURENCO DO SUL", value: "000008314" },
	{ label: "SAO LUIZ GONZAGA", value: "000008317" },
	{ label: "SAO MARCOS", value: "000008319" },
	{ label: "SAO MARTINHO", value: "000008321" },
	{ label: "SAO MARTINHO DA SERRA", value: "000008322" },
	{ label: "SAO MIGUEL DAS MISSOES", value: "000008324" },
	{ label: "SAO NICOLAU", value: "000008325" },
	{ label: "SAO PAULO DAS MISSOES", value: "000008327" },
	{ label: "SAO PEDRO DA SERRA", value: "000008330" },
	{ label: "SAO PEDRO DAS MISSOES", value: "000010172" },
	{ label: "SAO PEDRO DO BUTIA", value: "000008331" },
	{ label: "SAO PEDRO DO SUL", value: "000008333" },
	{ label: "SAO SEBASTIAO DO CAI", value: "000008337" },
	{ label: "SAO SEPE", value: "000008338" },
	{ label: "SAO VALENTIM", value: "000008340" },
	{ label: "SAO VALENTIM DO SUL", value: "000008342" },
	{ label: "SAO VALERIO DO SUL", value: "000008343" },
	{ label: "SAO VENDELINO", value: "000008344" },
	{ label: "SAO VICENTE DO SUL", value: "000008345" },
	{ label: "SAPIRANGA", value: "000008346" },
	{ label: "SAPUCAIA DO SUL", value: "000008347" },
	{ label: "SARANDI", value: "000008348" },
	{ label: "SEBERI", value: "000008350" },
	{ label: "SEDE NOVA", value: "000008353" },
	{ label: "SEGREDO", value: "000008354" },
	{ label: "SELBACH", value: "000008357" },
	{ label: "SENADOR SALGADO FILHO", value: "000008358" },
	{ label: "SENTINELA DO SUL", value: "000008359" },
	{ label: "SERAFINA CORREA", value: "000008361" },
	{ label: "SERIO", value: "000008362" },
	{ label: "SERTAO", value: "000008365" },
	{ label: "SERTAO SANTANA", value: "000008366" },
	{ label: "SETE DE SETEMBRO", value: "000008369" },
	{ label: "SEVERIANO DE ALMEIDA", value: "000008372" },
	{ label: "SILVEIRA MARTINS", value: "000008375" },
	{ label: "SINIMBU", value: "000008376" },
	{ label: "SOBRADINHO", value: "000008379" },
	{ label: "SOLEDADE", value: "000008380" },
	{ label: "TABAI", value: "000008383" },
	{ label: "TAPEJARA", value: "000008389" },
	{ label: "TAPERA", value: "000008390" },
	{ label: "TAPES", value: "000008392" },
	{ label: "TAQUARA", value: "000008393" },
	{ label: "TAQUARI", value: "000008394" },
	{ label: "TAQUARUCU DO SUL", value: "000008396" },
	{ label: "TAVARES", value: "000008397" },
	{ label: "TENENTE PORTELA", value: "000008398" },
	{ label: "TERRA DE AREIA", value: "000008399" },
	{ label: "TEUTONIA", value: "000008401" },
	{ label: "TIO HUGO", value: "000010173" },
	{ label: "TIRADENTES DO SUL", value: "000008404" },
	{ label: "TOROPI", value: "000008405" },
	{ label: "TORRES", value: "000008408" },
	{ label: "TRAMANDAI", value: "000008411" },
	{ label: "TRAVESSEIRO", value: "000008412" },
	{ label: "TRES ARROIOS", value: "000008414" },
	{ label: "TRES CACHOEIRAS", value: "000008416" },
	{ label: "TRES COROAS", value: "000008417" },
	{ label: "TRES DE MAIO", value: "000008418" },
	{ label: "TRES FORQUILHAS", value: "000008419" },
	{ label: "TRES PALMEIRAS", value: "000008420" },
	{ label: "TRES PASSOS", value: "000008421" },
	{ label: "TRINDADE DO SUL", value: "000008424" },
	{ label: "TRIUNFO", value: "000008425" },
	{ label: "TUCUNDUVA", value: "000008427" },
	{ label: "TUNAS", value: "000008429" },
	{ label: "TUPANCI DO SUL", value: "000008431" },
	{ label: "TUPANCIRETA", value: "000008432" },
	{ label: "TUPANDI", value: "000008434" },
	{ label: "TUPARENDI", value: "000008436" },
	{ label: "TURUCU", value: "000008439" },
	{ label: "UBIRETAMA", value: "000008441" },
	{ label: "UNIAO DA SERRA", value: "000008443" },
	{ label: "UNISTALDA", value: "000008444" },
	{ label: "URUGUAIANA", value: "000008445" },
	{ label: "VACARIA", value: "000008447" },
	{ label: "VALE DO SOL", value: "000008450" },
	{ label: "VALE REAL", value: "000008451" },
	{ label: "VALE VERDE", value: "000008453" },
	{ label: "VANINI", value: "000008454" },
	{ label: "VENANCIO AIRES", value: "000008455" },
	{ label: "VERA CRUZ", value: "000008456" },
	{ label: "VERANOPOLIS", value: "000008457" },
	{ label: "VESPASIANO CORREA", value: "000008459" },
	{ label: "VIADUTOS", value: "000008460" },
	{ label: "VIAMAO", value: "000008461" },
	{ label: "VICENTE DUTRA", value: "000008462" },
	{ label: "VICTOR GRAEFF", value: "000008463" },
	{ label: "VILA FLORES", value: "000008466" },
	{ label: "VILA LANGARO", value: "000008467" },
	{ label: "VILA MARIA", value: "000008469" },
	{ label: "VILA NOVA DO SUL", value: "000008470" },
	{ label: "VISTA ALEGRE", value: "000008475" },
	{ label: "VISTA ALEGRE DO PRATA", value: "000008476" },
	{ label: "VISTA GAUCHA", value: "000008477" },
	{ label: "VITORIA DAS MISSOES", value: "000008479" },
	{ label: "WESTFALIA", value: "000010174" },
	{ label: "XANGRI-LA", value: "000008484" },
];

const yesNo = [
	{ value: "on", label: "Sim" },
	{ value: "off", label: "Não" },
];

const habitacionalValue = [
	{ value: "true", label: "Sim" },
	{ value: "false", label: "Não" },
];

const sNOptions = [
	{ value: "S", label: "Sim" },
	{ value: "N", label: "Não" },
];

interface StepQuestion {
	title: string;
	type: string;
	name: string;
	mask?: string | { prefix: string; type: string };
	placeholder?: string;
	disabled?: boolean;
	subtype?: string;
	optionsType?: "city" | "uf" | "state";
	defaultProps?: { [key: string]: any };
	watchField?: string;
	options?: { label: string; value: string }[];
	dependent?: {
		field: string;
		value?: string;
		values?: string[];
		valueFunction?: (dependentValue: string) => boolean;
	};
	required?: string;
}

export const firstStep: StepQuestion[] = [
	// CPF
	{
		title: "CPF do proponente *",
		type: "mask",
		name: "cpf",
		mask: "999.999.999-99",
		placeholder: "CPF do proponente",
	},
	// NOME COMPLETO
	{
		title: "Nome do proponente *",
		type: "text",
		name: "nomeCompleto",
		placeholder: "Nome do proponente",
	},

	{
		title: "Empréstimo/Financiamentos",
		name: "emprestimosFinancimanentos",
		type: "select",
		options: yesNo,
		placeholder: "Empréstimo/Financimentos",
	},

	// DECLARAÇÃO DE PROPÓSITO
	{
		title: "Financiamento Habitacional",
		type: "select",
		name: "habitacional",
		options: habitacionalValue,
		placeholder: "Financiamento Habitacional",
		dependent: {
			field: "emprestimosFinancimanentos",
			value: "on",
		},
	},
	// {
	// 	title: "Declaração de propósito *",
	// 	type: "checklist",
	// 	name: "purpose",
	// 	options: [
	// 		{
	// 			title: "Operações internacionais/Câmbio",
	// 			name: "inter_oper",
	// 		},
	// 		{
	// 			title: "Seguros/Previdência Privada/Capitalização/Consórsios",
	// 			name: "insurance",
	// 		},
	// 		{ title: "Cartão de Crédito", name: "credit_card" },
	// 		{ title: "Investimento", name: "investment" },
	// 		{
	// 			title: "Empréstimo/Financiamentos",
	// 			name: "loan",
	// 		},
	// 		{
	// 			title: "Financiamento Habitacional",
	// 			dependent: { field: "loan", value: true },
	// 			name: "housing_finance",
	// 		},
	// 		{
	// 			title: "Movimentação de contas de Depósito/Poupança",
	// 			name: "account_mov",
	// 		},
	// 	],
	// },

	// NOME REDUZIDO
	{
		title: "Nome formato reduzido *",
		type: "text",
		name: "nomeReduzido",
		defaultProps: {
			maxLength: "25",
		},
		placeholder: "Nome reduzido",
	},

	// DATA DE NASCIMENTO
	{
		title: "Data de Nascimento (DD/MM/AAAA)",
		name: "dataNascimento",
		type: "mask",
		mask: "99/99/9999",
		placeholder: "Data de Nascimento",
	},

	// SEXO
	{
		title: "Sexo *",
		type: "select",
		name: "cmbSexo",
		options: sexOptions,
	},
	//NACIONALIDADE
	{
		title: "Nacionalidade *",
		type: "select",
		name: "cmbNacionalidade",
		options: natOptions,
	},
	// {se brasileiro} ESTADO E CIDADE
	{
		title: "Estado *",
		name: "cmbUFnaturalidade",
		type: "select",
		options: stateOptions,
		optionsType: "state",
		dependent: {
			field: "cmbNacionalidade",
			value: "BRASILEIRO",
		},
	},
	{
		title: "Cidade *",
		name: "cmbMunicipioNaturalidade",
		type: "select",
		required: "cities",
		watchField: "cmbUFnaturalidade",
		options: [],
		optionsType: "city",
		dependent: {
			field: "cmbNacionalidade",
			value: "BRASILEIRO",
		},
	},

	// {se estrangeiro} PAIS
	{
		title: "País *",
		name: "cmbPaisDeNacionalidade",
		type: "select",
		options: countriesOptions,
		dependent: {
			field: "cmbNacionalidade",
			value: "ESTRANGEIRO",
		},
	},

	// NOME DO PAI
	{
		title: "Nome do pai",
		type: "text",
		name: "nomePai",
		placeholder: "Nome do pai",
	},

	// NOME DA MÃE
	{
		title: "Nome da mãe",
		type: "text",
		name: "nomeMae",
		placeholder: "Nome da mãe *",
	},
	// GRAU DE INSTRUÇÃO
	{
		title: "Grau de instrução *",
		name: "cmbGrauInstrucao",
		type: "select",
		options: degreeOptions,
	},

	// PIS/NIS
	{
		title: "PIS/NIS",
		name: "pis",
		type: "mask",
		mask: "999.99999.99.9",
		placeholder: "PIS/NIS",
	},

	// TIPO DE DOCUMENTO
	{
		title: "Tipo de documento de identificação *",
		name: "cmbTipoDocumento",
		type: "select",
		options: docTypeOptions,
	},

	// {CNH} NUMERO DA CNH e DATA DA PRIMEIRA HABILITAÇÃO
	{
		title: "Número da carteira nacional de habilitação *",
		name: "identidadeNumeroCnh",
		placeholder: "Número da carteira nacional de habilitação *",
		type: "text",
		dependent: {
			field: "cmbTipoDocumento",
			value: "0782",
		},
	},
	{
		title: "Data 1ª habilitação (DD/MM/AAAA) *",
		name: "dataPrimeiraHabilitacaoCnh",
		type: "mask",
		mask: "99/99/9999",
		placeholder: "Data 1ª habilitação",
		dependent: {
			field: "cmbTipoDocumento",
			value: "0782",
		},
	},
	{
		title: "Órgão emissor *",
		name: "cmbOrgaoEmissorCnh",
		options: cnhTypeOptions,
		type: "select",
		dependent: {
			field: "cmbTipoDocumento",
			value: "0782",
		},
	},

	//{PASSAPORTE} NUMERO DO PASSAPORTE e PAIS DE ORIGEM
	{
		title: "Número do passaporte *",
		name: "identidadeNumeroPassaporte",
		placeholder: "Número do passaporte *",
		type: "text",
		dependent: {
			field: "cmbTipoDocumento",
			value: "0781",
		},
	},
	{
		title: "Órgão emissor *",
		name: "cmbOrgaoEmissorPassaporte",
		type: "select",
		options: passTypeOptions,
		dependent: {
			field: "cmbTipoDocumento",
			value: "0781",
		},
	},

	// {RIC} NÚMERO, ORGÃO EMISSOR, SUBTIPO DE DOCUMENTO
	{
		title: "Número de identidade *",
		name: "identidadeNumeroRg",
		placeholder: "Número de identidade *",
		mask: "99.999.999-9",
		type: "text",
		dependent: {
			field: "cmbTipoDocumento",
			value: "0372102",
		},
	},
	{
		title: "Órgão emissor *",
		name: "cmbRg",
		type: "select",
		options: ricTypeOptions,
		dependent: {
			field: "cmbTipoDocumento",
			value: "0372102",
		},
	},

	// {DOCUMENTO DE IDENTIFICAÇÃO} SUBTIPO, NÚMERO DE IDENTIDADE,
	{
		title: "Subtipo de documento *",
		name: "subTipoIdentidadeNumeroRg",
		type: "select",
		options: idSubTypeOptions,
		dependent: {
			field: "cmbTipoDocumento",
			value: "0372008",
		},
	},
	{
		title: "Número da identidade *",
		name: "identidadeNumeroRg",
		placeholder: "Número da identidade *",
		type: "mask",
		dependent: {
			field: "cmbTipoDocumento",
			value: "0372008",
		},
	},

	// {CARTEIRA DE IDENTIDADE}
	{
		title: "Órgão Emissor *",
		name: "cmbOrgaoEmissorRg",
		type: "select",
		options: docIdOptions,
		dependent: {
			field: "subTipoIdentidadeNumeroRg",
			value: "CI",
		},
	},

	// {CARTEIRA FUNCIONAL}
	{
		title: "Órgão Emissor *",
		name: "cmbOrgaoEmissorRg",
		type: "select",
		options: docFuncOptions,
		dependent: {
			field: "subTipoIdentidadeNumeroRg",
			value: "CF",
		},
	},

	// {IDENTIDADE MILITAR}
	{
		title: "Órgão Emissor *",
		name: "cmbOrgaoEmissorRg",
		type: "select",
		options: docArmyOptions,
		dependent: {
			field: "subTipoIdentidadeRg",
			value: "IM",
		},
	},

	// {CARTEIRA DE IDENTIDADE ESTRANGEIRA}
	{
		title: "Órgão Emissor *",
		name: "cmbOrgaoEmissorRg",
		type: "select",
		options: docEstOptions,
		dependent: {
			field: "subTipoIdentidadeRg",
			value: "CE",
		},
	},

	// UF

	// {CNH}

	{
		title: "UF CNH",
		name: "cmbUFIdentidadeCnh",
		type: "select",
		options: ufOptions,
		dependent: {
			field: "cmbTipoDocumento",
			value: "0782",
		},
	},

	// {PASSAPORTE}

	{
		title: "UF Passaporte",
		name: "cmbUFIdentidadePassaporte",
		type: "select",
		options: [],
		required: "states",
		dependent: {
			field: "cmbTipoDocumento",
			value: "0781",
		},
	},

	{
		title: "País de origem",
		name: "paisDeOrigemPassaporte",
		type: "select",
		options: passaporteOptions,
		dependent: {
			field: "cmbTipoDocumento",
			value: "0781",
		},
	},

	// {RIC} {DOCUMENTO DE IDENTIFICAÇÃO}

	{
		title: "UF Identidade",
		name: "cmbUFIdentidadeRg",
		type: "select",
		options: ufOptions,
		dependent: {
			field: "cmbTipoDocumento",
			values: ["0372102", "0372008"],
		},
	},

	// DATA DE EMISSÃO E FIM DE VALIDADE

	// {CNH}

	{
		title: "Data de emissão (DD/MM/AAAA)",
		name: "dataEmissaoIdentidadeCnh",
		type: "mask",
		mask: "99/99/9999",
		placeholder: "Data de emissão",
		dependent: {
			field: "cmbTipoDocumento",
			value: "0782",
		},
	},
	{
		title: "Data fim de validade (DD/MM/AAAA)",
		name: "dataFimValidadeCnh",
		type: "mask",
		mask: "99/99/9999",
		placeholder: "Data fim de validade",
		dependent: {
			field: "cmbTipoDocumento",
			value: "0782",
		},
	},

	// {PASSAPORTE}
	{
		title: "Data de emissão (DD/MM/AAAA)",
		name: "dataEmissaoIdentidadePassaporte",
		type: "mask",
		mask: "99/99/9999",
		placeholder: "Data de emissão",
		dependent: {
			field: "cmbTipoDocumento",
			value: "0781",
		},
	},
	{
		title: "Data fim de validade (DD/MM/AAAA)",
		name: "dataFimValidadePassaporte",
		type: "mask",
		mask: "99/99/9999",
		placeholder: "Data fim de validade",
		dependent: {
			field: "cmbTipoDocumento",
			value: "0781",
		},
	},

	// {RIC} {DOCUMENTO DE IDENTIFICAÇÃO}
	{
		title: "Data de emissão (DD/MM/AAAA)",
		name: "dataEmissaoIdentidadeRg",
		type: "mask",
		mask: "99/99/9999",
		placeholder: "Data de emissão",
		dependent: {
			field: "cmbTipoDocumento",
			values: ["0372102", "0372008"],
		},
	},
	{
		title: "Data fim de validade (DD/MM/AAAA)",
		name: "dataFimValidadeRg",
		type: "mask",
		mask: "99/99/9999",
		placeholder: "Data fim de validade",
		dependent: {
			field: "cmbTipoDocumento",
			values: ["0372102", "0372008"],
		},
	},

	{
		title: "Estado civil",
		name: "cmbEstadoCivil",
		type: "select",
		options: msOptions,
	},
	{
		title: "CPF do cônjuge *",
		name: "cpfConjuge",
		type: "mask",
		mask: "999.999.999-99",
		placeholder: "CPF do cônjuge",
		dependent: {
			field: "marital_status",
			values: ["cctb", "csb", "ccpb"],
		},
	},
	{
		title: "Tipo de ocupação *",
		name: "cmbTpOcupacao",
		type: "select",
		options: occupationTypeOptions,
	},
	{
		title: "Ocupação *",
		name: "cmbOcupacaoInformal",
		type: "select",
		options: iOccupationOptions,
		dependent: {
			field: "cmbTpOcupacao",
			value: "02",
		},
	},
	{
		title: "Ocupação *",
		name: "cmbOcupacaoFormal",
		type: "select",
		options: fOccupationOptions,
		dependent: {
			field: "cmbTpOcupacao",
			value: "01",
		},
	},
];

export const secondStep: StepQuestion[] = [
	{
		title: "CEP *",
		name: "cep",
		type: "mask",
		mask: "99999-999",
		placeholder: "CEP",
	},
	{
		title: "Logradouro *",
		name: "cmbTipoLogradouro",
		type: "select",
		options: ppOptions,
	},
	{
		title: "Rua",
		name: "logradouro",
		type: "text",
		placeholder: "Rua",
	},
	{
		title: "Número *",
		name: "numero",
		type: "text",
		placeholder: "Número *",
	},

	{
		title: "Complemento",
		name: "complemento",
		type: "text",
		placeholder: "Complemento",
	},
	{
		title: "Bairro *",
		name: "bairro",
		type: "text",
		placeholder: "Bairro",
	},
	{
		title: "UF Endereço *",
		name: "cmbUFEndereco",
		type: "text",
		placeholder: "UF",
	},
	{
		title: "Município *",
		name: "cmbMunicipioEndereco",
		type: "text",
		placeholder: "Município",
	},

	{
		title: "Tipo de imóvel *",
		name: "cmbTipoImovel",
		type: "select",
		options: propertyTypeOptions,
	},
	{
		title: "Ocupação do imóvel *",
		name: "cmbTipoOcupacaoImovel",
		type: "select",
		options: propertyOccupationOptions,
	},
	{
		title: "Comprovante de residência mês *",
		name: "comprovanteResidenciaMes",
		type: "mask",
		subtype: "date",
		mask: "99",
		placeholder: "ex: 10",
	},
	{
		title: "Comprovante de residência ano *",
		name: "comprovanteResidenciaAno",
		type: "mask",
		subtype: "date",
		mask: "9999",
		placeholder: "ex: 2021",
	},
	{
		title: "Telefone de contato (DDD) *",
		name: "dddRes",
		type: "mask",
		mask: "(99)",
		placeholder: "DDD",
	},
	{
		title: "Telefone de contato (Número) *",
		name: "telefoneRes",
		type: "mask",
		mask: "99999-9999",
		placeholder: "Telefone de contato",
	},
	{
		title: "Telefone celular (DDD)",
		name: "dddCel",
		type: "mask",
		mask: "(99)",
		placeholder: "DDD",
	},

	{
		title: "Telefone celular",
		name: "telefoneCel",
		type: "mask",
		mask: "99999-9999",
		placeholder: "Telefone celular",
	},
	{
		title: "E-mail",
		name: "email",
		type: "email",
		placeholder: "Endereço de e-mail",
	},
];

export const thirdStep: StepQuestion[] = [
	{
		title: "Características da renda *",
		name: "cmbCaracteristicaRenda",
		type: "select",
		options: caracRenda,
	},
	{
		title: "Tipo de renda *",
		name: "cmbCnpj_cpf",
		type: "select",
		options: incType,
		dependent: {
			field: "cmbCaracteristicaRenda",
			value: "6",
		},
	},
	{
		title: "CPF *",
		name: "numeroCpf",
		type: "mask",
		mask: "999.999.999-99",
		placeholder: "CPF",
		dependent: {
			field: "cmbCnpj_cpf",
			value: "1",
		},
	},
	{
		title: "CNPJ *",
		name: "numeroCnpj",
		type: "mask",
		mask: "99.999.999/9999-99",
		placeholder: "CNPJ",
		dependent: {
			field: "cmbCnpj_cpf",
			value: "2",
		},
	},
	{
		title: "Nome da fonte pagadora",
		name: "fontePagadora",
		type: "text",
		placeholder: "Nome da fonte pagadora",
		dependent: {
			field: "cmbCaracteristicaRenda",
			value: "6",
		},
	},
	{
		title: "Ocupação *",
		name: "cmbOcupacao",
		type: "select",
		options: fOccupationOptions,
		dependent: {
			field: "cmbCaracteristicaRenda",
			value: "6",
		},
	},
	{
		title: "Data de admissão (DD/MM/AAAA) *",
		name: "dataAdmissao",
		type: "mask",
		mask: "99/99/9999",
		placeholder: "Data de admissão",
		dependent: {
			field: "cmbCaracteristicaRenda",
			value: "6",
		},
	},
	{
		title: "Renda bruta *",
		name: "valorRendaBruta",
		type: "mask",
		mask: {
			prefix: "R$",
			type: "money",
		},

		placeholder: "Renda bruta",
		dependent: {
			field: "cmbCaracteristicaRenda",
			value: "6",
		},
	},
	{
		title: "Renda líquida *",
		name: "valorRendaLiquida",
		type: "mask",
		placeholder: "Renda líquida",
		dependent: {
			field: "cmbCaracteristicaRenda",
			value: "6",
		},
	},
	{
		title: "Documento de comprovante de renda *",
		name: "cmbComprovanteRenda",
		type: "select",
		options: docsIncProof,
		dependent: {
			field: "cmbCaracteristicaRenda",
			value: "6",
		},
	},
	{
		title: "Data do comprovante de renda (MM/AAAA) *",
		name: "dtRefCompr",
		type: "mask",
		mask: "99/9999",
		placeholder: "Data do comprovante de renda",
		dependent: {
			field: "cmbCaracteristicaRenda",
			value: "6",
		},
	},
	{
		title: "IRPF *",
		name: "iImposRendaRetFonte",
		type: "mask",
		placeholder: "IRPF",
		dependent: {
			field: "cmbComprovanteRenda",
			value: "64522009",
		},
	},
	{
		title: "Tempo no emprego anterior - Meses *",
		name: "empregoAnteriorMeses",
		type: "mask",
		mask: "99",
		placeholder: "Tempo no emprego anterior - Meses *",
		dependent: {
			field: "dataAdmissao",
			valueFunction(dependentValue: string) {
				if (!dependentValue) {
					return false;
				}

				const date = validateDate({
					value: dependentValue,
					subtype: DataSubtypes["date/month/year"],
				});
				const minDate = moment().subtract("120", "days").toDate();

				if (minDate > date) {
					//Se a data limite para não ter que renderizar esse input for maior que a data atual
					return false;
				}

				return true;
			},
		},
	},
	{
		title: "Tempo no emprego anterior - Anos *",
		name: "empregoAnteriorAnos",
		type: "mask",
		mask: "9999",
		placeholder: "Tempo no emprego anterior - Anos *",
		dependent: {
			field: "dataAdmissao",
			valueFunction(dependentValue: string) {
				if (!dependentValue) {
					return false;
				}

				const date = validateDate({
					value: dependentValue,
					subtype: DataSubtypes["date/month/year"],
				});
				const minDate = moment().subtract("120", "days").toDate();

				if (minDate > date) {
					//Se a data limite para não ter que renderizar esse input for maior que a data atual
					return false;
				}

				return true;
			},
		},
	},
	{
		title: "Ano de desligamento do emprego anterior",
		name: "anoDesligamento",
		type: "mask",
		mask: "9999",
		placeholder: "Ano de desligamento",
		dependent: {
			field: "dataAdmissao",
			valueFunction(dependentValue: string) {
				if (!dependentValue) {
					return false;
				}

				const date = validateDate({
					value: dependentValue,
					subtype: DataSubtypes["date/month/year"],
				});
				const minDate = moment().subtract("120", "days").toDate();

				if (minDate > date) {
					//Se a data limite para não ter que renderizar esse input for maior que a data atual
					return false;
				}

				return true;
			},
		},
	},
];

export const fourthStep: StepQuestion[] = [
	{
		title: "Nome da atividade *",
		name: "nomeAtividade",
		type: "select",
		options: iOccupationOptions,
	},
	{
		title: "Data de início (MM/AAAA) *",
		name: "dataDeInicio",
		type: "mask",
		mask: "99/9999",
		placeholder: "Data de início",
	},
	{
		title: "Renda líquida mensal *",
		name: "rendaLiquidaMensal",
		type: "mask",
		placeholder: "Renda líquida",
	},
	{
		title: "Documentos de comprovação *",
		name: "docCompAtivNComp",
		type: "select",
		options: sNOptions,
	},
	{
		title: "Documento *",
		name: "proof_doc",
		type: "checklist",
		options: [
			{
				label: "Água e esgoto, energia elétrica e telefone",
				value: "agua",
			},
			{
				label: "Fatura cartão, extrato C/C",
				value: "fatura",
			},
			{
				label: "Previdência, consórcio, seguro, plano de saúde",
				value: "prev",
			},
			{
				label: "Tv a cabo, internet, assinatura jornais/revista",
				value: "tv",
			},
		],
		dependent: {
			field: "docCompAtivNComp",
			value: "S",
		},
	},
];

export const fifthStep: StepQuestion[] = [
	{
		title: "Número de dependentes",
		name: "iNumSemDepRenda",
		placeholder: "",
		type: "text",
	},
];

export const sixthStep: StepQuestion[] = [
	{
		title: "Aluguel",
		name: "iAluguel",
		placeholder: "Aluguel",
		type: "number",
	},
	{
		title: "Condomínio",
		name: "iCondominio",
		placeholder: "Condomínio",
		type: "number",
	},
	{
		title: "Pensão Alimentícia",
		name: "iPenAli",
		placeholder: "Pensão Alimentícia",
		type: "number",
	},
];

export const seventhStep: StepQuestion[] = [
	{
		name: "cmbUFAgenciaRelacionamento",
		title: "UF Agencia",
		type: "select",
		options: ufOptions,
		optionsType: "uf",
		placeholder: "UF",
	},
	{
		name: "cmbMunicipioAgenciaRelacionamento",
		title: "Município",
		type: "select",
		watchField: "cmbUFAgenciaRelacionamento",
		options: munOptions,
		placeholder: "Município",
	},
	{
		name: "cmbAgenciaRelacionamento",
		title: "Código e Nome das Agências",
		type: "select",
		options: agenciaOptions,
		placeholder: "Código e Nome das Agências",
	},
	{
		name: "nomeAgenciaRelacionamento",
		title: "",
		type: "text",
		disabled: true,
		placeholder: "Nome da Agência",
		watchField: "cmbAgenciaRelacionamento",
	},
	{
		name: "nomeLocalidadeAgRelacionamento",
		title: "",
		type: "text",
		disabled: true,
		placeholder: "Local da Agência",
		watchField: "cmbMunicipioAgenciaRelacionamento",
	},
];

export const questionsByName = [
	...firstStep,
	...secondStep,
	...thirdStep,
	...fourthStep,
	...fifthStep,
	...sixthStep,
	...seventhStep,
].reduce((all, actual) => {
	const { name: key, ...data } = actual;
	if (data.type === "checklist" && data.options) {
		data.options.forEach((option: any) => {
			all[(option as { title: string; name: string }).name] = option;
		});
	}
	all[key as string] = data;
	return all;
}, {} as any);
